/*!
 * Font Awesome Free 6.0.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function Uo(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function B(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Uo(Object(t), !0).forEach(function(r) {
      bd(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : Uo(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function zr(n) {
  "@babel/helpers - typeof";
  return zr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zr(n);
}
function vd(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function gd(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function yd(n, e, t) {
  return e && gd(n.prototype, e), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
function bd(n, e, t) {
  return e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function Xi(n, e) {
  return wd(n) || Sd(n, e) || dc(n, e) || Od();
}
function sa(n) {
  return _d(n) || Cd(n) || dc(n) || xd();
}
function _d(n) {
  if (Array.isArray(n)) return hi(n);
}
function wd(n) {
  if (Array.isArray(n)) return n;
}
function Cd(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function Sd(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r = [], a = !0, i = !1, o, s;
    try {
      for (t = t.call(n); !(a = (o = t.next()).done) && (r.push(o.value), !(e && r.length === e)); a = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (i) throw s;
      }
    }
    return r;
  }
}
function dc(n, e) {
  if (n) {
    if (typeof n == "string") return hi(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return hi(n, e);
  }
}
function hi(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function xd() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Od() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var qo = function() {
}, eo = {}, pc = {}, hc = null, mc = {
  mark: qo,
  measure: qo
};
try {
  typeof window < "u" && (eo = window), typeof document < "u" && (pc = document), typeof MutationObserver < "u" && (hc = MutationObserver), typeof performance < "u" && (mc = performance);
} catch {
}
var Ad = eo.navigator || {}, Wo = Ad.userAgent, Vo = Wo === void 0 ? "" : Wo, Mt = eo, he = pc, Yo = hc, Or = mc;
Mt.document;
var Ct = !!he.documentElement && !!he.head && typeof he.addEventListener == "function" && typeof he.createElement == "function", vc = ~Vo.indexOf("MSIE") || ~Vo.indexOf("Trident/"), yt = "___FONT_AWESOME___", mi = 16, gc = "fa", yc = "svg-inline--fa", Jt = "data-fa-i2svg", vi = "data-fa-pseudo-element", $d = "data-fa-pseudo-element-pending", to = "data-prefix", no = "data-icon", Ko = "fontawesome-i2svg", Ed = "async", kd = ["HTML", "HEAD", "STYLE", "SCRIPT"], bc = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), ro = {
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  "fa-kit": "kit",
  fa: "solid"
}, Ur = {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}, _c = {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}, Dd = {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}, Td = /fa[srltdbk\-\ ]/, wc = "fa-layers-text", Md = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i, Pd = {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}, Cc = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Id = Cc.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Rd = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Wt = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Nd = [].concat(sa(Object.keys(Ur)), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Wt.GROUP, Wt.SWAP_OPACITY, Wt.PRIMARY, Wt.SECONDARY]).concat(Cc.map(function(n) {
  return "".concat(n, "x");
})).concat(Id.map(function(n) {
  return "w-".concat(n);
})), Sc = Mt.FontAwesomeConfig || {};
function Fd(n) {
  var e = he.querySelector("script[" + n + "]");
  if (e)
    return e.getAttribute(n);
}
function Ld(n) {
  return n === "" ? !0 : n === "false" ? !1 : n === "true" ? !0 : n;
}
if (he && typeof he.querySelector == "function") {
  var Bd = [["data-family-prefix", "familyPrefix"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  Bd.forEach(function(n) {
    var e = Xi(n, 2), t = e[0], r = e[1], a = Ld(Fd(t));
    a != null && (Sc[r] = a);
  });
}
var jd = {
  familyPrefix: gc,
  styleDefault: "solid",
  replacementClass: yc,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
}, Qn = B(B({}, jd), Sc);
Qn.autoReplaceSvg || (Qn.observeMutations = !1);
var Y = {};
Object.keys(Qn).forEach(function(n) {
  Object.defineProperty(Y, n, {
    enumerable: !0,
    set: function(t) {
      Qn[n] = t, Ir.forEach(function(r) {
        return r(Y);
      });
    },
    get: function() {
      return Qn[n];
    }
  });
});
Mt.FontAwesomeConfig = Y;
var Ir = [];
function Hd(n) {
  return Ir.push(n), function() {
    Ir.splice(Ir.indexOf(n), 1);
  };
}
var $t = mi, ut = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function zd(n) {
  if (!(!n || !Ct)) {
    var e = he.createElement("style");
    e.setAttribute("type", "text/css"), e.innerHTML = n;
    for (var t = he.head.childNodes, r = null, a = t.length - 1; a > -1; a--) {
      var i = t[a], o = (i.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(o) > -1 && (r = i);
    }
    return he.head.insertBefore(e, r), n;
  }
}
var Ud = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function or() {
  for (var n = 12, e = ""; n-- > 0; )
    e += Ud[Math.random() * 62 | 0];
  return e;
}
function Tn(n) {
  for (var e = [], t = (n || []).length >>> 0; t--; )
    e[t] = n[t];
  return e;
}
function ao(n) {
  return n.classList ? Tn(n.classList) : (n.getAttribute("class") || "").split(" ").filter(function(e) {
    return e;
  });
}
function xc(n) {
  return "".concat(n).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function qd(n) {
  return Object.keys(n || {}).reduce(function(e, t) {
    return e + "".concat(t, '="').concat(xc(n[t]), '" ');
  }, "").trim();
}
function la(n) {
  return Object.keys(n || {}).reduce(function(e, t) {
    return e + "".concat(t, ": ").concat(n[t].trim(), ";");
  }, "");
}
function io(n) {
  return n.size !== ut.size || n.x !== ut.x || n.y !== ut.y || n.rotate !== ut.rotate || n.flipX || n.flipY;
}
function Wd(n) {
  var e = n.transform, t = n.containerWidth, r = n.iconWidth, a = {
    transform: "translate(".concat(t / 2, " 256)")
  }, i = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), o = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), s = "rotate(".concat(e.rotate, " 0 0)"), l = {
    transform: "".concat(i, " ").concat(o, " ").concat(s)
  }, u = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: a,
    inner: l,
    path: u
  };
}
function Vd(n) {
  var e = n.transform, t = n.width, r = t === void 0 ? mi : t, a = n.height, i = a === void 0 ? mi : a, o = n.startCentered, s = o === void 0 ? !1 : o, l = "";
  return s && vc ? l += "translate(".concat(e.x / $t - r / 2, "em, ").concat(e.y / $t - i / 2, "em) ") : s ? l += "translate(calc(-50% + ".concat(e.x / $t, "em), calc(-50% + ").concat(e.y / $t, "em)) ") : l += "translate(".concat(e.x / $t, "em, ").concat(e.y / $t, "em) "), l += "scale(".concat(e.size / $t * (e.flipX ? -1 : 1), ", ").concat(e.size / $t * (e.flipY ? -1 : 1), ") "), l += "rotate(".concat(e.rotate, "deg) "), l;
}
var Yd = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function Oc() {
  var n = gc, e = yc, t = Y.familyPrefix, r = Y.replacementClass, a = Yd;
  if (t !== n || r !== e) {
    var i = new RegExp("\\.".concat(n, "\\-"), "g"), o = new RegExp("\\--".concat(n, "\\-"), "g"), s = new RegExp("\\.".concat(e), "g");
    a = a.replace(i, ".".concat(t, "-")).replace(o, "--".concat(t, "-")).replace(s, ".".concat(r));
  }
  return a;
}
var Go = !1;
function Ma() {
  Y.autoAddCss && !Go && (zd(Oc()), Go = !0);
}
var Kd = {
  mixout: function() {
    return {
      dom: {
        css: Oc,
        insertCss: Ma
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        Ma();
      },
      beforeI2svg: function() {
        Ma();
      }
    };
  }
}, bt = Mt || {};
bt[yt] || (bt[yt] = {});
bt[yt].styles || (bt[yt].styles = {});
bt[yt].hooks || (bt[yt].hooks = {});
bt[yt].shims || (bt[yt].shims = []);
var tt = bt[yt], Ac = [], Gd = function n() {
  he.removeEventListener("DOMContentLoaded", n), qr = 1, Ac.map(function(e) {
    return e();
  });
}, qr = !1;
Ct && (qr = (he.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(he.readyState), qr || he.addEventListener("DOMContentLoaded", Gd));
function Qd(n) {
  Ct && (qr ? setTimeout(n, 0) : Ac.push(n));
}
function dr(n) {
  var e = n.tag, t = n.attributes, r = t === void 0 ? {} : t, a = n.children, i = a === void 0 ? [] : a;
  return typeof n == "string" ? xc(n) : "<".concat(e, " ").concat(qd(r), ">").concat(i.map(dr).join(""), "</").concat(e, ">");
}
function Qo(n, e, t) {
  if (n && n[e] && n[e][t])
    return {
      prefix: e,
      iconName: t,
      icon: n[e][t]
    };
}
var Pa = function(e, t, r, a) {
  var i = Object.keys(e), o = i.length, s = t, l, u, c;
  for (r === void 0 ? (l = 1, c = e[i[0]]) : (l = 0, c = r); l < o; l++)
    u = i[l], c = s(c, e[u], u, e);
  return c;
};
function Jd(n) {
  for (var e = [], t = 0, r = n.length; t < r; ) {
    var a = n.charCodeAt(t++);
    if (a >= 55296 && a <= 56319 && t < r) {
      var i = n.charCodeAt(t++);
      (i & 64512) == 56320 ? e.push(((a & 1023) << 10) + (i & 1023) + 65536) : (e.push(a), t--);
    } else
      e.push(a);
  }
  return e;
}
function gi(n) {
  var e = Jd(n);
  return e.length === 1 ? e[0].toString(16) : null;
}
function Zd(n, e) {
  var t = n.length, r = n.charCodeAt(e), a;
  return r >= 55296 && r <= 56319 && t > e + 1 && (a = n.charCodeAt(e + 1), a >= 56320 && a <= 57343) ? (r - 55296) * 1024 + a - 56320 + 65536 : r;
}
function Jo(n) {
  return Object.keys(n).reduce(function(e, t) {
    var r = n[t], a = !!r.icon;
    return a ? e[r.iconName] = r.icon : e[t] = r, e;
  }, {});
}
function yi(n, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = t.skipHooks, a = r === void 0 ? !1 : r, i = Jo(e);
  typeof tt.hooks.addPack == "function" && !a ? tt.hooks.addPack(n, Jo(e)) : tt.styles[n] = B(B({}, tt.styles[n] || {}), i), n === "fas" && yi("fa", e);
}
var Jn = tt.styles, Xd = tt.shims, ep = Object.values(_c), oo = null, $c = {}, Ec = {}, kc = {}, Dc = {}, Tc = {}, tp = Object.keys(ro);
function np(n) {
  return ~Nd.indexOf(n);
}
function rp(n, e) {
  var t = e.split("-"), r = t[0], a = t.slice(1).join("-");
  return r === n && a !== "" && !np(a) ? a : null;
}
var Mc = function() {
  var e = function(i) {
    return Pa(Jn, function(o, s, l) {
      return o[l] = Pa(s, i, {}), o;
    }, {});
  };
  $c = e(function(a, i, o) {
    if (i[3] && (a[i[3]] = o), i[2]) {
      var s = i[2].filter(function(l) {
        return typeof l == "number";
      });
      s.forEach(function(l) {
        a[l.toString(16)] = o;
      });
    }
    return a;
  }), Ec = e(function(a, i, o) {
    if (a[o] = o, i[2]) {
      var s = i[2].filter(function(l) {
        return typeof l == "string";
      });
      s.forEach(function(l) {
        a[l] = o;
      });
    }
    return a;
  }), Tc = e(function(a, i, o) {
    var s = i[2];
    return a[o] = o, s.forEach(function(l) {
      a[l] = o;
    }), a;
  });
  var t = "far" in Jn || Y.autoFetchSvg, r = Pa(Xd, function(a, i) {
    var o = i[0], s = i[1], l = i[2];
    return s === "far" && !t && (s = "fas"), typeof o == "string" && (a.names[o] = {
      prefix: s,
      iconName: l
    }), typeof o == "number" && (a.unicodes[o.toString(16)] = {
      prefix: s,
      iconName: l
    }), a;
  }, {
    names: {},
    unicodes: {}
  });
  kc = r.names, Dc = r.unicodes, oo = ca(Y.styleDefault);
};
Hd(function(n) {
  oo = ca(n.styleDefault);
});
Mc();
function so(n, e) {
  return ($c[n] || {})[e];
}
function ap(n, e) {
  return (Ec[n] || {})[e];
}
function mn(n, e) {
  return (Tc[n] || {})[e];
}
function Pc(n) {
  return kc[n] || {
    prefix: null,
    iconName: null
  };
}
function ip(n) {
  var e = Dc[n], t = so("fas", n);
  return e || (t ? {
    prefix: "fas",
    iconName: t
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Pt() {
  return oo;
}
var lo = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function ca(n) {
  var e = ro[n], t = Ur[n] || Ur[e], r = n in tt.styles ? n : null;
  return t || r || null;
}
function ua(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = e.skipLookups, r = t === void 0 ? !1 : t, a = null, i = n.reduce(function(o, s) {
    var l = rp(Y.familyPrefix, s);
    if (Jn[s] ? (s = ep.includes(s) ? Dd[s] : s, a = s, o.prefix = s) : tp.indexOf(s) > -1 ? (a = s, o.prefix = ca(s)) : l ? o.iconName = l : s !== Y.replacementClass && o.rest.push(s), !r && o.prefix && o.iconName) {
      var u = a === "fa" ? Pc(o.iconName) : {}, c = mn(o.prefix, o.iconName);
      u.prefix && (a = null), o.iconName = u.iconName || c || o.iconName, o.prefix = u.prefix || o.prefix, o.prefix === "far" && !Jn.far && Jn.fas && !Y.autoFetchSvg && (o.prefix = "fas");
    }
    return o;
  }, lo());
  return (i.prefix === "fa" || a === "fa") && (i.prefix = Pt() || "fas"), i;
}
var op = /* @__PURE__ */ function() {
  function n() {
    vd(this, n), this.definitions = {};
  }
  return yd(n, [{
    key: "add",
    value: function() {
      for (var t = this, r = arguments.length, a = new Array(r), i = 0; i < r; i++)
        a[i] = arguments[i];
      var o = a.reduce(this._pullDefinitions, {});
      Object.keys(o).forEach(function(s) {
        t.definitions[s] = B(B({}, t.definitions[s] || {}), o[s]), yi(s, o[s]);
        var l = _c[s];
        l && yi(l, o[s]), Mc();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(t, r) {
      var a = r.prefix && r.iconName && r.icon ? {
        0: r
      } : r;
      return Object.keys(a).map(function(i) {
        var o = a[i], s = o.prefix, l = o.iconName, u = o.icon, c = u[2];
        t[s] || (t[s] = {}), c.length > 0 && c.forEach(function(p) {
          typeof p == "string" && (t[s][p] = u);
        }), t[s][l] = u;
      }), t;
    }
  }]), n;
}(), Zo = [], vn = {}, yn = {}, sp = Object.keys(yn);
function lp(n, e) {
  var t = e.mixoutsTo;
  return Zo = n, vn = {}, Object.keys(yn).forEach(function(r) {
    sp.indexOf(r) === -1 && delete yn[r];
  }), Zo.forEach(function(r) {
    var a = r.mixout ? r.mixout() : {};
    if (Object.keys(a).forEach(function(o) {
      typeof a[o] == "function" && (t[o] = a[o]), zr(a[o]) === "object" && Object.keys(a[o]).forEach(function(s) {
        t[o] || (t[o] = {}), t[o][s] = a[o][s];
      });
    }), r.hooks) {
      var i = r.hooks();
      Object.keys(i).forEach(function(o) {
        vn[o] || (vn[o] = []), vn[o].push(i[o]);
      });
    }
    r.provides && r.provides(yn);
  }), t;
}
function bi(n, e) {
  for (var t = arguments.length, r = new Array(t > 2 ? t - 2 : 0), a = 2; a < t; a++)
    r[a - 2] = arguments[a];
  var i = vn[n] || [];
  return i.forEach(function(o) {
    e = o.apply(null, [e].concat(r));
  }), e;
}
function Zt(n) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    t[r - 1] = arguments[r];
  var a = vn[n] || [];
  a.forEach(function(i) {
    i.apply(null, t);
  });
}
function _t() {
  var n = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return yn[n] ? yn[n].apply(null, e) : void 0;
}
function _i(n) {
  n.prefix === "fa" && (n.prefix = "fas");
  var e = n.iconName, t = n.prefix || Pt();
  if (e)
    return e = mn(t, e) || e, Qo(Ic.definitions, t, e) || Qo(tt.styles, t, e);
}
var Ic = new op(), cp = function() {
  Y.autoReplaceSvg = !1, Y.observeMutations = !1, Zt("noAuto");
}, up = {
  i2svg: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Ct ? (Zt("beforeI2svg", e), _t("pseudoElements2svg", e), _t("i2svg", e)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.autoReplaceSvgRoot;
    Y.autoReplaceSvg === !1 && (Y.autoReplaceSvg = !0), Y.observeMutations = !0, Qd(function() {
      dp({
        autoReplaceSvgRoot: t
      }), Zt("watch", e);
    });
  }
}, fp = {
  icon: function(e) {
    if (e === null)
      return null;
    if (zr(e) === "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: mn(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      var t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], r = ca(e[0]);
      return {
        prefix: r,
        iconName: mn(r, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(Y.familyPrefix, "-")) > -1 || e.match(Td))) {
      var a = ua(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: a.prefix || Pt(),
        iconName: mn(a.prefix, a.iconName) || a.iconName
      };
    }
    if (typeof e == "string") {
      var i = Pt();
      return {
        prefix: i,
        iconName: mn(i, e) || e
      };
    }
  }
}, Ve = {
  noAuto: cp,
  config: Y,
  dom: up,
  parse: fp,
  library: Ic,
  findIconDefinition: _i,
  toHtml: dr
}, dp = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.autoReplaceSvgRoot, r = t === void 0 ? he : t;
  (Object.keys(tt.styles).length > 0 || Y.autoFetchSvg) && Ct && Y.autoReplaceSvg && Ve.dom.i2svg({
    node: r
  });
};
function fa(n, e) {
  return Object.defineProperty(n, "abstract", {
    get: e
  }), Object.defineProperty(n, "html", {
    get: function() {
      return n.abstract.map(function(r) {
        return dr(r);
      });
    }
  }), Object.defineProperty(n, "node", {
    get: function() {
      if (Ct) {
        var r = he.createElement("div");
        return r.innerHTML = n.html, r.children;
      }
    }
  }), n;
}
function pp(n) {
  var e = n.children, t = n.main, r = n.mask, a = n.attributes, i = n.styles, o = n.transform;
  if (io(o) && t.found && !r.found) {
    var s = t.width, l = t.height, u = {
      x: s / l / 2,
      y: 0.5
    };
    a.style = la(B(B({}, i), {}, {
      "transform-origin": "".concat(u.x + o.x / 16, "em ").concat(u.y + o.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: a,
    children: e
  }];
}
function hp(n) {
  var e = n.prefix, t = n.iconName, r = n.children, a = n.attributes, i = n.symbol, o = i === !0 ? "".concat(e, "-").concat(Y.familyPrefix, "-").concat(t) : i;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: B(B({}, a), {}, {
        id: o
      }),
      children: r
    }]
  }];
}
function co(n) {
  var e = n.icons, t = e.main, r = e.mask, a = n.prefix, i = n.iconName, o = n.transform, s = n.symbol, l = n.title, u = n.maskId, c = n.titleId, p = n.extra, m = n.watchable, y = m === void 0 ? !1 : m, g = r.found ? r : t, b = g.width, w = g.height, C = a === "fak", S = [Y.replacementClass, i ? "".concat(Y.familyPrefix, "-").concat(i) : ""].filter(function(z) {
    return p.classes.indexOf(z) === -1;
  }).filter(function(z) {
    return z !== "" || !!z;
  }).concat(p.classes).join(" "), A = {
    children: [],
    attributes: B(B({}, p.attributes), {}, {
      "data-prefix": a,
      "data-icon": i,
      class: S,
      role: p.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(b, " ").concat(w)
    })
  }, h = C && !~p.classes.indexOf("fa-fw") ? {
    width: "".concat(b / w * 16 * 0.0625, "em")
  } : {};
  y && (A.attributes[Jt] = ""), l && (A.children.push({
    tag: "title",
    attributes: {
      id: A.attributes["aria-labelledby"] || "title-".concat(c || or())
    },
    children: [l]
  }), delete A.attributes.title);
  var E = B(B({}, A), {}, {
    prefix: a,
    iconName: i,
    main: t,
    mask: r,
    maskId: u,
    transform: o,
    symbol: s,
    styles: B(B({}, h), p.styles)
  }), _ = r.found && t.found ? _t("generateAbstractMask", E) || {
    children: [],
    attributes: {}
  } : _t("generateAbstractIcon", E) || {
    children: [],
    attributes: {}
  }, M = _.children, L = _.attributes;
  return E.children = M, E.attributes = L, s ? hp(E) : pp(E);
}
function Xo(n) {
  var e = n.content, t = n.width, r = n.height, a = n.transform, i = n.title, o = n.extra, s = n.watchable, l = s === void 0 ? !1 : s, u = B(B(B({}, o.attributes), i ? {
    title: i
  } : {}), {}, {
    class: o.classes.join(" ")
  });
  l && (u[Jt] = "");
  var c = B({}, o.styles);
  io(a) && (c.transform = Vd({
    transform: a,
    startCentered: !0,
    width: t,
    height: r
  }), c["-webkit-transform"] = c.transform);
  var p = la(c);
  p.length > 0 && (u.style = p);
  var m = [];
  return m.push({
    tag: "span",
    attributes: u,
    children: [e]
  }), i && m.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [i]
  }), m;
}
function mp(n) {
  var e = n.content, t = n.title, r = n.extra, a = B(B(B({}, r.attributes), t ? {
    title: t
  } : {}), {}, {
    class: r.classes.join(" ")
  }), i = la(r.styles);
  i.length > 0 && (a.style = i);
  var o = [];
  return o.push({
    tag: "span",
    attributes: a,
    children: [e]
  }), t && o.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [t]
  }), o;
}
var Ia = tt.styles;
function wi(n) {
  var e = n[0], t = n[1], r = n.slice(4), a = Xi(r, 1), i = a[0], o = null;
  return Array.isArray(i) ? o = {
    tag: "g",
    attributes: {
      class: "".concat(Y.familyPrefix, "-").concat(Wt.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(Y.familyPrefix, "-").concat(Wt.SECONDARY),
        fill: "currentColor",
        d: i[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(Y.familyPrefix, "-").concat(Wt.PRIMARY),
        fill: "currentColor",
        d: i[1]
      }
    }]
  } : o = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: i
    }
  }, {
    found: !0,
    width: e,
    height: t,
    icon: o
  };
}
var vp = {
  found: !1,
  width: 512,
  height: 512
};
function gp(n, e) {
  !bc && !Y.showMissingIcons && n && console.error('Icon with name "'.concat(n, '" and prefix "').concat(e, '" is missing.'));
}
function Ci(n, e) {
  var t = e;
  return e === "fa" && Y.styleDefault !== null && (e = Pt()), new Promise(function(r, a) {
    if (_t("missingIconAbstract"), t === "fa") {
      var i = Pc(n) || {};
      n = i.iconName || n, e = i.prefix || e;
    }
    if (n && e && Ia[e] && Ia[e][n]) {
      var o = Ia[e][n];
      return r(wi(o));
    }
    gp(n, e), r(B(B({}, vp), {}, {
      icon: Y.showMissingIcons && n ? _t("missingIconAbstract") || {} : {}
    }));
  });
}
var es = function() {
}, Si = Y.measurePerformance && Or && Or.mark && Or.measure ? Or : {
  mark: es,
  measure: es
}, Gn = 'FA "6.0.0"', yp = function(e) {
  return Si.mark("".concat(Gn, " ").concat(e, " begins")), function() {
    return Rc(e);
  };
}, Rc = function(e) {
  Si.mark("".concat(Gn, " ").concat(e, " ends")), Si.measure("".concat(Gn, " ").concat(e), "".concat(Gn, " ").concat(e, " begins"), "".concat(Gn, " ").concat(e, " ends"));
}, uo = {
  begin: yp,
  end: Rc
}, Rr = function() {
};
function ts(n) {
  var e = n.getAttribute ? n.getAttribute(Jt) : null;
  return typeof e == "string";
}
function bp(n) {
  var e = n.getAttribute ? n.getAttribute(to) : null, t = n.getAttribute ? n.getAttribute(no) : null;
  return e && t;
}
function _p(n) {
  return n && n.classList && n.classList.contains && n.classList.contains(Y.replacementClass);
}
function wp() {
  if (Y.autoReplaceSvg === !0)
    return Nr.replace;
  var n = Nr[Y.autoReplaceSvg];
  return n || Nr.replace;
}
function Cp(n) {
  return he.createElementNS("http://www.w3.org/2000/svg", n);
}
function Sp(n) {
  return he.createElement(n);
}
function Nc(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = e.ceFn, r = t === void 0 ? n.tag === "svg" ? Cp : Sp : t;
  if (typeof n == "string")
    return he.createTextNode(n);
  var a = r(n.tag);
  Object.keys(n.attributes || []).forEach(function(o) {
    a.setAttribute(o, n.attributes[o]);
  });
  var i = n.children || [];
  return i.forEach(function(o) {
    a.appendChild(Nc(o, {
      ceFn: r
    }));
  }), a;
}
function xp(n) {
  var e = " ".concat(n.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
var Nr = {
  replace: function(e) {
    var t = e[0];
    if (t.parentNode)
      if (e[1].forEach(function(a) {
        t.parentNode.insertBefore(Nc(a), t);
      }), t.getAttribute(Jt) === null && Y.keepOriginalSource) {
        var r = he.createComment(xp(t));
        t.parentNode.replaceChild(r, t);
      } else
        t.remove();
  },
  nest: function(e) {
    var t = e[0], r = e[1];
    if (~ao(t).indexOf(Y.replacementClass))
      return Nr.replace(e);
    var a = new RegExp("".concat(Y.familyPrefix, "-.*"));
    if (delete r[0].attributes.id, r[0].attributes.class) {
      var i = r[0].attributes.class.split(" ").reduce(function(s, l) {
        return l === Y.replacementClass || l.match(a) ? s.toSvg.push(l) : s.toNode.push(l), s;
      }, {
        toNode: [],
        toSvg: []
      });
      r[0].attributes.class = i.toSvg.join(" "), i.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", i.toNode.join(" "));
    }
    var o = r.map(function(s) {
      return dr(s);
    }).join(`
`);
    t.setAttribute(Jt, ""), t.innerHTML = o;
  }
};
function ns(n) {
  n();
}
function Fc(n, e) {
  var t = typeof e == "function" ? e : Rr;
  if (n.length === 0)
    t();
  else {
    var r = ns;
    Y.mutateApproach === Ed && (r = Mt.requestAnimationFrame || ns), r(function() {
      var a = wp(), i = uo.begin("mutate");
      n.map(a), i(), t();
    });
  }
}
var fo = !1;
function Lc() {
  fo = !0;
}
function xi() {
  fo = !1;
}
var Wr = null;
function rs(n) {
  if (Yo && Y.observeMutations) {
    var e = n.treeCallback, t = e === void 0 ? Rr : e, r = n.nodeCallback, a = r === void 0 ? Rr : r, i = n.pseudoElementsCallback, o = i === void 0 ? Rr : i, s = n.observeMutationsRoot, l = s === void 0 ? he : s;
    Wr = new Yo(function(u) {
      if (!fo) {
        var c = Pt();
        Tn(u).forEach(function(p) {
          if (p.type === "childList" && p.addedNodes.length > 0 && !ts(p.addedNodes[0]) && (Y.searchPseudoElements && o(p.target), t(p.target)), p.type === "attributes" && p.target.parentNode && Y.searchPseudoElements && o(p.target.parentNode), p.type === "attributes" && ts(p.target) && ~Rd.indexOf(p.attributeName))
            if (p.attributeName === "class" && bp(p.target)) {
              var m = ua(ao(p.target)), y = m.prefix, g = m.iconName;
              p.target.setAttribute(to, y || c), g && p.target.setAttribute(no, g);
            } else _p(p.target) && a(p.target);
        });
      }
    }), Ct && Wr.observe(l, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function Op() {
  Wr && Wr.disconnect();
}
function Ap(n) {
  var e = n.getAttribute("style"), t = [];
  return e && (t = e.split(";").reduce(function(r, a) {
    var i = a.split(":"), o = i[0], s = i.slice(1);
    return o && s.length > 0 && (r[o] = s.join(":").trim()), r;
  }, {})), t;
}
function $p(n) {
  var e = n.getAttribute("data-prefix"), t = n.getAttribute("data-icon"), r = n.innerText !== void 0 ? n.innerText.trim() : "", a = ua(ao(n));
  return a.prefix || (a.prefix = Pt()), e && t && (a.prefix = e, a.iconName = t), a.iconName && a.prefix || a.prefix && r.length > 0 && (a.iconName = ap(a.prefix, n.innerText) || so(a.prefix, gi(n.innerText))), a;
}
function Ep(n) {
  var e = Tn(n.attributes).reduce(function(a, i) {
    return a.name !== "class" && a.name !== "style" && (a[i.name] = i.value), a;
  }, {}), t = n.getAttribute("title"), r = n.getAttribute("data-fa-title-id");
  return Y.autoA11y && (t ? e["aria-labelledby"] = "".concat(Y.replacementClass, "-title-").concat(r || or()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function kp() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: ut,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function as(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, t = $p(n), r = t.iconName, a = t.prefix, i = t.rest, o = Ep(n), s = bi("parseNodeAttributes", {}, n), l = e.styleParser ? Ap(n) : [];
  return B({
    iconName: r,
    title: n.getAttribute("title"),
    titleId: n.getAttribute("data-fa-title-id"),
    prefix: a,
    transform: ut,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: l,
      attributes: o
    }
  }, s);
}
var Dp = tt.styles;
function Bc(n) {
  var e = Y.autoReplaceSvg === "nest" ? as(n, {
    styleParser: !1
  }) : as(n);
  return ~e.extra.classes.indexOf(wc) ? _t("generateLayersText", n, e) : _t("generateSvgReplacementMutation", n, e);
}
function is(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Ct) return Promise.resolve();
  var t = he.documentElement.classList, r = function(p) {
    return t.add("".concat(Ko, "-").concat(p));
  }, a = function(p) {
    return t.remove("".concat(Ko, "-").concat(p));
  }, i = Y.autoFetchSvg ? Object.keys(ro) : Object.keys(Dp), o = [".".concat(wc, ":not([").concat(Jt, "])")].concat(i.map(function(c) {
    return ".".concat(c, ":not([").concat(Jt, "])");
  })).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  var s = [];
  try {
    s = Tn(n.querySelectorAll(o));
  } catch {
  }
  if (s.length > 0)
    r("pending"), a("complete");
  else
    return Promise.resolve();
  var l = uo.begin("onTree"), u = s.reduce(function(c, p) {
    try {
      var m = Bc(p);
      m && c.push(m);
    } catch (y) {
      bc || y.name === "MissingIcon" && console.error(y);
    }
    return c;
  }, []);
  return new Promise(function(c, p) {
    Promise.all(u).then(function(m) {
      Fc(m, function() {
        r("active"), r("complete"), a("pending"), typeof e == "function" && e(), l(), c();
      });
    }).catch(function(m) {
      l(), p(m);
    });
  });
}
function Tp(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  Bc(n).then(function(t) {
    t && Fc([t], e);
  });
}
function Mp(n) {
  return function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = (e || {}).icon ? e : _i(e || {}), a = t.mask;
    return a && (a = (a || {}).icon ? a : _i(a || {})), n(r, B(B({}, t), {}, {
      mask: a
    }));
  };
}
var Pp = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.transform, a = r === void 0 ? ut : r, i = t.symbol, o = i === void 0 ? !1 : i, s = t.mask, l = s === void 0 ? null : s, u = t.maskId, c = u === void 0 ? null : u, p = t.title, m = p === void 0 ? null : p, y = t.titleId, g = y === void 0 ? null : y, b = t.classes, w = b === void 0 ? [] : b, C = t.attributes, S = C === void 0 ? {} : C, A = t.styles, h = A === void 0 ? {} : A;
  if (e) {
    var E = e.prefix, _ = e.iconName, M = e.icon;
    return fa(B({
      type: "icon"
    }, e), function() {
      return Zt("beforeDOMElementCreation", {
        iconDefinition: e,
        params: t
      }), Y.autoA11y && (m ? S["aria-labelledby"] = "".concat(Y.replacementClass, "-title-").concat(g || or()) : (S["aria-hidden"] = "true", S.focusable = "false")), co({
        icons: {
          main: wi(M),
          mask: l ? wi(l.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: E,
        iconName: _,
        transform: B(B({}, ut), a),
        symbol: o,
        title: m,
        maskId: c,
        titleId: g,
        extra: {
          attributes: S,
          styles: h,
          classes: w
        }
      });
    });
  }
}, Ip = {
  mixout: function() {
    return {
      icon: Mp(Pp)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(t) {
        return t.treeCallback = is, t.nodeCallback = Tp, t;
      }
    };
  },
  provides: function(e) {
    e.i2svg = function(t) {
      var r = t.node, a = r === void 0 ? he : r, i = t.callback, o = i === void 0 ? function() {
      } : i;
      return is(a, o);
    }, e.generateSvgReplacementMutation = function(t, r) {
      var a = r.iconName, i = r.title, o = r.titleId, s = r.prefix, l = r.transform, u = r.symbol, c = r.mask, p = r.maskId, m = r.extra;
      return new Promise(function(y, g) {
        Promise.all([Ci(a, s), c.iconName ? Ci(c.iconName, c.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(b) {
          var w = Xi(b, 2), C = w[0], S = w[1];
          y([t, co({
            icons: {
              main: C,
              mask: S
            },
            prefix: s,
            iconName: a,
            transform: l,
            symbol: u,
            maskId: p,
            title: i,
            titleId: o,
            extra: m,
            watchable: !0
          })]);
        }).catch(g);
      });
    }, e.generateAbstractIcon = function(t) {
      var r = t.children, a = t.attributes, i = t.main, o = t.transform, s = t.styles, l = la(s);
      l.length > 0 && (a.style = l);
      var u;
      return io(o) && (u = _t("generateAbstractTransformGrouping", {
        main: i,
        transform: o,
        containerWidth: i.width,
        iconWidth: i.width
      })), r.push(u || i.icon), {
        children: r,
        attributes: a
      };
    };
  }
}, Rp = {
  mixout: function() {
    return {
      layer: function(t) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.classes, i = a === void 0 ? [] : a;
        return fa({
          type: "layer"
        }, function() {
          Zt("beforeDOMElementCreation", {
            assembler: t,
            params: r
          });
          var o = [];
          return t(function(s) {
            Array.isArray(s) ? s.map(function(l) {
              o = o.concat(l.abstract);
            }) : o = o.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(Y.familyPrefix, "-layers")].concat(sa(i)).join(" ")
            },
            children: o
          }];
        });
      }
    };
  }
}, Np = {
  mixout: function() {
    return {
      counter: function(t) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.title, i = a === void 0 ? null : a, o = r.classes, s = o === void 0 ? [] : o, l = r.attributes, u = l === void 0 ? {} : l, c = r.styles, p = c === void 0 ? {} : c;
        return fa({
          type: "counter",
          content: t
        }, function() {
          return Zt("beforeDOMElementCreation", {
            content: t,
            params: r
          }), mp({
            content: t.toString(),
            title: i,
            extra: {
              attributes: u,
              styles: p,
              classes: ["".concat(Y.familyPrefix, "-layers-counter")].concat(sa(s))
            }
          });
        });
      }
    };
  }
}, Fp = {
  mixout: function() {
    return {
      text: function(t) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.transform, i = a === void 0 ? ut : a, o = r.title, s = o === void 0 ? null : o, l = r.classes, u = l === void 0 ? [] : l, c = r.attributes, p = c === void 0 ? {} : c, m = r.styles, y = m === void 0 ? {} : m;
        return fa({
          type: "text",
          content: t
        }, function() {
          return Zt("beforeDOMElementCreation", {
            content: t,
            params: r
          }), Xo({
            content: t,
            transform: B(B({}, ut), i),
            title: s,
            extra: {
              attributes: p,
              styles: y,
              classes: ["".concat(Y.familyPrefix, "-layers-text")].concat(sa(u))
            }
          });
        });
      }
    };
  },
  provides: function(e) {
    e.generateLayersText = function(t, r) {
      var a = r.title, i = r.transform, o = r.extra, s = null, l = null;
      if (vc) {
        var u = parseInt(getComputedStyle(t).fontSize, 10), c = t.getBoundingClientRect();
        s = c.width / u, l = c.height / u;
      }
      return Y.autoA11y && !a && (o.attributes["aria-hidden"] = "true"), Promise.resolve([t, Xo({
        content: t.innerHTML,
        width: s,
        height: l,
        transform: i,
        title: a,
        extra: o,
        watchable: !0
      })]);
    };
  }
}, Lp = new RegExp('"', "ug"), os = [1105920, 1112319];
function Bp(n) {
  var e = n.replace(Lp, ""), t = Zd(e, 0), r = t >= os[0] && t <= os[1], a = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: gi(a ? e[0] : e),
    isSecondary: r || a
  };
}
function ss(n, e) {
  var t = "".concat($d).concat(e.replace(":", "-"));
  return new Promise(function(r, a) {
    if (n.getAttribute(t) !== null)
      return r();
    var i = Tn(n.children), o = i.filter(function(_) {
      return _.getAttribute(vi) === e;
    })[0], s = Mt.getComputedStyle(n, e), l = s.getPropertyValue("font-family").match(Md), u = s.getPropertyValue("font-weight"), c = s.getPropertyValue("content");
    if (o && !l)
      return n.removeChild(o), r();
    if (l && c !== "none" && c !== "") {
      var p = s.getPropertyValue("content"), m = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(l[2]) ? Ur[l[2].toLowerCase()] : Pd[u], y = Bp(p), g = y.value, b = y.isSecondary, w = l[0].startsWith("FontAwesome"), C = so(m, g), S = C;
      if (w) {
        var A = ip(g);
        A.iconName && A.prefix && (C = A.iconName, m = A.prefix);
      }
      if (C && !b && (!o || o.getAttribute(to) !== m || o.getAttribute(no) !== S)) {
        n.setAttribute(t, S), o && n.removeChild(o);
        var h = kp(), E = h.extra;
        E.attributes[vi] = e, Ci(C, m).then(function(_) {
          var M = co(B(B({}, h), {}, {
            icons: {
              main: _,
              mask: lo()
            },
            prefix: m,
            iconName: S,
            extra: E,
            watchable: !0
          })), L = he.createElement("svg");
          e === "::before" ? n.insertBefore(L, n.firstChild) : n.appendChild(L), L.outerHTML = M.map(function(z) {
            return dr(z);
          }).join(`
`), n.removeAttribute(t), r();
        }).catch(a);
      } else
        r();
    } else
      r();
  });
}
function jp(n) {
  return Promise.all([ss(n, "::before"), ss(n, "::after")]);
}
function Hp(n) {
  return n.parentNode !== document.head && !~kd.indexOf(n.tagName.toUpperCase()) && !n.getAttribute(vi) && (!n.parentNode || n.parentNode.tagName !== "svg");
}
function ls(n) {
  if (Ct)
    return new Promise(function(e, t) {
      var r = Tn(n.querySelectorAll("*")).filter(Hp).map(jp), a = uo.begin("searchPseudoElements");
      Lc(), Promise.all(r).then(function() {
        a(), xi(), e();
      }).catch(function() {
        a(), xi(), t();
      });
    });
}
var zp = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(t) {
        return t.pseudoElementsCallback = ls, t;
      }
    };
  },
  provides: function(e) {
    e.pseudoElements2svg = function(t) {
      var r = t.node, a = r === void 0 ? he : r;
      Y.searchPseudoElements && ls(a);
    };
  }
}, cs = !1, Up = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          Lc(), cs = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        rs(bi("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        Op();
      },
      watch: function(t) {
        var r = t.observeMutationsRoot;
        cs ? xi() : rs(bi("mutationObserverCallbacks", {
          observeMutationsRoot: r
        }));
      }
    };
  }
}, us = function(e) {
  var t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce(function(r, a) {
    var i = a.toLowerCase().split("-"), o = i[0], s = i.slice(1).join("-");
    if (o && s === "h")
      return r.flipX = !0, r;
    if (o && s === "v")
      return r.flipY = !0, r;
    if (s = parseFloat(s), isNaN(s))
      return r;
    switch (o) {
      case "grow":
        r.size = r.size + s;
        break;
      case "shrink":
        r.size = r.size - s;
        break;
      case "left":
        r.x = r.x - s;
        break;
      case "right":
        r.x = r.x + s;
        break;
      case "up":
        r.y = r.y - s;
        break;
      case "down":
        r.y = r.y + s;
        break;
      case "rotate":
        r.rotate = r.rotate + s;
        break;
    }
    return r;
  }, t);
}, qp = {
  mixout: function() {
    return {
      parse: {
        transform: function(t) {
          return us(t);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(t, r) {
        var a = r.getAttribute("data-fa-transform");
        return a && (t.transform = us(a)), t;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractTransformGrouping = function(t) {
      var r = t.main, a = t.transform, i = t.containerWidth, o = t.iconWidth, s = {
        transform: "translate(".concat(i / 2, " 256)")
      }, l = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), u = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), c = "rotate(".concat(a.rotate, " 0 0)"), p = {
        transform: "".concat(l, " ").concat(u, " ").concat(c)
      }, m = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, y = {
        outer: s,
        inner: p,
        path: m
      };
      return {
        tag: "g",
        attributes: B({}, y.outer),
        children: [{
          tag: "g",
          attributes: B({}, y.inner),
          children: [{
            tag: r.icon.tag,
            children: r.icon.children,
            attributes: B(B({}, r.icon.attributes), y.path)
          }]
        }]
      };
    };
  }
}, Ra = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fs(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return n.attributes && (n.attributes.fill || e) && (n.attributes.fill = "black"), n;
}
function Wp(n) {
  return n.tag === "g" ? n.children : [n];
}
var Vp = {
  hooks: function() {
    return {
      parseNodeAttributes: function(t, r) {
        var a = r.getAttribute("data-fa-mask"), i = a ? ua(a.split(" ").map(function(o) {
          return o.trim();
        })) : lo();
        return i.prefix || (i.prefix = Pt()), t.mask = i, t.maskId = r.getAttribute("data-fa-mask-id"), t;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractMask = function(t) {
      var r = t.children, a = t.attributes, i = t.main, o = t.mask, s = t.maskId, l = t.transform, u = i.width, c = i.icon, p = o.width, m = o.icon, y = Wd({
        transform: l,
        containerWidth: p,
        iconWidth: u
      }), g = {
        tag: "rect",
        attributes: B(B({}, Ra), {}, {
          fill: "white"
        })
      }, b = c.children ? {
        children: c.children.map(fs)
      } : {}, w = {
        tag: "g",
        attributes: B({}, y.inner),
        children: [fs(B({
          tag: c.tag,
          attributes: B(B({}, c.attributes), y.path)
        }, b))]
      }, C = {
        tag: "g",
        attributes: B({}, y.outer),
        children: [w]
      }, S = "mask-".concat(s || or()), A = "clip-".concat(s || or()), h = {
        tag: "mask",
        attributes: B(B({}, Ra), {}, {
          id: S,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [g, C]
      }, E = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: A
          },
          children: Wp(m)
        }, h]
      };
      return r.push(E, {
        tag: "rect",
        attributes: B({
          fill: "currentColor",
          "clip-path": "url(#".concat(A, ")"),
          mask: "url(#".concat(S, ")")
        }, Ra)
      }), {
        children: r,
        attributes: a
      };
    };
  }
}, Yp = {
  provides: function(e) {
    var t = !1;
    Mt.matchMedia && (t = Mt.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      var r = [], a = {
        fill: "currentColor"
      }, i = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      r.push({
        tag: "path",
        attributes: B(B({}, a), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var o = B(B({}, i), {}, {
        attributeName: "opacity"
      }), s = {
        tag: "circle",
        attributes: B(B({}, a), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || s.children.push({
        tag: "animate",
        attributes: B(B({}, i), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: B(B({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), r.push(s), r.push({
        tag: "path",
        attributes: B(B({}, a), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: B(B({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || r.push({
        tag: "path",
        attributes: B(B({}, a), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: B(B({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: r
      };
    };
  }
}, Kp = {
  hooks: function() {
    return {
      parseNodeAttributes: function(t, r) {
        var a = r.getAttribute("data-fa-symbol"), i = a === null ? !1 : a === "" ? !0 : a;
        return t.symbol = i, t;
      }
    };
  }
}, Gp = [Kd, Ip, Rp, Np, Fp, zp, Up, qp, Vp, Yp, Kp];
lp(Gp, {
  mixoutsTo: Ve
});
Ve.noAuto;
var Qp = Ve.config, Pe = Ve.library;
Ve.dom;
var Oi = Ve.parse;
Ve.findIconDefinition;
Ve.toHtml;
var Jp = Ve.icon;
Ve.layer;
Ve.text;
Ve.counter;
var Dt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function tn(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function jc(n) {
  if (n.__esModule) return n;
  var e = n.default;
  if (typeof e == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(n).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(n, r);
    Object.defineProperty(t, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return n[r];
      }
    });
  }), t;
}
var Hc = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "exclamation-triangle", r = 576, a = 512, i = [], o = "f071", s = "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faExclamationTriangle = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(Hc);
var zc = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "lightbulb", r = 352, a = 512, i = [], o = "f0eb", s = "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faLightbulb = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(zc);
var Uc = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "comment-dots", r = 512, a = 512, i = [], o = "f4ad", s = "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faCommentDots = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(Uc);
var qc = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "check-circle", r = 512, a = 512, i = [], o = "f058", s = "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faCheckCircle = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(qc);
function ds(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Ge(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ds(Object(t), !0).forEach(function(r) {
      vt(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : ds(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Vr(n) {
  "@babel/helpers - typeof";
  return Vr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Vr(n);
}
function vt(n, e, t) {
  return e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function Zp(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(e.indexOf(a) >= 0) && (t[a] = n[a]);
  return t;
}
function Xp(n, e) {
  if (n == null) return {};
  var t = Zp(n, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(n);
    for (a = 0; a < i.length; a++)
      r = i[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function eh(n) {
  return th(n) || nh(n) || rh(n) || ah();
}
function th(n) {
  if (Array.isArray(n)) return Ai(n);
}
function nh(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function rh(n, e) {
  if (n) {
    if (typeof n == "string") return Ai(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ai(n, e);
  }
}
function Ai(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function ah() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var ih = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Wc = { exports: {} };
(function(n) {
  (function(e) {
    var t = function(C, S, A) {
      if (!u(S) || p(S) || m(S) || y(S) || l(S))
        return S;
      var h, E = 0, _ = 0;
      if (c(S))
        for (h = [], _ = S.length; E < _; E++)
          h.push(t(C, S[E], A));
      else {
        h = {};
        for (var M in S)
          Object.prototype.hasOwnProperty.call(S, M) && (h[C(M, A)] = t(C, S[M], A));
      }
      return h;
    }, r = function(C, S) {
      S = S || {};
      var A = S.separator || "_", h = S.split || /(?=[A-Z])/;
      return C.split(h).join(A);
    }, a = function(C) {
      return g(C) ? C : (C = C.replace(/[\-_\s]+(.)?/g, function(S, A) {
        return A ? A.toUpperCase() : "";
      }), C.substr(0, 1).toLowerCase() + C.substr(1));
    }, i = function(C) {
      var S = a(C);
      return S.substr(0, 1).toUpperCase() + S.substr(1);
    }, o = function(C, S) {
      return r(C, S).toLowerCase();
    }, s = Object.prototype.toString, l = function(C) {
      return typeof C == "function";
    }, u = function(C) {
      return C === Object(C);
    }, c = function(C) {
      return s.call(C) == "[object Array]";
    }, p = function(C) {
      return s.call(C) == "[object Date]";
    }, m = function(C) {
      return s.call(C) == "[object RegExp]";
    }, y = function(C) {
      return s.call(C) == "[object Boolean]";
    }, g = function(C) {
      return C = C - 0, C === C;
    }, b = function(C, S) {
      var A = S && "process" in S ? S.process : S;
      return typeof A != "function" ? C : function(h, E) {
        return A(h, C, E);
      };
    }, w = {
      camelize: a,
      decamelize: o,
      pascalize: i,
      depascalize: o,
      camelizeKeys: function(C, S) {
        return t(b(a, S), C);
      },
      decamelizeKeys: function(C, S) {
        return t(b(o, S), C, S);
      },
      pascalizeKeys: function(C, S) {
        return t(b(i, S), C);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    n.exports ? n.exports = w : e.humps = w;
  })(ih);
})(Wc);
var oh = Wc.exports, sh = ["class", "style", "attrs"];
function lh(n) {
  return n.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, t) {
    var r = t.indexOf(":"), a = oh.camelize(t.slice(0, r)), i = t.slice(r + 1).trim();
    return e[a] = i, e;
  }, {});
}
function ch(n) {
  return n.split(/\s+/).reduce(function(e, t) {
    return e[t] = !0, e;
  }, {});
}
function uh() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return e.reduce(function(r, a) {
    return Array.isArray(a) ? r = r.concat(a) : r.push(a), r;
  }, []);
}
function Vc(n, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = (e.children || []).map(Vc.bind(null, n)), i = Object.keys(e.attributes || {}).reduce(function(y, g) {
    var b = e.attributes[g];
    switch (g) {
      case "class":
        y.class = ch(b);
        break;
      case "style":
        y.style = lh(b);
        break;
      default:
        y.attrs[g] = b;
    }
    return y;
  }, {
    class: {},
    style: {},
    attrs: {}
  }), o = r.class, s = o === void 0 ? {} : o, l = r.style, u = l === void 0 ? {} : l, c = r.attrs, p = c === void 0 ? {} : c, m = Xp(r, sh);
  return typeof e == "string" ? e : n(e.tag, Ge(Ge({
    class: uh(i.class, s),
    style: Ge(Ge({}, i.style), u),
    attrs: Ge(Ge({}, i.attrs), p)
  }, m), {}, {
    props: t
  }), a);
}
var Yc = !1;
try {
  Yc = process.env.NODE_ENV === "production";
} catch {
}
function fh() {
  if (!Yc && console && typeof console.error == "function") {
    var n;
    (n = console).error.apply(n, arguments);
  }
}
function Na(n, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? vt({}, n, e) : {};
}
function dh(n) {
  var e, t = (e = {
    "fa-spin": n.spin,
    "fa-spin-pulse": n.spinPulse,
    "fa-spin-reverse": n.spinReverse,
    "fa-pulse": n.pulse,
    "fa-beat": n.beat,
    "fa-fade": n.fade,
    "fa-flash": n.flash,
    "fa-fw": n.fixedWidth,
    "fa-border": n.border,
    "fa-li": n.listItem,
    "fa-inverse": n.inverse,
    "fa-flip": n.flip === !0,
    "fa-flip-horizontal": n.flip === "horizontal" || n.flip === "both",
    "fa-flip-vertical": n.flip === "vertical" || n.flip === "both"
  }, vt(e, "fa-".concat(n.size), n.size !== null), vt(e, "fa-rotate-".concat(n.rotation), n.rotation !== null), vt(e, "fa-pull-".concat(n.pull), n.pull !== null), vt(e, "fa-swap-opacity", n.swapOpacity), vt(e, "fa-bounce", n.bounce), vt(e, "fa-shake", n.shake), vt(e, "fa-beat-fade", n.beatFade), e);
  return Object.keys(t).map(function(r) {
    return t[r] ? r : null;
  }).filter(function(r) {
    return r;
  });
}
function ph(n, e) {
  var t = (n || "").length === 0 ? [] : [n];
  return t.concat(e).join(" ");
}
function ps(n) {
  if (n && Vr(n) === "object" && n.prefix && n.iconName && n.icon)
    return n;
  if (Oi.icon)
    return Oi.icon(n);
  if (n === null)
    return null;
  if (Vr(n) === "object" && n.prefix && n.iconName)
    return n;
  if (Array.isArray(n) && n.length === 2)
    return {
      prefix: n[0],
      iconName: n[1]
    };
  if (typeof n == "string")
    return {
      prefix: "fas",
      iconName: n
    };
}
var Ie = {
  name: "FontAwesomeIcon",
  functional: !0,
  props: {
    beat: {
      type: Boolean,
      default: !1
    },
    border: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(e) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(e) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(e) {
        return ["right", "left"].indexOf(e) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(e) {
        return [90, 180, 270].indexOf(parseInt(e, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(e) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(e) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    }
  },
  render: function(e, t) {
    var r = t.props, a = r.icon, i = r.mask, o = r.symbol, s = r.title, l = ps(a), u = Na("classes", dh(r)), c = Na("transform", typeof r.transform == "string" ? Oi.transform(r.transform) : r.transform), p = Na("mask", ps(i)), m = Jp(l, Ge(Ge(Ge(Ge({}, u), c), p), {}, {
      symbol: o,
      title: s
    }));
    if (!m)
      return fh("Could not find one or more icon(s)", l, p);
    var y = m.abstract, g = Vc.bind(null, e);
    return g(y[0], {}, t.data);
  }
}, Kc = {
  name: "FontAwesomeLayers",
  functional: !0,
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  render: function(e, t) {
    var r = Qp.familyPrefix, a = t.data.staticClass, i = ["".concat(r, "-layers")].concat(eh(t.props.fixedWidth ? ["".concat(r, "-fw")] : []));
    return e("div", Ge(Ge({}, t.data), {}, {
      staticClass: ph(a, i)
    }), t.children);
  }
};
function ee(n, e, t, r, a, i, o, s) {
  var l = typeof n == "function" ? n.options : n;
  return e && (l.render = e, l.staticRenderFns = t, l._compiled = !0), i && (l._scopeId = "data-v-" + i), {
    exports: n,
    options: l
  };
}
Pe.add(Hc.faExclamationTriangle, qc.faCheckCircle, zc.faLightbulb, Uc.faCommentDots);
const hh = {
  props: {
    type: {
      required: !0,
      type: String,
      validator(n) {
        return ["primary", "danger", "info", "warning", "success", "custom"].includes(n);
      }
    },
    iconHidden: {
      type: Boolean,
      default: !1
    },
    customBackgroundColor: {
      type: String
    },
    customBorderColor: {
      type: String
    }
  },
  components: {
    "font-awesome-icon": Ie
  },
  computed: {
    customAlertStyle() {
      return this.type === "custom" ? `background-color: ${this.customBackgroundColor};
                border-left: 0.3rem solid ${this.customBorderColor};` : !1;
    },
    faIconFromType() {
      switch (this.type) {
        case "danger":
          return "exclamation-triangle";
        case "warning":
          return "comment-dots";
        case "success":
          return "check-circle";
        case "info":
          return "lightbulb";
        default:
          return null;
      }
    }
  }
};
var mh = function() {
  var e = this, t = e._self._c;
  return t("div", { class: ["x-alert", `x-alert--${e.type}`], style: e.customAlertStyle }, [e.iconHidden ? e._e() : t("span", { class: ["x-alert__icon", `x-alert__icon--${e.type}`] }, [e._t("icon", function() {
    return [e.faIconFromType ? t("font-awesome-icon", { attrs: { icon: e.faIconFromType } }) : e._e()];
  })], 2), e._t("default")], 2);
}, vh = [], gh = /* @__PURE__ */ ee(
  hh,
  mh,
  vh,
  !1,
  null,
  "6f88eb01"
);
const yh = gh.exports, bh = {
  name: "Carousel",
  props: {
    id: {
      type: String,
      default: null
    },
    slides: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      activeSlide: 1
    };
  },
  mounted() {
    this.listenOnRoot("unrux::carousel::back", this.previousSlide), this.listenOnRoot("unrux::carousel::next", this.nextSlide), this.listenOnRoot("unrux::carousel::reset", this.resetActiveSlide);
  },
  computed: {
    text() {
      return this.slides[this.activeSlide - 1].text;
    }
  },
  methods: {
    slideVisible(n) {
      return this.activeSlide === n;
    },
    listenOnRoot(n, e) {
      this.$root.$on(n, e), this.$on("hook:beforeDestroy", () => {
        this.$root.$off(n, e);
      });
    },
    previousSlide(n) {
      this.checkId(n) && this.activeSlide--;
    },
    nextSlide(n) {
      this.checkId(n) && this.activeSlide++;
    },
    resetActiveSlide(n) {
      this.checkId(n) && (this.activeSlide = 1);
    },
    checkId(n) {
      return n === this.id;
    }
  },
  watch: {
    activeSlide(n) {
      this.$emit("active-slide", n);
    }
  }
};
var _h = function() {
  var e = this, t = e._self._c;
  return t("div", { attrs: { id: e.id } }, [e._l(e.slides, function(r, a) {
    return t("div", { directives: [{ name: "show", rawName: "v-show", value: e.slideVisible(a + 1), expression: "slideVisible(index + 1)" }], key: a }, [e._t(r.key)], 2);
  }), t("div", { staticClass: "text", domProps: { innerHTML: e._s(e.text) } }), t("ul", { staticClass: "mini-pager" }, e._l(e.slides.length, function(r) {
    return t("li", { key: r, class: { active: e.activeSlide === r } }, [e._v("•")]);
  }), 0)], 2);
}, wh = [], Ch = /* @__PURE__ */ ee(
  bh,
  _h,
  wh,
  !1,
  null,
  "9d34e30e"
);
const Sh = Ch.exports, qn = "__UNRUX_boundEventListeners__";
function da(n) {
  return {
    bind(e, t, r) {
      const a = t.arg;
      let i = null;
      t.expression && (i = t.value);
      const o = (l) => {
        t.modifiers.prevent && l.preventDefault(), t.modifiers.stop && l.stopPropagation(), r.context.$root.$emit(n, a, i, r.elm);
      };
      r.elm.addEventListener("click", o);
      const s = r.elm[qn] || {};
      s.click = s.click || [], s.click.push(o), r.elm[qn] = s;
    },
    unbind(e, t, r) {
      const a = r.elm[qn] && r.elm[qn].click;
      a && (a.forEach((i) => r.elm.removeEventListener("click", i)), delete r.elm[qn].click);
    }
  };
}
const xh = "unrux::carousel::back", Oh = "unrux::carousel::next", Ah = da(xh), $h = da(Oh);
var Gc = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "chevron-down", r = 448, a = 512, i = [], o = "f078", s = "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faChevronDown = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(Gc);
Pe.add(Gc.faChevronDown);
const Qc = "CollapsableList", Eh = {
  name: "CollapsableListItem",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    headless: {
      type: Boolean,
      default: !1
    },
    alwaysUnfold: {
      type: Boolean,
      default: !1
    },
    spaceLess: {
      type: Boolean,
      default: !1
    },
    open: {
      type: Boolean,
      default: !1
    }
  },
  mounted() {
    (this.alwaysUnfold || this.open) && this.showContent(), this.registerContentObserver();
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  data() {
    return {
      collapsed: !0,
      maxHeight: 0
    };
  },
  computed: {
    styleContent() {
      return {
        maxHeight: this.collapsed ? 0 : `${this.maxHeight}px`
      };
    },
    isCollapsed() {
      return this.collapsed;
    }
  },
  methods: {
    calculateContentHeight() {
      this.maxHeight = this.$refs.content.scrollHeight;
    },
    registerContentObserver() {
      this.observer = new MutationObserver(this.calculateContentHeight), this.observer.observe(this.$refs.content, { childList: !0, subtree: !0 });
    },
    toggleContent() {
      this.disabled || this.alwaysUnfold || (this.getParent().clicked(this.$el), this.collapsed ? this.showContent() : this.hideContent());
    },
    getParent() {
      let n = this.$parent;
      for (let e = 0; e < 2; e++) {
        if (n.$options.name === Qc)
          return n;
        n = n.$parent;
      }
      return !1;
    },
    showContent() {
      this.collapsed = !1, this.calculateContentHeight();
    },
    hideContent() {
      this.collapsed = !0;
    }
  },
  watch: {
    open: {
      immediate: !0,
      handler(n) {
        n && this.showContent();
      }
    }
  },
  components: {
    "font-awesome-icon": Ie
  }
};
var kh = function() {
  var e = this, t = e._self._c;
  return t("div", { class: ["collapsable-list-item", { disabled: e.disabled }, { "space-between": !e.spaceLess }] }, [t("header", { class: ["collapsable-list-item__header", { default: !e.headless }], on: { click: e.toggleContent } }, [t("div", { staticClass: "titles" }, [e._t("title"), e._t("subtitle")], 2), e.alwaysUnfold ? e._e() : t("font-awesome-icon", { class: ["collapsable-list-item__icon-header", { "open-item": !e.isCollapsed }], attrs: { icon: "chevron-down" } })], 1), t("div", { ref: "content", staticClass: "collapsable-list-item__content", style: e.styleContent }, [t("div", { class: { "collapsable-list-item__content-inside": !e.headless } }, [e._t("default")], 2)])]);
}, Dh = [], Th = /* @__PURE__ */ ee(
  Eh,
  kh,
  Dh,
  !1,
  null,
  "13896bfc"
);
const Jc = Th.exports, Mh = {
  name: Qc,
  props: {
    accordion: {
      default: !1,
      type: Boolean
    }
  },
  methods: {
    clicked(n) {
      this.accordion && this.closeAllItems(n);
    },
    closeAllItems(n) {
      this.$children.filter((t) => t.$options.name === Jc.name).map((t) => {
        t.$el !== n && t.hideContent();
      });
    }
  }
};
var Ph = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "collapsable-list-container" }, [e._t("default")], 2);
}, Ih = [], Rh = /* @__PURE__ */ ee(
  Mh,
  Ph,
  Ih,
  !1,
  null,
  null
);
const Nh = Rh.exports;
var Zc = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "copy", r = 448, a = 512, i = [], o = "f0c5", s = "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faCopy = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(Zc);
var Xc = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "check", r = 512, a = 512, i = [], o = "f00c", s = "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faCheck = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(Xc);
var eu = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "exclamation", r = 192, a = 512, i = [], o = "f12a", s = "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faExclamation = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(eu);
var Ne = "top", Je = "bottom", Ze = "right", Fe = "left", po = "auto", pr = [Ne, Je, Ze, Fe], Cn = "start", sr = "end", Fh = "clippingParents", tu = "viewport", Wn = "popper", Lh = "reference", hs = /* @__PURE__ */ pr.reduce(function(n, e) {
  return n.concat([e + "-" + Cn, e + "-" + sr]);
}, []), nu = /* @__PURE__ */ [].concat(pr, [po]).reduce(function(n, e) {
  return n.concat([e, e + "-" + Cn, e + "-" + sr]);
}, []), Bh = "beforeRead", jh = "read", Hh = "afterRead", zh = "beforeMain", Uh = "main", qh = "afterMain", Wh = "beforeWrite", Vh = "write", Yh = "afterWrite", Kh = [Bh, jh, Hh, zh, Uh, qh, Wh, Vh, Yh];
function dt(n) {
  return n ? (n.nodeName || "").toLowerCase() : null;
}
function We(n) {
  if (n == null)
    return window;
  if (n.toString() !== "[object Window]") {
    var e = n.ownerDocument;
    return e && e.defaultView || window;
  }
  return n;
}
function Xt(n) {
  var e = We(n).Element;
  return n instanceof e || n instanceof Element;
}
function Qe(n) {
  var e = We(n).HTMLElement;
  return n instanceof e || n instanceof HTMLElement;
}
function ho(n) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = We(n).ShadowRoot;
  return n instanceof e || n instanceof ShadowRoot;
}
function Gh(n) {
  var e = n.state;
  Object.keys(e.elements).forEach(function(t) {
    var r = e.styles[t] || {}, a = e.attributes[t] || {}, i = e.elements[t];
    !Qe(i) || !dt(i) || (Object.assign(i.style, r), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function Qh(n) {
  var e = n.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.styles = t, e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var a = e.elements[r], i = e.attributes[r] || {}, o = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : t[r]), s = o.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !Qe(a) || !dt(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
const ru = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Gh,
  effect: Qh,
  requires: ["computeStyles"]
};
function ft(n) {
  return n.split("-")[0];
}
var Yt = Math.max, Yr = Math.min, Sn = Math.round;
function $i() {
  var n = navigator.userAgentData;
  return n != null && n.brands && Array.isArray(n.brands) ? n.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function au() {
  return !/^((?!chrome|android).)*safari/i.test($i());
}
function xn(n, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var r = n.getBoundingClientRect(), a = 1, i = 1;
  e && Qe(n) && (a = n.offsetWidth > 0 && Sn(r.width) / n.offsetWidth || 1, i = n.offsetHeight > 0 && Sn(r.height) / n.offsetHeight || 1);
  var o = Xt(n) ? We(n) : window, s = o.visualViewport, l = !au() && t, u = (r.left + (l && s ? s.offsetLeft : 0)) / a, c = (r.top + (l && s ? s.offsetTop : 0)) / i, p = r.width / a, m = r.height / i;
  return {
    width: p,
    height: m,
    top: c,
    right: u + p,
    bottom: c + m,
    left: u,
    x: u,
    y: c
  };
}
function mo(n) {
  var e = xn(n), t = n.offsetWidth, r = n.offsetHeight;
  return Math.abs(e.width - t) <= 1 && (t = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: n.offsetLeft,
    y: n.offsetTop,
    width: t,
    height: r
  };
}
function iu(n, e) {
  var t = e.getRootNode && e.getRootNode();
  if (n.contains(e))
    return !0;
  if (t && ho(t)) {
    var r = e;
    do {
      if (r && n.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function wt(n) {
  return We(n).getComputedStyle(n);
}
function Jh(n) {
  return ["table", "td", "th"].indexOf(dt(n)) >= 0;
}
function It(n) {
  return ((Xt(n) ? n.ownerDocument : (
    // $FlowFixMe[prop-missing]
    n.document
  )) || window.document).documentElement;
}
function pa(n) {
  return dt(n) === "html" ? n : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    n.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    n.parentNode || // DOM Element detected
    (ho(n) ? n.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    It(n)
  );
}
function ms(n) {
  return !Qe(n) || // https://github.com/popperjs/popper-core/issues/837
  wt(n).position === "fixed" ? null : n.offsetParent;
}
function Zh(n) {
  var e = /firefox/i.test($i()), t = /Trident/i.test($i());
  if (t && Qe(n)) {
    var r = wt(n);
    if (r.position === "fixed")
      return null;
  }
  var a = pa(n);
  for (ho(a) && (a = a.host); Qe(a) && ["html", "body"].indexOf(dt(a)) < 0; ) {
    var i = wt(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function hr(n) {
  for (var e = We(n), t = ms(n); t && Jh(t) && wt(t).position === "static"; )
    t = ms(t);
  return t && (dt(t) === "html" || dt(t) === "body" && wt(t).position === "static") ? e : t || Zh(n) || e;
}
function vo(n) {
  return ["top", "bottom"].indexOf(n) >= 0 ? "x" : "y";
}
function Zn(n, e, t) {
  return Yt(n, Yr(e, t));
}
function Xh(n, e, t) {
  var r = Zn(n, e, t);
  return r > t ? t : r;
}
function ou() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function su(n) {
  return Object.assign({}, ou(), n);
}
function lu(n, e) {
  return e.reduce(function(t, r) {
    return t[r] = n, t;
  }, {});
}
var em = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, su(typeof e != "number" ? e : lu(e, pr));
};
function tm(n) {
  var e, t = n.state, r = n.name, a = n.options, i = t.elements.arrow, o = t.modifiersData.popperOffsets, s = ft(t.placement), l = vo(s), u = [Fe, Ze].indexOf(s) >= 0, c = u ? "height" : "width";
  if (!(!i || !o)) {
    var p = em(a.padding, t), m = mo(i), y = l === "y" ? Ne : Fe, g = l === "y" ? Je : Ze, b = t.rects.reference[c] + t.rects.reference[l] - o[l] - t.rects.popper[c], w = o[l] - t.rects.reference[l], C = hr(i), S = C ? l === "y" ? C.clientHeight || 0 : C.clientWidth || 0 : 0, A = b / 2 - w / 2, h = p[y], E = S - m[c] - p[g], _ = S / 2 - m[c] / 2 + A, M = Zn(h, _, E), L = l;
    t.modifiersData[r] = (e = {}, e[L] = M, e.centerOffset = M - _, e);
  }
}
function nm(n) {
  var e = n.state, t = n.options, r = t.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  a != null && (typeof a == "string" && (a = e.elements.popper.querySelector(a), !a) || iu(e.elements.popper, a) && (e.elements.arrow = a));
}
const rm = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: tm,
  effect: nm,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function On(n) {
  return n.split("-")[1];
}
var am = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function im(n, e) {
  var t = n.x, r = n.y, a = e.devicePixelRatio || 1;
  return {
    x: Sn(t * a) / a || 0,
    y: Sn(r * a) / a || 0
  };
}
function vs(n) {
  var e, t = n.popper, r = n.popperRect, a = n.placement, i = n.variation, o = n.offsets, s = n.position, l = n.gpuAcceleration, u = n.adaptive, c = n.roundOffsets, p = n.isFixed, m = o.x, y = m === void 0 ? 0 : m, g = o.y, b = g === void 0 ? 0 : g, w = typeof c == "function" ? c({
    x: y,
    y: b
  }) : {
    x: y,
    y: b
  };
  y = w.x, b = w.y;
  var C = o.hasOwnProperty("x"), S = o.hasOwnProperty("y"), A = Fe, h = Ne, E = window;
  if (u) {
    var _ = hr(t), M = "clientHeight", L = "clientWidth";
    if (_ === We(t) && (_ = It(t), wt(_).position !== "static" && s === "absolute" && (M = "scrollHeight", L = "scrollWidth")), _ = _, a === Ne || (a === Fe || a === Ze) && i === sr) {
      h = Je;
      var z = p && _ === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        _[M]
      );
      b -= z - r.height, b *= l ? 1 : -1;
    }
    if (a === Fe || (a === Ne || a === Je) && i === sr) {
      A = Ze;
      var U = p && _ === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        _[L]
      );
      y -= U - r.width, y *= l ? 1 : -1;
    }
  }
  var V = Object.assign({
    position: s
  }, u && am), J = c === !0 ? im({
    x: y,
    y: b
  }, We(t)) : {
    x: y,
    y: b
  };
  if (y = J.x, b = J.y, l) {
    var G;
    return Object.assign({}, V, (G = {}, G[h] = S ? "0" : "", G[A] = C ? "0" : "", G.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + y + "px, " + b + "px)" : "translate3d(" + y + "px, " + b + "px, 0)", G));
  }
  return Object.assign({}, V, (e = {}, e[h] = S ? b + "px" : "", e[A] = C ? y + "px" : "", e.transform = "", e));
}
function om(n) {
  var e = n.state, t = n.options, r = t.gpuAcceleration, a = r === void 0 ? !0 : r, i = t.adaptive, o = i === void 0 ? !0 : i, s = t.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: ft(e.placement),
    variation: On(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: a,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, vs(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, vs(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const sm = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: om,
  data: {}
};
var Ar = {
  passive: !0
};
function lm(n) {
  var e = n.state, t = n.instance, r = n.options, a = r.scroll, i = a === void 0 ? !0 : a, o = r.resize, s = o === void 0 ? !0 : o, l = We(e.elements.popper), u = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && u.forEach(function(c) {
    c.addEventListener("scroll", t.update, Ar);
  }), s && l.addEventListener("resize", t.update, Ar), function() {
    i && u.forEach(function(c) {
      c.removeEventListener("scroll", t.update, Ar);
    }), s && l.removeEventListener("resize", t.update, Ar);
  };
}
const cm = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: lm,
  data: {}
};
var um = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Fr(n) {
  return n.replace(/left|right|bottom|top/g, function(e) {
    return um[e];
  });
}
var fm = {
  start: "end",
  end: "start"
};
function gs(n) {
  return n.replace(/start|end/g, function(e) {
    return fm[e];
  });
}
function go(n) {
  var e = We(n), t = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: r
  };
}
function yo(n) {
  return xn(It(n)).left + go(n).scrollLeft;
}
function dm(n, e) {
  var t = We(n), r = It(n), a = t.visualViewport, i = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    var u = au();
    (u || !u && e === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + yo(n),
    y: l
  };
}
function pm(n) {
  var e, t = It(n), r = go(n), a = (e = n.ownerDocument) == null ? void 0 : e.body, i = Yt(t.scrollWidth, t.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = Yt(t.scrollHeight, t.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -r.scrollLeft + yo(n), l = -r.scrollTop;
  return wt(a || t).direction === "rtl" && (s += Yt(t.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function bo(n) {
  var e = wt(n), t = e.overflow, r = e.overflowX, a = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + a + r);
}
function cu(n) {
  return ["html", "body", "#document"].indexOf(dt(n)) >= 0 ? n.ownerDocument.body : Qe(n) && bo(n) ? n : cu(pa(n));
}
function Xn(n, e) {
  var t;
  e === void 0 && (e = []);
  var r = cu(n), a = r === ((t = n.ownerDocument) == null ? void 0 : t.body), i = We(r), o = a ? [i].concat(i.visualViewport || [], bo(r) ? r : []) : r, s = e.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Xn(pa(o)))
  );
}
function Ei(n) {
  return Object.assign({}, n, {
    left: n.x,
    top: n.y,
    right: n.x + n.width,
    bottom: n.y + n.height
  });
}
function hm(n, e) {
  var t = xn(n, !1, e === "fixed");
  return t.top = t.top + n.clientTop, t.left = t.left + n.clientLeft, t.bottom = t.top + n.clientHeight, t.right = t.left + n.clientWidth, t.width = n.clientWidth, t.height = n.clientHeight, t.x = t.left, t.y = t.top, t;
}
function ys(n, e, t) {
  return e === tu ? Ei(dm(n, t)) : Xt(e) ? hm(e, t) : Ei(pm(It(n)));
}
function mm(n) {
  var e = Xn(pa(n)), t = ["absolute", "fixed"].indexOf(wt(n).position) >= 0, r = t && Qe(n) ? hr(n) : n;
  return Xt(r) ? e.filter(function(a) {
    return Xt(a) && iu(a, r) && dt(a) !== "body";
  }) : [];
}
function vm(n, e, t, r) {
  var a = e === "clippingParents" ? mm(n) : [].concat(e), i = [].concat(a, [t]), o = i[0], s = i.reduce(function(l, u) {
    var c = ys(n, u, r);
    return l.top = Yt(c.top, l.top), l.right = Yr(c.right, l.right), l.bottom = Yr(c.bottom, l.bottom), l.left = Yt(c.left, l.left), l;
  }, ys(n, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function uu(n) {
  var e = n.reference, t = n.element, r = n.placement, a = r ? ft(r) : null, i = r ? On(r) : null, o = e.x + e.width / 2 - t.width / 2, s = e.y + e.height / 2 - t.height / 2, l;
  switch (a) {
    case Ne:
      l = {
        x: o,
        y: e.y - t.height
      };
      break;
    case Je:
      l = {
        x: o,
        y: e.y + e.height
      };
      break;
    case Ze:
      l = {
        x: e.x + e.width,
        y: s
      };
      break;
    case Fe:
      l = {
        x: e.x - t.width,
        y: s
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var u = a ? vo(a) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (i) {
      case Cn:
        l[u] = l[u] - (e[c] / 2 - t[c] / 2);
        break;
      case sr:
        l[u] = l[u] + (e[c] / 2 - t[c] / 2);
        break;
    }
  }
  return l;
}
function An(n, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, a = r === void 0 ? n.placement : r, i = t.strategy, o = i === void 0 ? n.strategy : i, s = t.boundary, l = s === void 0 ? Fh : s, u = t.rootBoundary, c = u === void 0 ? tu : u, p = t.elementContext, m = p === void 0 ? Wn : p, y = t.altBoundary, g = y === void 0 ? !1 : y, b = t.padding, w = b === void 0 ? 0 : b, C = su(typeof w != "number" ? w : lu(w, pr)), S = m === Wn ? Lh : Wn, A = n.rects.popper, h = n.elements[g ? S : m], E = vm(Xt(h) ? h : h.contextElement || It(n.elements.popper), l, c, o), _ = xn(n.elements.reference), M = uu({
    reference: _,
    element: A,
    strategy: "absolute",
    placement: a
  }), L = Ei(Object.assign({}, A, M)), z = m === Wn ? L : _, U = {
    top: E.top - z.top + C.top,
    bottom: z.bottom - E.bottom + C.bottom,
    left: E.left - z.left + C.left,
    right: z.right - E.right + C.right
  }, V = n.modifiersData.offset;
  if (m === Wn && V) {
    var J = V[a];
    Object.keys(U).forEach(function(G) {
      var F = [Ze, Je].indexOf(G) >= 0 ? 1 : -1, D = [Ne, Je].indexOf(G) >= 0 ? "y" : "x";
      U[G] += J[D] * F;
    });
  }
  return U;
}
function gm(n, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, a = t.boundary, i = t.rootBoundary, o = t.padding, s = t.flipVariations, l = t.allowedAutoPlacements, u = l === void 0 ? nu : l, c = On(r), p = c ? s ? hs : hs.filter(function(g) {
    return On(g) === c;
  }) : pr, m = p.filter(function(g) {
    return u.indexOf(g) >= 0;
  });
  m.length === 0 && (m = p);
  var y = m.reduce(function(g, b) {
    return g[b] = An(n, {
      placement: b,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[ft(b)], g;
  }, {});
  return Object.keys(y).sort(function(g, b) {
    return y[g] - y[b];
  });
}
function ym(n) {
  if (ft(n) === po)
    return [];
  var e = Fr(n);
  return [gs(n), e, gs(e)];
}
function bm(n) {
  var e = n.state, t = n.options, r = n.name;
  if (!e.modifiersData[r]._skip) {
    for (var a = t.mainAxis, i = a === void 0 ? !0 : a, o = t.altAxis, s = o === void 0 ? !0 : o, l = t.fallbackPlacements, u = t.padding, c = t.boundary, p = t.rootBoundary, m = t.altBoundary, y = t.flipVariations, g = y === void 0 ? !0 : y, b = t.allowedAutoPlacements, w = e.options.placement, C = ft(w), S = C === w, A = l || (S || !g ? [Fr(w)] : ym(w)), h = [w].concat(A).reduce(function(ue, le) {
      return ue.concat(ft(le) === po ? gm(e, {
        placement: le,
        boundary: c,
        rootBoundary: p,
        padding: u,
        flipVariations: g,
        allowedAutoPlacements: b
      }) : le);
    }, []), E = e.rects.reference, _ = e.rects.popper, M = /* @__PURE__ */ new Map(), L = !0, z = h[0], U = 0; U < h.length; U++) {
      var V = h[U], J = ft(V), G = On(V) === Cn, F = [Ne, Je].indexOf(J) >= 0, D = F ? "width" : "height", k = An(e, {
        placement: V,
        boundary: c,
        rootBoundary: p,
        altBoundary: m,
        padding: u
      }), R = F ? G ? Ze : Fe : G ? Je : Ne;
      E[D] > _[D] && (R = Fr(R));
      var T = Fr(R), q = [];
      if (i && q.push(k[J] <= 0), s && q.push(k[R] <= 0, k[T] <= 0), q.every(function(ue) {
        return ue;
      })) {
        z = V, L = !1;
        break;
      }
      M.set(V, q);
    }
    if (L)
      for (var W = g ? 3 : 1, te = function(le) {
        var ye = h.find(function(we) {
          var me = M.get(we);
          if (me)
            return me.slice(0, le).every(function(Ce) {
              return Ce;
            });
        });
        if (ye)
          return z = ye, "break";
      }, ie = W; ie > 0; ie--) {
        var ce = te(ie);
        if (ce === "break") break;
      }
    e.placement !== z && (e.modifiersData[r]._skip = !0, e.placement = z, e.reset = !0);
  }
}
const _m = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: bm,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function bs(n, e, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: n.top - e.height - t.y,
    right: n.right - e.width + t.x,
    bottom: n.bottom - e.height + t.y,
    left: n.left - e.width - t.x
  };
}
function _s(n) {
  return [Ne, Ze, Je, Fe].some(function(e) {
    return n[e] >= 0;
  });
}
function wm(n) {
  var e = n.state, t = n.name, r = e.rects.reference, a = e.rects.popper, i = e.modifiersData.preventOverflow, o = An(e, {
    elementContext: "reference"
  }), s = An(e, {
    altBoundary: !0
  }), l = bs(o, r), u = bs(s, a, i), c = _s(l), p = _s(u);
  e.modifiersData[t] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: p
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": p
  });
}
const Cm = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: wm
};
function Sm(n, e, t) {
  var r = ft(n), a = [Fe, Ne].indexOf(r) >= 0 ? -1 : 1, i = typeof t == "function" ? t(Object.assign({}, e, {
    placement: n
  })) : t, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [Fe, Ze].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function xm(n) {
  var e = n.state, t = n.options, r = n.name, a = t.offset, i = a === void 0 ? [0, 0] : a, o = nu.reduce(function(c, p) {
    return c[p] = Sm(p, e.rects, i), c;
  }, {}), s = o[e.placement], l = s.x, u = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += u), e.modifiersData[r] = o;
}
const Om = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: xm
};
function Am(n) {
  var e = n.state, t = n.name;
  e.modifiersData[t] = uu({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const $m = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Am,
  data: {}
};
function Em(n) {
  return n === "x" ? "y" : "x";
}
function km(n) {
  var e = n.state, t = n.options, r = n.name, a = t.mainAxis, i = a === void 0 ? !0 : a, o = t.altAxis, s = o === void 0 ? !1 : o, l = t.boundary, u = t.rootBoundary, c = t.altBoundary, p = t.padding, m = t.tether, y = m === void 0 ? !0 : m, g = t.tetherOffset, b = g === void 0 ? 0 : g, w = An(e, {
    boundary: l,
    rootBoundary: u,
    padding: p,
    altBoundary: c
  }), C = ft(e.placement), S = On(e.placement), A = !S, h = vo(C), E = Em(h), _ = e.modifiersData.popperOffsets, M = e.rects.reference, L = e.rects.popper, z = typeof b == "function" ? b(Object.assign({}, e.rects, {
    placement: e.placement
  })) : b, U = typeof z == "number" ? {
    mainAxis: z,
    altAxis: z
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, z), V = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, J = {
    x: 0,
    y: 0
  };
  if (_) {
    if (i) {
      var G, F = h === "y" ? Ne : Fe, D = h === "y" ? Je : Ze, k = h === "y" ? "height" : "width", R = _[h], T = R + w[F], q = R - w[D], W = y ? -L[k] / 2 : 0, te = S === Cn ? M[k] : L[k], ie = S === Cn ? -L[k] : -M[k], ce = e.elements.arrow, ue = y && ce ? mo(ce) : {
        width: 0,
        height: 0
      }, le = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : ou(), ye = le[F], we = le[D], me = Zn(0, M[k], ue[k]), Ce = A ? M[k] / 2 - W - me - ye - U.mainAxis : te - me - ye - U.mainAxis, de = A ? -M[k] / 2 + W + me + we + U.mainAxis : ie + me + we + U.mainAxis, xe = e.elements.arrow && hr(e.elements.arrow), De = xe ? h === "y" ? xe.clientTop || 0 : xe.clientLeft || 0 : 0, Ye = (G = V == null ? void 0 : V[h]) != null ? G : 0, on = R + Ce - Ye - De, Nt = R + de - Ye, Ft = Zn(y ? Yr(T, on) : T, R, y ? Yt(q, Nt) : q);
      _[h] = Ft, J[h] = Ft - R;
    }
    if (s) {
      var xt, Lt = h === "x" ? Ne : Fe, pt = h === "x" ? Je : Ze, Xe = _[E], at = E === "y" ? "height" : "width", Ot = Xe + w[Lt], et = Xe - w[pt], At = [Ne, Fe].indexOf(C) !== -1, ht = (xt = V == null ? void 0 : V[E]) != null ? xt : 0, sn = At ? Ot : Xe - M[at] - L[at] - ht + U.altAxis, Bt = At ? Xe + M[at] + L[at] - ht - U.altAxis : et, ln = y && At ? Xh(sn, Xe, Bt) : Zn(y ? sn : Ot, Xe, y ? Bt : et);
      _[E] = ln, J[E] = ln - Xe;
    }
    e.modifiersData[r] = J;
  }
}
const Dm = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: km,
  requiresIfExists: ["offset"]
};
function Tm(n) {
  return {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  };
}
function Mm(n) {
  return n === We(n) || !Qe(n) ? go(n) : Tm(n);
}
function Pm(n) {
  var e = n.getBoundingClientRect(), t = Sn(e.width) / n.offsetWidth || 1, r = Sn(e.height) / n.offsetHeight || 1;
  return t !== 1 || r !== 1;
}
function Im(n, e, t) {
  t === void 0 && (t = !1);
  var r = Qe(e), a = Qe(e) && Pm(e), i = It(e), o = xn(n, a, t), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !t) && ((dt(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  bo(i)) && (s = Mm(e)), Qe(e) ? (l = xn(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : i && (l.x = yo(i))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function Rm(n) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), r = [];
  n.forEach(function(i) {
    e.set(i.name, i);
  });
  function a(i) {
    t.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!t.has(s)) {
        var l = e.get(s);
        l && a(l);
      }
    }), r.push(i);
  }
  return n.forEach(function(i) {
    t.has(i.name) || a(i);
  }), r;
}
function Nm(n) {
  var e = Rm(n);
  return Kh.reduce(function(t, r) {
    return t.concat(e.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function Fm(n) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(n());
      });
    })), e;
  };
}
function Lm(n) {
  var e = n.reduce(function(t, r) {
    var a = t[r.name];
    return t[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
var ws = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Cs() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Bm(n) {
  n === void 0 && (n = {});
  var e = n, t = e.defaultModifiers, r = t === void 0 ? [] : t, a = e.defaultOptions, i = a === void 0 ? ws : a;
  return function(s, l, u) {
    u === void 0 && (u = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ws, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, p = [], m = !1, y = {
      state: c,
      setOptions: function(C) {
        var S = typeof C == "function" ? C(c.options) : C;
        b(), c.options = Object.assign({}, i, c.options, S), c.scrollParents = {
          reference: Xt(s) ? Xn(s) : s.contextElement ? Xn(s.contextElement) : [],
          popper: Xn(l)
        };
        var A = Nm(Lm([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = A.filter(function(h) {
          return h.enabled;
        }), g(), y.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!m) {
          var C = c.elements, S = C.reference, A = C.popper;
          if (Cs(S, A)) {
            c.rects = {
              reference: Im(S, hr(A), c.options.strategy === "fixed"),
              popper: mo(A)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(U) {
              return c.modifiersData[U.name] = Object.assign({}, U.data);
            });
            for (var h = 0; h < c.orderedModifiers.length; h++) {
              if (c.reset === !0) {
                c.reset = !1, h = -1;
                continue;
              }
              var E = c.orderedModifiers[h], _ = E.fn, M = E.options, L = M === void 0 ? {} : M, z = E.name;
              typeof _ == "function" && (c = _({
                state: c,
                options: L,
                name: z,
                instance: y
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Fm(function() {
        return new Promise(function(w) {
          y.forceUpdate(), w(c);
        });
      }),
      destroy: function() {
        b(), m = !0;
      }
    };
    if (!Cs(s, l))
      return y;
    y.setOptions(u).then(function(w) {
      !m && u.onFirstUpdate && u.onFirstUpdate(w);
    });
    function g() {
      c.orderedModifiers.forEach(function(w) {
        var C = w.name, S = w.options, A = S === void 0 ? {} : S, h = w.effect;
        if (typeof h == "function") {
          var E = h({
            state: c,
            name: C,
            instance: y,
            options: A
          }), _ = function() {
          };
          p.push(E || _);
        }
      });
    }
    function b() {
      p.forEach(function(w) {
        return w();
      }), p = [];
    }
    return y;
  };
}
var jm = [cm, $m, sm, ru, Om, _m, Dm, rm, Cm], ha = /* @__PURE__ */ Bm({
  defaultModifiers: jm
}), Hm = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>', zm = "tippy-box", fu = "tippy-content", Um = "tippy-backdrop", du = "tippy-arrow", pu = "tippy-svg-arrow", jt = {
  passive: !0,
  capture: !0
}, hu = function() {
  return document.body;
};
function qm(n, e) {
  return {}.hasOwnProperty.call(n, e);
}
function Fa(n, e, t) {
  if (Array.isArray(n)) {
    var r = n[e];
    return r ?? (Array.isArray(t) ? t[e] : t);
  }
  return n;
}
function _o(n, e) {
  var t = {}.toString.call(n);
  return t.indexOf("[object") === 0 && t.indexOf(e + "]") > -1;
}
function mu(n, e) {
  return typeof n == "function" ? n.apply(void 0, e) : n;
}
function Ss(n, e) {
  if (e === 0)
    return n;
  var t;
  return function(r) {
    clearTimeout(t), t = setTimeout(function() {
      n(r);
    }, e);
  };
}
function Wm(n, e) {
  var t = Object.assign({}, n);
  return e.forEach(function(r) {
    delete t[r];
  }), t;
}
function Vm(n) {
  return n.split(/\s+/).filter(Boolean);
}
function pn(n) {
  return [].concat(n);
}
function xs(n, e) {
  n.indexOf(e) === -1 && n.push(e);
}
function Ym(n) {
  return n.filter(function(e, t) {
    return n.indexOf(e) === t;
  });
}
function Km(n) {
  return n.split("-")[0];
}
function Kr(n) {
  return [].slice.call(n);
}
function Os(n) {
  return Object.keys(n).reduce(function(e, t) {
    return n[t] !== void 0 && (e[t] = n[t]), e;
  }, {});
}
function er() {
  return document.createElement("div");
}
function lr(n) {
  return ["Element", "Fragment"].some(function(e) {
    return _o(n, e);
  });
}
function Gm(n) {
  return _o(n, "NodeList");
}
function Qm(n) {
  return _o(n, "MouseEvent");
}
function Jm(n) {
  return !!(n && n._tippy && n._tippy.reference === n);
}
function Zm(n) {
  return lr(n) ? [n] : Gm(n) ? Kr(n) : Array.isArray(n) ? n : Kr(document.querySelectorAll(n));
}
function La(n, e) {
  n.forEach(function(t) {
    t && (t.style.transitionDuration = e + "ms");
  });
}
function As(n, e) {
  n.forEach(function(t) {
    t && t.setAttribute("data-state", e);
  });
}
function Xm(n) {
  var e, t = pn(n), r = t[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function e1(n, e) {
  var t = e.clientX, r = e.clientY;
  return n.every(function(a) {
    var i = a.popperRect, o = a.popperState, s = a.props, l = s.interactiveBorder, u = Km(o.placement), c = o.modifiersData.offset;
    if (!c)
      return !0;
    var p = u === "bottom" ? c.top.y : 0, m = u === "top" ? c.bottom.y : 0, y = u === "right" ? c.left.x : 0, g = u === "left" ? c.right.x : 0, b = i.top - r + p > l, w = r - i.bottom - m > l, C = i.left - t + y > l, S = t - i.right - g > l;
    return b || w || C || S;
  });
}
function Ba(n, e, t) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(a) {
    n[r](a, t);
  });
}
function $s(n, e) {
  for (var t = e; t; ) {
    var r;
    if (n.contains(t))
      return !0;
    t = t.getRootNode == null || (r = t.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var lt = {
  isTouch: !1
}, Es = 0;
function t1() {
  lt.isTouch || (lt.isTouch = !0, window.performance && document.addEventListener("mousemove", vu));
}
function vu() {
  var n = performance.now();
  n - Es < 20 && (lt.isTouch = !1, document.removeEventListener("mousemove", vu)), Es = n;
}
function n1() {
  var n = document.activeElement;
  if (Jm(n)) {
    var e = n._tippy;
    n.blur && !e.state.isVisible && n.blur();
  }
}
function r1() {
  document.addEventListener("touchstart", t1, jt), window.addEventListener("blur", n1);
}
var a1 = typeof window < "u" && typeof document < "u", i1 = a1 ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function un(n) {
  var e = n === "destroy" ? "n already-" : " ";
  return [n + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function ks(n) {
  var e = /[ \t]{2,}/g, t = /^[ \t]*/gm;
  return n.replace(e, " ").replace(t, "").trim();
}
function o1(n) {
  return ks(`
  %ctippy.js

  %c` + ks(n) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function gu(n) {
  return [
    o1(n),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var cr;
process.env.NODE_ENV !== "production" && s1();
function s1() {
  cr = /* @__PURE__ */ new Set();
}
function gt(n, e) {
  if (n && !cr.has(e)) {
    var t;
    cr.add(e), (t = console).warn.apply(t, gu(e));
  }
}
function ki(n, e) {
  if (n && !cr.has(e)) {
    var t;
    cr.add(e), (t = console).error.apply(t, gu(e));
  }
}
function l1(n) {
  var e = !n, t = Object.prototype.toString.call(n) === "[object Object]" && !n.addEventListener;
  ki(e, ["tippy() was passed", "`" + String(n) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), ki(t, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var yu = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, c1 = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Ue = Object.assign({
  appendTo: hu,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, yu, c1), u1 = Object.keys(Ue), f1 = function(e) {
  process.env.NODE_ENV !== "production" && _u(e, []);
  var t = Object.keys(e);
  t.forEach(function(r) {
    Ue[r] = e[r];
  });
};
function bu(n) {
  var e = n.plugins || [], t = e.reduce(function(r, a) {
    var i = a.name, o = a.defaultValue;
    if (i) {
      var s;
      r[i] = n[i] !== void 0 ? n[i] : (s = Ue[i]) != null ? s : o;
    }
    return r;
  }, {});
  return Object.assign({}, n, t);
}
function d1(n, e) {
  var t = e ? Object.keys(bu(Object.assign({}, Ue, {
    plugins: e
  }))) : u1, r = t.reduce(function(a, i) {
    var o = (n.getAttribute("data-tippy-" + i) || "").trim();
    if (!o)
      return a;
    if (i === "content")
      a[i] = o;
    else
      try {
        a[i] = JSON.parse(o);
      } catch {
        a[i] = o;
      }
    return a;
  }, {});
  return r;
}
function Ds(n, e) {
  var t = Object.assign({}, e, {
    content: mu(e.content, [n])
  }, e.ignoreAttributes ? {} : d1(n, e.plugins));
  return t.aria = Object.assign({}, Ue.aria, t.aria), t.aria = {
    expanded: t.aria.expanded === "auto" ? e.interactive : t.aria.expanded,
    content: t.aria.content === "auto" ? e.interactive ? null : "describedby" : t.aria.content
  }, t;
}
function _u(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = []);
  var t = Object.keys(n);
  t.forEach(function(r) {
    var a = Wm(Ue, Object.keys(yu)), i = !qm(a, r);
    i && (i = e.filter(function(o) {
      return o.name === r;
    }).length === 0), gt(i, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var p1 = function() {
  return "innerHTML";
};
function Di(n, e) {
  n[p1()] = e;
}
function Ts(n) {
  var e = er();
  return n === !0 ? e.className = du : (e.className = pu, lr(n) ? e.appendChild(n) : Di(e, n)), e;
}
function Ms(n, e) {
  lr(e.content) ? (Di(n, ""), n.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? Di(n, e.content) : n.textContent = e.content);
}
function Ti(n) {
  var e = n.firstElementChild, t = Kr(e.children);
  return {
    box: e,
    content: t.find(function(r) {
      return r.classList.contains(fu);
    }),
    arrow: t.find(function(r) {
      return r.classList.contains(du) || r.classList.contains(pu);
    }),
    backdrop: t.find(function(r) {
      return r.classList.contains(Um);
    })
  };
}
function wu(n) {
  var e = er(), t = er();
  t.className = zm, t.setAttribute("data-state", "hidden"), t.setAttribute("tabindex", "-1");
  var r = er();
  r.className = fu, r.setAttribute("data-state", "hidden"), Ms(r, n.props), e.appendChild(t), t.appendChild(r), a(n.props, n.props);
  function a(i, o) {
    var s = Ti(e), l = s.box, u = s.content, c = s.arrow;
    o.theme ? l.setAttribute("data-theme", o.theme) : l.removeAttribute("data-theme"), typeof o.animation == "string" ? l.setAttribute("data-animation", o.animation) : l.removeAttribute("data-animation"), o.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? l.setAttribute("role", o.role) : l.removeAttribute("role"), (i.content !== o.content || i.allowHTML !== o.allowHTML) && Ms(u, n.props), o.arrow ? c ? i.arrow !== o.arrow && (l.removeChild(c), l.appendChild(Ts(o.arrow))) : l.appendChild(Ts(o.arrow)) : c && l.removeChild(c);
  }
  return {
    popper: e,
    onUpdate: a
  };
}
wu.$$tippy = !0;
var h1 = 1, $r = [], ja = [];
function m1(n, e) {
  var t = Ds(n, Object.assign({}, Ue, bu(Os(e)))), r, a, i, o = !1, s = !1, l = !1, u = !1, c, p, m, y = [], g = Ss(on, t.interactiveDebounce), b, w = h1++, C = null, S = Ym(t.plugins), A = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, h = {
    // properties
    id: w,
    reference: n,
    popper: er(),
    popperInstance: C,
    props: t,
    state: A,
    plugins: S,
    // methods
    clearDelayTimeouts: sn,
    setProps: Bt,
    setContent: ln,
    show: Cr,
    hide: Ea,
    hideWithInteractivity: ka,
    enable: At,
    disable: ht,
    unmount: Sr,
    destroy: Da
  };
  if (!t.render)
    return process.env.NODE_ENV !== "production" && ki(!0, "render() function has not been supplied."), h;
  var E = t.render(h), _ = E.popper, M = E.onUpdate;
  _.setAttribute("data-tippy-root", ""), _.id = "tippy-" + h.id, h.popper = _, n._tippy = h, _._tippy = h;
  var L = S.map(function($) {
    return $.fn(h);
  }), z = n.hasAttribute("aria-expanded");
  return xe(), W(), R(), T("onCreate", [h]), t.showOnCreate && Ot(), _.addEventListener("mouseenter", function() {
    h.props.interactive && h.state.isVisible && h.clearDelayTimeouts();
  }), _.addEventListener("mouseleave", function() {
    h.props.interactive && h.props.trigger.indexOf("mouseenter") >= 0 && F().addEventListener("mousemove", g);
  }), h;
  function U() {
    var $ = h.props.touch;
    return Array.isArray($) ? $ : [$, 0];
  }
  function V() {
    return U()[0] === "hold";
  }
  function J() {
    var $;
    return !!(($ = h.props.render) != null && $.$$tippy);
  }
  function G() {
    return b || n;
  }
  function F() {
    var $ = G().parentNode;
    return $ ? Xm($) : document;
  }
  function D() {
    return Ti(_);
  }
  function k($) {
    return h.state.isMounted && !h.state.isVisible || lt.isTouch || c && c.type === "focus" ? 0 : Fa(h.props.delay, $ ? 0 : 1, Ue.delay);
  }
  function R($) {
    $ === void 0 && ($ = !1), _.style.pointerEvents = h.props.interactive && !$ ? "" : "none", _.style.zIndex = "" + h.props.zIndex;
  }
  function T($, I, K) {
    if (K === void 0 && (K = !0), L.forEach(function(ae) {
      ae[$] && ae[$].apply(ae, I);
    }), K) {
      var oe;
      (oe = h.props)[$].apply(oe, I);
    }
  }
  function q() {
    var $ = h.props.aria;
    if ($.content) {
      var I = "aria-" + $.content, K = _.id, oe = pn(h.props.triggerTarget || n);
      oe.forEach(function(ae) {
        var be = ae.getAttribute(I);
        if (h.state.isVisible)
          ae.setAttribute(I, be ? be + " " + K : K);
        else {
          var Ae = be && be.replace(K, "").trim();
          Ae ? ae.setAttribute(I, Ae) : ae.removeAttribute(I);
        }
      });
    }
  }
  function W() {
    if (!(z || !h.props.aria.expanded)) {
      var $ = pn(h.props.triggerTarget || n);
      $.forEach(function(I) {
        h.props.interactive ? I.setAttribute("aria-expanded", h.state.isVisible && I === G() ? "true" : "false") : I.removeAttribute("aria-expanded");
      });
    }
  }
  function te() {
    F().removeEventListener("mousemove", g), $r = $r.filter(function($) {
      return $ !== g;
    });
  }
  function ie($) {
    if (!(lt.isTouch && (l || $.type === "mousedown"))) {
      var I = $.composedPath && $.composedPath()[0] || $.target;
      if (!(h.props.interactive && $s(_, I))) {
        if (pn(h.props.triggerTarget || n).some(function(K) {
          return $s(K, I);
        })) {
          if (lt.isTouch || h.state.isVisible && h.props.trigger.indexOf("click") >= 0)
            return;
        } else
          T("onClickOutside", [h, $]);
        h.props.hideOnClick === !0 && (h.clearDelayTimeouts(), h.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), h.state.isMounted || ye());
      }
    }
  }
  function ce() {
    l = !0;
  }
  function ue() {
    l = !1;
  }
  function le() {
    var $ = F();
    $.addEventListener("mousedown", ie, !0), $.addEventListener("touchend", ie, jt), $.addEventListener("touchstart", ue, jt), $.addEventListener("touchmove", ce, jt);
  }
  function ye() {
    var $ = F();
    $.removeEventListener("mousedown", ie, !0), $.removeEventListener("touchend", ie, jt), $.removeEventListener("touchstart", ue, jt), $.removeEventListener("touchmove", ce, jt);
  }
  function we($, I) {
    Ce($, function() {
      !h.state.isVisible && _.parentNode && _.parentNode.contains(_) && I();
    });
  }
  function me($, I) {
    Ce($, I);
  }
  function Ce($, I) {
    var K = D().box;
    function oe(ae) {
      ae.target === K && (Ba(K, "remove", oe), I());
    }
    if ($ === 0)
      return I();
    Ba(K, "remove", p), Ba(K, "add", oe), p = oe;
  }
  function de($, I, K) {
    K === void 0 && (K = !1);
    var oe = pn(h.props.triggerTarget || n);
    oe.forEach(function(ae) {
      ae.addEventListener($, I, K), y.push({
        node: ae,
        eventType: $,
        handler: I,
        options: K
      });
    });
  }
  function xe() {
    V() && (de("touchstart", Ye, {
      passive: !0
    }), de("touchend", Nt, {
      passive: !0
    })), Vm(h.props.trigger).forEach(function($) {
      if ($ !== "manual")
        switch (de($, Ye), $) {
          case "mouseenter":
            de("mouseleave", Nt);
            break;
          case "focus":
            de(i1 ? "focusout" : "blur", Ft);
            break;
          case "focusin":
            de("focusout", Ft);
            break;
        }
    });
  }
  function De() {
    y.forEach(function($) {
      var I = $.node, K = $.eventType, oe = $.handler, ae = $.options;
      I.removeEventListener(K, oe, ae);
    }), y = [];
  }
  function Ye($) {
    var I, K = !1;
    if (!(!h.state.isEnabled || xt($) || s)) {
      var oe = ((I = c) == null ? void 0 : I.type) === "focus";
      c = $, b = $.currentTarget, W(), !h.state.isVisible && Qm($) && $r.forEach(function(ae) {
        return ae($);
      }), $.type === "click" && (h.props.trigger.indexOf("mouseenter") < 0 || o) && h.props.hideOnClick !== !1 && h.state.isVisible ? K = !0 : Ot($), $.type === "click" && (o = !K), K && !oe && et($);
    }
  }
  function on($) {
    var I = $.target, K = G().contains(I) || _.contains(I);
    if (!($.type === "mousemove" && K)) {
      var oe = at().concat(_).map(function(ae) {
        var be, Ae = ae._tippy, $e = (be = Ae.popperInstance) == null ? void 0 : be.state;
        return $e ? {
          popperRect: ae.getBoundingClientRect(),
          popperState: $e,
          props: t
        } : null;
      }).filter(Boolean);
      e1(oe, $) && (te(), et($));
    }
  }
  function Nt($) {
    var I = xt($) || h.props.trigger.indexOf("click") >= 0 && o;
    if (!I) {
      if (h.props.interactive) {
        h.hideWithInteractivity($);
        return;
      }
      et($);
    }
  }
  function Ft($) {
    h.props.trigger.indexOf("focusin") < 0 && $.target !== G() || h.props.interactive && $.relatedTarget && _.contains($.relatedTarget) || et($);
  }
  function xt($) {
    return lt.isTouch ? V() !== $.type.indexOf("touch") >= 0 : !1;
  }
  function Lt() {
    pt();
    var $ = h.props, I = $.popperOptions, K = $.placement, oe = $.offset, ae = $.getReferenceClientRect, be = $.moveTransition, Ae = J() ? Ti(_).arrow : null, $e = ae ? {
      getBoundingClientRect: ae,
      contextElement: ae.contextElement || G()
    } : n, xr = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(d) {
        var v = d.state;
        if (J()) {
          var O = D(), P = O.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(N) {
            N === "placement" ? P.setAttribute("data-placement", v.placement) : v.attributes.popper["data-popper-" + N] ? P.setAttribute("data-" + N, "") : P.removeAttribute("data-" + N);
          }), v.attributes.popper = {};
        }
      }
    }, mt = [{
      name: "offset",
      options: {
        offset: oe
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !be
      }
    }, xr];
    J() && Ae && mt.push({
      name: "arrow",
      options: {
        element: Ae,
        padding: 3
      }
    }), mt.push.apply(mt, (I == null ? void 0 : I.modifiers) || []), h.popperInstance = ha($e, _, Object.assign({}, I, {
      placement: K,
      onFirstUpdate: m,
      modifiers: mt
    }));
  }
  function pt() {
    h.popperInstance && (h.popperInstance.destroy(), h.popperInstance = null);
  }
  function Xe() {
    var $ = h.props.appendTo, I, K = G();
    h.props.interactive && $ === hu || $ === "parent" ? I = K.parentNode : I = mu($, [K]), I.contains(_) || I.appendChild(_), h.state.isMounted = !0, Lt(), process.env.NODE_ENV !== "production" && gt(h.props.interactive && $ === Ue.appendTo && K.nextElementSibling !== _, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function at() {
    return Kr(_.querySelectorAll("[data-tippy-root]"));
  }
  function Ot($) {
    h.clearDelayTimeouts(), $ && T("onTrigger", [h, $]), le();
    var I = k(!0), K = U(), oe = K[0], ae = K[1];
    lt.isTouch && oe === "hold" && ae && (I = ae), I ? r = setTimeout(function() {
      h.show();
    }, I) : h.show();
  }
  function et($) {
    if (h.clearDelayTimeouts(), T("onUntrigger", [h, $]), !h.state.isVisible) {
      ye();
      return;
    }
    if (!(h.props.trigger.indexOf("mouseenter") >= 0 && h.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf($.type) >= 0 && o)) {
      var I = k(!1);
      I ? a = setTimeout(function() {
        h.state.isVisible && h.hide();
      }, I) : i = requestAnimationFrame(function() {
        h.hide();
      });
    }
  }
  function At() {
    h.state.isEnabled = !0;
  }
  function ht() {
    h.hide(), h.state.isEnabled = !1;
  }
  function sn() {
    clearTimeout(r), clearTimeout(a), cancelAnimationFrame(i);
  }
  function Bt($) {
    if (process.env.NODE_ENV !== "production" && gt(h.state.isDestroyed, un("setProps")), !h.state.isDestroyed) {
      T("onBeforeUpdate", [h, $]), De();
      var I = h.props, K = Ds(n, Object.assign({}, I, Os($), {
        ignoreAttributes: !0
      }));
      h.props = K, xe(), I.interactiveDebounce !== K.interactiveDebounce && (te(), g = Ss(on, K.interactiveDebounce)), I.triggerTarget && !K.triggerTarget ? pn(I.triggerTarget).forEach(function(oe) {
        oe.removeAttribute("aria-expanded");
      }) : K.triggerTarget && n.removeAttribute("aria-expanded"), W(), R(), M && M(I, K), h.popperInstance && (Lt(), at().forEach(function(oe) {
        requestAnimationFrame(oe._tippy.popperInstance.forceUpdate);
      })), T("onAfterUpdate", [h, $]);
    }
  }
  function ln($) {
    h.setProps({
      content: $
    });
  }
  function Cr() {
    process.env.NODE_ENV !== "production" && gt(h.state.isDestroyed, un("show"));
    var $ = h.state.isVisible, I = h.state.isDestroyed, K = !h.state.isEnabled, oe = lt.isTouch && !h.props.touch, ae = Fa(h.props.duration, 0, Ue.duration);
    if (!($ || I || K || oe) && !G().hasAttribute("disabled") && (T("onShow", [h], !1), h.props.onShow(h) !== !1)) {
      if (h.state.isVisible = !0, J() && (_.style.visibility = "visible"), R(), le(), h.state.isMounted || (_.style.transition = "none"), J()) {
        var be = D(), Ae = be.box, $e = be.content;
        La([Ae, $e], 0);
      }
      m = function() {
        var mt;
        if (!(!h.state.isVisible || u)) {
          if (u = !0, _.offsetHeight, _.style.transition = h.props.moveTransition, J() && h.props.animation) {
            var f = D(), d = f.box, v = f.content;
            La([d, v], ae), As([d, v], "visible");
          }
          q(), W(), xs(ja, h), (mt = h.popperInstance) == null || mt.forceUpdate(), T("onMount", [h]), h.props.animation && J() && me(ae, function() {
            h.state.isShown = !0, T("onShown", [h]);
          });
        }
      }, Xe();
    }
  }
  function Ea() {
    process.env.NODE_ENV !== "production" && gt(h.state.isDestroyed, un("hide"));
    var $ = !h.state.isVisible, I = h.state.isDestroyed, K = !h.state.isEnabled, oe = Fa(h.props.duration, 1, Ue.duration);
    if (!($ || I || K) && (T("onHide", [h], !1), h.props.onHide(h) !== !1)) {
      if (h.state.isVisible = !1, h.state.isShown = !1, u = !1, o = !1, J() && (_.style.visibility = "hidden"), te(), ye(), R(!0), J()) {
        var ae = D(), be = ae.box, Ae = ae.content;
        h.props.animation && (La([be, Ae], oe), As([be, Ae], "hidden"));
      }
      q(), W(), h.props.animation ? J() && we(oe, h.unmount) : h.unmount();
    }
  }
  function ka($) {
    process.env.NODE_ENV !== "production" && gt(h.state.isDestroyed, un("hideWithInteractivity")), F().addEventListener("mousemove", g), xs($r, g), g($);
  }
  function Sr() {
    process.env.NODE_ENV !== "production" && gt(h.state.isDestroyed, un("unmount")), h.state.isVisible && h.hide(), h.state.isMounted && (pt(), at().forEach(function($) {
      $._tippy.unmount();
    }), _.parentNode && _.parentNode.removeChild(_), ja = ja.filter(function($) {
      return $ !== h;
    }), h.state.isMounted = !1, T("onHidden", [h]));
  }
  function Da() {
    process.env.NODE_ENV !== "production" && gt(h.state.isDestroyed, un("destroy")), !h.state.isDestroyed && (h.clearDelayTimeouts(), h.unmount(), De(), delete n._tippy, h.state.isDestroyed = !0, T("onDestroy", [h]));
  }
}
function mr(n, e) {
  e === void 0 && (e = {});
  var t = Ue.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (l1(n), _u(e, t)), r1();
  var r = Object.assign({}, e, {
    plugins: t
  }), a = Zm(n);
  if (process.env.NODE_ENV !== "production") {
    var i = lr(r.content), o = a.length > 1;
    gt(i && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = a.reduce(function(l, u) {
    var c = u && m1(u, r);
    return c && l.push(c), l;
  }, []);
  return lr(n) ? s[0] : s;
}
mr.defaultProps = Ue;
mr.setDefaultProps = f1;
mr.currentInput = lt;
Object.assign({}, ru, {
  effect: function(e) {
    var t = e.state, r = {
      popper: {
        position: t.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow);
  }
});
mr.setDefaultProps({
  render: wu
});
const v1 = {
  name: "TooltipGenerator",
  props: {
    tag: {
      type: String,
      default: "span"
    },
    content: {
      type: String,
      default: ""
    },
    isHTMLContent: {
      type: Boolean,
      default: !1
    },
    underline: {
      type: Boolean,
      default: !1
    },
    trigger: {
      type: String,
      default: "mouseenter focus"
    }
  },
  data() {
    return {
      tippyInstance: null
    };
  },
  mounted() {
    this.anyContent && this.$nextTick(() => {
      this.initialize();
    });
  },
  watch: {
    content(n) {
      n.trim() !== "" ? (this.tippyInstance === null && this.initialize(), this.tippyInstance.enable(), this.tippyInstance.setContent(n)) : this.tippyInstance !== null && this.tippyInstance.disable();
    }
  },
  computed: {
    anyContent() {
      return this.content && this.content.trim() !== "";
    },
    computedUnderline() {
      return this.underline && this.anyContent;
    }
  },
  methods: {
    initialize() {
      this.tippyInstance = mr(this.$refs.target, {
        appendTo: this.$root.$el,
        arrow: Hm,
        placement: "top",
        animation: !1,
        content: this.content,
        allowHTML: this.isHTMLContent,
        trigger: this.trigger,
        hideOnClick: !1
      });
    }
  }
};
var g1 = function() {
  var e = this, t = e._self._c;
  return t(e.tag, { ref: "target", tag: "component", staticClass: "tooltip-target", class: { "tooltip-target--underlined": e.computedUnderline }, attrs: { tabindex: this.anyContent ? 0 : !1 } }, [e._t("default")], 2);
}, y1 = [], b1 = /* @__PURE__ */ ee(
  v1,
  g1,
  y1,
  !1,
  null,
  "6b6d5d0d"
);
const Mn = b1.exports;
Pe.add(Zc.faCopy, Xc.faCheck, eu.faExclamation);
const _1 = 2e3, w1 = {
  props: {
    // `copyValue` respects whitespace, but ignores "emptyString"
    copyValue: {
      type: String,
      default: null
    },
    showTooltip: {
      type: Boolean,
      default: !0
    },
    tooltipContent: {
      type: String,
      default: null
    },
    copyOnTextClicked: {
      type: Boolean,
      default: !0
    },
    highlightValue: {
      type: Boolean,
      default: !0
    },
    defaultSlotWrapperTag: {
      type: String,
      default: "span"
    }
  },
  data() {
    return {
      displayCopySuccess: !1,
      displayCopyError: !1,
      value: this.copyValue,
      checkmarkTimeout: null
    };
  },
  mounted() {
    var n;
    this.value = this.copyValue || ((n = this.$refs.defaultSlotWrapper) == null ? void 0 : n.innerText);
  },
  watch: {
    copyValue(n) {
      this.value = n;
    }
  },
  methods: {
    textClicked() {
      this.copyOnTextClicked && this.copyValueToClipboard();
    },
    iconClicked() {
      this.copyValueToClipboard();
    },
    copyValueToClipboard() {
      const n = this.value;
      n ? (navigator.clipboard.writeText(n).then(() => {
        this.displayCopySuccess = !0, this.displayCopyError = !1;
      }).catch((e) => {
        throw this.displayCopySuccess = !1, this.displayCopyError = !0, e;
      }), this.checkmarkTimeout && clearTimeout(this.checkmarkTimeout), this.checkmarkTimeout = setTimeout(() => this.displayCopySuccess = !1, _1)) : console.warn("No value to be copied!");
    },
    resetDisplayCopySuccess() {
      this.displayCopySuccess = !1, this.checkmarkTimeout && clearTimeout(this.checkmarkTimeout);
    }
  },
  computed: {
    computedTooltipContent() {
      var n;
      return !this.showTooltipOnHover || !this.value ? null : this.displayCopySuccess ? "Copied to clipboard" : (n = this.tooltipContent) != null && n.trim() ? this.tooltipContent : this.copyOnTextClicked ? `Click to copy '${this.value}' to clipboard` : `Click the icon to copy '${this.value}' to your clipboard`;
    },
    showTooltipOnHover() {
      return this.showTooltip && !this.highlightValueOnHover;
    },
    highlightValueOnHover() {
      return this.copyValue === null ? this.value && this.highlightValue : !1;
    }
  },
  components: {
    Tooltip: Mn,
    FontAwesomeIcon: Ie,
    FontAwesomeLayers: Kc
  }
};
var C1 = function() {
  var e = this, t = e._self._c;
  return t("Tooltip", { staticClass: "copy-to-clipboard", class: { "copy-to-clipboard--wrapper-clickable": e.copyOnTextClicked, "default-slot--highlight-on-hover": e.highlightValueOnHover }, attrs: { tag: "span", trigger: "mouseenter", content: e.computedTooltipContent, underline: e.copyOnTextClicked, "data-cy": "tooltip-wrapper" } }, [t(e.defaultSlotWrapperTag, { ref: "defaultSlotWrapper", tag: "component", staticClass: "default-slot__wrapper", attrs: { "data-cy": "default-slot__wrapper" }, on: { click: e.textClicked } }, [e._t("default", function() {
    return [e._v("The value that is copied to the clipboard")];
  })], 2), t("FontAwesomeLayers", { staticClass: "copy-icon__button", class: { "copy-icon__button--success": e.displayCopySuccess, "copy-icon__button--error": e.displayCopyError }, attrs: { role: "button", tabindex: "0", "data-cy": "copy-icon__button" }, on: { click: e.iconClicked } }, [t("FontAwesomeIcon", { attrs: { "fixed-width": "", icon: "copy", "data-cy": "copy-icon" } }), e.displayCopySuccess ? t("FontAwesomeIcon", { style: { color: "white" }, attrs: { "fixed-width": "", icon: "check", transform: "shrink-6 right-2", "data-cy": "check-icon" } }) : e.displayCopyError ? t("FontAwesomeIcon", { style: { color: "white" }, attrs: { "fixed-width": "", icon: "exclamation", transform: "shrink-6 right-2", "data-cy": "exclamation-icon" } }) : e._e()], 1)], 1);
}, S1 = [], x1 = /* @__PURE__ */ ee(
  w1,
  C1,
  S1,
  !1,
  null,
  "604d11bf"
);
const O1 = x1.exports, A1 = "unrux::clipboard::copy", $1 = da(A1);
async function Me(...n) {
  var e;
  typeof ((e = window.DD_RUM) == null ? void 0 : e.addAction) == "function" && window.DD_RUM.addAction(...n);
}
const Cu = "unrux::modal::show", E1 = "unrux::modal::hide", k1 = da(Cu), D1 = {
  name: "Modal",
  props: {
    id: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "normal",
      validator(n) {
        return ["normal", "wide", "extra-wide", "narrow", "fullscreen", null].includes(n);
      }
    },
    options: {
      type: Object,
      /* eslint-disable no-console */
      validator(n) {
        return n === null ? !0 : n.backdrop && !["clickable", "static"].includes(n.backdrop) ? (console.warn(`The 'backdrop' option value '${n.backdrop}' is not a valid option`), !1) : n.dismissible && typeof n.dismissible != "boolean" ? (console.warn("The 'dismissible' option value is not a valid boolean"), !1) : n.buttonAlignment && !["spreaded", "right", "left"].includes(n.buttonAlignment) ? (console.warn(`The 'buttonAlignment' option value '${n.buttonAlignment}' is not a valid option`), !1) : n.centerTitle && typeof n.centerTitle != "boolean" ? (console.warn("The 'centerTitle' option value is not a valid boolean"), !1) : n.padded && typeof n.padded != "boolean" ? (console.warn("The 'padded' option value is not a valid boolean"), !1) : !0;
      }
      /* eslint-enable no-console */
    }
  },
  data() {
    return {
      visible: !1,
      parameters: null,
      defaultOptions: {
        backdrop: "clickable",
        dismissible: !0,
        buttonAlignment: "spreaded",
        centerTitle: !1,
        padded: !1
      }
    };
  },
  computed: {
    modalWidthClass() {
      switch (this.type) {
        case "narrow":
          return "modal__surface--narrow";
        case "wide":
          return "modal__surface--wide";
        case "extra-wide":
          return "modal__surface--extra-wide";
        case "fullscreen":
          return "modal__surface--fullscreen";
        case "normal":
        default:
          return null;
      }
    },
    mergedOptions() {
      return {
        ...this.defaultOptions,
        ...this.options
      };
    }
  },
  methods: {
    openModal(n, e = null) {
      n === this.id && (this.addRumAction("opening"), this.$emit("open"), this.visible = !0, this.parameters = e);
    },
    closeModal(n = "directive") {
      this.addRumAction("closing", { method: n }), this.$emit("close"), this.visible = !1;
    },
    backdropClickListener() {
      const { backdrop: n, dismissible: e } = this.mergedOptions;
      e && n !== "static" && this.closeModal("backdrop");
    },
    listenOnRoot(n, e) {
      this.$root.$on(n, e), this.$on("hook:beforeDestroy", () => {
        this.$root.$off(n, e);
      });
    },
    addRumAction(n, e) {
      Me(`${n} modal`, {
        modalId: this.id,
        ...e
      });
    }
  },
  mounted() {
    this.listenOnRoot(Cu, this.openModal), this.listenOnRoot(E1, this.closeModal), this.escapeListener = document.addEventListener("keydown", (n) => {
      const e = n.code === "Escape";
      this.visible && e && this.closeModal("escape key");
    });
  },
  beforeDestroy() {
    this.escapeListener && document.removeEventListener(this.escapeListener);
  }
};
var T1 = function() {
  var e = this, t = e._self._c;
  return t("transition", { attrs: { name: "modal" } }, [t("div", { directives: [{ name: "show", rawName: "v-show", value: e.visible, expression: "visible" }], staticClass: "modal__backdrop", attrs: { id: e.id, "data-cy": "modal__backdrop" }, on: { click: e.backdropClickListener } }, [t("div", { class: ["modal__surface", e.modalWidthClass], attrs: { tabindex: "-1", role: "dialog", "aria-labelledby": `modal-title-${e.type}`, "aria-describedby": `modal-content-${e.type}` }, on: { click: function(r) {
    r.stopPropagation();
  } } }, [t("div", { staticClass: "modal__header" }, [t("h2", { class: ["modal__header__title", { "modal__header__title--centered": e.mergedOptions.centerTitle }, { "modal__header__title--centered--dismissible": e.mergedOptions.dismissible && e.mergedOptions.centerTitle }], attrs: { "data-cy": "modal__title" } }, [e._t("title", null, { parameters: e.parameters })], 2), e.mergedOptions.dismissible ? t("div", { staticClass: "modal__header-close", attrs: { "aria-label": "Close" }, on: { click: () => e.closeModal("close button") } }) : e._e()]), t("div", { staticClass: "modal__body modal__body--scrollable", class: { "modal__body--padded": e.mergedOptions.padded } }, [e._t("body", null, { parameters: e.parameters })], 2), t("div", { class: ["modal__footer", `modal__footer--${e.mergedOptions.buttonAlignment}`] }, [e._t("footer", null, { closeAction: () => e.closeModal("close callback"), parameters: e.parameters })], 2)])])]);
}, M1 = [], P1 = /* @__PURE__ */ ee(
  D1,
  T1,
  M1,
  !1,
  null,
  "3e05a537"
);
const Su = P1.exports;
function I1(n, e, t, r) {
  function a(i) {
    return i instanceof t ? i : new t(function(o) {
      o(i);
    });
  }
  return new (t || (t = Promise))(function(i, o) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (p) {
        o(p);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (p) {
        o(p);
      }
    }
    function u(c) {
      c.done ? i(c.value) : a(c.value).then(s, l);
    }
    u((r = r.apply(n, [])).next());
  });
}
function R1(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var N1 = function n(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var r, a, i;
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (a = r; a-- !== 0; )
        if (!n(e[a], t[a])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if (i = Object.keys(e), r = i.length, r !== Object.keys(t).length) return !1;
    for (a = r; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[a])) return !1;
    for (a = r; a-- !== 0; ) {
      var o = i[a];
      if (!n(e[o], t[o])) return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}, F1 = /* @__PURE__ */ R1(N1);
const Ps = "__googleMapsScriptId";
var gn;
(function(n) {
  n[n.INITIALIZED = 0] = "INITIALIZED", n[n.LOADING = 1] = "LOADING", n[n.SUCCESS = 2] = "SUCCESS", n[n.FAILURE = 3] = "FAILURE";
})(gn || (gn = {}));
class zt {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor({ apiKey: e, authReferrerPolicy: t, channel: r, client: a, id: i = Ps, language: o, libraries: s = [], mapIds: l, nonce: u, region: c, retries: p = 3, url: m = "https://maps.googleapis.com/maps/api/js", version: y }) {
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = e, this.authReferrerPolicy = t, this.channel = r, this.client = a, this.id = i || Ps, this.language = o, this.libraries = s, this.mapIds = l, this.nonce = u, this.region = c, this.retries = p, this.url = m, this.version = y, zt.instance) {
      if (!F1(this.options, zt.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(zt.instance.options)}`);
      return zt.instance;
    }
    zt.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? gn.FAILURE : this.done ? gn.SUCCESS : this.loading ? gn.LOADING : gn.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    let e = this.url;
    return e += "?callback=__googleMapsCallback&loading=async", this.apiKey && (e += `&key=${this.apiKey}`), this.channel && (e += `&channel=${this.channel}`), this.client && (e += `&client=${this.client}`), this.libraries.length > 0 && (e += `&libraries=${this.libraries.join(",")}`), this.language && (e += `&language=${this.language}`), this.region && (e += `&region=${this.region}`), this.version && (e += `&v=${this.version}`), this.mapIds && (e += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (e += `&auth_referrer_policy=${this.authReferrerPolicy}`), e;
  }
  deleteScript() {
    const e = document.getElementById(this.id);
    e && e.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((e, t) => {
      this.loadCallback((r) => {
        r ? t(r.error) : e(window.google);
      });
    });
  }
  importLibrary(e) {
    return this.execute(), google.maps.importLibrary(e);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(e) {
    this.callbacks.push(e), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var e, t;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const r = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(r).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (i) => !r[i] && delete r[i]
    ), !((t = (e = window == null ? void 0 : window.google) === null || e === void 0 ? void 0 : e.maps) === null || t === void 0) && t.importLibrary || ((i) => {
      let o, s, l, u = "The Google Maps JavaScript API", c = "google", p = "importLibrary", m = "__ib__", y = document, g = window;
      g = g[c] || (g[c] = {});
      const b = g.maps || (g.maps = {}), w = /* @__PURE__ */ new Set(), C = new URLSearchParams(), S = () => (
        // @ts-ignore
        o || (o = new Promise((A, h) => I1(this, void 0, void 0, function* () {
          var E;
          yield s = y.createElement("script"), s.id = this.id, C.set("libraries", [...w] + "");
          for (l in i)
            C.set(l.replace(/[A-Z]/g, (_) => "_" + _[0].toLowerCase()), i[l]);
          C.set("callback", c + ".maps." + m), s.src = this.url + "?" + C, b[m] = A, s.onerror = () => o = h(Error(u + " could not load.")), s.nonce = this.nonce || ((E = y.querySelector("script[nonce]")) === null || E === void 0 ? void 0 : E.nonce) || "", y.head.append(s);
        })))
      );
      b[p] ? console.warn(u + " only loads once. Ignoring:", i) : b[p] = (A, ...h) => w.add(A) && S().then(() => b[p](A, ...h));
    })(r);
    const a = this.libraries.map((i) => this.importLibrary(i));
    a.length || a.push(this.importLibrary("core")), Promise.all(a).then(() => this.callback(), (i) => {
      const o = new ErrorEvent("error", { error: i });
      this.loadErrorCallback(o);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(e) {
    if (this.errors.push(e), this.errors.length <= this.retries) {
      const t = this.errors.length * Math.pow(2, this.errors.length);
      console.error(`Failed to load Google Maps script, retrying in ${t} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, t);
    } else
      this.onerrorEvent = e, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((e) => {
      e(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), !this.loading)
      if (this.done)
        this.callback();
      else {
        if (window.google && window.google.maps && window.google.maps.version) {
          console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match."), this.callback();
          return;
        }
        this.loading = !0, this.setScript();
      }
  }
}
const L1 = {
  props: {
    mapConfig: Object,
    locationIsApproximated: Boolean,
    googleMapsApiKey: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      google: null,
      map: null
    };
  },
  async mounted() {
    try {
      const n = new zt({
        apiKey: this.googleMapsApiKey,
        version: "weekly",
        libraries: ["marker"]
      });
      this.google = await n.load(), this.initializeMap();
    } catch (n) {
      console.error("Failed to load Google Maps", n);
    }
  },
  methods: {
    initializeMap() {
      const n = this.$refs.googleMap;
      this.map = new this.google.maps.Map(n, this.mapConfig), this.$root.$emit("MapInitialised", this.map, this.google);
    }
  }
};
var B1 = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "location-map-container" }, [e.locationIsApproximated ? t("div", { staticClass: "location-map-is-approximated" }, [e._v(" " + e._s(e.$t("navigation.infinity.address_approximated")) + " ")]) : e._e(), t("div", { ref: "googleMap", attrs: { id: "store-location-map" } }), e.google && e.map ? [e._t("default", null, { google: e.google, map: e.map })] : e._e()], 2);
}, j1 = [], H1 = /* @__PURE__ */ ee(
  L1,
  B1,
  j1,
  !1,
  null,
  null
);
const z1 = H1.exports, U1 = {
  components: {
    GoogleMapLoader: z1
  },
  props: ["name", "addressFull", "lat", "long", "translations", "googleMapsInfo"],
  data() {
    return {
      marker: null,
      showMap: !0,
      google: null,
      map: null,
      locationIsApproximated: !1
    };
  },
  computed: {
    address() {
      let n;
      return this.addressFull.address || this.addressFull.city ? n = (this.addressFull.address !== null ? this.addressFull.address + ", " : "") + (this.addressFull.postal_code !== null ? this.addressFull.postal_code + ", " : "") + (this.addressFull.city !== null ? this.addressFull.city : "") : n = this.addressFull.join(", "), n;
    },
    mapConfig() {
      return {
        clickableIcons: !1,
        zoom: 14,
        mapTypeControl: !1,
        streetViewControl: !1,
        scrollwheel: !1,
        mapId: this.googleMapsInfo.mapId
      };
    }
  },
  methods: {
    setMarkerInCenterMap() {
      if (Is(this.lat) && Is(this.long)) {
        const n = {
          lat: parseFloat(this.lat),
          lng: parseFloat(this.long)
        };
        this.map.setCenter(n), this.marker = new this.google.maps.marker.AdvancedMarkerElement({
          map: this.map,
          position: n,
          title: this.name
        });
      } else
        this.addressLookup();
    },
    addressLookup() {
      new this.google.maps.Geocoder().geocode({ address: this.address }, (e, t) => {
        if (t !== "OK" || !e[0])
          throw this.showMap = !1, new Error(t);
        this.locationIsApproximated = !0;
        const r = e[0].geometry.location;
        this.map.setCenter(r), this.marker.setPosition(r);
      });
    }
  },
  /* The map that is loaded will be fired from this created event (gmaps is initialised)
   * This event is (and should) only be fired once, otherwise it will keep adding listeners.
   * */
  created() {
    this.$root.$once("MapInitialised", (n, e) => {
      this.map = n, this.google = e, this.setMarkerInCenterMap();
    });
  }
};
function Is(n) {
  let e = Number.parseFloat(n);
  return !Number.isNaN(e) && !Number.isInteger(e);
}
var q1 = function() {
  var e = this, t = e._self._c;
  return e.showMap ? t("GoogleMapLoader", { attrs: { mapConfig: e.mapConfig, locationIsApproximated: e.locationIsApproximated, "google-maps-api-key": e.googleMapsInfo.apiKey } }, [e._t("default", null, { google: e.google, map: e.map })], 2) : e._e();
}, W1 = [], V1 = /* @__PURE__ */ ee(
  U1,
  q1,
  W1,
  !1,
  null,
  null
);
const wo = V1.exports, Y1 = {
  infinity: {
    store: "Store",
    division: "Division",
    customer_organization: "Organization",
    address: "Address",
    address_approximated: "The location was approximated based on the address",
    division_plural: "Divisions",
    store_plural: "Stores"
  }
}, K1 = {
  navigation: Y1
}, G1 = K1;
window.translations || (window.translations = G1);
const Q1 = {
  props: ["name", "address", "lat", "long", "googleMapsInfo"],
  components: {
    SingleMarkerMap: wo
  },
  data: function() {
    return {
      translations: window.translations
    };
  }
};
var J1 = function() {
  var e = this, t = e._self._c;
  return t("single-marker-map", { attrs: { "address-full": e.address, lat: e.lat, long: e.long, name: e.name, translations: e.translations, "google-maps-info": e.googleMapsInfo } });
}, Z1 = [], X1 = /* @__PURE__ */ ee(
  Q1,
  J1,
  Z1,
  !1,
  null,
  null
);
const ev = X1.exports;
function tv(n) {
  var e = typeof n;
  return n != null && (e == "object" || e == "function");
}
var St = tv, nv = typeof Dt == "object" && Dt && Dt.Object === Object && Dt, xu = nv, rv = xu, av = typeof self == "object" && self && self.Object === Object && self, iv = rv || av || Function("return this")(), nt = iv, ov = nt, sv = function() {
  return ov.Date.now();
}, lv = sv, cv = /\s/;
function uv(n) {
  for (var e = n.length; e-- && cv.test(n.charAt(e)); )
    ;
  return e;
}
var fv = uv, dv = fv, pv = /^\s+/;
function hv(n) {
  return n && n.slice(0, dv(n) + 1).replace(pv, "");
}
var mv = hv, vv = nt, gv = vv.Symbol, ma = gv, Rs = ma, Ou = Object.prototype, yv = Ou.hasOwnProperty, bv = Ou.toString, Vn = Rs ? Rs.toStringTag : void 0;
function _v(n) {
  var e = yv.call(n, Vn), t = n[Vn];
  try {
    n[Vn] = void 0;
    var r = !0;
  } catch {
  }
  var a = bv.call(n);
  return r && (e ? n[Vn] = t : delete n[Vn]), a;
}
var wv = _v, Cv = Object.prototype, Sv = Cv.toString;
function xv(n) {
  return Sv.call(n);
}
var Ov = xv, Ns = ma, Av = wv, $v = Ov, Ev = "[object Null]", kv = "[object Undefined]", Fs = Ns ? Ns.toStringTag : void 0;
function Dv(n) {
  return n == null ? n === void 0 ? kv : Ev : Fs && Fs in Object(n) ? Av(n) : $v(n);
}
var Pn = Dv;
function Tv(n) {
  return n != null && typeof n == "object";
}
var nn = Tv, Mv = Pn, Pv = nn, Iv = "[object Symbol]";
function Rv(n) {
  return typeof n == "symbol" || Pv(n) && Mv(n) == Iv;
}
var va = Rv, Nv = mv, Ls = St, Fv = va, Bs = NaN, Lv = /^[-+]0x[0-9a-f]+$/i, Bv = /^0b[01]+$/i, jv = /^0o[0-7]+$/i, Hv = parseInt;
function zv(n) {
  if (typeof n == "number")
    return n;
  if (Fv(n))
    return Bs;
  if (Ls(n)) {
    var e = typeof n.valueOf == "function" ? n.valueOf() : n;
    n = Ls(e) ? e + "" : e;
  }
  if (typeof n != "string")
    return n === 0 ? n : +n;
  n = Nv(n);
  var t = Bv.test(n);
  return t || jv.test(n) ? Hv(n.slice(2), t ? 2 : 8) : Lv.test(n) ? Bs : +n;
}
var Uv = zv, qv = St, Ha = lv, js = Uv, Wv = "Expected a function", Vv = Math.max, Yv = Math.min;
function Kv(n, e, t) {
  var r, a, i, o, s, l, u = 0, c = !1, p = !1, m = !0;
  if (typeof n != "function")
    throw new TypeError(Wv);
  e = js(e) || 0, qv(t) && (c = !!t.leading, p = "maxWait" in t, i = p ? Vv(js(t.maxWait) || 0, e) : i, m = "trailing" in t ? !!t.trailing : m);
  function y(_) {
    var M = r, L = a;
    return r = a = void 0, u = _, o = n.apply(L, M), o;
  }
  function g(_) {
    return u = _, s = setTimeout(C, e), c ? y(_) : o;
  }
  function b(_) {
    var M = _ - l, L = _ - u, z = e - M;
    return p ? Yv(z, i - L) : z;
  }
  function w(_) {
    var M = _ - l, L = _ - u;
    return l === void 0 || M >= e || M < 0 || p && L >= i;
  }
  function C() {
    var _ = Ha();
    if (w(_))
      return S(_);
    s = setTimeout(C, b(_));
  }
  function S(_) {
    return s = void 0, m && r ? y(_) : (r = a = void 0, o);
  }
  function A() {
    s !== void 0 && clearTimeout(s), u = 0, r = l = a = s = void 0;
  }
  function h() {
    return s === void 0 ? o : S(Ha());
  }
  function E() {
    var _ = Ha(), M = w(_);
    if (r = arguments, a = this, l = _, M) {
      if (s === void 0)
        return g(l);
      if (p)
        return clearTimeout(s), s = setTimeout(C, e), y(l);
    }
    return s === void 0 && (s = setTimeout(C, e)), o;
  }
  return E.cancel = A, E.flush = h, E;
}
var Gv = Kv;
const vr = /* @__PURE__ */ tn(Gv);
/*!
 * Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 */
var Qv = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [448, 512, [], "f078", "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"]
}, Au = {
  prefix: "fas",
  iconName: "search",
  icon: [512, 512, [], "f002", "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"]
}, Jv = {
  prefix: "fas",
  iconName: "sort-down",
  icon: [320, 512, [], "f0dd", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"]
}, Zv = {
  prefix: "fas",
  iconName: "sort-up",
  icon: [320, 512, [], "f0de", "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"]
}, Xv = {
  prefix: "fas",
  iconName: "spinner",
  icon: [512, 512, [], "f110", "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"]
}, eg = {
  prefix: "fas",
  iconName: "times",
  icon: [352, 512, [], "f00d", "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"]
};
const tg = {
  name: "sameWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: n }) => {
    n.styles.popper.width = `${n.rects.reference.width}px`;
  },
  effect: ({ state: n }) => {
    n.elements.popper.style.width = `${n.elements.reference.offsetWidth}px`;
  }
};
Pe.add(Au, Xv);
const ng = {
  name: "Autocomplete",
  props: {
    placeholder: String,
    disabled: Boolean,
    buildQueryUrl: Function,
    wrapperClass: String,
    debounce: {
      type: Number,
      default: 500
    },
    inputClass: {
      type: String,
      default: "form-field__input"
    },
    getOptionKey: {
      type: Function,
      default: (n) => n
    },
    getOptionText: {
      type: Function,
      default: (n) => n.toString()
    },
    value: Object
  },
  data() {
    return {
      query: "",
      cachedQuery: null,
      options: [],
      loading: !1,
      error: !1,
      focused: !1,
      popperInstance: null,
      selectIndex: -1
    };
  },
  beforeDestroy() {
    this.popperInstance && this.popperInstance.destroy();
  },
  computed: {
    searchContentDebounced() {
      return vr(this.searchContent, this.debounce);
    },
    resultsExpanded() {
      return this.focused && this.options.length > 0;
    }
  },
  watch: {
    query(n, e) {
      const t = n === this.cachedQuery, r = this.value && this.getOptionTextStripHtml(this.value) === n;
      t || r || e !== n && this.searchContentDebounced(n);
    },
    resultsExpanded(n) {
      const { input: e, results: t, popperInstance: r } = this.$refs;
      n && !r && (this.popperInstance = ha(e, t, {
        modifiers: [tg]
      })), !n && r && (r.destroy(), this.popperInstance = null);
    },
    value: {
      immediate: !0,
      handler(n) {
        n && this.setQueryToOption(n);
      }
    }
  },
  methods: {
    onFocus() {
      this.selectIndex = -1, this.query = this.cachedQuery, this.focused = !0;
    },
    onBlur() {
      const { value: n } = this;
      this.focused = !1, this.cachedQuery = this.query, n && this.setQueryToOption(n), this.$emit("blur");
    },
    onArrowUp() {
      this.selectIndex = Math.max(this.selectIndex - 1, -1);
    },
    onArrowDown() {
      this.selectIndex = Math.min(this.selectIndex + 1, this.options.length - 1);
    },
    onEnter() {
      this.selectIndex !== -1 && this.onSelect(this.options[this.selectIndex]);
    },
    setQueryToOption(n) {
      this.query = this.getOptionTextStripHtml(n);
    },
    onSelect(n) {
      const { input: e } = this.$refs;
      this.$emit("input", n), e.blur();
    },
    getOptionTextStripHtml(n) {
      return this.getOptionText(n).replace(/<[^>]*>?/gm, "");
    },
    highlightSearch(n) {
      return this.query ? n.replace(new RegExp(`(${this.query})`, "gi"), "<strong>$1</strong>") : n;
    },
    async searchContent(n) {
      const { buildQueryUrl: e, focused: t } = this;
      if (t) {
        if (n && n.length < 2) {
          this.options = [];
          return;
        }
        this.loading = !0;
        try {
          const r = await fetch(e(n));
          this.options = await r.json(), this.$emit("options-change", this.options);
        } catch {
          this.options = [];
        } finally {
          this.loading = !1;
        }
      }
    }
  },
  components: {
    FontAwesomeIcon: Ie
  }
};
var rg = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "autocomplete-wrapper", class: [e.wrapperClass], attrs: { "data-cy": "autocomplete-wrapper" } }, [t("div", { staticClass: "icon-container" }, [t("FontAwesomeIcon", { staticClass: "input-prefix-icon", attrs: { spin: e.loading, prefix: "fa", icon: e.loading ? "spinner" : "search" } })], 1), t("input", { directives: [{ name: "model", rawName: "v-model", value: e.query, expression: "query" }], ref: "input", class: e.inputClass, attrs: { type: "text", placeholder: e.placeholder, "data-cy": "autocomplete-input" }, domProps: { value: e.query }, on: { focus: function(r) {
    return r.preventDefault(), e.onFocus.apply(null, arguments);
  }, blur: function(r) {
    return r.preventDefault(), e.onBlur.apply(null, arguments);
  }, keyup: [function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "enter", 13, r.key, "Enter") ? null : e.onEnter.apply(null, arguments);
  }, function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "down", 40, r.key, ["Down", "ArrowDown"]) ? null : e.onArrowDown.apply(null, arguments);
  }, function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "up", 38, r.key, ["Up", "ArrowUp"]) ? null : e.onArrowUp.apply(null, arguments);
  }], input: function(r) {
    r.target.composing || (e.query = r.target.value);
  } } }), t("div", { ref: "results", attrs: { "data-cy": "autocomplete-list-wrapper" } }, [e.resultsExpanded ? t("ul", { staticClass: "search-options", attrs: { "data-cy": "autocomplete-list" } }, e._l(e.options, function(r, a) {
    return t("li", { key: e.getOptionKey(r), attrs: { "data-is-selected": a === e.selectIndex }, domProps: { innerHTML: e._s(e.highlightSearch(e.getOptionText(r))) }, on: { mousedown: function(i) {
      return i.preventDefault(), (() => e.onSelect(r)).apply(null, arguments);
    } } });
  }), 0) : e._e()])]);
}, ag = [], ig = /* @__PURE__ */ ee(
  ng,
  rg,
  ag,
  !1,
  null,
  "178e93b1"
);
const og = ig.exports;
var sg = {
  name: "maxSize",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["offset", "preventOverflow", "flip"],
  fn: function(e) {
    var t = e.state, r = e.name, a = e.options, i = An(t, a), o = t.modifiersData.preventOverflow || {
      x: 0,
      y: 0
    }, s = o.x, l = o.y, u = t.rects.popper, c = u.width, p = u.height, m = t.placement.split("-"), y = m[0], g = y === "left" ? "left" : "right", b = y === "top" ? "top" : "bottom";
    t.modifiersData[r] = {
      width: c - i[g] - s,
      height: p - i[b] - l
    };
  }
};
const lg = {
  name: "applyMaxSize",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["maxSize"],
  fn({ state: n }) {
    const { height: e } = n.modifiersData.maxSize, t = 10;
    n.styles.popper.maxHeight = `${e - t}px`;
  }
}, cg = [sg, lg], ug = {
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    placement: {
      default: "bottom-end"
    },
    offset: {
      type: Array,
      default: () => [-5, 5]
    }
  },
  data() {
    return {
      dropdownVisible: !1,
      popperInstance: null
    };
  },
  watch: {
    dropdownVisible(n) {
      n ? this.popperInstance = this.initiatePopper() : (this.popperInstance.destroy(), this.popperInstance = null);
    }
  },
  methods: {
    openDropdown() {
      this.disabled || (this.dropdownVisible = !0);
    },
    closeDropDown() {
      this.dropdownVisible = !1;
    },
    initiatePopper() {
      const { trigger: n, content: e } = this.$refs;
      return ha(n, e, {
        strategy: "fixed",
        placement: this.placement,
        modifiers: [{
          name: "offset",
          options: { offset: this.offset }
        }, ...cg]
      });
    }
  }
};
var fg = function() {
  var e = this, t = e._self._c;
  return t("div", [t("div", { directives: [{ name: "show", rawName: "v-show", value: e.dropdownVisible, expression: "dropdownVisible" }], staticClass: "dropdown-backdrop", on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.closeDropDown.apply(null, arguments);
  } } }), t("span", { ref: "trigger", on: { click: function(r) {
    return r.preventDefault(), r.stopPropagation(), e.openDropdown.apply(null, arguments);
  } } }, [e._t("trigger", function() {
    return [e._v("Click here to open dropdown")];
  })], 2), t("div", { directives: [{ name: "show", rawName: "v-show", value: e.dropdownVisible, expression: "dropdownVisible" }], ref: "content", staticClass: "dropdown-container" }, [e._t("content", function() {
    return [e._v("No dropdown content")];
  }, { closeAction: e.closeDropDown })], 2)]);
}, dg = [], pg = /* @__PURE__ */ ee(
  ug,
  fg,
  dg,
  !1,
  null,
  "9c5bacbc"
);
const $u = pg.exports;
var hg = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128" } }, n.$listeners), [t("rect", { attrs: { width: "53", height: "53", x: ".5", fill: "#fff", rx: "8", ry: "8" } }), t("rect", { attrs: { width: "53", height: "53", y: "75", fill: "#fff", rx: "8", ry: "8" } }), t("rect", { attrs: { width: "53", height: "53", x: "75", y: "75", fill: "#fff", rx: "8", ry: "8" } }), t("rect", { attrs: { width: "53", height: "53", x: "75", fill: "#fff", rx: "8", ry: "8" } })]);
};
const mg = {
  render: hg
}, za = [
  { id: "analytics", name: "Analytics", domains: ["analytics"], visible: !0 },
  { id: "device_management", name: "Device Management", domains: ["devicemanagement", "dm", "devices"], visible: !0 },
  { id: "idcloud", name: "iD Cloud", domains: ["idcloud"], visible: !0 },
  { id: "lpcloud_web", name: "iD Cloud Loss Prevention", domains: ["lossprevention", "lpcloud"], visible: !0 }
], vg = {
  props: {
    // The application_preferences are specified in DM; see app/models/retail_applications_policy.rb
    applicationPreferences: {
      type: Array,
      default: () => []
    }
  },
  beforeMount() {
    this.hideCurrentAppFromDropdownList();
  },
  data() {
    return {};
  },
  computed: {
    isLocalhost() {
      return window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    },
    splittedHostname() {
      return window.location.hostname.split(".");
    },
    applicationWithEnvironmentFromUrl() {
      return this.splittedHostname[0];
    },
    applicationFromUrl() {
      return this.applicationWithEnvironmentFromUrl.split("-")[0];
    },
    localization() {
      return this.splittedHostname[this.splittedHostname.length - 1];
    },
    environment() {
      const n = this.applicationWithEnvironmentFromUrl.split("-");
      return n.length > 1 ? "-" + n.pop() : "";
    },
    protocol() {
      return window.location.protocol;
    },
    pathname() {
      return window.location.pathname;
    },
    dropdownListContent() {
      return za.filter((n) => n.visible && this.applicationPreferences.includes(n.id));
    },
    currentApplication() {
      return za.find((n) => n.domains.includes(this.applicationFromUrl)) || {};
    }
  },
  methods: {
    hideCurrentAppFromDropdownList() {
      this.currentApplication.visible = !1;
    },
    isDeviceManagement(n) {
      return za.find((e) => e.id === "device_management" && e.domains.includes(n));
    },
    currentTarget(n) {
      const t = /(customer_organizations|divisions|stores)(\/\d*)?/g.exec(this.pathname);
      return t == null ? "" : this.isDeviceManagement(n) ? "manage/" + t[0] : t[0];
    },
    applicationWithTargetUrl(n) {
      return this.isLocalhost ? "https://" + n + "-test.nedapretail.com/" + this.currentTarget(n) : this.protocol + "//" + n + this.environment + ".nedapretail." + this.localization + "/" + this.currentTarget(n);
    }
  },
  components: {
    SimpleDropdown: $u,
    UnruxSwitcherIcon: mg
  }
};
var gg = function() {
  var e = this, t = e._self._c;
  return t("simple-dropdown", { scopedSlots: e._u([{ key: "trigger", fn: function() {
    return [t("div", { class: ["switcher", `switcher-${e.currentApplication.id}`] }, [t("UnruxSwitcherIcon", { staticClass: "switcher__icon" })], 1)];
  }, proxy: !0 }, { key: "content", fn: function() {
    return [e.dropdownListContent.length > 0 ? t("ul", { staticClass: "application-list" }, e._l(e.dropdownListContent, function(r) {
      return t("li", { key: r.id }, [t("a", { attrs: { href: e.applicationWithTargetUrl(r.domains[0]), target: "_blank" } }, [e._v(e._s(r.name))])]);
    }), 0) : t("div", { staticClass: "missing-applications" }, [e._v("You don't have application preferences.")])];
  }, proxy: !0 }]) });
}, yg = [], bg = /* @__PURE__ */ ee(
  vg,
  gg,
  yg,
  !1,
  null,
  "900f3545"
);
const _g = bg.exports, wg = {
  props: {
    applicationRootPath: {
      type: String
    },
    showApplicationSwitcher: {
      type: Boolean,
      default: !1
    },
    applicationPreferences: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showSearchAndActions() {
      return !!this.$slots.search || !!this.$slots.actions;
    }
  },
  components: {
    ApplicationSwitcher: _g
  }
};
var Cg = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "header-bar" }, [t("div", { class: ["application", { "application--clickable": e.applicationRootPath }] }, [t("a", { staticClass: "application--link", attrs: { href: e.applicationRootPath } }, [t("h1", { staticClass: "application-name" }, [e._t("name")], 2)]), e.showApplicationSwitcher ? t("application-switcher", { staticClass: "application-switcher", attrs: { "application-preferences": e.applicationPreferences } }) : e._e()], 1), e.showSearchAndActions ? t("div", { staticClass: "search-and-actions", attrs: { id: "search-and-actions" } }, [e._t("search"), t("div", { staticClass: "actions" }, [e._t("actions")], 2)], 2) : e._e()]);
}, Sg = [], xg = /* @__PURE__ */ ee(
  wg,
  Cg,
  Sg,
  !1,
  null,
  "a7b659cc"
);
const Og = xg.exports;
function Hs(n) {
  switch (n) {
    case "staging":
      return "EU Staging";
    case "production":
      return "EU Production";
    case "us_staging":
      return "US Staging";
    case "us_production":
      return "US Production";
    case "development":
      return "Development";
    default:
      return null;
  }
}
var Ag = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 751.72 494.06" } }, n.$listeners), [t("path", { attrs: { fill: "currentColor", d: "M359.86 347a37.5 37.5 0 0 0-15.7-11.61q-10-4.2-25.69-4.19H292v109.61h26.44q15.69 0 25.69-4.2A37.5 37.5 0 0 0 359.86 425a42.11 42.11 0 0 0 7.74-17.41 115.48 115.48 0 0 0 0-43.22 42.11 42.11 0 0 0-7.74-17.37Z" } }), t("path", { attrs: { fill: "currentColor", d: "M150.05 382.66c0-1.49 0-3 .08-4.46a45.47 45.47 0 0 1-4-18.7v-23.9a45.44 45.44 0 0 1 22.1-39l23.72-14.21a140.8 140.8 0 0 1 99.37-41h94.78v-4.29a11.36 11.36 0 0 0-3.3-8l-9.4-9.4a11.36 11.36 0 0 0-8-3.3h-16a11.31 11.31 0 0 1-8-19.3l9.4-9.4a11.36 11.36 0 0 1 8-3.3h32a11.35 11.35 0 0 0 11.3-11.3v-9.4a11.35 11.35 0 0 0-11.3-11.3h-36.7a16 16 0 0 0-16 16v4.5a16 16 0 0 1-10.9 15.2l-31.6 10.5a8 8 0 0 0-5.5 7.6v2.2a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8 8 8 0 0 0-8-8H247a8.15 8.15 0 0 0-7.2 4.4l-9.4 18.7a15.92 15.92 0 0 1-14.3 8.8H194a16 16 0 0 1-16-16V191a16.06 16.06 0 0 1 4.7-11.3l20.1-20.1a24.74 24.74 0 0 0 7.2-17.5 8 8 0 0 1 5.5-7.6l40-13.3a11.64 11.64 0 0 0 4.4-2.7l26.8-26.8a11.31 11.31 0 0 0-8-19.3H258l-16 16v8a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-20a8.05 8.05 0 0 1 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3 108.29 0 196.6 86.16 200.08 193.42h48C492.43 107.46 382.8 0 248 0 111 0 0 111 0 248c0 121.12 86.76 221.9 201.54 243.64a141 141 0 0 1-51.49-108.98Zm-20-241.56a11.36 11.36 0 0 1 3.3-8l25.4-25.4a11.31 11.31 0 0 1 19.3 8v16a11.36 11.36 0 0 1-3.3 8l-9.4 9.4a11.36 11.36 0 0 1-8 3.3h-16a11.35 11.35 0 0 1-11.25-11.3Z" } }), t("path", { attrs: { fill: "currentColor", d: "M640.31 271.25h-349a111.41 111.41 0 1 0 0 222.81h349a111.41 111.41 0 1 0 0-222.81ZM392.54 415.87a70.14 70.14 0 0 1-12.15 24.4 56.74 56.74 0 0 1-21.07 16.45q-12.9 6-30.53 6h-63.64V309.23h63.64q17.63 0 30.53 6a56.72 56.72 0 0 1 21.07 16.44 70.28 70.28 0 0 1 12.15 24.41 114.19 114.19 0 0 1 0 59.77Zm139.85 46.87h-112V309.23h110.5v23.22h-83.64v40.2h77.4v21.93h-77.4v44.94h85.14Zm87.08 0h-29.89l-51.17-153.51h28l38.44 121.47h.43l39.34-121.47h27.31Z" } })]);
};
const $g = {
  render: Ag
};
var Eg = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 731.31 494.32" } }, n.$listeners), [t("path", { attrs: { fill: "currentColor", d: "M150.31 382.66c0-1.32 0-2.64.06-4a45.43 45.43 0 0 1-4.27-19.21V335.6a45.44 45.44 0 0 1 22.1-39l24.67-14.78a140.51 140.51 0 0 1 98.42-40.14h94.81v-4.58a11.36 11.36 0 0 0-3.3-8l-9.4-9.4a11.36 11.36 0 0 0-8-3.3h-16a11.31 11.31 0 0 1-8-19.3l9.4-9.4a11.36 11.36 0 0 1 8-3.3h32a11.35 11.35 0 0 0 11.3-11.3v-9.4a11.35 11.35 0 0 0-11.3-11.3h-36.7a16 16 0 0 0-16 16v4.5a16 16 0 0 1-10.9 15.2l-31.6 10.5a8 8 0 0 0-5.5 7.6v2.2a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8 8 8 0 0 0-8-8H247a8.15 8.15 0 0 0-7.2 4.4l-9.4 18.7a15.92 15.92 0 0 1-14.3 8.8H194a16 16 0 0 1-16-16V191a16.06 16.06 0 0 1 4.7-11.3l20.1-20.1a24.74 24.74 0 0 0 7.2-17.5 8 8 0 0 1 5.5-7.6l40-13.3a11.64 11.64 0 0 0 4.4-2.7l26.8-26.8a11.31 11.31 0 0 0-8-19.3H258l-16 16v8a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-20a8.05 8.05 0 0 1 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3 108.38 0 196.74 86.29 200.09 193.68h48C492.57 107.6 382.89 0 248 0 111 0 0 111 0 248c0 121.31 87 222.22 202.08 243.74a140.75 140.75 0 0 1-51.77-109.08ZM130.1 141.1a11.36 11.36 0 0 1 3.3-8l25.4-25.4a11.31 11.31 0 0 1 19.3 8v16a11.36 11.36 0 0 1-3.3 8l-9.4 9.4a11.36 11.36 0 0 1-8 3.3h-16a11.35 11.35 0 0 1-11.3-11.3Z" } }), t("path", { attrs: { fill: "currentColor", d: "M619.65 271H291.29a111.67 111.67 0 1 0 0 223.33h328.36a111.67 111.67 0 0 0 0-223.33ZM377.17 462.74h-112V309.23h110.49v23.22H292v40.2h77.4v21.93H292v44.94h85.14Zm147.7-55.26q0 14.83-4.52 25.8a49.58 49.58 0 0 1-12.79 18.38 53.38 53.38 0 0 1-19.89 11.08 93 93 0 0 1-51.6 0 53.26 53.26 0 0 1-19.88-11.08 49.61 49.61 0 0 1-12.8-18.38q-4.51-11-4.51-25.8v-98.25h26.87v89.44q0 7.74.76 15.69a35.74 35.74 0 0 0 4.3 14.3 27.3 27.3 0 0 0 10.75 10.43q7.2 4.08 20.31 4.08t20.32-4.08a27.36 27.36 0 0 0 10.75-10.43 35.74 35.74 0 0 0 4.3-14.3q.75-8 .75-15.69v-89.44h26.88Zm141.57 32.79a44.71 44.71 0 0 1-13.86 14.94A60.33 60.33 0 0 1 633 463.7a93.65 93.65 0 0 1-22.36 2.69 92 92 0 0 1-24.72-3.22 57.9 57.9 0 0 1-20.21-9.89 48.24 48.24 0 0 1-13.71-17.1q-5.16-10.43-5.38-24.61h26.88a34.32 34.32 0 0 0 3 15.05 27.09 27.09 0 0 0 8.38 10.21 35.57 35.57 0 0 0 12.36 5.8 59.71 59.71 0 0 0 15.16 1.83 48.73 48.73 0 0 0 15-2 30.36 30.36 0 0 0 10.1-5.27 18.94 18.94 0 0 0 5.59-7.42 22.11 22.11 0 0 0 1.73-8.49q0-8.81-4-13a22.9 22.9 0 0 0-8.71-5.91 185.94 185.94 0 0 0-19-5.7q-10.86-2.69-26.77-7a57.22 57.22 0 0 1-16.44-6.78 39 39 0 0 1-10.43-9.35 32.72 32.72 0 0 1-5.48-11 43.78 43.78 0 0 1-1.61-11.83q0-11.61 4.83-20.1A43.07 43.07 0 0 1 570 316.54a56.09 56.09 0 0 1 18.06-8.28 79.14 79.14 0 0 1 20.42-2.69 80.2 80.2 0 0 1 22.68 3.12 56.11 56.11 0 0 1 18.73 9.31 44.37 44.37 0 0 1 17.52 36.55h-26.88q-1.06-14.83-10.1-21t-23-6.13a50 50 0 0 0-9.68 1 30.66 30.66 0 0 0-9 3.22 19.88 19.88 0 0 0-6.77 6.13 16.52 16.52 0 0 0-2.69 9.68q0 8.17 5 12.79a32.83 32.83 0 0 0 13.22 7c.58.14 2.83.75 6.78 1.82s8.35 2.26 13.22 3.55 9.64 2.55 14.3 3.76 8 2.12 10 2.69a45.06 45.06 0 0 1 13.11 6.45 41.46 41.46 0 0 1 9.35 9.35 38.77 38.77 0 0 1 5.59 11.29 41.26 41.26 0 0 1 1.83 12q.02 12.98-5.25 22.12Z" } })]);
};
const kg = {
  render: Eg
};
var Dg = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 737.27 495.9" } }, n.$listeners), [t("path", { attrs: { fill: "currentColor", d: "M625.68 272.72H291.32a111.59 111.59 0 0 0 0 223.18h334.36a111.59 111.59 0 1 0 0-223.18ZM389.46 409.14q0 14.82-4.52 25.79a49.82 49.82 0 0 1-12.79 18.39 53.5 53.5 0 0 1-19.89 11.07 93 93 0 0 1-51.6 0 53.5 53.5 0 0 1-19.89-11.07A49.7 49.7 0 0 1 268 434.93q-4.51-11-4.52-25.79v-98.26h26.88v89.44q0 7.74.75 15.69a35.85 35.85 0 0 0 4.3 14.3 27.43 27.43 0 0 0 10.75 10.43q7.2 4.08 20.32 4.08t20.32-4.08a27.43 27.43 0 0 0 10.75-10.43 36 36 0 0 0 4.3-14.3q.75-8 .75-15.69v-89.44h26.88ZM531 441.92a44.75 44.75 0 0 1-13.87 14.94 60 60 0 0 1-19.56 8.5 93.71 93.71 0 0 1-22.33 2.64 92 92 0 0 1-24.73-3.22 57.9 57.9 0 0 1-20.21-9.89 48.4 48.4 0 0 1-13.76-17.09q-5.16-10.43-5.37-24.62H438a34.32 34.32 0 0 0 3 15 27.12 27.12 0 0 0 8.39 10.21 35.59 35.59 0 0 0 12.36 5.81 59.72 59.72 0 0 0 15.25 1.91 48.47 48.47 0 0 0 15.05-2 30.45 30.45 0 0 0 10.1-5.27 19 19 0 0 0 5.59-7.41 22.18 22.18 0 0 0 1.72-8.5q0-8.81-4-13a22.71 22.71 0 0 0-8.7-5.92 183.6 183.6 0 0 0-19-5.69q-10.86-2.68-26.77-7a57.57 57.57 0 0 1-16.45-6.77 39.33 39.33 0 0 1-10.42-9.36 32.93 32.93 0 0 1-5.49-11 44.18 44.18 0 0 1-1.63-11.82q0-11.6 4.84-20.1a43 43 0 0 1 12.79-14.08 56.3 56.3 0 0 1 18.06-8.28 79.28 79.28 0 0 1 20.43-2.69 80.66 80.66 0 0 1 22.68 3.12 55.89 55.89 0 0 1 18.7 9.36 44.34 44.34 0 0 1 17.5 36.54h-26.88q-1.08-14.83-10.1-21t-23-6.12a50.63 50.63 0 0 0-9.67 1 30.68 30.68 0 0 0-9 3.23 19.69 19.69 0 0 0-6.78 6.12 16.59 16.59 0 0 0-2.68 9.68q0 8.18 5 12.79a32.57 32.57 0 0 0 13.22 7q.86.21 6.77 1.83t13.23 3.54l14.29 3.77q7 1.83 10 2.69a44.73 44.73 0 0 1 13.12 6.44 41.71 41.71 0 0 1 9.35 9.36 38.85 38.85 0 0 1 5.59 11.28 41.27 41.27 0 0 1 1.83 12.05q.01 12.89-5.29 22.02Zm139.32 0a44.75 44.75 0 0 1-13.87 14.94 60.08 60.08 0 0 1-19.56 8.5 93.73 93.73 0 0 1-22.34 2.64 92 92 0 0 1-24.72-3.22 57.9 57.9 0 0 1-20.21-9.89 48.4 48.4 0 0 1-13.76-17.09q-5.16-10.43-5.37-24.62h26.87a34.32 34.32 0 0 0 3 15 27.12 27.12 0 0 0 8.39 10.21 35.59 35.59 0 0 0 12.36 5.81 59.66 59.66 0 0 0 15.16 1.82 48.47 48.47 0 0 0 15.05-2 30.45 30.45 0 0 0 10.1-5.27 19 19 0 0 0 5.59-7.41 22.18 22.18 0 0 0 1.72-8.5q0-8.81-4-13a22.67 22.67 0 0 0-8.71-5.92 183.36 183.36 0 0 0-19-5.69q-10.86-2.68-26.77-7a57.57 57.57 0 0 1-16.45-6.77 39.38 39.38 0 0 1-10.43-9.36 32.91 32.91 0 0 1-5.48-11 44.18 44.18 0 0 1-1.61-11.83q0-11.6 4.84-20.1a43 43 0 0 1 12.79-14.08 56.3 56.3 0 0 1 18.09-8.18 79.28 79.28 0 0 1 20.43-2.69 80.66 80.66 0 0 1 22.68 3.12 55.89 55.89 0 0 1 18.7 9.36 44.37 44.37 0 0 1 17.52 36.54h-26.89q-1.08-14.83-10.11-21t-23-6.12a50.63 50.63 0 0 0-9.67 1 30.84 30.84 0 0 0-9 3.23 19.75 19.75 0 0 0-6.77 6.12 16.59 16.59 0 0 0-2.68 9.68q0 8.18 5.05 12.79a32.57 32.57 0 0 0 13.22 7q.85.21 6.77 1.83t13.23 3.54l14.29 3.77q7 1.83 10 2.69a44.73 44.73 0 0 1 13.12 6.44 41.71 41.71 0 0 1 9.35 9.36 38.85 38.85 0 0 1 5.59 11.28 41.61 41.61 0 0 1 1.83 12.05q-.04 12.89-5.31 22.02Z" } }), t("path", { attrs: { fill: "currentColor", d: "M150.27 384.31a140.63 140.63 0 0 1 42.81-101.11c-13.59-7.47-30.34-16.5-42.35-22.55a144.16 144.16 0 0 1-31.65-21.75l-.8-.72a114.79 114.79 0 0 1-18.06-20.74C90.84 203.67 75.56 181 65.63 166.3a201.09 201.09 0 0 1 103.2-101.89l24 12A16 16 0 0 0 216 62.11v-11.3a199.85 199.85 0 0 1 24.39-2.42l28.3 28.3a16 16 0 0 1 0 22.63L264 104l-10.34 10.34a8 8 0 0 0 0 11.31l4.69 4.69a8 8 0 0 1 0 11.31l-8 8a8 8 0 0 1-5.66 2.34h-9a8 8 0 0 0-5.58 2.27l-9.92 9.65a8 8 0 0 0-1.58 9.31l15.59 31.19a8 8 0 0 1-7.14 11.59h-5.64a8 8 0 0 1-5.24-2l-9.28-8a16 16 0 0 0-15.55-3.1l-31.17 10.39a12 12 0 0 0-1.56 22l11.08 5.54A67.72 67.72 0 0 0 200 248c5.68 0 11.81 8 17.74 16a140.15 140.15 0 0 1 73.57-20.75h102.86l-9.3-13.95a24 24 0 0 1 0-26.62l19.59-29.38a24 24 0 0 1 9.24-8.15l13-6.49a198.65 198.65 0 0 1 21.25 84.59h48C493.41 108.48 383.38 0 248 0 111 0 0 111 0 248c0 120.34 85.71 220.65 199.42 243.23a140.78 140.78 0 0 1-49.15-106.92Z" } })]);
};
const Tg = {
  render: Dg
};
var Mg = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 608.97 495.98" } }, n.$listeners), [t("path", { attrs: { fill: "currentColor", d: "M152 382.66v-.79a45.44 45.44 0 0 1-5.88-22.37v-23.9a45.44 45.44 0 0 1 22.1-39l31.61-18.94a138.78 138.78 0 0 1 91.48-34.32h94.79v-6.24a11.36 11.36 0 0 0-3.3-8l-9.4-9.4a11.36 11.36 0 0 0-8-3.3h-16a11.31 11.31 0 0 1-8-19.3l9.4-9.4a11.36 11.36 0 0 1 8-3.3h32a11.35 11.35 0 0 0 11.3-11.3v-9.4a11.35 11.35 0 0 0-11.3-11.3h-36.7a16 16 0 0 0-16 16v4.5a16 16 0 0 1-10.9 15.2l-31.6 10.5a8 8 0 0 0-5.5 7.6v2.2a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8 8 8 0 0 0-8-8H247a8.15 8.15 0 0 0-7.2 4.4l-9.4 18.7a15.92 15.92 0 0 1-14.3 8.8H194a16 16 0 0 1-16-16V191a16.06 16.06 0 0 1 4.7-11.3l20.1-20.1a24.74 24.74 0 0 0 7.2-17.5 8 8 0 0 1 5.5-7.6l40-13.3a11.64 11.64 0 0 0 4.4-2.7l26.8-26.8a11.31 11.31 0 0 0-8-19.3H258l-16 16v8a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8v-20a8.05 8.05 0 0 1 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3 108.94 0 197.65 87.18 200.14 195.34h48C493.46 108.49 383.44 0 248 0 111 0 0 111 0 248c0 122.51 88.76 224.21 205.5 244.36a139.14 139.14 0 0 1-53.5-109.7ZM130.1 141.1a11.36 11.36 0 0 1 3.3-8l25.4-25.4a11.31 11.31 0 0 1 19.3 8v16a11.36 11.36 0 0 1-3.3 8l-9.4 9.4a11.36 11.36 0 0 1-8 3.3h-16a11.35 11.35 0 0 1-11.3-11.3Z" } }), t("path", { attrs: { fill: "currentColor", d: "M495.65 269.34H291.29a113.32 113.32 0 1 0 0 226.64h204.36a113.32 113.32 0 1 0 0-226.64Zm-118.48 193.4h-112V309.23h110.49v23.22H292v40.2h77.4v21.93H292v44.94h85.14Zm147.7-55.26q0 14.83-4.52 25.8a49.58 49.58 0 0 1-12.79 18.38 53.38 53.38 0 0 1-19.89 11.08 93 93 0 0 1-51.6 0 53.26 53.26 0 0 1-19.88-11.08 49.61 49.61 0 0 1-12.8-18.38q-4.51-11-4.51-25.8v-98.25h26.87v89.44q0 7.74.76 15.69a35.74 35.74 0 0 0 4.3 14.3 27.3 27.3 0 0 0 10.75 10.43q7.2 4.08 20.31 4.08t20.32-4.08a27.36 27.36 0 0 0 10.75-10.43 35.74 35.74 0 0 0 4.3-14.3q.75-8 .75-15.69v-89.44h26.88Z" } })]);
};
const Pg = {
  render: Mg
};
var Ig = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 609 497.63" } }, n.$listeners), [t("path", { attrs: { fill: "currentColor", d: "M495.68 271H291.32a113.32 113.32 0 0 0 0 226.64h204.36a113.32 113.32 0 0 0 0-226.64ZM389.46 409.14q0 14.82-4.52 25.79a49.82 49.82 0 0 1-12.79 18.39 53.5 53.5 0 0 1-19.89 11.07 93 93 0 0 1-51.6 0 53.5 53.5 0 0 1-19.89-11.07A49.7 49.7 0 0 1 268 434.93q-4.51-11-4.52-25.79v-98.26h26.88v89.44q0 7.74.75 15.69a35.85 35.85 0 0 0 4.3 14.3 27.43 27.43 0 0 0 10.75 10.43q7.2 4.08 20.32 4.08t20.32-4.08a27.43 27.43 0 0 0 10.75-10.43 36 36 0 0 0 4.3-14.3q.75-8 .75-15.69v-89.44h26.88ZM531 441.92a44.75 44.75 0 0 1-13.87 14.94 60 60 0 0 1-19.56 8.5 93.71 93.71 0 0 1-22.33 2.64 92 92 0 0 1-24.73-3.22 57.9 57.9 0 0 1-20.21-9.89 48.4 48.4 0 0 1-13.76-17.09q-5.16-10.43-5.37-24.62H438a34.32 34.32 0 0 0 3 15 27.12 27.12 0 0 0 8.39 10.21 35.59 35.59 0 0 0 12.36 5.81 59.72 59.72 0 0 0 15.25 1.91 48.47 48.47 0 0 0 15.05-2 30.45 30.45 0 0 0 10.1-5.27 19 19 0 0 0 5.59-7.41 22.18 22.18 0 0 0 1.72-8.5q0-8.81-4-13a22.71 22.71 0 0 0-8.7-5.92 183.6 183.6 0 0 0-19-5.69q-10.86-2.68-26.77-7a57.57 57.57 0 0 1-16.45-6.77 39.33 39.33 0 0 1-10.42-9.36 32.93 32.93 0 0 1-5.49-11 44.18 44.18 0 0 1-1.63-11.82q0-11.6 4.84-20.1a43 43 0 0 1 12.79-14.08 56.3 56.3 0 0 1 18.06-8.28 79.28 79.28 0 0 1 20.43-2.69 80.66 80.66 0 0 1 22.68 3.12 55.89 55.89 0 0 1 18.7 9.36 44.34 44.34 0 0 1 17.5 36.54h-26.88q-1.08-14.83-10.1-21t-23-6.12a50.63 50.63 0 0 0-9.67 1 30.68 30.68 0 0 0-9 3.23 19.69 19.69 0 0 0-6.78 6.12 16.59 16.59 0 0 0-2.68 9.68q0 8.18 5 12.79a32.57 32.57 0 0 0 13.22 7q.86.21 6.77 1.83t13.23 3.54l14.29 3.77q7 1.83 10 2.69a44.73 44.73 0 0 1 13.12 6.44 41.71 41.71 0 0 1 9.35 9.36 38.85 38.85 0 0 1 5.59 11.28 41.27 41.27 0 0 1 1.83 12.05q.01 12.89-5.29 22.02Z" } }), t("path", { attrs: { fill: "currentColor", d: "M152 384.31a138.92 138.92 0 0 1 42.67-100.24c-13.86-7.62-31.46-17.13-43.94-23.42a144.16 144.16 0 0 1-31.65-21.75l-.8-.72a114.79 114.79 0 0 1-18.06-20.74C90.84 203.67 75.56 181 65.63 166.3a201.09 201.09 0 0 1 103.2-101.89l24 12A16 16 0 0 0 216 62.11v-11.3a199.85 199.85 0 0 1 24.39-2.42l28.3 28.3a16 16 0 0 1 0 22.63L264 104l-10.34 10.34a8 8 0 0 0 0 11.31l4.69 4.69a8 8 0 0 1 0 11.31l-8 8a8 8 0 0 1-5.66 2.34h-9a8 8 0 0 0-5.58 2.27l-9.92 9.65a8 8 0 0 0-1.58 9.31l15.59 31.19a8 8 0 0 1-7.14 11.59h-5.64a8 8 0 0 1-5.24-2l-9.28-8a16 16 0 0 0-15.55-3.1l-31.17 10.39a12 12 0 0 0-1.56 22l11.08 5.54A67.72 67.72 0 0 0 200 248c6 0 12.53 8.91 18.76 17.42A138.49 138.49 0 0 1 291.32 245h104l-10.45-15.68a24 24 0 0 1 0-26.62l19.59-29.38a24 24 0 0 1 9.24-8.15l13-6.49A198.46 198.46 0 0 1 448 245h48C494.35 109.41 384 0 248 0 111 0 0 111 0 248c0 121.57 87.47 222.69 202.9 243.9A139.12 139.12 0 0 1 152 384.31Z" } })]);
};
const Rg = {
  render: Ig
}, Ng = {
  name: "EnvironmentIndicator",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    environment: {
      type: String,
      default: "development"
    }
  },
  computed: {
    visible() {
      return Hs(this.environment);
    },
    iconFromEnv() {
      return `EnvIcon_${this.environment}`;
    },
    tooltipContent() {
      return `Currently showing ${Hs(this.environment)} environment`;
    }
  },
  components: {
    Tooltip: Mn,
    EnvIcon_development: $g,
    EnvIcon_staging: kg,
    EnvIcon_us_staging: Tg,
    EnvIcon_production: Pg,
    EnvIcon_us_production: Rg
  }
};
var Fg = function() {
  var e = this, t = e._self._c;
  return e.visible ? t(e.tag, { tag: "component", staticClass: "x-environment-icon", attrs: { "data-cy": "indicator-wrapper" } }, [t("Tooltip", { attrs: { tag: "a", content: e.tooltipContent, "data-cy": "indicator-tooltip" } }, [t(e.iconFromEnv, { tag: "component", attrs: { "data-cy": "indicator-svg" } })], 1)], 1) : e._e();
}, Lg = [], Bg = /* @__PURE__ */ ee(
  Ng,
  Fg,
  Lg,
  !1,
  null,
  "c816232c"
);
const jg = Bg.exports;
var Hg = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ staticStyle: { "enable-background": "new 0 0 930 176" }, attrs: { xmlns: "http://www.w3.org/2000/svg", "xml:space": "preserve", viewBox: "0 0 930 176" } }, n.$listeners), [t("path", { staticStyle: { fill: "#023a4f" }, attrs: { d: "M609.4 34.4c-.4.5-.4 1.2-.4 2.6v17.9c0 .4-.1.6-.3.8-.1.1-.3.2-.5.2-.3.1-.7.1-1.2.1h-71c-14.1 0-21.2 0-25.6 4.4C506 64.8 506 71.9 506 86v30c0 14.1 0 21.2 4.4 25.6 4.4 4.4 11.5 4.4 25.6 4.4h98V26l-22.2 7.2c-1.4.4-2 .7-2.4 1.2zm-4.6 92.4c-1.4.2-3.2.2-5.8.2h-58c-4.7 0-7.1 0-8.5-1.5-1.5-1.5-1.5-3.8-1.5-8.5V85c0-4.7 0-7.1 1.5-8.5C534 75 536.3 75 541 75h68v42c0 4.7 0 7.1-1.5 8.5-.6.7-1.5 1.1-2.7 1.3zM684 146c-14.1 0-21.2 0-25.6-4.4-4.4-4.4-4.4-11.5-4.4-25.6v-10c0-2.7 0-4.8.1-6.5.2-2.5.7-4.2 1.9-5.4 1-1 2.3-1.5 4.1-1.8 1-.2 2.2-.2 3.7-.3h92c.2 0 .3 0 .4-.1.2 0 .3-.1.5-.2.1-.1.2-.3.3-.6V82.2c0-1.3-.1-2.4-.3-3.3-.1-.6-.3-1.1-.5-1.5-.2-.3-.4-.6-.7-.9C754 75 751.7 75 747 75h-93V56h98c14.1 0 21.2 0 25.6 4.4C782 64.8 782 71.9 782 86v60h-98zm73-36h-69.5c-3.3 0-4.9 0-6.1.7-.3.2-.5.4-.8.6l-.3.3c-.1.1-.2.2-.2.3-.1.2-.3.3-.4.5-.7 1.2-.7 2.8-.7 6.1 0 2.3 0 3.7.2 4.8.1.5.3.9.5 1.3.4.7 1 1.2 1.6 1.7 1.2.7 2.8.7 6.1.7h61.5c.8 0 1.5 0 2.1-.1 2.2-.1 3.6-.4 4.5-1.4.6-.6.9-1.3 1.1-2.2.3-1.5.3-3.5.3-6.4V110zm70 56.6c0 .3-.1.5-.1.7 0 .1-.1.3-.2.4-.4.5-1.1.7-2.4 1.2L802 176V56h98c14.1 0 21.2 0 25.6 4.4C930 64.8 930 71.9 930 86v30c0 14.1 0 21.2-4.4 25.6-4.4 4.4-11.5 4.4-25.6 4.4h-72.2c-.2 0-.4.1-.5.2-.2.2-.2.4-.3.7V166.6zm4.1-91.3c-1.1.2-2 .6-2.6 1.2C827 78 827 80.3 827 85v42h68c4.7 0 7.1 0 8.5-1.5 1.5-1.5 1.5-3.8 1.5-8.5V85c0-4.7 0-7.1-1.5-8.5C902 75 899.7 75 895 75h-58c-1.7 0-3.1 0-4.3.1-.6 0-1.1.1-1.6.2zM456 56c14.1 0 21.2 0 25.6 4.4C486 64.8 486 71.9 486 86v10c0 6.6 0 9.9-2.1 11.9-2.1 2.1-5.3 2.1-11.9 2.1h-87c-.9 0-1.4 0-1.7.3s-.3.8-.3 1.7v5c0 4.7 0 7.1 1.5 8.5 1.5 1.5 3.8 1.5 8.5 1.5h93v19h-98c-14.1 0-21.2 0-25.6-4.4-4.4-4.4-4.4-11.5-4.4-25.6V86c0-14.1 0-21.2 4.4-25.6C366.8 56 373.9 56 388 56h68zm-73 36h69.5c3.3 0 4.9 0 6.1-.7.7-.4 1.2-1 1.6-1.7.2-.4.4-.8.5-1.3.2-1.1.2-2.6.2-4.8 0-1.4 0-2.6-.1-3.5-.1-1.2-.3-2-.7-2.6-.4-.7-1-1.2-1.6-1.7-1.2-.7-2.8-.7-6.1-.7H393c-4.7 0-7.1 0-8.5 1.5C383 78 383 80.3 383 85v7zm-51.4-29.6C325.1 56 314.7 56 294 56h-84v90h25V85c0-4.7 0-7.1 1.5-8.5C238 75 240.3 75 245 75h48c9.4 0 14.1 0 17.1 2.9 2.9 2.9 2.9 7.6 2.9 17.1v51h25v-46c0-20.7 0-31.1-6.4-37.6z" } }), t("path", { staticStyle: { fill: "#ff6c37" }, attrs: { d: "M93.1 56c3.8 0 5.8 0 6.8-1.2 1.1-1.2.8-3.1.3-6.9L94.3 6.4c-.4-2.9-.6-4.4-1.6-5.3-1-.9-2.5-.9-5.5-.9h-4.4c-3 0-4.4 0-5.5.9-1 .9-1.2 2.3-1.6 5.3l-5.9 41.4c-.5 3.8-.8 5.7.3 6.9 1.1 1.2 3 1.2 6.8 1.2h16.2zM57.3 70.2c1.2-3.6 1.8-5.5.9-6.9-.8-1.4-2.7-1.7-6.5-2.4l-41.2-7.2c-2.9-.5-4.4-.7-5.5 0-1.1.7-1.6 2.1-2.5 4.9l-1.4 4.2C.2 65.6-.3 67 .2 68.3c.5 1.2 1.9 1.9 4.5 3.2l37.6 18.4c3.4 1.7 5.2 2.5 6.7 1.9 1.5-.6 2.1-2.5 3.3-6.1l5-15.5zm2.2 38.3c-3.1-2.3-4.7-3.4-6.2-3-1.6.4-2.5 2.1-4.3 5.5l-19.6 37c-1.4 2.6-2.1 3.9-1.8 5.2.3 1.3 1.5 2.2 3.9 3.9l3.6 2.6c2.4 1.7 3.6 2.6 4.9 2.5 1.3-.1 2.4-1.2 4.4-3.3l29.1-30c2.7-2.8 4-4.1 3.9-5.8-.1-1.6-1.7-2.8-4.8-5l-13.1-9.6zm58.3-23.1c1.2 3.6 1.8 5.5 3.3 6.1 1.5.6 3.2-.2 6.7-1.9l37.6-18.4c2.7-1.3 4-2 4.5-3.2.5-1.2.1-2.6-.9-5.5l-1.4-4.2c-.9-2.8-1.4-4.2-2.5-4.9-1.1-.7-2.6-.4-5.5.1l-41.2 7.2c-3.8.7-5.7 1-6.5 2.4-.8 1.4-.2 3.2.9 6.9l5 15.4zm-20.6 32.5c-3.1 2.3-4.7 3.4-4.8 5-.1 1.6 1.2 3 3.9 5.8l29.1 30c2.1 2.1 3.1 3.2 4.4 3.3 1.3.1 2.5-.8 4.9-2.5l3.6-2.6c2.4-1.7 3.6-2.6 3.9-3.9.3-1.3-.4-2.6-1.8-5.2l-19.6-37c-1.8-3.4-2.7-5.1-4.3-5.5-1.6-.4-3.1.8-6.2 3l-13.1 9.6z" } })]);
};
const zg = {
  render: Hg
}, Ug = {
  props: {
    container: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    NedapLogoIcon: zg
  }
};
var qg = function() {
  var e = this, t = e._self._c;
  return t("footer", { class: ["footer", { "footer--container": e.container }] }, [t("div", { staticClass: "footer__logo" }, [t("a", { attrs: { target: "_blank", href: "https://www.nedap-retail.com" } }, [t("NedapLogoIcon")], 1)]), e._t("content"), t("div", { staticClass: "footer__actions" }, [e._t("actions"), t("a", { staticClass: "footer__link", attrs: { target: "_blank", href: "https://nedap.com/en/disclaimer" } }, [e._v("Privacy statement & disclaimer")])], 2), e._t("after-privacy-link")], 2);
}, Wg = [], Vg = /* @__PURE__ */ ee(
  Ug,
  qg,
  Wg,
  !1,
  null,
  "76200ac3"
);
const Yg = Vg.exports;
var Kg = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 852 812" } }, n.$listeners), [t("path", { attrs: { fill: "#FF6C37", d: "M466.53 279.859c19.191 0 28.786 0 34.133-6.147 5.347-6.147 3.998-15.642 1.299-34.633L472.527 32.133c-2.099-14.643-3.148-21.989-8.146-26.337-5.047-4.398-12.444-4.398-27.236-4.398h-22.239c-14.792 0-22.189 0-27.236 4.398-5.048 4.398-6.097 11.694-8.146 26.337l-29.485 206.946c-2.699 18.991-4.048 28.486 1.299 34.633 5.347 6.147 14.943 6.147 34.133 6.147h81.059ZM287.984 350.674c5.947-18.241 8.895-27.336 4.697-34.333-4.198-6.996-13.643-8.646-32.533-11.944L54.201 268.415c-14.593-2.549-21.889-3.798-27.586-.4-5.697 3.449-7.996 10.495-12.594 24.538l-6.846 21.189c-4.598 14.093-6.847 21.09-4.248 27.237 2.599 6.147 9.245 9.395 22.539 15.892l187.705 91.953c17.242 8.446 25.837 12.644 33.334 9.446 7.496-3.199 10.494-12.294 16.391-30.535l25.088-77.061ZM300.161 542.38c-15.492-11.295-23.288-16.892-31.234-15.043-7.946 1.849-12.444 10.295-21.39 27.287l-97.85 184.657c-6.947 13.093-10.395 19.64-8.896 26.137 1.499 6.497 7.496 10.844 19.49 19.54l17.991 13.043c11.994 8.696 17.941 13.044 24.588 12.494 6.647-.6 11.794-5.897 22.089-16.542l145.427-150.124c13.343-13.793 19.99-20.64 19.29-28.786-.7-8.146-8.446-13.743-23.988-25.037l-65.517-47.626ZM486.162 590.055c-15.493 11.294-23.289 16.891-23.988 25.037-.7 8.146 5.947 14.992 19.29 28.786l145.427 150.124c10.295 10.645 15.442 15.942 22.089 16.542 6.647.6 12.644-3.748 24.588-12.494l17.991-13.043c11.993-8.696 17.941-13.044 19.49-19.541 1.549-6.496-1.949-13.043-8.896-26.136l-97.751-184.708c-8.995-16.941-13.443-25.437-21.389-27.236-7.946-1.849-15.692 3.798-31.234 15.042l-65.617 47.627ZM589.097 427.834c5.947 18.241 8.896 27.336 16.392 30.535 7.496 3.198 16.142-1.05 33.334-9.496l187.705-91.953c13.293-6.497 19.94-9.745 22.539-15.892s.3-13.194-4.248-27.237l-6.846-21.139c-4.598-14.093-6.847-21.089-12.594-24.538-5.697-3.448-12.994-2.149-27.586.4l-205.897 35.982c-18.89 3.298-28.336 4.948-32.534 11.944-4.197 6.996-1.249 16.092 4.698 34.333l25.037 77.061Z" } })]);
};
const Gg = {
  render: Kg
}, Qg = {
  props: {
    inverted: {
      type: Boolean,
      default: !1
    },
    tooltipContent: {
      type: String,
      default: "This feature is only available for Nedap users"
    }
  },
  components: {
    Tooltip: Mn,
    NedapSpark: Gg
  }
};
var Jg = function() {
  var e = this, t = e._self._c;
  return t("Tooltip", { staticClass: "nedap-only-badge", class: { "nedap-only-badge--inverted": e.inverted }, attrs: { content: e.tooltipContent } }, [t("span", { staticClass: "nedap-only-badge__spark" }, [t("NedapSpark", { attrs: { "data-cy": "nedap-spark" } })], 1), t("span", { staticClass: "nedap-only-badge__text" }, [e._v(" Nedap only ")])]);
}, Zg = [], Xg = /* @__PURE__ */ ee(
  Qg,
  Jg,
  Zg,
  !1,
  null,
  "f5c79515"
);
const e0 = Xg.exports, t0 = {
  props: {
    max: {
      type: Number,
      default: 3
    },
    current: {
      type: Number,
      default: 1
    },
    // Indeterminate progressbars are displayed full-width
    indeterminate: {
      type: Boolean,
      default: !1
    },
    visible: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    progressBarWidth() {
      return this.indeterminate ? 100 : 92 / this.max * this.current + 8;
    }
  }
};
var n0 = function() {
  var e = this, t = e._self._c;
  return t("div", { class: ["loading-indicator", { "loading-indicator--invisible": !e.visible }], style: { width: `${e.progressBarWidth}%` } });
}, r0 = [], a0 = /* @__PURE__ */ ee(
  t0,
  n0,
  r0,
  !1,
  null,
  "9c68aebf"
);
const Eu = a0.exports;
var ku = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "far", t = "bell", r = 448, a = 512, i = [], o = "f0f3", s = "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faBell = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(ku);
Pe.add(ku.faBell);
const i0 = {
  props: {
    releasesUrl: String
  },
  components: {
    "font-awesome-icon": Ie
  }
};
var o0 = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "x-releases", attrs: { id: "x-releases" } }, [t("a", { staticClass: "x-releases__anchor", attrs: { href: e.releasesUrl, target: "_releases" } }, [t("font-awesome-icon", { attrs: { icon: ["far", "bell"] } })], 1)]);
}, s0 = [], l0 = /* @__PURE__ */ ee(
  i0,
  o0,
  s0,
  !1,
  null,
  "b71e43c1"
);
const c0 = l0.exports;
function Du(n, e) {
  return function() {
    return n.apply(e, arguments);
  };
}
const { toString: u0 } = Object.prototype, { getPrototypeOf: Co } = Object, ga = /* @__PURE__ */ ((n) => (e) => {
  const t = u0.call(e);
  return n[t] || (n[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), rt = (n) => (n = n.toLowerCase(), (e) => ga(e) === n), ya = (n) => (e) => typeof e === n, { isArray: In } = Array, ur = ya("undefined");
function f0(n) {
  return n !== null && !ur(n) && n.constructor !== null && !ur(n.constructor) && qe(n.constructor.isBuffer) && n.constructor.isBuffer(n);
}
const Tu = rt("ArrayBuffer");
function d0(n) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(n) : e = n && n.buffer && Tu(n.buffer), e;
}
const p0 = ya("string"), qe = ya("function"), Mu = ya("number"), ba = (n) => n !== null && typeof n == "object", h0 = (n) => n === !0 || n === !1, Lr = (n) => {
  if (ga(n) !== "object")
    return !1;
  const e = Co(n);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in n) && !(Symbol.iterator in n);
}, m0 = rt("Date"), v0 = rt("File"), g0 = rt("Blob"), y0 = rt("FileList"), b0 = (n) => ba(n) && qe(n.pipe), _0 = (n) => {
  let e;
  return n && (typeof FormData == "function" && n instanceof FormData || qe(n.append) && ((e = ga(n)) === "formdata" || // detect form-data instance
  e === "object" && qe(n.toString) && n.toString() === "[object FormData]"));
}, w0 = rt("URLSearchParams"), [C0, S0, x0, O0] = ["ReadableStream", "Request", "Response", "Headers"].map(rt), A0 = (n) => n.trim ? n.trim() : n.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function gr(n, e, { allOwnKeys: t = !1 } = {}) {
  if (n === null || typeof n > "u")
    return;
  let r, a;
  if (typeof n != "object" && (n = [n]), In(n))
    for (r = 0, a = n.length; r < a; r++)
      e.call(null, n[r], r, n);
  else {
    const i = t ? Object.getOwnPropertyNames(n) : Object.keys(n), o = i.length;
    let s;
    for (r = 0; r < o; r++)
      s = i[r], e.call(null, n[s], s, n);
  }
}
function Pu(n, e) {
  e = e.toLowerCase();
  const t = Object.keys(n);
  let r = t.length, a;
  for (; r-- > 0; )
    if (a = t[r], e === a.toLowerCase())
      return a;
  return null;
}
const Vt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Iu = (n) => !ur(n) && n !== Vt;
function Mi() {
  const { caseless: n } = Iu(this) && this || {}, e = {}, t = (r, a) => {
    const i = n && Pu(e, a) || a;
    Lr(e[i]) && Lr(r) ? e[i] = Mi(e[i], r) : Lr(r) ? e[i] = Mi({}, r) : In(r) ? e[i] = r.slice() : e[i] = r;
  };
  for (let r = 0, a = arguments.length; r < a; r++)
    arguments[r] && gr(arguments[r], t);
  return e;
}
const $0 = (n, e, t, { allOwnKeys: r } = {}) => (gr(e, (a, i) => {
  t && qe(a) ? n[i] = Du(a, t) : n[i] = a;
}, { allOwnKeys: r }), n), E0 = (n) => (n.charCodeAt(0) === 65279 && (n = n.slice(1)), n), k0 = (n, e, t, r) => {
  n.prototype = Object.create(e.prototype, r), n.prototype.constructor = n, Object.defineProperty(n, "super", {
    value: e.prototype
  }), t && Object.assign(n.prototype, t);
}, D0 = (n, e, t, r) => {
  let a, i, o;
  const s = {};
  if (e = e || {}, n == null) return e;
  do {
    for (a = Object.getOwnPropertyNames(n), i = a.length; i-- > 0; )
      o = a[i], (!r || r(o, n, e)) && !s[o] && (e[o] = n[o], s[o] = !0);
    n = t !== !1 && Co(n);
  } while (n && (!t || t(n, e)) && n !== Object.prototype);
  return e;
}, T0 = (n, e, t) => {
  n = String(n), (t === void 0 || t > n.length) && (t = n.length), t -= e.length;
  const r = n.indexOf(e, t);
  return r !== -1 && r === t;
}, M0 = (n) => {
  if (!n) return null;
  if (In(n)) return n;
  let e = n.length;
  if (!Mu(e)) return null;
  const t = new Array(e);
  for (; e-- > 0; )
    t[e] = n[e];
  return t;
}, P0 = /* @__PURE__ */ ((n) => (e) => n && e instanceof n)(typeof Uint8Array < "u" && Co(Uint8Array)), I0 = (n, e) => {
  const r = (n && n[Symbol.iterator]).call(n);
  let a;
  for (; (a = r.next()) && !a.done; ) {
    const i = a.value;
    e.call(n, i[0], i[1]);
  }
}, R0 = (n, e) => {
  let t;
  const r = [];
  for (; (t = n.exec(e)) !== null; )
    r.push(t);
  return r;
}, N0 = rt("HTMLFormElement"), F0 = (n) => n.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, r, a) {
    return r.toUpperCase() + a;
  }
), zs = (({ hasOwnProperty: n }) => (e, t) => n.call(e, t))(Object.prototype), L0 = rt("RegExp"), Ru = (n, e) => {
  const t = Object.getOwnPropertyDescriptors(n), r = {};
  gr(t, (a, i) => {
    let o;
    (o = e(a, i, n)) !== !1 && (r[i] = o || a);
  }), Object.defineProperties(n, r);
}, B0 = (n) => {
  Ru(n, (e, t) => {
    if (qe(n) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const r = n[t];
    if (qe(r)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, j0 = (n, e) => {
  const t = {}, r = (a) => {
    a.forEach((i) => {
      t[i] = !0;
    });
  };
  return In(n) ? r(n) : r(String(n).split(e)), t;
}, H0 = () => {
}, z0 = (n, e) => n != null && Number.isFinite(n = +n) ? n : e, Ua = "abcdefghijklmnopqrstuvwxyz", Us = "0123456789", Nu = {
  DIGIT: Us,
  ALPHA: Ua,
  ALPHA_DIGIT: Ua + Ua.toUpperCase() + Us
}, U0 = (n = 16, e = Nu.ALPHA_DIGIT) => {
  let t = "";
  const { length: r } = e;
  for (; n--; )
    t += e[Math.random() * r | 0];
  return t;
};
function q0(n) {
  return !!(n && qe(n.append) && n[Symbol.toStringTag] === "FormData" && n[Symbol.iterator]);
}
const W0 = (n) => {
  const e = new Array(10), t = (r, a) => {
    if (ba(r)) {
      if (e.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        e[a] = r;
        const i = In(r) ? [] : {};
        return gr(r, (o, s) => {
          const l = t(o, a + 1);
          !ur(l) && (i[s] = l);
        }), e[a] = void 0, i;
      }
    }
    return r;
  };
  return t(n, 0);
}, V0 = rt("AsyncFunction"), Y0 = (n) => n && (ba(n) || qe(n)) && qe(n.then) && qe(n.catch), Fu = ((n, e) => n ? setImmediate : e ? ((t, r) => (Vt.addEventListener("message", ({ source: a, data: i }) => {
  a === Vt && i === t && r.length && r.shift()();
}, !1), (a) => {
  r.push(a), Vt.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  qe(Vt.postMessage)
), K0 = typeof queueMicrotask < "u" ? queueMicrotask.bind(Vt) : typeof process < "u" && process.nextTick || Fu, x = {
  isArray: In,
  isArrayBuffer: Tu,
  isBuffer: f0,
  isFormData: _0,
  isArrayBufferView: d0,
  isString: p0,
  isNumber: Mu,
  isBoolean: h0,
  isObject: ba,
  isPlainObject: Lr,
  isReadableStream: C0,
  isRequest: S0,
  isResponse: x0,
  isHeaders: O0,
  isUndefined: ur,
  isDate: m0,
  isFile: v0,
  isBlob: g0,
  isRegExp: L0,
  isFunction: qe,
  isStream: b0,
  isURLSearchParams: w0,
  isTypedArray: P0,
  isFileList: y0,
  forEach: gr,
  merge: Mi,
  extend: $0,
  trim: A0,
  stripBOM: E0,
  inherits: k0,
  toFlatObject: D0,
  kindOf: ga,
  kindOfTest: rt,
  endsWith: T0,
  toArray: M0,
  forEachEntry: I0,
  matchAll: R0,
  isHTMLForm: N0,
  hasOwnProperty: zs,
  hasOwnProp: zs,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ru,
  freezeMethods: B0,
  toObjectSet: j0,
  toCamelCase: F0,
  noop: H0,
  toFiniteNumber: z0,
  findKey: Pu,
  global: Vt,
  isContextDefined: Iu,
  ALPHABET: Nu,
  generateString: U0,
  isSpecCompliantForm: q0,
  toJSONObject: W0,
  isAsyncFn: V0,
  isThenable: Y0,
  setImmediate: Fu,
  asap: K0
};
function Z(n, e, t, r, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = n, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), r && (this.request = r), a && (this.response = a, this.status = a.status ? a.status : null);
}
x.inherits(Z, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: x.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Lu = Z.prototype, Bu = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((n) => {
  Bu[n] = { value: n };
});
Object.defineProperties(Z, Bu);
Object.defineProperty(Lu, "isAxiosError", { value: !0 });
Z.from = (n, e, t, r, a, i) => {
  const o = Object.create(Lu);
  return x.toFlatObject(n, o, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), Z.call(o, n.message, e, t, r, a), o.cause = n, o.name = n.name, i && Object.assign(o, i), o;
};
const G0 = null;
function Pi(n) {
  return x.isPlainObject(n) || x.isArray(n);
}
function ju(n) {
  return x.endsWith(n, "[]") ? n.slice(0, -2) : n;
}
function qs(n, e, t) {
  return n ? n.concat(e).map(function(a, i) {
    return a = ju(a), !t && i ? "[" + a + "]" : a;
  }).join(t ? "." : "") : e;
}
function Q0(n) {
  return x.isArray(n) && !n.some(Pi);
}
const J0 = x.toFlatObject(x, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function _a(n, e, t) {
  if (!x.isObject(n))
    throw new TypeError("target must be an object");
  e = e || new FormData(), t = x.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(b, w) {
    return !x.isUndefined(w[b]);
  });
  const r = t.metaTokens, a = t.visitor || c, i = t.dots, o = t.indexes, l = (t.Blob || typeof Blob < "u" && Blob) && x.isSpecCompliantForm(e);
  if (!x.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(g) {
    if (g === null) return "";
    if (x.isDate(g))
      return g.toISOString();
    if (!l && x.isBlob(g))
      throw new Z("Blob is not supported. Use a Buffer instead.");
    return x.isArrayBuffer(g) || x.isTypedArray(g) ? l && typeof Blob == "function" ? new Blob([g]) : Buffer.from(g) : g;
  }
  function c(g, b, w) {
    let C = g;
    if (g && !w && typeof g == "object") {
      if (x.endsWith(b, "{}"))
        b = r ? b : b.slice(0, -2), g = JSON.stringify(g);
      else if (x.isArray(g) && Q0(g) || (x.isFileList(g) || x.endsWith(b, "[]")) && (C = x.toArray(g)))
        return b = ju(b), C.forEach(function(A, h) {
          !(x.isUndefined(A) || A === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? qs([b], h, i) : o === null ? b : b + "[]",
            u(A)
          );
        }), !1;
    }
    return Pi(g) ? !0 : (e.append(qs(w, b, i), u(g)), !1);
  }
  const p = [], m = Object.assign(J0, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: Pi
  });
  function y(g, b) {
    if (!x.isUndefined(g)) {
      if (p.indexOf(g) !== -1)
        throw Error("Circular reference detected in " + b.join("."));
      p.push(g), x.forEach(g, function(C, S) {
        (!(x.isUndefined(C) || C === null) && a.call(
          e,
          C,
          x.isString(S) ? S.trim() : S,
          b,
          m
        )) === !0 && y(C, b ? b.concat(S) : [S]);
      }), p.pop();
    }
  }
  if (!x.isObject(n))
    throw new TypeError("data must be an object");
  return y(n), e;
}
function Ws(n) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(n).replace(/[!'()~]|%20|%00/g, function(r) {
    return e[r];
  });
}
function So(n, e) {
  this._pairs = [], n && _a(n, this, e);
}
const Hu = So.prototype;
Hu.append = function(e, t) {
  this._pairs.push([e, t]);
};
Hu.toString = function(e) {
  const t = e ? function(r) {
    return e.call(this, r, Ws);
  } : Ws;
  return this._pairs.map(function(a) {
    return t(a[0]) + "=" + t(a[1]);
  }, "").join("&");
};
function Z0(n) {
  return encodeURIComponent(n).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function zu(n, e, t) {
  if (!e)
    return n;
  const r = t && t.encode || Z0, a = t && t.serialize;
  let i;
  if (a ? i = a(e, t) : i = x.isURLSearchParams(e) ? e.toString() : new So(e, t).toString(r), i) {
    const o = n.indexOf("#");
    o !== -1 && (n = n.slice(0, o)), n += (n.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return n;
}
class Vs {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, t, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    x.forEach(this.handlers, function(r) {
      r !== null && e(r);
    });
  }
}
const Uu = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, X0 = typeof URLSearchParams < "u" ? URLSearchParams : So, ey = typeof FormData < "u" ? FormData : null, ty = typeof Blob < "u" ? Blob : null, ny = {
  isBrowser: !0,
  classes: {
    URLSearchParams: X0,
    FormData: ey,
    Blob: ty
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, xo = typeof window < "u" && typeof document < "u", Ii = typeof navigator == "object" && navigator || void 0, ry = xo && (!Ii || ["ReactNative", "NativeScript", "NS"].indexOf(Ii.product) < 0), ay = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", iy = xo && window.location.href || "http://localhost", oy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: xo,
  hasStandardBrowserEnv: ry,
  hasStandardBrowserWebWorkerEnv: ay,
  navigator: Ii,
  origin: iy
}, Symbol.toStringTag, { value: "Module" })), Le = {
  ...oy,
  ...ny
};
function sy(n, e) {
  return _a(n, new Le.classes.URLSearchParams(), Object.assign({
    visitor: function(t, r, a, i) {
      return Le.isNode && x.isBuffer(t) ? (this.append(r, t.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function ly(n) {
  return x.matchAll(/\w+|\[(\w*)]/g, n).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function cy(n) {
  const e = {}, t = Object.keys(n);
  let r;
  const a = t.length;
  let i;
  for (r = 0; r < a; r++)
    i = t[r], e[i] = n[i];
  return e;
}
function qu(n) {
  function e(t, r, a, i) {
    let o = t[i++];
    if (o === "__proto__") return !0;
    const s = Number.isFinite(+o), l = i >= t.length;
    return o = !o && x.isArray(a) ? a.length : o, l ? (x.hasOwnProp(a, o) ? a[o] = [a[o], r] : a[o] = r, !s) : ((!a[o] || !x.isObject(a[o])) && (a[o] = []), e(t, r, a[o], i) && x.isArray(a[o]) && (a[o] = cy(a[o])), !s);
  }
  if (x.isFormData(n) && x.isFunction(n.entries)) {
    const t = {};
    return x.forEachEntry(n, (r, a) => {
      e(ly(r), a, t, 0);
    }), t;
  }
  return null;
}
function uy(n, e, t) {
  if (x.isString(n))
    try {
      return (e || JSON.parse)(n), x.trim(n);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (t || JSON.stringify)(n);
}
const yr = {
  transitional: Uu,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const r = t.getContentType() || "", a = r.indexOf("application/json") > -1, i = x.isObject(e);
    if (i && x.isHTMLForm(e) && (e = new FormData(e)), x.isFormData(e))
      return a ? JSON.stringify(qu(e)) : e;
    if (x.isArrayBuffer(e) || x.isBuffer(e) || x.isStream(e) || x.isFile(e) || x.isBlob(e) || x.isReadableStream(e))
      return e;
    if (x.isArrayBufferView(e))
      return e.buffer;
    if (x.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let s;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return sy(e, this.formSerializer).toString();
      if ((s = x.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return _a(
          s ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || a ? (t.setContentType("application/json", !1), uy(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || yr.transitional, r = t && t.forcedJSONParsing, a = this.responseType === "json";
    if (x.isResponse(e) || x.isReadableStream(e))
      return e;
    if (e && x.isString(e) && (r && !this.responseType || a)) {
      const o = !(t && t.silentJSONParsing) && a;
      try {
        return JSON.parse(e);
      } catch (s) {
        if (o)
          throw s.name === "SyntaxError" ? Z.from(s, Z.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Le.classes.FormData,
    Blob: Le.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
x.forEach(["delete", "get", "head", "post", "put", "patch"], (n) => {
  yr.headers[n] = {};
});
const fy = x.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), dy = (n) => {
  const e = {};
  let t, r, a;
  return n && n.split(`
`).forEach(function(o) {
    a = o.indexOf(":"), t = o.substring(0, a).trim().toLowerCase(), r = o.substring(a + 1).trim(), !(!t || e[t] && fy[t]) && (t === "set-cookie" ? e[t] ? e[t].push(r) : e[t] = [r] : e[t] = e[t] ? e[t] + ", " + r : r);
  }), e;
}, Ys = Symbol("internals");
function Yn(n) {
  return n && String(n).trim().toLowerCase();
}
function Br(n) {
  return n === !1 || n == null ? n : x.isArray(n) ? n.map(Br) : String(n);
}
function py(n) {
  const e = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = t.exec(n); )
    e[r[1]] = r[2];
  return e;
}
const hy = (n) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(n.trim());
function qa(n, e, t, r, a) {
  if (x.isFunction(r))
    return r.call(this, e, t);
  if (a && (e = t), !!x.isString(e)) {
    if (x.isString(r))
      return e.indexOf(r) !== -1;
    if (x.isRegExp(r))
      return r.test(e);
  }
}
function my(n) {
  return n.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, r) => t.toUpperCase() + r);
}
function vy(n, e) {
  const t = x.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(n, r + t, {
      value: function(a, i, o) {
        return this[r].call(this, e, a, i, o);
      },
      configurable: !0
    });
  });
}
class Be {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, r) {
    const a = this;
    function i(s, l, u) {
      const c = Yn(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const p = x.findKey(a, c);
      (!p || a[p] === void 0 || u === !0 || u === void 0 && a[p] !== !1) && (a[p || l] = Br(s));
    }
    const o = (s, l) => x.forEach(s, (u, c) => i(u, c, l));
    if (x.isPlainObject(e) || e instanceof this.constructor)
      o(e, t);
    else if (x.isString(e) && (e = e.trim()) && !hy(e))
      o(dy(e), t);
    else if (x.isHeaders(e))
      for (const [s, l] of e.entries())
        i(l, s, r);
    else
      e != null && i(t, e, r);
    return this;
  }
  get(e, t) {
    if (e = Yn(e), e) {
      const r = x.findKey(this, e);
      if (r) {
        const a = this[r];
        if (!t)
          return a;
        if (t === !0)
          return py(a);
        if (x.isFunction(t))
          return t.call(this, a, r);
        if (x.isRegExp(t))
          return t.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = Yn(e), e) {
      const r = x.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!t || qa(this, this[r], r, t)));
    }
    return !1;
  }
  delete(e, t) {
    const r = this;
    let a = !1;
    function i(o) {
      if (o = Yn(o), o) {
        const s = x.findKey(r, o);
        s && (!t || qa(r, r[s], s, t)) && (delete r[s], a = !0);
      }
    }
    return x.isArray(e) ? e.forEach(i) : i(e), a;
  }
  clear(e) {
    const t = Object.keys(this);
    let r = t.length, a = !1;
    for (; r--; ) {
      const i = t[r];
      (!e || qa(this, this[i], i, e, !0)) && (delete this[i], a = !0);
    }
    return a;
  }
  normalize(e) {
    const t = this, r = {};
    return x.forEach(this, (a, i) => {
      const o = x.findKey(r, i);
      if (o) {
        t[o] = Br(a), delete t[i];
        return;
      }
      const s = e ? my(i) : String(i).trim();
      s !== i && delete t[i], t[s] = Br(a), r[s] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return x.forEach(this, (r, a) => {
      r != null && r !== !1 && (t[a] = e && x.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const r = new this(e);
    return t.forEach((a) => r.set(a)), r;
  }
  static accessor(e) {
    const r = (this[Ys] = this[Ys] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function i(o) {
      const s = Yn(o);
      r[s] || (vy(a, o), r[s] = !0);
    }
    return x.isArray(e) ? e.forEach(i) : i(e), this;
  }
}
Be.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
x.reduceDescriptors(Be.prototype, ({ value: n }, e) => {
  let t = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => n,
    set(r) {
      this[t] = r;
    }
  };
});
x.freezeMethods(Be);
function Wa(n, e) {
  const t = this || yr, r = e || t, a = Be.from(r.headers);
  let i = r.data;
  return x.forEach(n, function(s) {
    i = s.call(t, i, a.normalize(), e ? e.status : void 0);
  }), a.normalize(), i;
}
function Wu(n) {
  return !!(n && n.__CANCEL__);
}
function Rn(n, e, t) {
  Z.call(this, n ?? "canceled", Z.ERR_CANCELED, e, t), this.name = "CanceledError";
}
x.inherits(Rn, Z, {
  __CANCEL__: !0
});
function Vu(n, e, t) {
  const r = t.config.validateStatus;
  !t.status || !r || r(t.status) ? n(t) : e(new Z(
    "Request failed with status code " + t.status,
    [Z.ERR_BAD_REQUEST, Z.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function gy(n) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(n);
  return e && e[1] || "";
}
function yy(n, e) {
  n = n || 10;
  const t = new Array(n), r = new Array(n);
  let a = 0, i = 0, o;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const u = Date.now(), c = r[i];
    o || (o = u), t[a] = l, r[a] = u;
    let p = i, m = 0;
    for (; p !== a; )
      m += t[p++], p = p % n;
    if (a = (a + 1) % n, a === i && (i = (i + 1) % n), u - o < e)
      return;
    const y = c && u - c;
    return y ? Math.round(m * 1e3 / y) : void 0;
  };
}
function by(n, e) {
  let t = 0, r = 1e3 / e, a, i;
  const o = (u, c = Date.now()) => {
    t = c, a = null, i && (clearTimeout(i), i = null), n.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), p = c - t;
    p >= r ? o(u, c) : (a = u, i || (i = setTimeout(() => {
      i = null, o(a);
    }, r - p)));
  }, () => a && o(a)];
}
const Gr = (n, e, t = 3) => {
  let r = 0;
  const a = yy(50, 250);
  return by((i) => {
    const o = i.loaded, s = i.lengthComputable ? i.total : void 0, l = o - r, u = a(l), c = o <= s;
    r = o;
    const p = {
      loaded: o,
      total: s,
      progress: s ? o / s : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && s && c ? (s - o) / u : void 0,
      event: i,
      lengthComputable: s != null,
      [e ? "download" : "upload"]: !0
    };
    n(p);
  }, t);
}, Ks = (n, e) => {
  const t = n != null;
  return [(r) => e[0]({
    lengthComputable: t,
    total: n,
    loaded: r
  }), e[1]];
}, Gs = (n) => (...e) => x.asap(() => n(...e)), _y = Le.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = Le.navigator && /(msie|trident)/i.test(Le.navigator.userAgent), t = document.createElement("a");
    let r;
    function a(i) {
      let o = i;
      return e && (t.setAttribute("href", o), o = t.href), t.setAttribute("href", o), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return r = a(window.location.href), function(o) {
      const s = x.isString(o) ? a(o) : o;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), wy = Le.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(n, e, t, r, a, i) {
      const o = [n + "=" + encodeURIComponent(e)];
      x.isNumber(t) && o.push("expires=" + new Date(t).toGMTString()), x.isString(r) && o.push("path=" + r), x.isString(a) && o.push("domain=" + a), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(n) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(n) {
      this.write(n, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Cy(n) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(n);
}
function Sy(n, e) {
  return e ? n.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : n;
}
function Yu(n, e) {
  return n && !Cy(e) ? Sy(n, e) : e;
}
const Qs = (n) => n instanceof Be ? { ...n } : n;
function en(n, e) {
  e = e || {};
  const t = {};
  function r(u, c, p) {
    return x.isPlainObject(u) && x.isPlainObject(c) ? x.merge.call({ caseless: p }, u, c) : x.isPlainObject(c) ? x.merge({}, c) : x.isArray(c) ? c.slice() : c;
  }
  function a(u, c, p) {
    if (x.isUndefined(c)) {
      if (!x.isUndefined(u))
        return r(void 0, u, p);
    } else return r(u, c, p);
  }
  function i(u, c) {
    if (!x.isUndefined(c))
      return r(void 0, c);
  }
  function o(u, c) {
    if (x.isUndefined(c)) {
      if (!x.isUndefined(u))
        return r(void 0, u);
    } else return r(void 0, c);
  }
  function s(u, c, p) {
    if (p in e)
      return r(u, c);
    if (p in n)
      return r(void 0, u);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: s,
    headers: (u, c) => a(Qs(u), Qs(c), !0)
  };
  return x.forEach(Object.keys(Object.assign({}, n, e)), function(c) {
    const p = l[c] || a, m = p(n[c], e[c], c);
    x.isUndefined(m) && p !== s || (t[c] = m);
  }), t;
}
const Ku = (n) => {
  const e = en({}, n);
  let { data: t, withXSRFToken: r, xsrfHeaderName: a, xsrfCookieName: i, headers: o, auth: s } = e;
  e.headers = o = Be.from(o), e.url = zu(Yu(e.baseURL, e.url), n.params, n.paramsSerializer), s && o.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (x.isFormData(t)) {
    if (Le.hasStandardBrowserEnv || Le.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((l = o.getContentType()) !== !1) {
      const [u, ...c] = l ? l.split(";").map((p) => p.trim()).filter(Boolean) : [];
      o.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (Le.hasStandardBrowserEnv && (r && x.isFunction(r) && (r = r(e)), r || r !== !1 && _y(e.url))) {
    const u = a && i && wy.read(i);
    u && o.set(a, u);
  }
  return e;
}, xy = typeof XMLHttpRequest < "u", Oy = xy && function(n) {
  return new Promise(function(t, r) {
    const a = Ku(n);
    let i = a.data;
    const o = Be.from(a.headers).normalize();
    let { responseType: s, onUploadProgress: l, onDownloadProgress: u } = a, c, p, m, y, g;
    function b() {
      y && y(), g && g(), a.cancelToken && a.cancelToken.unsubscribe(c), a.signal && a.signal.removeEventListener("abort", c);
    }
    let w = new XMLHttpRequest();
    w.open(a.method.toUpperCase(), a.url, !0), w.timeout = a.timeout;
    function C() {
      if (!w)
        return;
      const A = Be.from(
        "getAllResponseHeaders" in w && w.getAllResponseHeaders()
      ), E = {
        data: !s || s === "text" || s === "json" ? w.responseText : w.response,
        status: w.status,
        statusText: w.statusText,
        headers: A,
        config: n,
        request: w
      };
      Vu(function(M) {
        t(M), b();
      }, function(M) {
        r(M), b();
      }, E), w = null;
    }
    "onloadend" in w ? w.onloadend = C : w.onreadystatechange = function() {
      !w || w.readyState !== 4 || w.status === 0 && !(w.responseURL && w.responseURL.indexOf("file:") === 0) || setTimeout(C);
    }, w.onabort = function() {
      w && (r(new Z("Request aborted", Z.ECONNABORTED, n, w)), w = null);
    }, w.onerror = function() {
      r(new Z("Network Error", Z.ERR_NETWORK, n, w)), w = null;
    }, w.ontimeout = function() {
      let h = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const E = a.transitional || Uu;
      a.timeoutErrorMessage && (h = a.timeoutErrorMessage), r(new Z(
        h,
        E.clarifyTimeoutError ? Z.ETIMEDOUT : Z.ECONNABORTED,
        n,
        w
      )), w = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in w && x.forEach(o.toJSON(), function(h, E) {
      w.setRequestHeader(E, h);
    }), x.isUndefined(a.withCredentials) || (w.withCredentials = !!a.withCredentials), s && s !== "json" && (w.responseType = a.responseType), u && ([m, g] = Gr(u, !0), w.addEventListener("progress", m)), l && w.upload && ([p, y] = Gr(l), w.upload.addEventListener("progress", p), w.upload.addEventListener("loadend", y)), (a.cancelToken || a.signal) && (c = (A) => {
      w && (r(!A || A.type ? new Rn(null, n, w) : A), w.abort(), w = null);
    }, a.cancelToken && a.cancelToken.subscribe(c), a.signal && (a.signal.aborted ? c() : a.signal.addEventListener("abort", c)));
    const S = gy(a.url);
    if (S && Le.protocols.indexOf(S) === -1) {
      r(new Z("Unsupported protocol " + S + ":", Z.ERR_BAD_REQUEST, n));
      return;
    }
    w.send(i || null);
  });
}, Ay = (n, e) => {
  const { length: t } = n = n ? n.filter(Boolean) : [];
  if (e || t) {
    let r = new AbortController(), a;
    const i = function(u) {
      if (!a) {
        a = !0, s();
        const c = u instanceof Error ? u : this.reason;
        r.abort(c instanceof Z ? c : new Rn(c instanceof Error ? c.message : c));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new Z(`timeout ${e} of ms exceeded`, Z.ETIMEDOUT));
    }, e);
    const s = () => {
      n && (o && clearTimeout(o), o = null, n.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), n = null);
    };
    n.forEach((u) => u.addEventListener("abort", i));
    const { signal: l } = r;
    return l.unsubscribe = () => x.asap(s), l;
  }
}, $y = function* (n, e) {
  let t = n.byteLength;
  if (!e || t < e) {
    yield n;
    return;
  }
  let r = 0, a;
  for (; r < t; )
    a = r + e, yield n.slice(r, a), r = a;
}, Ey = async function* (n, e) {
  for await (const t of ky(n))
    yield* $y(t, e);
}, ky = async function* (n) {
  if (n[Symbol.asyncIterator]) {
    yield* n;
    return;
  }
  const e = n.getReader();
  try {
    for (; ; ) {
      const { done: t, value: r } = await e.read();
      if (t)
        break;
      yield r;
    }
  } finally {
    await e.cancel();
  }
}, Js = (n, e, t, r) => {
  const a = Ey(n, e);
  let i = 0, o, s = (l) => {
    o || (o = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: c } = await a.next();
        if (u) {
          s(), l.close();
          return;
        }
        let p = c.byteLength;
        if (t) {
          let m = i += p;
          t(m);
        }
        l.enqueue(new Uint8Array(c));
      } catch (u) {
        throw s(u), u;
      }
    },
    cancel(l) {
      return s(l), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, wa = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Gu = wa && typeof ReadableStream == "function", Dy = wa && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((n) => (e) => n.encode(e))(new TextEncoder()) : async (n) => new Uint8Array(await new Response(n).arrayBuffer())), Qu = (n, ...e) => {
  try {
    return !!n(...e);
  } catch {
    return !1;
  }
}, Ty = Gu && Qu(() => {
  let n = !1;
  const e = new Request(Le.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return n = !0, "half";
    }
  }).headers.has("Content-Type");
  return n && !e;
}), Zs = 64 * 1024, Ri = Gu && Qu(() => x.isReadableStream(new Response("").body)), Qr = {
  stream: Ri && ((n) => n.body)
};
wa && ((n) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Qr[e] && (Qr[e] = x.isFunction(n[e]) ? (t) => t[e]() : (t, r) => {
      throw new Z(`Response type '${e}' is not supported`, Z.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const My = async (n) => {
  if (n == null)
    return 0;
  if (x.isBlob(n))
    return n.size;
  if (x.isSpecCompliantForm(n))
    return (await new Request(Le.origin, {
      method: "POST",
      body: n
    }).arrayBuffer()).byteLength;
  if (x.isArrayBufferView(n) || x.isArrayBuffer(n))
    return n.byteLength;
  if (x.isURLSearchParams(n) && (n = n + ""), x.isString(n))
    return (await Dy(n)).byteLength;
}, Py = async (n, e) => {
  const t = x.toFiniteNumber(n.getContentLength());
  return t ?? My(e);
}, Iy = wa && (async (n) => {
  let {
    url: e,
    method: t,
    data: r,
    signal: a,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: u,
    headers: c,
    withCredentials: p = "same-origin",
    fetchOptions: m
  } = Ku(n);
  u = u ? (u + "").toLowerCase() : "text";
  let y = Ay([a, i && i.toAbortSignal()], o), g;
  const b = y && y.unsubscribe && (() => {
    y.unsubscribe();
  });
  let w;
  try {
    if (l && Ty && t !== "get" && t !== "head" && (w = await Py(c, r)) !== 0) {
      let E = new Request(e, {
        method: "POST",
        body: r,
        duplex: "half"
      }), _;
      if (x.isFormData(r) && (_ = E.headers.get("content-type")) && c.setContentType(_), E.body) {
        const [M, L] = Ks(
          w,
          Gr(Gs(l))
        );
        r = Js(E.body, Zs, M, L);
      }
    }
    x.isString(p) || (p = p ? "include" : "omit");
    const C = "credentials" in Request.prototype;
    g = new Request(e, {
      ...m,
      signal: y,
      method: t.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: C ? p : void 0
    });
    let S = await fetch(g);
    const A = Ri && (u === "stream" || u === "response");
    if (Ri && (s || A && b)) {
      const E = {};
      ["status", "statusText", "headers"].forEach((z) => {
        E[z] = S[z];
      });
      const _ = x.toFiniteNumber(S.headers.get("content-length")), [M, L] = s && Ks(
        _,
        Gr(Gs(s), !0)
      ) || [];
      S = new Response(
        Js(S.body, Zs, M, () => {
          L && L(), b && b();
        }),
        E
      );
    }
    u = u || "text";
    let h = await Qr[x.findKey(Qr, u) || "text"](S, n);
    return !A && b && b(), await new Promise((E, _) => {
      Vu(E, _, {
        data: h,
        headers: Be.from(S.headers),
        status: S.status,
        statusText: S.statusText,
        config: n,
        request: g
      });
    });
  } catch (C) {
    throw b && b(), C && C.name === "TypeError" && /fetch/i.test(C.message) ? Object.assign(
      new Z("Network Error", Z.ERR_NETWORK, n, g),
      {
        cause: C.cause || C
      }
    ) : Z.from(C, C && C.code, n, g);
  }
}), Ni = {
  http: G0,
  xhr: Oy,
  fetch: Iy
};
x.forEach(Ni, (n, e) => {
  if (n) {
    try {
      Object.defineProperty(n, "name", { value: e });
    } catch {
    }
    Object.defineProperty(n, "adapterName", { value: e });
  }
});
const Xs = (n) => `- ${n}`, Ry = (n) => x.isFunction(n) || n === null || n === !1, Ju = {
  getAdapter: (n) => {
    n = x.isArray(n) ? n : [n];
    const { length: e } = n;
    let t, r;
    const a = {};
    for (let i = 0; i < e; i++) {
      t = n[i];
      let o;
      if (r = t, !Ry(t) && (r = Ni[(o = String(t)).toLowerCase()], r === void 0))
        throw new Z(`Unknown adapter '${o}'`);
      if (r)
        break;
      a[o || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(a).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = e ? i.length > 1 ? `since :
` + i.map(Xs).join(`
`) : " " + Xs(i[0]) : "as no adapter specified";
      throw new Z(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Ni
};
function Va(n) {
  if (n.cancelToken && n.cancelToken.throwIfRequested(), n.signal && n.signal.aborted)
    throw new Rn(null, n);
}
function el(n) {
  return Va(n), n.headers = Be.from(n.headers), n.data = Wa.call(
    n,
    n.transformRequest
  ), ["post", "put", "patch"].indexOf(n.method) !== -1 && n.headers.setContentType("application/x-www-form-urlencoded", !1), Ju.getAdapter(n.adapter || yr.adapter)(n).then(function(r) {
    return Va(n), r.data = Wa.call(
      n,
      n.transformResponse,
      r
    ), r.headers = Be.from(r.headers), r;
  }, function(r) {
    return Wu(r) || (Va(n), r && r.response && (r.response.data = Wa.call(
      n,
      n.transformResponse,
      r.response
    ), r.response.headers = Be.from(r.response.headers))), Promise.reject(r);
  });
}
const Zu = "1.7.7", Oo = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((n, e) => {
  Oo[n] = function(r) {
    return typeof r === n || "a" + (e < 1 ? "n " : " ") + n;
  };
});
const tl = {};
Oo.transitional = function(e, t, r) {
  function a(i, o) {
    return "[Axios v" + Zu + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
  }
  return (i, o, s) => {
    if (e === !1)
      throw new Z(
        a(o, " has been removed" + (t ? " in " + t : "")),
        Z.ERR_DEPRECATED
      );
    return t && !tl[o] && (tl[o] = !0, console.warn(
      a(
        o,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(i, o, s) : !0;
  };
};
function Ny(n, e, t) {
  if (typeof n != "object")
    throw new Z("options must be an object", Z.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(n);
  let a = r.length;
  for (; a-- > 0; ) {
    const i = r[a], o = e[i];
    if (o) {
      const s = n[i], l = s === void 0 || o(s, i, n);
      if (l !== !0)
        throw new Z("option " + i + " must be " + l, Z.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new Z("Unknown option " + i, Z.ERR_BAD_OPTION);
  }
}
const Fi = {
  assertOptions: Ny,
  validators: Oo
}, Et = Fi.validators;
class Kt {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new Vs(),
      response: new Vs()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (r) {
      if (r instanceof Error) {
        let a;
        Error.captureStackTrace ? Error.captureStackTrace(a = {}) : a = new Error();
        const i = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = en(this.defaults, t);
    const { transitional: r, paramsSerializer: a, headers: i } = t;
    r !== void 0 && Fi.assertOptions(r, {
      silentJSONParsing: Et.transitional(Et.boolean),
      forcedJSONParsing: Et.transitional(Et.boolean),
      clarifyTimeoutError: Et.transitional(Et.boolean)
    }, !1), a != null && (x.isFunction(a) ? t.paramsSerializer = {
      serialize: a
    } : Fi.assertOptions(a, {
      encode: Et.function,
      serialize: Et.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let o = i && x.merge(
      i.common,
      i[t.method]
    );
    i && x.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (g) => {
        delete i[g];
      }
    ), t.headers = Be.concat(o, i);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(b) {
      typeof b.runWhen == "function" && b.runWhen(t) === !1 || (l = l && b.synchronous, s.unshift(b.fulfilled, b.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(b) {
      u.push(b.fulfilled, b.rejected);
    });
    let c, p = 0, m;
    if (!l) {
      const g = [el.bind(this), void 0];
      for (g.unshift.apply(g, s), g.push.apply(g, u), m = g.length, c = Promise.resolve(t); p < m; )
        c = c.then(g[p++], g[p++]);
      return c;
    }
    m = s.length;
    let y = t;
    for (p = 0; p < m; ) {
      const g = s[p++], b = s[p++];
      try {
        y = g(y);
      } catch (w) {
        b.call(this, w);
        break;
      }
    }
    try {
      c = el.call(this, y);
    } catch (g) {
      return Promise.reject(g);
    }
    for (p = 0, m = u.length; p < m; )
      c = c.then(u[p++], u[p++]);
    return c;
  }
  getUri(e) {
    e = en(this.defaults, e);
    const t = Yu(e.baseURL, e.url);
    return zu(t, e.params, e.paramsSerializer);
  }
}
x.forEach(["delete", "get", "head", "options"], function(e) {
  Kt.prototype[e] = function(t, r) {
    return this.request(en(r || {}, {
      method: e,
      url: t,
      data: (r || {}).data
    }));
  };
});
x.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(i, o, s) {
      return this.request(en(s || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  Kt.prototype[e] = t(), Kt.prototype[e + "Form"] = t(!0);
});
class Ao {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(i) {
      t = i;
    });
    const r = this;
    this.promise.then((a) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](a);
      r._listeners = null;
    }), this.promise.then = (a) => {
      let i;
      const o = new Promise((s) => {
        r.subscribe(s), i = s;
      }).then(a);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, e(function(i, o, s) {
      r.reason || (r.reason = new Rn(i, o, s), t(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), t = (r) => {
      e.abort(r);
    };
    return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Ao(function(a) {
        e = a;
      }),
      cancel: e
    };
  }
}
function Fy(n) {
  return function(t) {
    return n.apply(null, t);
  };
}
function Ly(n) {
  return x.isObject(n) && n.isAxiosError === !0;
}
const Li = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Li).forEach(([n, e]) => {
  Li[e] = n;
});
function Xu(n) {
  const e = new Kt(n), t = Du(Kt.prototype.request, e);
  return x.extend(t, Kt.prototype, e, { allOwnKeys: !0 }), x.extend(t, e, null, { allOwnKeys: !0 }), t.create = function(a) {
    return Xu(en(n, a));
  }, t;
}
const ve = Xu(yr);
ve.Axios = Kt;
ve.CanceledError = Rn;
ve.CancelToken = Ao;
ve.isCancel = Wu;
ve.VERSION = Zu;
ve.toFormData = _a;
ve.AxiosError = Z;
ve.Cancel = ve.CanceledError;
ve.all = function(e) {
  return Promise.all(e);
};
ve.spread = Fy;
ve.isAxiosError = Ly;
ve.mergeConfig = en;
ve.AxiosHeaders = Be;
ve.formToJSON = (n) => qu(x.isHTMLForm(n) ? new FormData(n) : n);
ve.getAdapter = Ju.getAdapter;
ve.HttpStatusCode = Li;
ve.default = ve;
var By = Error, jy = EvalError, Hy = RangeError, zy = ReferenceError, ef = SyntaxError, br = TypeError, Uy = URIError, qy = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, t = Symbol("test"), r = Object(t);
  if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
    return !1;
  var a = 42;
  e[t] = a;
  for (t in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var i = Object.getOwnPropertySymbols(e);
  if (i.length !== 1 || i[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var o = Object.getOwnPropertyDescriptor(e, t);
    if (o.value !== a || o.enumerable !== !0)
      return !1;
  }
  return !0;
}, nl = typeof Symbol < "u" && Symbol, Wy = qy, Vy = function() {
  return typeof nl != "function" || typeof Symbol != "function" || typeof nl("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Wy();
}, Ya = {
  __proto__: null,
  foo: {}
}, Yy = Object, Ky = function() {
  return { __proto__: Ya }.foo === Ya.foo && !(Ya instanceof Yy);
}, Gy = "Function.prototype.bind called on incompatible ", Qy = Object.prototype.toString, Jy = Math.max, Zy = "[object Function]", rl = function(e, t) {
  for (var r = [], a = 0; a < e.length; a += 1)
    r[a] = e[a];
  for (var i = 0; i < t.length; i += 1)
    r[i + e.length] = t[i];
  return r;
}, Xy = function(e, t) {
  for (var r = [], a = t, i = 0; a < e.length; a += 1, i += 1)
    r[i] = e[a];
  return r;
}, e2 = function(n, e) {
  for (var t = "", r = 0; r < n.length; r += 1)
    t += n[r], r + 1 < n.length && (t += e);
  return t;
}, t2 = function(e) {
  var t = this;
  if (typeof t != "function" || Qy.apply(t) !== Zy)
    throw new TypeError(Gy + t);
  for (var r = Xy(arguments, 1), a, i = function() {
    if (this instanceof a) {
      var c = t.apply(
        this,
        rl(r, arguments)
      );
      return Object(c) === c ? c : this;
    }
    return t.apply(
      e,
      rl(r, arguments)
    );
  }, o = Jy(0, t.length - r.length), s = [], l = 0; l < o; l++)
    s[l] = "$" + l;
  if (a = Function("binder", "return function (" + e2(s, ",") + "){ return binder.apply(this,arguments); }")(i), t.prototype) {
    var u = function() {
    };
    u.prototype = t.prototype, a.prototype = new u(), u.prototype = null;
  }
  return a;
}, n2 = t2, $o = Function.prototype.bind || n2, r2 = Function.prototype.call, a2 = Object.prototype.hasOwnProperty, i2 = $o, o2 = i2.call(r2, a2), re, s2 = By, l2 = jy, c2 = Hy, u2 = zy, $n = ef, bn = br, f2 = Uy, tf = Function, Ka = function(n) {
  try {
    return tf('"use strict"; return (' + n + ").constructor;")();
  } catch {
  }
}, Gt = Object.getOwnPropertyDescriptor;
if (Gt)
  try {
    Gt({}, "");
  } catch {
    Gt = null;
  }
var Ga = function() {
  throw new bn();
}, d2 = Gt ? function() {
  try {
    return arguments.callee, Ga;
  } catch {
    try {
      return Gt(arguments, "callee").get;
    } catch {
      return Ga;
    }
  }
}() : Ga, fn = Vy(), p2 = Ky(), Oe = Object.getPrototypeOf || (p2 ? function(n) {
  return n.__proto__;
} : null), hn = {}, h2 = typeof Uint8Array > "u" || !Oe ? re : Oe(Uint8Array), Qt = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? re : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? re : ArrayBuffer,
  "%ArrayIteratorPrototype%": fn && Oe ? Oe([][Symbol.iterator]()) : re,
  "%AsyncFromSyncIteratorPrototype%": re,
  "%AsyncFunction%": hn,
  "%AsyncGenerator%": hn,
  "%AsyncGeneratorFunction%": hn,
  "%AsyncIteratorPrototype%": hn,
  "%Atomics%": typeof Atomics > "u" ? re : Atomics,
  "%BigInt%": typeof BigInt > "u" ? re : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? re : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? re : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? re : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": s2,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": l2,
  "%Float32Array%": typeof Float32Array > "u" ? re : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? re : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? re : FinalizationRegistry,
  "%Function%": tf,
  "%GeneratorFunction%": hn,
  "%Int8Array%": typeof Int8Array > "u" ? re : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? re : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? re : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": fn && Oe ? Oe(Oe([][Symbol.iterator]())) : re,
  "%JSON%": typeof JSON == "object" ? JSON : re,
  "%Map%": typeof Map > "u" ? re : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !fn || !Oe ? re : Oe((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? re : Promise,
  "%Proxy%": typeof Proxy > "u" ? re : Proxy,
  "%RangeError%": c2,
  "%ReferenceError%": u2,
  "%Reflect%": typeof Reflect > "u" ? re : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? re : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !fn || !Oe ? re : Oe((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? re : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": fn && Oe ? Oe(""[Symbol.iterator]()) : re,
  "%Symbol%": fn ? Symbol : re,
  "%SyntaxError%": $n,
  "%ThrowTypeError%": d2,
  "%TypedArray%": h2,
  "%TypeError%": bn,
  "%Uint8Array%": typeof Uint8Array > "u" ? re : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? re : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? re : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? re : Uint32Array,
  "%URIError%": f2,
  "%WeakMap%": typeof WeakMap > "u" ? re : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? re : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? re : WeakSet
};
if (Oe)
  try {
    null.error;
  } catch (n) {
    var m2 = Oe(Oe(n));
    Qt["%Error.prototype%"] = m2;
  }
var v2 = function n(e) {
  var t;
  if (e === "%AsyncFunction%")
    t = Ka("async function () {}");
  else if (e === "%GeneratorFunction%")
    t = Ka("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    t = Ka("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var r = n("%AsyncGeneratorFunction%");
    r && (t = r.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var a = n("%AsyncGenerator%");
    a && Oe && (t = Oe(a.prototype));
  }
  return Qt[e] = t, t;
}, al = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, _r = $o, Jr = o2, g2 = _r.call(Function.call, Array.prototype.concat), y2 = _r.call(Function.apply, Array.prototype.splice), il = _r.call(Function.call, String.prototype.replace), Zr = _r.call(Function.call, String.prototype.slice), b2 = _r.call(Function.call, RegExp.prototype.exec), _2 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, w2 = /\\(\\)?/g, C2 = function(e) {
  var t = Zr(e, 0, 1), r = Zr(e, -1);
  if (t === "%" && r !== "%")
    throw new $n("invalid intrinsic syntax, expected closing `%`");
  if (r === "%" && t !== "%")
    throw new $n("invalid intrinsic syntax, expected opening `%`");
  var a = [];
  return il(e, _2, function(i, o, s, l) {
    a[a.length] = s ? il(l, w2, "$1") : o || i;
  }), a;
}, S2 = function(e, t) {
  var r = e, a;
  if (Jr(al, r) && (a = al[r], r = "%" + a[0] + "%"), Jr(Qt, r)) {
    var i = Qt[r];
    if (i === hn && (i = v2(r)), typeof i > "u" && !t)
      throw new bn("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: a,
      name: r,
      value: i
    };
  }
  throw new $n("intrinsic " + e + " does not exist!");
}, Nn = function(e, t) {
  if (typeof e != "string" || e.length === 0)
    throw new bn("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof t != "boolean")
    throw new bn('"allowMissing" argument must be a boolean');
  if (b2(/^%?[^%]*%?$/, e) === null)
    throw new $n("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var r = C2(e), a = r.length > 0 ? r[0] : "", i = S2("%" + a + "%", t), o = i.name, s = i.value, l = !1, u = i.alias;
  u && (a = u[0], y2(r, g2([0, 1], u)));
  for (var c = 1, p = !0; c < r.length; c += 1) {
    var m = r[c], y = Zr(m, 0, 1), g = Zr(m, -1);
    if ((y === '"' || y === "'" || y === "`" || g === '"' || g === "'" || g === "`") && y !== g)
      throw new $n("property names with quotes must have matching quotes");
    if ((m === "constructor" || !p) && (l = !0), a += "." + m, o = "%" + a + "%", Jr(Qt, o))
      s = Qt[o];
    else if (s != null) {
      if (!(m in s)) {
        if (!t)
          throw new bn("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (Gt && c + 1 >= r.length) {
        var b = Gt(s, m);
        p = !!b, p && "get" in b && !("originalValue" in b.get) ? s = b.get : s = s[m];
      } else
        p = Jr(s, m), s = s[m];
      p && !l && (Qt[o] = s);
    }
  }
  return s;
}, nf = { exports: {} }, Qa, ol;
function Eo() {
  if (ol) return Qa;
  ol = 1;
  var n = Nn, e = n("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Qa = e, Qa;
}
var x2 = Nn, jr = x2("%Object.getOwnPropertyDescriptor%", !0);
if (jr)
  try {
    jr([], "length");
  } catch {
    jr = null;
  }
var rf = jr, sl = Eo(), O2 = ef, dn = br, ll = rf, A2 = function(e, t, r) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new dn("`obj` must be an object or a function`");
  if (typeof t != "string" && typeof t != "symbol")
    throw new dn("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new dn("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new dn("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new dn("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new dn("`loose`, if provided, must be a boolean");
  var a = arguments.length > 3 ? arguments[3] : null, i = arguments.length > 4 ? arguments[4] : null, o = arguments.length > 5 ? arguments[5] : null, s = arguments.length > 6 ? arguments[6] : !1, l = !!ll && ll(e, t);
  if (sl)
    sl(e, t, {
      configurable: o === null && l ? l.configurable : !o,
      enumerable: a === null && l ? l.enumerable : !a,
      value: r,
      writable: i === null && l ? l.writable : !i
    });
  else if (s || !a && !i && !o)
    e[t] = r;
  else
    throw new O2("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Bi = Eo(), af = function() {
  return !!Bi;
};
af.hasArrayLengthDefineBug = function() {
  if (!Bi)
    return null;
  try {
    return Bi([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var $2 = af, E2 = Nn, cl = A2, k2 = $2(), ul = rf, fl = br, D2 = E2("%Math.floor%"), T2 = function(e, t) {
  if (typeof e != "function")
    throw new fl("`fn` is not a function");
  if (typeof t != "number" || t < 0 || t > 4294967295 || D2(t) !== t)
    throw new fl("`length` must be a positive 32-bit integer");
  var r = arguments.length > 2 && !!arguments[2], a = !0, i = !0;
  if ("length" in e && ul) {
    var o = ul(e, "length");
    o && !o.configurable && (a = !1), o && !o.writable && (i = !1);
  }
  return (a || i || !r) && (k2 ? cl(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    t,
    !0,
    !0
  ) : cl(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    t
  )), e;
};
(function(n) {
  var e = $o, t = Nn, r = T2, a = br, i = t("%Function.prototype.apply%"), o = t("%Function.prototype.call%"), s = t("%Reflect.apply%", !0) || e.call(o, i), l = Eo(), u = t("%Math.max%");
  n.exports = function(m) {
    if (typeof m != "function")
      throw new a("a function is required");
    var y = s(e, o, arguments);
    return r(
      y,
      1 + u(0, m.length - (arguments.length - 1)),
      !0
    );
  };
  var c = function() {
    return s(e, i, arguments);
  };
  l ? l(n.exports, "apply", { value: c }) : n.exports.apply = c;
})(nf);
var M2 = nf.exports, of = Nn, sf = M2, P2 = sf(of("String.prototype.indexOf")), I2 = function(e, t) {
  var r = of(e, !!t);
  return typeof r == "function" && P2(e, ".prototype.") > -1 ? sf(r) : r;
};
const R2 = {}, N2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R2
}, Symbol.toStringTag, { value: "Module" })), F2 = /* @__PURE__ */ jc(N2);
var ko = typeof Map == "function" && Map.prototype, Ja = Object.getOwnPropertyDescriptor && ko ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, Xr = ko && Ja && typeof Ja.get == "function" ? Ja.get : null, dl = ko && Map.prototype.forEach, Do = typeof Set == "function" && Set.prototype, Za = Object.getOwnPropertyDescriptor && Do ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, ea = Do && Za && typeof Za.get == "function" ? Za.get : null, pl = Do && Set.prototype.forEach, L2 = typeof WeakMap == "function" && WeakMap.prototype, tr = L2 ? WeakMap.prototype.has : null, B2 = typeof WeakSet == "function" && WeakSet.prototype, nr = B2 ? WeakSet.prototype.has : null, j2 = typeof WeakRef == "function" && WeakRef.prototype, hl = j2 ? WeakRef.prototype.deref : null, H2 = Boolean.prototype.valueOf, z2 = Object.prototype.toString, U2 = Function.prototype.toString, q2 = String.prototype.match, To = String.prototype.slice, Tt = String.prototype.replace, W2 = String.prototype.toUpperCase, ml = String.prototype.toLowerCase, lf = RegExp.prototype.test, vl = Array.prototype.concat, ct = Array.prototype.join, V2 = Array.prototype.slice, gl = Math.floor, ji = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Xa = Object.getOwnPropertySymbols, Hi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, En = typeof Symbol == "function" && typeof Symbol.iterator == "object", ke = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === En || !0) ? Symbol.toStringTag : null, cf = Object.prototype.propertyIsEnumerable, yl = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(n) {
  return n.__proto__;
} : null);
function bl(n, e) {
  if (n === 1 / 0 || n === -1 / 0 || n !== n || n && n > -1e3 && n < 1e3 || lf.call(/e/, e))
    return e;
  var t = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof n == "number") {
    var r = n < 0 ? -gl(-n) : gl(n);
    if (r !== n) {
      var a = String(r), i = To.call(e, a.length + 1);
      return Tt.call(a, t, "$&_") + "." + Tt.call(Tt.call(i, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return Tt.call(e, t, "$&_");
}
var zi = F2, _l = zi.custom, wl = ff(_l) ? _l : null, Y2 = function n(e, t, r, a) {
  var i = t || {};
  if (kt(i, "quoteStyle") && i.quoteStyle !== "single" && i.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (kt(i, "maxStringLength") && (typeof i.maxStringLength == "number" ? i.maxStringLength < 0 && i.maxStringLength !== 1 / 0 : i.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var o = kt(i, "customInspect") ? i.customInspect : !0;
  if (typeof o != "boolean" && o !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (kt(i, "indent") && i.indent !== null && i.indent !== "	" && !(parseInt(i.indent, 10) === i.indent && i.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (kt(i, "numericSeparator") && typeof i.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var s = i.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return pf(e, i);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var l = String(e);
    return s ? bl(e, l) : l;
  }
  if (typeof e == "bigint") {
    var u = String(e) + "n";
    return s ? bl(e, u) : u;
  }
  var c = typeof i.depth > "u" ? 5 : i.depth;
  if (typeof r > "u" && (r = 0), r >= c && c > 0 && typeof e == "object")
    return Ui(e) ? "[Array]" : "[Object]";
  var p = fb(i, r);
  if (typeof a > "u")
    a = [];
  else if (df(a, e) >= 0)
    return "[Circular]";
  function m(G, F, D) {
    if (F && (a = V2.call(a), a.push(F)), D) {
      var k = {
        depth: i.depth
      };
      return kt(i, "quoteStyle") && (k.quoteStyle = i.quoteStyle), n(G, k, r + 1, a);
    }
    return n(G, i, r + 1, a);
  }
  if (typeof e == "function" && !Cl(e)) {
    var y = nb(e), g = Er(e, m);
    return "[Function" + (y ? ": " + y : " (anonymous)") + "]" + (g.length > 0 ? " { " + ct.call(g, ", ") + " }" : "");
  }
  if (ff(e)) {
    var b = En ? Tt.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : Hi.call(e);
    return typeof e == "object" && !En ? Kn(b) : b;
  }
  if (lb(e)) {
    for (var w = "<" + ml.call(String(e.nodeName)), C = e.attributes || [], S = 0; S < C.length; S++)
      w += " " + C[S].name + "=" + uf(K2(C[S].value), "double", i);
    return w += ">", e.childNodes && e.childNodes.length && (w += "..."), w += "</" + ml.call(String(e.nodeName)) + ">", w;
  }
  if (Ui(e)) {
    if (e.length === 0)
      return "[]";
    var A = Er(e, m);
    return p && !ub(A) ? "[" + qi(A, p) + "]" : "[ " + ct.call(A, ", ") + " ]";
  }
  if (Q2(e)) {
    var h = Er(e, m);
    return !("cause" in Error.prototype) && "cause" in e && !cf.call(e, "cause") ? "{ [" + String(e) + "] " + ct.call(vl.call("[cause]: " + m(e.cause), h), ", ") + " }" : h.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + ct.call(h, ", ") + " }";
  }
  if (typeof e == "object" && o) {
    if (wl && typeof e[wl] == "function" && zi)
      return zi(e, { depth: c - r });
    if (o !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (rb(e)) {
    var E = [];
    return dl && dl.call(e, function(G, F) {
      E.push(m(F, e, !0) + " => " + m(G, e));
    }), Sl("Map", Xr.call(e), E, p);
  }
  if (ob(e)) {
    var _ = [];
    return pl && pl.call(e, function(G) {
      _.push(m(G, e));
    }), Sl("Set", ea.call(e), _, p);
  }
  if (ab(e))
    return ei("WeakMap");
  if (sb(e))
    return ei("WeakSet");
  if (ib(e))
    return ei("WeakRef");
  if (Z2(e))
    return Kn(m(Number(e)));
  if (eb(e))
    return Kn(m(ji.call(e)));
  if (X2(e))
    return Kn(H2.call(e));
  if (J2(e))
    return Kn(m(String(e)));
  if (typeof window < "u" && e === window)
    return "{ [object Window] }";
  if (typeof globalThis < "u" && e === globalThis || typeof Dt < "u" && e === Dt)
    return "{ [object globalThis] }";
  if (!G2(e) && !Cl(e)) {
    var M = Er(e, m), L = yl ? yl(e) === Object.prototype : e instanceof Object || e.constructor === Object, z = e instanceof Object ? "" : "null prototype", U = !L && ke && Object(e) === e && ke in e ? To.call(Rt(e), 8, -1) : z ? "Object" : "", V = L || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", J = V + (U || z ? "[" + ct.call(vl.call([], U || [], z || []), ": ") + "] " : "");
    return M.length === 0 ? J + "{}" : p ? J + "{" + qi(M, p) + "}" : J + "{ " + ct.call(M, ", ") + " }";
  }
  return String(e);
};
function uf(n, e, t) {
  var r = (t.quoteStyle || e) === "double" ? '"' : "'";
  return r + n + r;
}
function K2(n) {
  return Tt.call(String(n), /"/g, "&quot;");
}
function Ui(n) {
  return Rt(n) === "[object Array]" && (!ke || !(typeof n == "object" && ke in n));
}
function G2(n) {
  return Rt(n) === "[object Date]" && (!ke || !(typeof n == "object" && ke in n));
}
function Cl(n) {
  return Rt(n) === "[object RegExp]" && (!ke || !(typeof n == "object" && ke in n));
}
function Q2(n) {
  return Rt(n) === "[object Error]" && (!ke || !(typeof n == "object" && ke in n));
}
function J2(n) {
  return Rt(n) === "[object String]" && (!ke || !(typeof n == "object" && ke in n));
}
function Z2(n) {
  return Rt(n) === "[object Number]" && (!ke || !(typeof n == "object" && ke in n));
}
function X2(n) {
  return Rt(n) === "[object Boolean]" && (!ke || !(typeof n == "object" && ke in n));
}
function ff(n) {
  if (En)
    return n && typeof n == "object" && n instanceof Symbol;
  if (typeof n == "symbol")
    return !0;
  if (!n || typeof n != "object" || !Hi)
    return !1;
  try {
    return Hi.call(n), !0;
  } catch {
  }
  return !1;
}
function eb(n) {
  if (!n || typeof n != "object" || !ji)
    return !1;
  try {
    return ji.call(n), !0;
  } catch {
  }
  return !1;
}
var tb = Object.prototype.hasOwnProperty || function(n) {
  return n in this;
};
function kt(n, e) {
  return tb.call(n, e);
}
function Rt(n) {
  return z2.call(n);
}
function nb(n) {
  if (n.name)
    return n.name;
  var e = q2.call(U2.call(n), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function df(n, e) {
  if (n.indexOf)
    return n.indexOf(e);
  for (var t = 0, r = n.length; t < r; t++)
    if (n[t] === e)
      return t;
  return -1;
}
function rb(n) {
  if (!Xr || !n || typeof n != "object")
    return !1;
  try {
    Xr.call(n);
    try {
      ea.call(n);
    } catch {
      return !0;
    }
    return n instanceof Map;
  } catch {
  }
  return !1;
}
function ab(n) {
  if (!tr || !n || typeof n != "object")
    return !1;
  try {
    tr.call(n, tr);
    try {
      nr.call(n, nr);
    } catch {
      return !0;
    }
    return n instanceof WeakMap;
  } catch {
  }
  return !1;
}
function ib(n) {
  if (!hl || !n || typeof n != "object")
    return !1;
  try {
    return hl.call(n), !0;
  } catch {
  }
  return !1;
}
function ob(n) {
  if (!ea || !n || typeof n != "object")
    return !1;
  try {
    ea.call(n);
    try {
      Xr.call(n);
    } catch {
      return !0;
    }
    return n instanceof Set;
  } catch {
  }
  return !1;
}
function sb(n) {
  if (!nr || !n || typeof n != "object")
    return !1;
  try {
    nr.call(n, nr);
    try {
      tr.call(n, tr);
    } catch {
      return !0;
    }
    return n instanceof WeakSet;
  } catch {
  }
  return !1;
}
function lb(n) {
  return !n || typeof n != "object" ? !1 : typeof HTMLElement < "u" && n instanceof HTMLElement ? !0 : typeof n.nodeName == "string" && typeof n.getAttribute == "function";
}
function pf(n, e) {
  if (n.length > e.maxStringLength) {
    var t = n.length - e.maxStringLength, r = "... " + t + " more character" + (t > 1 ? "s" : "");
    return pf(To.call(n, 0, e.maxStringLength), e) + r;
  }
  var a = Tt.call(Tt.call(n, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, cb);
  return uf(a, "single", e);
}
function cb(n) {
  var e = n.charCodeAt(0), t = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return t ? "\\" + t : "\\x" + (e < 16 ? "0" : "") + W2.call(e.toString(16));
}
function Kn(n) {
  return "Object(" + n + ")";
}
function ei(n) {
  return n + " { ? }";
}
function Sl(n, e, t, r) {
  var a = r ? qi(t, r) : ct.call(t, ", ");
  return n + " (" + e + ") {" + a + "}";
}
function ub(n) {
  for (var e = 0; e < n.length; e++)
    if (df(n[e], `
`) >= 0)
      return !1;
  return !0;
}
function fb(n, e) {
  var t;
  if (n.indent === "	")
    t = "	";
  else if (typeof n.indent == "number" && n.indent > 0)
    t = ct.call(Array(n.indent + 1), " ");
  else
    return null;
  return {
    base: t,
    prev: ct.call(Array(e + 1), t)
  };
}
function qi(n, e) {
  if (n.length === 0)
    return "";
  var t = `
` + e.prev + e.base;
  return t + ct.call(n, "," + t) + `
` + e.prev;
}
function Er(n, e) {
  var t = Ui(n), r = [];
  if (t) {
    r.length = n.length;
    for (var a = 0; a < n.length; a++)
      r[a] = kt(n, a) ? e(n[a], n) : "";
  }
  var i = typeof Xa == "function" ? Xa(n) : [], o;
  if (En) {
    o = {};
    for (var s = 0; s < i.length; s++)
      o["$" + i[s]] = i[s];
  }
  for (var l in n)
    kt(n, l) && (t && String(Number(l)) === l && l < n.length || En && o["$" + l] instanceof Symbol || (lf.call(/[^\w$]/, l) ? r.push(e(l, n) + ": " + e(n[l], n)) : r.push(l + ": " + e(n[l], n))));
  if (typeof Xa == "function")
    for (var u = 0; u < i.length; u++)
      cf.call(n, i[u]) && r.push("[" + e(i[u]) + "]: " + e(n[i[u]], n));
  return r;
}
var hf = Nn, Fn = I2, db = Y2, pb = br, kr = hf("%WeakMap%", !0), Dr = hf("%Map%", !0), hb = Fn("WeakMap.prototype.get", !0), mb = Fn("WeakMap.prototype.set", !0), vb = Fn("WeakMap.prototype.has", !0), gb = Fn("Map.prototype.get", !0), yb = Fn("Map.prototype.set", !0), bb = Fn("Map.prototype.has", !0), Mo = function(n, e) {
  for (var t = n, r; (r = t.next) !== null; t = r)
    if (r.key === e)
      return t.next = r.next, r.next = /** @type {NonNullable<typeof list.next>} */
      n.next, n.next = r, r;
}, _b = function(n, e) {
  var t = Mo(n, e);
  return t && t.value;
}, wb = function(n, e, t) {
  var r = Mo(n, e);
  r ? r.value = t : n.next = /** @type {import('.').ListNode<typeof value>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: e,
    next: n.next,
    value: t
  };
}, Cb = function(n, e) {
  return !!Mo(n, e);
}, Sb = function() {
  var e, t, r, a = {
    assert: function(i) {
      if (!a.has(i))
        throw new pb("Side channel does not contain " + db(i));
    },
    get: function(i) {
      if (kr && i && (typeof i == "object" || typeof i == "function")) {
        if (e)
          return hb(e, i);
      } else if (Dr) {
        if (t)
          return gb(t, i);
      } else if (r)
        return _b(r, i);
    },
    has: function(i) {
      if (kr && i && (typeof i == "object" || typeof i == "function")) {
        if (e)
          return vb(e, i);
      } else if (Dr) {
        if (t)
          return bb(t, i);
      } else if (r)
        return Cb(r, i);
      return !1;
    },
    set: function(i, o) {
      kr && i && (typeof i == "object" || typeof i == "function") ? (e || (e = new kr()), mb(e, i, o)) : Dr ? (t || (t = new Dr()), yb(t, i, o)) : (r || (r = { key: {}, next: null }), wb(r, i, o));
    }
  };
  return a;
}, xb = String.prototype.replace, Ob = /%20/g, ti = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Po = {
  default: ti.RFC3986,
  formatters: {
    RFC1738: function(n) {
      return xb.call(n, Ob, "+");
    },
    RFC3986: function(n) {
      return String(n);
    }
  },
  RFC1738: ti.RFC1738,
  RFC3986: ti.RFC3986
}, Ab = Po, ni = Object.prototype.hasOwnProperty, Ut = Array.isArray, ot = function() {
  for (var n = [], e = 0; e < 256; ++e)
    n.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
  return n;
}(), $b = function(e) {
  for (; e.length > 1; ) {
    var t = e.pop(), r = t.obj[t.prop];
    if (Ut(r)) {
      for (var a = [], i = 0; i < r.length; ++i)
        typeof r[i] < "u" && a.push(r[i]);
      t.obj[t.prop] = a;
    }
  }
}, mf = function(e, t) {
  for (var r = t && t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = 0; a < e.length; ++a)
    typeof e[a] < "u" && (r[a] = e[a]);
  return r;
}, Eb = function n(e, t, r) {
  if (!t)
    return e;
  if (typeof t != "object") {
    if (Ut(e))
      e.push(t);
    else if (e && typeof e == "object")
      (r && (r.plainObjects || r.allowPrototypes) || !ni.call(Object.prototype, t)) && (e[t] = !0);
    else
      return [e, t];
    return e;
  }
  if (!e || typeof e != "object")
    return [e].concat(t);
  var a = e;
  return Ut(e) && !Ut(t) && (a = mf(e, r)), Ut(e) && Ut(t) ? (t.forEach(function(i, o) {
    if (ni.call(e, o)) {
      var s = e[o];
      s && typeof s == "object" && i && typeof i == "object" ? e[o] = n(s, i, r) : e.push(i);
    } else
      e[o] = i;
  }), e) : Object.keys(t).reduce(function(i, o) {
    var s = t[o];
    return ni.call(i, o) ? i[o] = n(i[o], s, r) : i[o] = s, i;
  }, a);
}, kb = function(e, t) {
  return Object.keys(t).reduce(function(r, a) {
    return r[a] = t[a], r;
  }, e);
}, Db = function(n, e, t) {
  var r = n.replace(/\+/g, " ");
  if (t === "iso-8859-1")
    return r.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(r);
  } catch {
    return r;
  }
}, ri = 1024, Tb = function(e, t, r, a, i) {
  if (e.length === 0)
    return e;
  var o = e;
  if (typeof e == "symbol" ? o = Symbol.prototype.toString.call(e) : typeof e != "string" && (o = String(e)), r === "iso-8859-1")
    return escape(o).replace(/%u[0-9a-f]{4}/gi, function(y) {
      return "%26%23" + parseInt(y.slice(2), 16) + "%3B";
    });
  for (var s = "", l = 0; l < o.length; l += ri) {
    for (var u = o.length >= ri ? o.slice(l, l + ri) : o, c = [], p = 0; p < u.length; ++p) {
      var m = u.charCodeAt(p);
      if (m === 45 || m === 46 || m === 95 || m === 126 || m >= 48 && m <= 57 || m >= 65 && m <= 90 || m >= 97 && m <= 122 || i === Ab.RFC1738 && (m === 40 || m === 41)) {
        c[c.length] = u.charAt(p);
        continue;
      }
      if (m < 128) {
        c[c.length] = ot[m];
        continue;
      }
      if (m < 2048) {
        c[c.length] = ot[192 | m >> 6] + ot[128 | m & 63];
        continue;
      }
      if (m < 55296 || m >= 57344) {
        c[c.length] = ot[224 | m >> 12] + ot[128 | m >> 6 & 63] + ot[128 | m & 63];
        continue;
      }
      p += 1, m = 65536 + ((m & 1023) << 10 | u.charCodeAt(p) & 1023), c[c.length] = ot[240 | m >> 18] + ot[128 | m >> 12 & 63] + ot[128 | m >> 6 & 63] + ot[128 | m & 63];
    }
    s += c.join("");
  }
  return s;
}, Mb = function(e) {
  for (var t = [{ obj: { o: e }, prop: "o" }], r = [], a = 0; a < t.length; ++a)
    for (var i = t[a], o = i.obj[i.prop], s = Object.keys(o), l = 0; l < s.length; ++l) {
      var u = s[l], c = o[u];
      typeof c == "object" && c !== null && r.indexOf(c) === -1 && (t.push({ obj: o, prop: u }), r.push(c));
    }
  return $b(t), e;
}, Pb = function(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}, Ib = function(e) {
  return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
}, Rb = function(e, t) {
  return [].concat(e, t);
}, Nb = function(e, t) {
  if (Ut(e)) {
    for (var r = [], a = 0; a < e.length; a += 1)
      r.push(t(e[a]));
    return r;
  }
  return t(e);
}, vf = {
  arrayToObject: mf,
  assign: kb,
  combine: Rb,
  compact: Mb,
  decode: Db,
  encode: Tb,
  isBuffer: Ib,
  isRegExp: Pb,
  maybeMap: Nb,
  merge: Eb
}, gf = Sb, Hr = vf, rr = Po, Fb = Object.prototype.hasOwnProperty, yf = {
  brackets: function(e) {
    return e + "[]";
  },
  comma: "comma",
  indices: function(e, t) {
    return e + "[" + t + "]";
  },
  repeat: function(e) {
    return e;
  }
}, st = Array.isArray, Lb = Array.prototype.push, bf = function(n, e) {
  Lb.apply(n, st(e) ? e : [e]);
}, Bb = Date.prototype.toISOString, xl = rr.default, Se = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: Hr.encode,
  encodeValuesOnly: !1,
  format: xl,
  formatter: rr.formatters[xl],
  // deprecated
  indices: !1,
  serializeDate: function(e) {
    return Bb.call(e);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, jb = function(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
}, ai = {}, Hb = function n(e, t, r, a, i, o, s, l, u, c, p, m, y, g, b, w, C, S) {
  for (var A = e, h = S, E = 0, _ = !1; (h = h.get(ai)) !== void 0 && !_; ) {
    var M = h.get(e);
    if (E += 1, typeof M < "u") {
      if (M === E)
        throw new RangeError("Cyclic object value");
      _ = !0;
    }
    typeof h.get(ai) > "u" && (E = 0);
  }
  if (typeof c == "function" ? A = c(t, A) : A instanceof Date ? A = y(A) : r === "comma" && st(A) && (A = Hr.maybeMap(A, function(W) {
    return W instanceof Date ? y(W) : W;
  })), A === null) {
    if (o)
      return u && !w ? u(t, Se.encoder, C, "key", g) : t;
    A = "";
  }
  if (jb(A) || Hr.isBuffer(A)) {
    if (u) {
      var L = w ? t : u(t, Se.encoder, C, "key", g);
      return [b(L) + "=" + b(u(A, Se.encoder, C, "value", g))];
    }
    return [b(t) + "=" + b(String(A))];
  }
  var z = [];
  if (typeof A > "u")
    return z;
  var U;
  if (r === "comma" && st(A))
    w && u && (A = Hr.maybeMap(A, u)), U = [{ value: A.length > 0 ? A.join(",") || null : void 0 }];
  else if (st(c))
    U = c;
  else {
    var V = Object.keys(A);
    U = p ? V.sort(p) : V;
  }
  var J = l ? t.replace(/\./g, "%2E") : t, G = a && st(A) && A.length === 1 ? J + "[]" : J;
  if (i && st(A) && A.length === 0)
    return G + "[]";
  for (var F = 0; F < U.length; ++F) {
    var D = U[F], k = typeof D == "object" && typeof D.value < "u" ? D.value : A[D];
    if (!(s && k === null)) {
      var R = m && l ? D.replace(/\./g, "%2E") : D, T = st(A) ? typeof r == "function" ? r(G, R) : G : G + (m ? "." + R : "[" + R + "]");
      S.set(e, E);
      var q = gf();
      q.set(ai, S), bf(z, n(
        k,
        T,
        r,
        a,
        i,
        o,
        s,
        l,
        r === "comma" && w && st(A) ? null : u,
        c,
        p,
        m,
        y,
        g,
        b,
        w,
        C,
        q
      ));
    }
  }
  return z;
}, zb = function(e) {
  if (!e)
    return Se;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.encodeDotInKeys < "u" && typeof e.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var t = e.charset || Se.charset;
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = rr.default;
  if (typeof e.format < "u") {
    if (!Fb.call(rr.formatters, e.format))
      throw new TypeError("Unknown format option provided.");
    r = e.format;
  }
  var a = rr.formatters[r], i = Se.filter;
  (typeof e.filter == "function" || st(e.filter)) && (i = e.filter);
  var o;
  if (e.arrayFormat in yf ? o = e.arrayFormat : "indices" in e ? o = e.indices ? "indices" : "repeat" : o = Se.arrayFormat, "commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var s = typeof e.allowDots > "u" ? e.encodeDotInKeys === !0 ? !0 : Se.allowDots : !!e.allowDots;
  return {
    addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : Se.addQueryPrefix,
    allowDots: s,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : Se.allowEmptyArrays,
    arrayFormat: o,
    charset: t,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : Se.charsetSentinel,
    commaRoundTrip: e.commaRoundTrip,
    delimiter: typeof e.delimiter > "u" ? Se.delimiter : e.delimiter,
    encode: typeof e.encode == "boolean" ? e.encode : Se.encode,
    encodeDotInKeys: typeof e.encodeDotInKeys == "boolean" ? e.encodeDotInKeys : Se.encodeDotInKeys,
    encoder: typeof e.encoder == "function" ? e.encoder : Se.encoder,
    encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : Se.encodeValuesOnly,
    filter: i,
    format: r,
    formatter: a,
    serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : Se.serializeDate,
    skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : Se.skipNulls,
    sort: typeof e.sort == "function" ? e.sort : null,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : Se.strictNullHandling
  };
}, Ub = function(n, e) {
  var t = n, r = zb(e), a, i;
  typeof r.filter == "function" ? (i = r.filter, t = i("", t)) : st(r.filter) && (i = r.filter, a = i);
  var o = [];
  if (typeof t != "object" || t === null)
    return "";
  var s = yf[r.arrayFormat], l = s === "comma" && r.commaRoundTrip;
  a || (a = Object.keys(t)), r.sort && a.sort(r.sort);
  for (var u = gf(), c = 0; c < a.length; ++c) {
    var p = a[c];
    r.skipNulls && t[p] === null || bf(o, Hb(
      t[p],
      p,
      s,
      l,
      r.allowEmptyArrays,
      r.strictNullHandling,
      r.skipNulls,
      r.encodeDotInKeys,
      r.encode ? r.encoder : null,
      r.filter,
      r.sort,
      r.allowDots,
      r.serializeDate,
      r.format,
      r.formatter,
      r.encodeValuesOnly,
      r.charset,
      u
    ));
  }
  var m = o.join(r.delimiter), y = r.addQueryPrefix === !0 ? "?" : "";
  return r.charsetSentinel && (r.charset === "iso-8859-1" ? y += "utf8=%26%2310003%3B&" : y += "utf8=%E2%9C%93&"), m.length > 0 ? y + m : "";
}, kn = vf, Wi = Object.prototype.hasOwnProperty, qb = Array.isArray, ge = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: kn.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictDepth: !1,
  strictNullHandling: !1
}, Wb = function(n) {
  return n.replace(/&#(\d+);/g, function(e, t) {
    return String.fromCharCode(parseInt(t, 10));
  });
}, _f = function(n, e) {
  return n && typeof n == "string" && e.comma && n.indexOf(",") > -1 ? n.split(",") : n;
}, Vb = "utf8=%26%2310003%3B", Yb = "utf8=%E2%9C%93", Kb = function(e, t) {
  var r = { __proto__: null }, a = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e;
  a = a.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var i = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit, o = a.split(t.delimiter, i), s = -1, l, u = t.charset;
  if (t.charsetSentinel)
    for (l = 0; l < o.length; ++l)
      o[l].indexOf("utf8=") === 0 && (o[l] === Yb ? u = "utf-8" : o[l] === Vb && (u = "iso-8859-1"), s = l, l = o.length);
  for (l = 0; l < o.length; ++l)
    if (l !== s) {
      var c = o[l], p = c.indexOf("]="), m = p === -1 ? c.indexOf("=") : p + 1, y, g;
      m === -1 ? (y = t.decoder(c, ge.decoder, u, "key"), g = t.strictNullHandling ? null : "") : (y = t.decoder(c.slice(0, m), ge.decoder, u, "key"), g = kn.maybeMap(
        _f(c.slice(m + 1), t),
        function(w) {
          return t.decoder(w, ge.decoder, u, "value");
        }
      )), g && t.interpretNumericEntities && u === "iso-8859-1" && (g = Wb(g)), c.indexOf("[]=") > -1 && (g = qb(g) ? [g] : g);
      var b = Wi.call(r, y);
      b && t.duplicates === "combine" ? r[y] = kn.combine(r[y], g) : (!b || t.duplicates === "last") && (r[y] = g);
    }
  return r;
}, Gb = function(n, e, t, r) {
  for (var a = r ? e : _f(e, t), i = n.length - 1; i >= 0; --i) {
    var o, s = n[i];
    if (s === "[]" && t.parseArrays)
      o = t.allowEmptyArrays && (a === "" || t.strictNullHandling && a === null) ? [] : [].concat(a);
    else {
      o = t.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var l = s.charAt(0) === "[" && s.charAt(s.length - 1) === "]" ? s.slice(1, -1) : s, u = t.decodeDotInKeys ? l.replace(/%2E/g, ".") : l, c = parseInt(u, 10);
      !t.parseArrays && u === "" ? o = { 0: a } : !isNaN(c) && s !== u && String(c) === u && c >= 0 && t.parseArrays && c <= t.arrayLimit ? (o = [], o[c] = a) : u !== "__proto__" && (o[u] = a);
    }
    a = o;
  }
  return a;
}, Qb = function(e, t, r, a) {
  if (e) {
    var i = r.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e, o = /(\[[^[\]]*])/, s = /(\[[^[\]]*])/g, l = r.depth > 0 && o.exec(i), u = l ? i.slice(0, l.index) : i, c = [];
    if (u) {
      if (!r.plainObjects && Wi.call(Object.prototype, u) && !r.allowPrototypes)
        return;
      c.push(u);
    }
    for (var p = 0; r.depth > 0 && (l = s.exec(i)) !== null && p < r.depth; ) {
      if (p += 1, !r.plainObjects && Wi.call(Object.prototype, l[1].slice(1, -1)) && !r.allowPrototypes)
        return;
      c.push(l[1]);
    }
    if (l) {
      if (r.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + r.depth + " and strictDepth is true");
      c.push("[" + i.slice(l.index) + "]");
    }
    return Gb(c, t, r, a);
  }
}, Jb = function(e) {
  if (!e)
    return ge;
  if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof e.decodeDotInKeys < "u" && typeof e.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (e.decoder !== null && typeof e.decoder < "u" && typeof e.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var t = typeof e.charset > "u" ? ge.charset : e.charset, r = typeof e.duplicates > "u" ? ge.duplicates : e.duplicates;
  if (r !== "combine" && r !== "first" && r !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var a = typeof e.allowDots > "u" ? e.decodeDotInKeys === !0 ? !0 : ge.allowDots : !!e.allowDots;
  return {
    allowDots: a,
    allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : ge.allowEmptyArrays,
    allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : ge.allowPrototypes,
    allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : ge.allowSparse,
    arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : ge.arrayLimit,
    charset: t,
    charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : ge.charsetSentinel,
    comma: typeof e.comma == "boolean" ? e.comma : ge.comma,
    decodeDotInKeys: typeof e.decodeDotInKeys == "boolean" ? e.decodeDotInKeys : ge.decodeDotInKeys,
    decoder: typeof e.decoder == "function" ? e.decoder : ge.decoder,
    delimiter: typeof e.delimiter == "string" || kn.isRegExp(e.delimiter) ? e.delimiter : ge.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : ge.depth,
    duplicates: r,
    ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : ge.interpretNumericEntities,
    parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : ge.parameterLimit,
    parseArrays: e.parseArrays !== !1,
    plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : ge.plainObjects,
    strictDepth: typeof e.strictDepth == "boolean" ? !!e.strictDepth : ge.strictDepth,
    strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : ge.strictNullHandling
  };
}, Zb = function(n, e) {
  var t = Jb(e);
  if (n === "" || n === null || typeof n > "u")
    return t.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var r = typeof n == "string" ? Kb(n, t) : n, a = t.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = Object.keys(r), o = 0; o < i.length; ++o) {
    var s = i[o], l = Qb(s, r[s], t, typeof n == "string");
    a = kn.merge(a, l, t);
  }
  return t.allowSparse === !0 ? a : kn.compact(a);
}, Xb = Ub, e4 = Zb, t4 = Po, n4 = {
  formats: t4,
  parse: e4,
  stringify: Xb
};
const wf = /* @__PURE__ */ tn(n4);
var r4 = Array.isArray, rn = r4, a4 = rn, i4 = va, o4 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, s4 = /^\w*$/;
function l4(n, e) {
  if (a4(n))
    return !1;
  var t = typeof n;
  return t == "number" || t == "symbol" || t == "boolean" || n == null || i4(n) ? !0 : s4.test(n) || !o4.test(n) || e != null && n in Object(e);
}
var c4 = l4, u4 = Pn, f4 = St, d4 = "[object AsyncFunction]", p4 = "[object Function]", h4 = "[object GeneratorFunction]", m4 = "[object Proxy]";
function v4(n) {
  if (!f4(n))
    return !1;
  var e = u4(n);
  return e == p4 || e == h4 || e == d4 || e == m4;
}
var Io = v4, g4 = nt, y4 = g4["__core-js_shared__"], b4 = y4, ii = b4, Ol = function() {
  var n = /[^.]+$/.exec(ii && ii.keys && ii.keys.IE_PROTO || "");
  return n ? "Symbol(src)_1." + n : "";
}();
function _4(n) {
  return !!Ol && Ol in n;
}
var w4 = _4, C4 = Function.prototype, S4 = C4.toString;
function x4(n) {
  if (n != null) {
    try {
      return S4.call(n);
    } catch {
    }
    try {
      return n + "";
    } catch {
    }
  }
  return "";
}
var Cf = x4, O4 = Io, A4 = w4, $4 = St, E4 = Cf, k4 = /[\\^$.*+?()[\]{}|]/g, D4 = /^\[object .+?Constructor\]$/, T4 = Function.prototype, M4 = Object.prototype, P4 = T4.toString, I4 = M4.hasOwnProperty, R4 = RegExp(
  "^" + P4.call(I4).replace(k4, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function N4(n) {
  if (!$4(n) || A4(n))
    return !1;
  var e = O4(n) ? R4 : D4;
  return e.test(E4(n));
}
var F4 = N4;
function L4(n, e) {
  return n == null ? void 0 : n[e];
}
var B4 = L4, j4 = F4, H4 = B4;
function z4(n, e) {
  var t = H4(n, e);
  return j4(t) ? t : void 0;
}
var an = z4, U4 = an, q4 = U4(Object, "create"), Ca = q4, Al = Ca;
function W4() {
  this.__data__ = Al ? Al(null) : {}, this.size = 0;
}
var V4 = W4;
function Y4(n) {
  var e = this.has(n) && delete this.__data__[n];
  return this.size -= e ? 1 : 0, e;
}
var K4 = Y4, G4 = Ca, Q4 = "__lodash_hash_undefined__", J4 = Object.prototype, Z4 = J4.hasOwnProperty;
function X4(n) {
  var e = this.__data__;
  if (G4) {
    var t = e[n];
    return t === Q4 ? void 0 : t;
  }
  return Z4.call(e, n) ? e[n] : void 0;
}
var e_ = X4, t_ = Ca, n_ = Object.prototype, r_ = n_.hasOwnProperty;
function a_(n) {
  var e = this.__data__;
  return t_ ? e[n] !== void 0 : r_.call(e, n);
}
var i_ = a_, o_ = Ca, s_ = "__lodash_hash_undefined__";
function l_(n, e) {
  var t = this.__data__;
  return this.size += this.has(n) ? 0 : 1, t[n] = o_ && e === void 0 ? s_ : e, this;
}
var c_ = l_, u_ = V4, f_ = K4, d_ = e_, p_ = i_, h_ = c_;
function Ln(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.clear(); ++e < t; ) {
    var r = n[e];
    this.set(r[0], r[1]);
  }
}
Ln.prototype.clear = u_;
Ln.prototype.delete = f_;
Ln.prototype.get = d_;
Ln.prototype.has = p_;
Ln.prototype.set = h_;
var m_ = Ln;
function v_() {
  this.__data__ = [], this.size = 0;
}
var g_ = v_;
function y_(n, e) {
  return n === e || n !== n && e !== e;
}
var wr = y_, b_ = wr;
function __(n, e) {
  for (var t = n.length; t--; )
    if (b_(n[t][0], e))
      return t;
  return -1;
}
var Sa = __, w_ = Sa, C_ = Array.prototype, S_ = C_.splice;
function x_(n) {
  var e = this.__data__, t = w_(e, n);
  if (t < 0)
    return !1;
  var r = e.length - 1;
  return t == r ? e.pop() : S_.call(e, t, 1), --this.size, !0;
}
var O_ = x_, A_ = Sa;
function $_(n) {
  var e = this.__data__, t = A_(e, n);
  return t < 0 ? void 0 : e[t][1];
}
var E_ = $_, k_ = Sa;
function D_(n) {
  return k_(this.__data__, n) > -1;
}
var T_ = D_, M_ = Sa;
function P_(n, e) {
  var t = this.__data__, r = M_(t, n);
  return r < 0 ? (++this.size, t.push([n, e])) : t[r][1] = e, this;
}
var I_ = P_, R_ = g_, N_ = O_, F_ = E_, L_ = T_, B_ = I_;
function Bn(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.clear(); ++e < t; ) {
    var r = n[e];
    this.set(r[0], r[1]);
  }
}
Bn.prototype.clear = R_;
Bn.prototype.delete = N_;
Bn.prototype.get = F_;
Bn.prototype.has = L_;
Bn.prototype.set = B_;
var xa = Bn, j_ = an, H_ = nt, z_ = j_(H_, "Map"), Ro = z_, $l = m_, U_ = xa, q_ = Ro;
function W_() {
  this.size = 0, this.__data__ = {
    hash: new $l(),
    map: new (q_ || U_)(),
    string: new $l()
  };
}
var V_ = W_;
function Y_(n) {
  var e = typeof n;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? n !== "__proto__" : n === null;
}
var K_ = Y_, G_ = K_;
function Q_(n, e) {
  var t = n.__data__;
  return G_(e) ? t[typeof e == "string" ? "string" : "hash"] : t.map;
}
var Oa = Q_, J_ = Oa;
function Z_(n) {
  var e = J_(this, n).delete(n);
  return this.size -= e ? 1 : 0, e;
}
var X_ = Z_, e3 = Oa;
function t3(n) {
  return e3(this, n).get(n);
}
var n3 = t3, r3 = Oa;
function a3(n) {
  return r3(this, n).has(n);
}
var i3 = a3, o3 = Oa;
function s3(n, e) {
  var t = o3(this, n), r = t.size;
  return t.set(n, e), this.size += t.size == r ? 0 : 1, this;
}
var l3 = s3, c3 = V_, u3 = X_, f3 = n3, d3 = i3, p3 = l3;
function jn(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.clear(); ++e < t; ) {
    var r = n[e];
    this.set(r[0], r[1]);
  }
}
jn.prototype.clear = c3;
jn.prototype.delete = u3;
jn.prototype.get = f3;
jn.prototype.has = d3;
jn.prototype.set = p3;
var No = jn, Sf = No, h3 = "Expected a function";
function Fo(n, e) {
  if (typeof n != "function" || e != null && typeof e != "function")
    throw new TypeError(h3);
  var t = function() {
    var r = arguments, a = e ? e.apply(this, r) : r[0], i = t.cache;
    if (i.has(a))
      return i.get(a);
    var o = n.apply(this, r);
    return t.cache = i.set(a, o) || i, o;
  };
  return t.cache = new (Fo.Cache || Sf)(), t;
}
Fo.Cache = Sf;
var m3 = Fo, v3 = m3, g3 = 500;
function y3(n) {
  var e = v3(n, function(r) {
    return t.size === g3 && t.clear(), r;
  }), t = e.cache;
  return e;
}
var b3 = y3, _3 = b3, w3 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, C3 = /\\(\\)?/g, S3 = _3(function(n) {
  var e = [];
  return n.charCodeAt(0) === 46 && e.push(""), n.replace(w3, function(t, r, a, i) {
    e.push(a ? i.replace(C3, "$1") : r || t);
  }), e;
}), x3 = S3;
function O3(n, e) {
  for (var t = -1, r = n == null ? 0 : n.length, a = Array(r); ++t < r; )
    a[t] = e(n[t], t, n);
  return a;
}
var A3 = O3, El = ma, $3 = A3, E3 = rn, k3 = va, D3 = 1 / 0, kl = El ? El.prototype : void 0, Dl = kl ? kl.toString : void 0;
function xf(n) {
  if (typeof n == "string")
    return n;
  if (E3(n))
    return $3(n, xf) + "";
  if (k3(n))
    return Dl ? Dl.call(n) : "";
  var e = n + "";
  return e == "0" && 1 / n == -D3 ? "-0" : e;
}
var T3 = xf, M3 = T3;
function P3(n) {
  return n == null ? "" : M3(n);
}
var I3 = P3, R3 = rn, N3 = c4, F3 = x3, L3 = I3;
function B3(n, e) {
  return R3(n) ? n : N3(n, e) ? [n] : F3(L3(n));
}
var j3 = B3, H3 = va, z3 = 1 / 0;
function U3(n) {
  if (typeof n == "string" || H3(n))
    return n;
  var e = n + "";
  return e == "0" && 1 / n == -z3 ? "-0" : e;
}
var q3 = U3, W3 = j3, V3 = q3;
function Y3(n, e) {
  e = W3(e, n);
  for (var t = 0, r = e.length; n != null && t < r; )
    n = n[V3(e[t++])];
  return t && t == r ? n : void 0;
}
var K3 = Y3, G3 = K3;
function Q3(n, e, t) {
  var r = n == null ? void 0 : G3(n, e);
  return r === void 0 ? t : r;
}
var J3 = Q3;
const Dn = /* @__PURE__ */ tn(J3);
var Of = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "search", r = 512, a = 512, i = [], o = "f002", s = "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faSearch = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(Of);
const Z3 = {
  props: {
    result: {
      type: Object,
      required: !0
    },
    category: {
      type: String,
      default: "target"
    }
  },
  methods: {
    trackNavigation() {
      Me(`global search go to ${this.category}`);
    }
  }
};
var X3 = function() {
  var e = this, t = e._self._c;
  return t("li", [t("a", { staticClass: "search-results__item", attrs: { href: e.result.link_to_overview }, on: { click: e.trackNavigation } }, [e.result.meta ? t("span", { staticClass: "search-results__item-meta" }, [e._v(" " + e._s(e.result.meta) + " ")]) : e._e(), e._v(" " + e._s(e.result.name) + " ")])]);
}, ew = [], tw = /* @__PURE__ */ ee(
  Z3,
  X3,
  ew,
  !1,
  null,
  "72433875"
);
const nw = tw.exports, rw = {
  props: {
    categoryLabel: {
      type: String,
      required: !0
    },
    category: {
      type: String,
      required: !0
    },
    results: {
      type: Array,
      required: !0
    }
  },
  components: {
    SearchResult: nw
  }
};
var aw = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "x-search__results" }, [t("h3", { staticClass: "x-search__results__category" }, [e._v(e._s(e.categoryLabel))]), t("ul", e._l(e.results, function(r, a) {
    return t("search-result", { key: a, attrs: { result: r, category: e.category } });
  }), 1)]);
}, iw = [], ow = /* @__PURE__ */ ee(
  rw,
  aw,
  iw,
  !1,
  null,
  "8efe61df"
);
const sw = ow.exports;
Pe.add(Of.faSearch);
const lw = {
  loading: "Search in progress...",
  no_results: "No results, try narrowing your search terms...",
  placeholder: "e.g. an organization or store name",
  search: "Search",
  too_short: "Please enter a search term longer than 2 characters...",
  target: {
    stores: "Stores",
    customer_organizations: "Customer organizations",
    divisions: "Divisions",
    business_partners: "Business partners",
    devices: "Systems",
    people: "Users",
    firmwares: "Firmwares",
    invitations: "Invitations"
  }
}, cw = {
  props: {
    searchUrl: {
      type: String,
      required: !0
    },
    prefilledSearchInput: {
      type: String,
      default: ""
    },
    vueI18n: {
      required: !1,
      default: null
    },
    i18nPrefix: {
      type: String,
      required: !1,
      default: null
    }
  },
  data() {
    return {
      isActive: !1,
      searchLoading: !1,
      searchResults: {},
      lastCompletedSearchQuery: "",
      selectedSearchTarget: null,
      searchInput: "" + this.prefilledSearchInput
    };
  },
  watch: {
    isActive(n) {
      Me(`global search ${n ? "active" : "closed"}`), this.searchInput && this.searchInput !== this.lastCompletedSearchQuery && this.startSearch();
    }
  },
  computed: {
    nonEmptySearchTargets() {
      return Object.keys(this.searchResults).filter((n) => this.searchResults[n].length > 0);
    },
    message() {
      return this.searchLoading ? this.getTranslation("loading") : this.searchInput.length <= 2 ? this.getTranslation("too_short") : this.nonEmptySearchTargets.length == 0 ? this.getTranslation("no_results") : "";
    }
  },
  methods: {
    getTranslation(n) {
      return this.vueI18n ? this.vueI18n(`${this.i18nPrefix}.${n}`) : Dn(lw, n, null);
    },
    onFocus() {
      this.isActive = !0;
    },
    onBlur() {
      this.isActive = !1;
    },
    targetToLabelText(n) {
      return this.getTranslation(`target.${n}`) || this.getTranslation("target.other");
    },
    startSearch: vr(function() {
      if (this.searchInput.length <= 2) {
        this.searchLoading = !1;
        return;
      }
      this.searchResults = {}, this.searchLoading = !0, Me("global search loading results", {
        query: this.searchInput
      });
      const n = this.searchUrl + "?" + wf.stringify({ q: this.searchInput });
      ve.get(n).then((e) => {
        this.searchResults = e.data, this.lastCompletedSearchQuery = this.searchInput, this.searchLoading = !1;
      });
    }, 400),
    resetSearch() {
      Me("global search clear input clicked"), this.$refs.searchInput.blur();
    },
    toggleSearchTarget(n) {
      this.selectedSearchTarget === n ? (Me("global search see all"), this.selectedSearchTarget = null) : (Me(`global search see only ${n}`), this.selectedSearchTarget = n);
    }
  },
  components: {
    FontAwesomeIcon: Ie,
    SearchResults: sw
  }
};
var uw = function() {
  var e = this, t = e._self._c;
  return t("div", { class: ["x-search", { "x-search--active": e.isActive }], attrs: { id: "x-search" } }, [t("div", { staticClass: "x-search__controls" }, [t("label", { staticClass: "x-search__label" }, [t("span", { staticClass: "x-search__label__icon" }, [t("font-awesome-icon", { attrs: { icon: "search" } })], 1), t("span", { staticClass: "x-search__label__text" }, [e._v(e._s(e.getTranslation("search")))]), t("input", { directives: [{ name: "model", rawName: "v-model.trim", value: e.searchInput, expression: "searchInput", modifiers: { trim: !0 } }], ref: "searchInput", staticClass: "x-search__input", attrs: { type: "search", placeholder: e.getTranslation("placeholder"), autocomplete: "off", autocorrect: "off", autocapitalize: "off", spellcheck: "false" }, domProps: { value: e.searchInput }, on: { input: [function(r) {
    r.target.composing || (e.searchInput = r.target.value.trim());
  }, e.startSearch], blur: [e.onBlur, function(r) {
    return e.$forceUpdate();
  }], focus: e.onFocus } })]), t("a", { staticClass: "x-search__controls__close", attrs: { href: "#" }, on: { mousedown: function(r) {
    r.preventDefault();
  }, click: function(r) {
    return r.preventDefault(), e.resetSearch.apply(null, arguments);
  } } }, [t("i", { staticClass: "fa fa-times-circle" })])]), t("transition", { attrs: { name: "x-search__popup" } }, [e.isActive ? t("div", { staticClass: "x-search__popup", on: { mousedown: function(r) {
    r.preventDefault();
  } } }, [e.nonEmptySearchTargets.length > 0 ? [e.nonEmptySearchTargets.length > 1 ? t("div", { staticClass: "x-search__filters" }, e._l(e.nonEmptySearchTargets, function(r, a) {
    return t("button", { key: a, class: ["x-search__filters__option", { "x-search__filters__option--active": e.selectedSearchTarget === r }], on: { click: function(i) {
      return e.toggleSearchTarget(r);
    } } }, [e._v(" " + e._s(e.targetToLabelText(r)) + " ")]);
  }), 0) : e._e(), t("transition-group", { attrs: { name: "x-search__results" } }, e._l(e.nonEmptySearchTargets, function(r) {
    return e.selectedSearchTarget == null || e.selectedSearchTarget === r ? t("search-results", { key: r, attrs: { targetToLabelTextFunction: e.targetToLabelText, category: r, categoryLabel: e.targetToLabelText(r), results: e.searchResults[r] } }) : e._e();
  }), 1)] : [t("p", { staticClass: "x-search__popup__no-results" }, [e._v(e._s(e.message))])]], 2) : e._e()])], 1);
}, fw = [], dw = /* @__PURE__ */ ee(
  cw,
  uw,
  fw,
  !1,
  null,
  "b3362187"
);
const pw = dw.exports, hw = {
  props: {
    value: Boolean,
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    onInput() {
      this.disabled || this.$emit("input", !this.value);
    }
  }
};
var mw = function() {
  var e = this, t = e._self._c;
  return t("label", { class: ["switch-container", { "switch-container--disabled": e.disabled }], attrs: { tabindex: "0" }, on: { click: e.onInput } }, [t("span", { class: ["switch", { "switch--checked": e.value }] }, [t("span", { staticClass: "slider" })]), e._t("default")], 2);
}, vw = [], gw = /* @__PURE__ */ ee(
  hw,
  mw,
  vw,
  !1,
  null,
  "e2880c99"
);
const yw = gw.exports;
var Af = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "bookmark", r = 384, a = 512, i = [], o = "f02e", s = "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faBookmark = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(Af);
Pe.add(Af.faBookmark);
const bw = {
  components: {
    FontAwesomeIcon: Ie
  },
  props: {
    color: {
      type: String,
      default: "var(--color-text-base)"
    }
  },
  computed: {
    flagIconStyle() {
      return {
        color: this.color
      };
    }
  }
};
var _w = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "status-flag" }, [t("FontAwesomeIcon", { style: e.flagIconStyle, attrs: { icon: "bookmark" } })], 1);
}, ww = [], Cw = /* @__PURE__ */ ee(
  bw,
  _w,
  ww,
  !1,
  null,
  "48a4e07b"
);
const Sw = Cw.exports, xw = {
  closeOnBackdropClicked: !0,
  closeOnEscapePressed: !0,
  backdropVisible: !0,
  panelLocation: "right",
  returnFocusAfterClose: !0
  // A11y option, only turn off when focussing is causing issues
}, Ow = {
  name: "PanelContainer",
  props: {
    label: {
      type: String,
      required: !0
    },
    options: {
      type: Object,
      required: !1
    },
    focusOnFirstElement: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      invokingContext: null,
      // Reference to element that invoked the panel activating
      panelActive: !1
    };
  },
  computed: {
    mergedOptions() {
      return {
        ...xw,
        ...this.options
      };
    },
    panelLocationClass() {
      return this.mergedOptions.panelLocation === "left" ? "x-panel--left" : "";
    },
    computedAriaLabel() {
      return this.label.startsWith("#") ? { "aria-labelledby": this.label.replace("#", "") } : { "aria-label": this.label };
    }
  },
  methods: {
    openPanel(n) {
      this.panelActive = !0, this.invokingContext = n.target, setTimeout(() => {
        if (this.$refs.panel) {
          const e = this.$refs.panel.querySelector("input") || this.$refs.panel.querySelector("button");
          e && this.focusOnFirstElement && e.focus();
        }
      }, 150);
    },
    closePanel() {
      this.panelActive = !1, this.mergedOptions.returnFocusAfterClose && this.invokingContext && (this.invokingContext.focus(), this.invokingContext = null);
    },
    backdropClicked() {
      this.mergedOptions.closeOnBackdropClicked && this.closePanel();
    },
    escapePressed() {
      this.mergedOptions.closeOnEscapePressed && this.closePanel();
    }
  }
};
var Aw = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "x-panel-container" }, [e._t("default", null, { openPanel: e.openPanel, panelIsOpen: e.panelActive }), e.mergedOptions.backdropVisible ? t("div", { class: ["x-panel-backdrop", { "x-panel-backdrop--visible": e.panelActive }], attrs: { "data-cy": "panel-backdrop" }, on: { click: e.backdropClicked } }) : e._e(), t("div", e._b({ ref: "panel", class: ["x-panel", e.panelLocationClass, { "x-panel--visible": e.panelActive }], attrs: { role: "dialog", "data-cy": "panel-body" }, on: { keyup: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "esc", 27, r.key, ["Esc", "Escape"]) ? null : e.escapePressed.apply(null, arguments);
  } } }, "div", e.computedAriaLabel, !1), [e._t("panel-content", function() {
    return [t("h3", [e._v(e._s(e.label))])];
  }, { closePanel: e.closePanel })], 2)], 2);
}, $w = [], Ew = /* @__PURE__ */ ee(
  Ow,
  Aw,
  $w,
  !1,
  null,
  "e79bd7cf"
);
const kw = Ew.exports;
function Dw(n) {
  return n.querySelector('[name="csrf-token"]').content;
}
var Aa = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "chevron-right", r = 320, a = 512, i = [], o = "f054", s = "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faChevronRight = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(Aa);
Pe.add(Aa.faChevronRight);
const Tw = {
  name: "BranchList",
  props: {
    branch: {
      type: Object,
      required: !0
    },
    targetList: {
      type: Array,
      required: !0
    },
    targetType: {
      type: String,
      required: !0
    }
  },
  computed: {
    sortedTargetList() {
      return this.targetList.sort((n, e) => n.name > e.name ? 1 : -1);
    }
  },
  methods: {
    targetClicked(n) {
      this.$emit("clean-highlighting"), n.setStateRecursive({ highlighted: !0 }), Me(`infinite navigation select ${this.targetType}`), this.$root.$emit("unrux::infinite_navigation::update_breadcrumbs", n);
    },
    targetDoubleClicked(n) {
      n.isAccessible ? (Me(`infinite navigation go to ${this.targetType}`, { action: "double-click" }), window.location.href = n.url) : Me(`infinite navigation try to access inaccessible ${this.targetType}`);
    }
  },
  components: {
    FontAwesomeIcon: Ie
  }
};
var Mw = function() {
  var e = this, t = e._self._c;
  return e.targetList.length ? t("div", [t("div", { staticClass: "target_label" }, [e._v(e._s(e.$t(`navigation.infinity.${e.targetType}_plural`)))]), t("ul", e._l(e.sortedTargetList, function(r) {
    return t("li", { key: `${e.targetType}-${r.id}`, class: [
      "option",
      { "option--highlighted": r.highlighted },
      { "option--origin": r.origin }
    ], attrs: { title: e.$t("navigation.infinity.doubleclick", { branchName: r.name }) }, on: { click: function(a) {
      return e.targetClicked(r);
    }, dblclick: function(a) {
      return e.targetDoubleClicked(r);
    } } }, [t("span", { staticClass: "option__name", attrs: { translate: "no" } }, [e._v(e._s(r.name))]), t("font-awesome-icon", { staticClass: "option__icon", attrs: { icon: "chevron-right" } })], 1);
  }), 0)]) : e._e();
}, Pw = [], Iw = /* @__PURE__ */ ee(
  Tw,
  Mw,
  Pw,
  !1,
  null,
  "b9019dac"
);
const Rw = Iw.exports, Nw = {};
var Fw = function() {
  var e = this;
  return e._self._c, e._m(0);
}, Lw = [function() {
  var n = this, e = n._self._c;
  return e("div", { staticClass: "skeleton-list" }, [e("div", { staticClass: "skeleton-list__header" }), e("div", { staticClass: "skeleton-list__list-item skeleton-list__list-item--1" }), e("div", { staticClass: "skeleton-list__list-item skeleton-list__list-item--2" }), e("div", { staticClass: "skeleton-list__list-item skeleton-list__list-item--3" }), e("div", { staticClass: "skeleton-list__list-item skeleton-list__list-item--4" })]);
}], Bw = /* @__PURE__ */ ee(
  Nw,
  Fw,
  Lw,
  !1,
  null,
  "3e908334"
);
const jw = Bw.exports, Hw = {};
var zw = function() {
  var e = this;
  return e._self._c, e._m(0);
}, Uw = [function() {
  var n = this, e = n._self._c;
  return e("div", { staticClass: "skeleton-store" }, [e("div", { staticClass: "skeleton-store__map" }), e("div", { staticClass: "skeleton-store__header" }), e("div", { staticClass: "skeleton-store__list-item skeleton-store__list-item--1" }), e("div", { staticClass: "skeleton-store__list-item skeleton-store__list-item--2" }), e("div", { staticClass: "skeleton-store__list-item skeleton-store__list-item--3" })]);
}], qw = /* @__PURE__ */ ee(
  Hw,
  zw,
  Uw,
  !1,
  null,
  "f3cf3e9d"
);
const Ww = qw.exports;
var $f = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "info-circle", r = 512, a = 512, i = [], o = "f05a", s = "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faInfoCircle = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})($f);
Pe.add(Aa.faChevronRight, $f.faInfoCircle);
const Vw = {
  name: "Branch",
  props: {
    branch: {
      type: Object,
      default: () => ({})
    },
    firstLoad: {
      type: Boolean,
      default: !0
    },
    googleMapsInfo: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      isScrollable: !1
    };
  },
  computed: {
    hasChildren() {
      return Array.isArray(this.branch.children.divisions) && this.branch.children.divisions.length > 0 || Array.isArray(this.branch.children.stores) && this.branch.children.stores.length > 0;
    },
    isLeaf() {
      return !this.hasChildren;
    },
    isStore() {
      return this.branch.type === "Store";
    },
    address() {
      return this.branch && this.branch.address ? this.branch.address : null;
    }
  },
  methods: {
    fullCountryName(n) {
      if (Intl.DisplayNames) {
        const e = this.$i18n.locale;
        return new Intl.DisplayNames([e], { type: "region" }).of(n);
      } else
        return n;
    },
    setIsScrollable() {
      const n = this.$refs.divisionContent;
      n && (this.isScrollable = n.scrollHeight > n.clientHeight && n.scrollTop !== n.scrollHeight - n.offsetHeight);
    },
    cleanHighlighting() {
      const e = [
        ...this.branch.children.divisions,
        ...this.branch.children.stores
      ].find((t) => t.highlighted);
      e && e.cleanHighlightingRecursive();
    }
  },
  mounted() {
    this.setIsScrollable(), window.addEventListener("resize", this.setIsScrollable);
  },
  destroyed() {
    window.removeEventListener("resize", this.setIsScrollable);
  },
  components: {
    SingleMarkerMap: wo,
    BranchList: Rw,
    BranchListSkeleton: jw,
    BranchStoreSkeleton: Ww,
    Tooltip: Mn,
    FontAwesomeIcon: Ie
  }
};
var Yw = function() {
  var e = this, t = e._self._c;
  return t("div", { class: ["branch", { "branch--store": e.isStore, "branch--scrollable": e.isScrollable, "branch--loading": e.branch.isLoading }] }, [t("div", { staticClass: "header-wrapper" }, [t("div", { class: ["header", { "header--leaf": e.isLeaf }] }, [t("div", { staticClass: "header__target_type" }, [t("span", [e._v(e._s(e.$t(`navigation.infinity.${e.branch.type_translation_key}`)))]), !e.firstLoad && e.branch.isInaccessible ? t("Tooltip", { staticClass: "header__target_type-restricted", attrs: { content: e.$t("navigation.infinity.restricted_helptext") } }, [e._v(e._s(e.$t("navigation.infinity.restricted")) + " "), t("font-awesome-icon", { attrs: { icon: "info-circle" } })], 1) : e._e()], 1), t("div", { staticClass: "header__target_name", attrs: { translate: "no" } }, [e._v(e._s(e.branch.name))])])]), e.branch.isLoading || e.firstLoad ? t("div", { staticClass: "content" }, [e.isStore ? t("branch-store-skeleton") : t("branch-list-skeleton")], 1) : [e.isStore ? t("div", { class: ["content", { "content--has-overlay": e.branch.requiresMembershipSwitch }] }, [e.branch.fullyLoaded || e.branch.requiresMembershipSwitch ? [e.address ? t("SingleMarkerMap", { staticClass: "content__map", attrs: { "address-full": e.address, lat: e.address.latitude, long: e.address.longitude, name: e.branch.name, "google-maps-info": e.googleMapsInfo } }) : e._e(), t("div", { staticClass: "content__address" }, [t("div", { staticClass: "content__target_label" }, [e._v("Address")]), t("address", [e.address.address_line_1 ? [e._v(e._s(e.address.address_line_1)), t("br")] : e._e(), e.address.address_line_2 ? [e._v(e._s(e.address.address_line_2)), t("br")] : e._e(), e.address.city ? [e._v(e._s(e.address.city)), t("br")] : e._e(), e.address.postal_code ? [e._v(e._s(e.address.postal_code)), t("br")] : e._e(), e.address.country_code ? [e._v(e._s(e.fullCountryName(e.address.country_code))), t("br")] : e._e()], 2)]), e._t("after-branch-content", null, { branch: e.branch }), e.branch.requiresMembershipSwitch ? t("div", { staticClass: "content__membership-switch-overlay" }, [t("div", [t("p", [e._v(e._s(e.$t("navigation.infinity.switch_membership_helptext", { branchType: e.$t("navigation.infinity.store") })))]), t("a", { staticClass: "btn btn--primary", on: { click: function(r) {
    return e.$root.$emit("unrux::infinite_navigation::switch_membership", e.branch.accessibleThrough, e.branch.url);
  } } }, [e._v(" " + e._s(e.$t("navigation.infinity.switch_membership")) + " "), t("font-awesome-icon", { staticClass: "options__icon", attrs: { icon: "chevron-right" } })], 1)])]) : e._e()] : e._e()], 2) : e.hasChildren ? t("div", { ref: "divisionContent", class: ["content", { "content--has-overlay": e.branch.requiresMembershipSwitch }], on: { scroll: e.setIsScrollable } }, [t("branch-list", { staticClass: "first-branch-list", attrs: { branch: e.branch, "target-list": e.branch.children.divisions, "target-type": "division" }, on: { "clean-highlighting": e.cleanHighlighting } }), t("branch-list", { attrs: { branch: e.branch, "target-list": e.branch.children.stores, "target-type": "store" }, on: { "clean-highlighting": e.cleanHighlighting } }), e.branch.requiresMembershipSwitch ? t("div", { staticClass: "content__membership-switch-overlay" }, [t("div", [t("p", [e._v(e._s(e.$t("navigation.infinity.switch_membership_helptext", { branchType: e.$t("navigation.infinity.division") })))]), t("a", { staticClass: "btn btn--primary", on: { click: function(r) {
    return e.$root.$emit("unrux::infinite_navigation::switch_membership", e.branch.accessibleThrough, e.branch.url);
  } } }, [e._v(" " + e._s(e.$t("navigation.infinity.switch_membership")) + " "), t("font-awesome-icon", { staticClass: "options__icon", attrs: { icon: "chevron-right" } })], 1)])]) : e._e()], 1) : t("div", { staticClass: "content" }, [t("p", { staticClass: "empty-division-message" }, [e._v(" " + e._s(e.$t("navigation.infinity.division_empty")) + " ")])])]], 2);
}, Kw = [], Gw = /* @__PURE__ */ ee(
  Vw,
  Yw,
  Kw,
  !1,
  null,
  "3692e8dd"
);
const Qw = Gw.exports;
Pe.add(Aa.faChevronRight);
const Jw = {
  props: {
    breadcrumbs: {
      type: Array,
      required: !0
    },
    customerOrganizationName: {
      type: String,
      default: ""
    },
    hasMultipleCustomerOrganizations: {
      type: Boolean,
      default: !1
    },
    firstLoad: {
      type: Boolean,
      default: !0
    },
    googleMapsInfo: {
      type: Object,
      required: !0
    }
  },
  computed: {
    modalTitle() {
      return this.$t("navigation.infinity.organization_tree_of", { organization_name: `<span translate="no">${this.customerOrganizationName}</span>` });
    },
    activeBreadcrumb() {
      return this.breadcrumbs[0] || null;
    },
    goToBranchButtonText() {
      return this.$t("navigation.infinity.go_to_x", {
        branchType: this.$t(`navigation.infinity.${this.activeBreadcrumb.type_translation_key}`),
        branchName: `<span translate="no">${this.activeBreadcrumb.name}</span>`
      });
    }
  },
  methods: {
    addRumAction(n) {
      Me(`infinite navigation go to ${n == null ? void 0 : n.type}`, { action: "primary button" });
    },
    saveBranchScrollPositions() {
      this.breadcrumbScrollPositions = {}, this.$refs.branches && this.$refs.branches.forEach((n) => {
        n.$refs.divisionContent && (this.breadcrumbScrollPositions[n.branch.id] = n.$refs.divisionContent.scrollTop);
      });
    },
    restoreBranchScrollPositions() {
      this.$refs.branches && this.$refs.branches.forEach((n) => {
        if (n.$refs.divisionContent) {
          const e = this.breadcrumbScrollPositions[n.branch.id];
          e && n.$refs.divisionContent && (n.$refs.divisionContent.scrollTop = e);
        }
      });
    }
  },
  beforeUpdate() {
    this.saveBranchScrollPositions();
  },
  data() {
    return {
      breadcrumbScrollPositions: {}
    };
  },
  watch: {
    breadcrumbs() {
      this.$nextTick(() => {
        this.restoreBranchScrollPositions();
      });
    }
  },
  components: {
    "x-modal": Su,
    Branch: Qw,
    FontAwesomeIcon: Ie
  }
};
var Zw = function() {
  var e = this, t = e._self._c;
  return t("x-modal", { attrs: { id: "infinite-navigation-modal", type: "fullscreen" }, on: { "on-close": function(r) {
    return e.$emit("on-close");
  } } }, [t("div", { staticClass: "modal-title", attrs: { slot: "title" }, domProps: { innerHTML: e._s(e.modalTitle) }, slot: "title" }), t("div", { staticClass: "modal-content branch-wrapper", attrs: { slot: "body" }, slot: "body" }, e._l(e.breadcrumbs, function(r, a) {
    return t("branch", { key: `branch-${a}`, ref: "branches", refInFor: !0, attrs: { branch: r, "first-load": e.firstLoad, "google-maps-info": e.googleMapsInfo }, scopedSlots: e._u([{ key: "after-branch-content", fn: function(i) {
      return [e._t("after-branch-content", null, { branch: i.branch })];
    } }], null, !0) });
  }), 1), t("template", { slot: "footer" }, [t("div", [e.hasMultipleCustomerOrganizations ? [t("span", { domProps: { innerHTML: e._s(e.$t("navigation.infinity.switch_organization_html")) } })] : e._e()], 2), e.activeBreadcrumb ? t("a", { class: ["btn", "btn--primary", "modal-footer__select-button", { disabled: !e.activeBreadcrumb.isAccessible }], attrs: { href: e.activeBreadcrumb.url }, on: { click: function(r) {
    return e.addRumAction(e.activeBreadcrumb);
  } } }, [t("span", { domProps: { innerHTML: e._s(e.goToBranchButtonText) } }), t("font-awesome-icon", { staticClass: "options__icon", attrs: { icon: "chevron-right" } })], 1) : e._e()])], 2);
}, Xw = [], e5 = /* @__PURE__ */ ee(
  Jw,
  Zw,
  Xw,
  !1,
  null,
  "9d51d886"
);
const t5 = e5.exports, n5 = {
  components: { InfiniteNavigationModal: t5 },
  props: {
    apiUrl: {
      type: String,
      required: !0
    },
    accountsUrl: {
      type: String,
      default: null
    },
    hasMultipleCustomerOrganizations: {
      type: Boolean,
      default: !1
    },
    activeMembershipId: {
      type: Number,
      default: null
    },
    vuexModels: {
      type: Object,
      required: !0
    },
    switchMembershipFunction: {
      type: Function,
      default: null
    },
    googleMapsInfo: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      customerOrganizationId: null,
      currentBreadcrumbsLeaf: null,
      memberships: [],
      firstOpen: !0,
      firstLoad: !0
    };
  },
  mounted() {
    this.listenOnRoot("unrux::infinite_navigation::show", this.openInfiniteNavigationModal), this.listenOnRoot("unrux::infinite_navigation::update_breadcrumbs", this.updateCurrentBreadcrumbLeaf), this.listenOnRoot("unrux::infinite_navigation::switch_membership", this.switchMembership);
  },
  computed: {
    reversedBreadcrumbs() {
      return this.breadcrumbs.slice().reverse();
    },
    breadcrumbs() {
      return this.currentBreadcrumbsLeaf ? this.currentBreadcrumbsLeafModel.path : [];
    },
    currentBreadcrumbsLeafModel() {
      switch (this.currentBreadcrumbsLeaf.type) {
        case "CustomerOrganization":
          return this.vuexModels.NavigationDivision.find(this.customerOrganization.root_division_id);
        case "Division":
          return this.vuexModels.NavigationDivision.find(this.currentBreadcrumbsLeaf.id);
        case "Store":
          return this.vuexModels.NavigationStore.find(this.currentBreadcrumbsLeaf.id);
        default:
          return null;
      }
    },
    customerOrganization() {
      return this.vuexModels.NavigationCustomerOrganization.find(this.customerOrganizationId);
    },
    activeMembership() {
      return this.memberships.filter((n) => n.id === this.activeMembershipId)[0] || null;
    }
  },
  methods: {
    listenOnRoot(n, e) {
      this.$root.$on(n, e), this.$on("hook:beforeDestroy", () => {
        this.$root.$off(n, e);
      });
    },
    openInfiniteNavigationModal(n) {
      this.$root.$emit("unrux::modal::show", "infinite-navigation-modal"), Me("open infinite navigation modal"), this.firstOpen && (this.firstOpen = !1, this.insertBreadcrumbsToStore(n).then(() => {
        this.insertMembershipsToStore().then(() => {
          this.firstLoad = !1, this.fetchShallowBreadcrumbs(this.breadcrumbs), this.currentBreadcrumbsLeafModel.setStateRecursive({ origin: !0, highlight: !0 });
        });
      }));
    },
    updateCurrentBreadcrumbLeaf(n) {
      this.currentBreadcrumbsLeaf = n, n.fullyLoaded || this.fetchBreadcrumbModel(n);
    },
    // The order of the breadcrumbs array is important, because relationships (organization->root division;
    // parent division->division; division->store) are defined by the order of the items.
    async insertBreadcrumbsToStore(n) {
      let e = null, t = n[1] ? n[1].id : null;
      for (const r of n)
        switch (r.type) {
          case "CustomerOrganization":
            this.customerOrganizationId = r.id, await this.insertTargetToStore(r.type, {
              ...r,
              highlighted: !0,
              root_division_id: t,
              accessibility: "inaccessible"
            });
            break;
          case "Division":
            await this.insertTargetToStore(r.type, {
              ...r,
              highlighted: !0,
              parent_id: e,
              accessibility: "inaccessible"
            }), e = r.id;
            break;
          case "Store":
            await this.insertTargetToStore(r.type, {
              ...r,
              highlighted: !0,
              parent_id: e,
              accessibility: "inaccessible"
            });
            break;
        }
      this.currentBreadcrumbsLeaf = n[n.length - 1];
    },
    async insertMembershipsToStore() {
      return new Promise((n) => {
        ve.get("/api/v1/navigation/memberships").then(async (e) => {
          this.memberships = e.data;
          const t = [];
          for (const r of this.memberships) {
            const a = r.id === this.activeMembershipId;
            if (r.target_type === null && a) {
              await this.vuexModels.NavigationCustomerOrganization.find(this.customerOrganizationId).setStateRecursive({ accessibility: "accessible" }, "down");
              return;
            }
            for (const i of r.targets) {
              if (r.target_type === "CustomerOrganization" && i.id !== this.customerOrganizationId || r.target_type !== "CustomerOrganization" && i.record_path[i.record_path.length - 1].id !== this.customerOrganizationId)
                continue;
              let o = r.target_type;
              r.target_type === "BusinessPartner" && (o = "Division"), t.push({
                target: await this.insertTargetToStore(o, i),
                active: a,
                membershipId: r.id
              });
            }
          }
          for (const r of t)
            if (r.target.record_path)
              for (const a of r.target.record_path)
                await this.insertTargetToStore(a.type, { ...a, accessibility: "inaccessible" });
          for (const r of t.filter((a) => !a.active))
            await r.target.setState({
              accessibility: "switchMembership",
              accessibleThrough: r.membershipId
            });
          for (const r of t.filter((a) => a.active))
            await r.target.setStateRecursive({ accessibility: "accessible" }, "down");
        }).then(() => {
          n();
        });
      });
    },
    async insertTargetToStore(n, e) {
      switch (n) {
        case "CustomerOrganization":
          return await this.vuexModels.NavigationCustomerOrganization.insertOrUpdate({
            data: e
          }), this.vuexModels.NavigationCustomerOrganization.find(e.id);
        case "Division":
          return await this.vuexModels.NavigationDivision.insertOrUpdate({
            data: e
          }), this.vuexModels.NavigationDivision.find(e.id);
        case "Store":
          return await this.vuexModels.NavigationStore.insertOrUpdate({
            data: e
          }), this.vuexModels.NavigationStore.find(e.id);
      }
    },
    fetchShallowBreadcrumbs(n) {
      for (const e of n)
        e.fullyLoaded || this.fetchBreadcrumbModel(e);
    },
    fetchBreadcrumbModel(n) {
      return n.constructor.api().fetch(this.apiUrl, n.id);
    },
    clearHighlighting() {
      Me("close infinite navigation modal"), this.vuexModels.NavigationDivision.find(this.customerOrganization.root_division_id).cleanHighlightingRecursive();
    },
    switchMembership(n, e) {
      const t = Dw(document);
      this.switchMembershipFunction ? this.switchMembershipFunction(n, e, t) : this.accountsUrl && ve.patch(this.accountsUrl, {
        authenticity_token: t,
        account: {
          active_membership_id: n
        }
      }).then(() => {
        window.location.href = e;
      });
    }
  }
};
var r5 = function() {
  var e = this, t = e._self._c;
  return t("InfiniteNavigationModal", { attrs: { breadcrumbs: e.reversedBreadcrumbs, "customer-organization-name": e.customerOrganization ? e.customerOrganization.name : "", "has-multiple-customer-organizations": e.hasMultipleCustomerOrganizations, "first-load": e.firstLoad, "google-maps-info": e.googleMapsInfo }, on: { "on-close": e.clearHighlighting }, scopedSlots: e._u([{ key: "after-branch-content", fn: function(r) {
    return [e._t("after-branch-content", null, { branch: r.branch })];
  } }], null, !0) });
}, a5 = [], i5 = /* @__PURE__ */ ee(
  n5,
  r5,
  a5,
  !1,
  null,
  null
);
const o5 = i5.exports;
var s5 = xa;
function l5() {
  this.__data__ = new s5(), this.size = 0;
}
var c5 = l5;
function u5(n) {
  var e = this.__data__, t = e.delete(n);
  return this.size = e.size, t;
}
var f5 = u5;
function d5(n) {
  return this.__data__.get(n);
}
var p5 = d5;
function h5(n) {
  return this.__data__.has(n);
}
var m5 = h5, v5 = xa, g5 = Ro, y5 = No, b5 = 200;
function _5(n, e) {
  var t = this.__data__;
  if (t instanceof v5) {
    var r = t.__data__;
    if (!g5 || r.length < b5 - 1)
      return r.push([n, e]), this.size = ++t.size, this;
    t = this.__data__ = new y5(r);
  }
  return t.set(n, e), this.size = t.size, this;
}
var w5 = _5, C5 = xa, S5 = c5, x5 = f5, O5 = p5, A5 = m5, $5 = w5;
function Hn(n) {
  var e = this.__data__ = new C5(n);
  this.size = e.size;
}
Hn.prototype.clear = S5;
Hn.prototype.delete = x5;
Hn.prototype.get = O5;
Hn.prototype.has = A5;
Hn.prototype.set = $5;
var Ef = Hn, E5 = an, k5 = function() {
  try {
    var n = E5(Object, "defineProperty");
    return n({}, "", {}), n;
  } catch {
  }
}(), kf = k5, Tl = kf;
function D5(n, e, t) {
  e == "__proto__" && Tl ? Tl(n, e, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : n[e] = t;
}
var Lo = D5, T5 = Lo, M5 = wr;
function P5(n, e, t) {
  (t !== void 0 && !M5(n[e], t) || t === void 0 && !(e in n)) && T5(n, e, t);
}
var Df = P5;
function I5(n) {
  return function(e, t, r) {
    for (var a = -1, i = Object(e), o = r(e), s = o.length; s--; ) {
      var l = o[n ? s : ++a];
      if (t(i[l], l, i) === !1)
        break;
    }
    return e;
  };
}
var R5 = I5, N5 = R5, F5 = N5(), L5 = F5, ta = { exports: {} };
ta.exports;
(function(n, e) {
  var t = nt, r = e && !e.nodeType && e, a = r && !0 && n && !n.nodeType && n, i = a && a.exports === r, o = i ? t.Buffer : void 0, s = o ? o.allocUnsafe : void 0;
  function l(u, c) {
    if (c)
      return u.slice();
    var p = u.length, m = s ? s(p) : new u.constructor(p);
    return u.copy(m), m;
  }
  n.exports = l;
})(ta, ta.exports);
var B5 = ta.exports, j5 = nt, H5 = j5.Uint8Array, Tf = H5, Ml = Tf;
function z5(n) {
  var e = new n.constructor(n.byteLength);
  return new Ml(e).set(new Ml(n)), e;
}
var U5 = z5, q5 = U5;
function W5(n, e) {
  var t = e ? q5(n.buffer) : n.buffer;
  return new n.constructor(t, n.byteOffset, n.length);
}
var V5 = W5;
function Y5(n, e) {
  var t = -1, r = n.length;
  for (e || (e = Array(r)); ++t < r; )
    e[t] = n[t];
  return e;
}
var K5 = Y5, G5 = St, Pl = Object.create, Q5 = /* @__PURE__ */ function() {
  function n() {
  }
  return function(e) {
    if (!G5(e))
      return {};
    if (Pl)
      return Pl(e);
    n.prototype = e;
    var t = new n();
    return n.prototype = void 0, t;
  };
}(), J5 = Q5;
function Z5(n, e) {
  return function(t) {
    return n(e(t));
  };
}
var Mf = Z5, X5 = Mf, e8 = X5(Object.getPrototypeOf, Object), Pf = e8, t8 = Object.prototype;
function n8(n) {
  var e = n && n.constructor, t = typeof e == "function" && e.prototype || t8;
  return n === t;
}
var Bo = n8, r8 = J5, a8 = Pf, i8 = Bo;
function o8(n) {
  return typeof n.constructor == "function" && !i8(n) ? r8(a8(n)) : {};
}
var s8 = o8, l8 = Pn, c8 = nn, u8 = "[object Arguments]";
function f8(n) {
  return c8(n) && l8(n) == u8;
}
var d8 = f8, Il = d8, p8 = nn, If = Object.prototype, h8 = If.hasOwnProperty, m8 = If.propertyIsEnumerable, v8 = Il(/* @__PURE__ */ function() {
  return arguments;
}()) ? Il : function(n) {
  return p8(n) && h8.call(n, "callee") && !m8.call(n, "callee");
}, Rf = v8, g8 = 9007199254740991;
function y8(n) {
  return typeof n == "number" && n > -1 && n % 1 == 0 && n <= g8;
}
var Nf = y8, b8 = Io, _8 = Nf;
function w8(n) {
  return n != null && _8(n.length) && !b8(n);
}
var $a = w8, C8 = $a, S8 = nn;
function x8(n) {
  return S8(n) && C8(n);
}
var O8 = x8, na = { exports: {} };
function A8() {
  return !1;
}
var $8 = A8;
na.exports;
(function(n, e) {
  var t = nt, r = $8, a = e && !e.nodeType && e, i = a && !0 && n && !n.nodeType && n, o = i && i.exports === a, s = o ? t.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || r;
  n.exports = u;
})(na, na.exports);
var jo = na.exports, E8 = Pn, k8 = Pf, D8 = nn, T8 = "[object Object]", M8 = Function.prototype, P8 = Object.prototype, Ff = M8.toString, I8 = P8.hasOwnProperty, R8 = Ff.call(Object);
function N8(n) {
  if (!D8(n) || E8(n) != T8)
    return !1;
  var e = k8(n);
  if (e === null)
    return !0;
  var t = I8.call(e, "constructor") && e.constructor;
  return typeof t == "function" && t instanceof t && Ff.call(t) == R8;
}
var F8 = N8, L8 = Pn, B8 = Nf, j8 = nn, H8 = "[object Arguments]", z8 = "[object Array]", U8 = "[object Boolean]", q8 = "[object Date]", W8 = "[object Error]", V8 = "[object Function]", Y8 = "[object Map]", K8 = "[object Number]", G8 = "[object Object]", Q8 = "[object RegExp]", J8 = "[object Set]", Z8 = "[object String]", X8 = "[object WeakMap]", e6 = "[object ArrayBuffer]", t6 = "[object DataView]", n6 = "[object Float32Array]", r6 = "[object Float64Array]", a6 = "[object Int8Array]", i6 = "[object Int16Array]", o6 = "[object Int32Array]", s6 = "[object Uint8Array]", l6 = "[object Uint8ClampedArray]", c6 = "[object Uint16Array]", u6 = "[object Uint32Array]", pe = {};
pe[n6] = pe[r6] = pe[a6] = pe[i6] = pe[o6] = pe[s6] = pe[l6] = pe[c6] = pe[u6] = !0;
pe[H8] = pe[z8] = pe[e6] = pe[U8] = pe[t6] = pe[q8] = pe[W8] = pe[V8] = pe[Y8] = pe[K8] = pe[G8] = pe[Q8] = pe[J8] = pe[Z8] = pe[X8] = !1;
function f6(n) {
  return j8(n) && B8(n.length) && !!pe[L8(n)];
}
var d6 = f6;
function p6(n) {
  return function(e) {
    return n(e);
  };
}
var h6 = p6, ra = { exports: {} };
ra.exports;
(function(n, e) {
  var t = xu, r = e && !e.nodeType && e, a = r && !0 && n && !n.nodeType && n, i = a && a.exports === r, o = i && t.process, s = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  n.exports = s;
})(ra, ra.exports);
var m6 = ra.exports, v6 = d6, g6 = h6, Rl = m6, Nl = Rl && Rl.isTypedArray, y6 = Nl ? g6(Nl) : v6, Ho = y6;
function b6(n, e) {
  if (!(e === "constructor" && typeof n[e] == "function") && e != "__proto__")
    return n[e];
}
var Lf = b6, _6 = Lo, w6 = wr, C6 = Object.prototype, S6 = C6.hasOwnProperty;
function x6(n, e, t) {
  var r = n[e];
  (!(S6.call(n, e) && w6(r, t)) || t === void 0 && !(e in n)) && _6(n, e, t);
}
var O6 = x6, A6 = O6, $6 = Lo;
function E6(n, e, t, r) {
  var a = !t;
  t || (t = {});
  for (var i = -1, o = e.length; ++i < o; ) {
    var s = e[i], l = r ? r(t[s], n[s], s, t, n) : void 0;
    l === void 0 && (l = n[s]), a ? $6(t, s, l) : A6(t, s, l);
  }
  return t;
}
var k6 = E6;
function D6(n, e) {
  for (var t = -1, r = Array(n); ++t < n; )
    r[t] = e(t);
  return r;
}
var T6 = D6, M6 = 9007199254740991, P6 = /^(?:0|[1-9]\d*)$/;
function I6(n, e) {
  var t = typeof n;
  return e = e ?? M6, !!e && (t == "number" || t != "symbol" && P6.test(n)) && n > -1 && n % 1 == 0 && n < e;
}
var Bf = I6, R6 = T6, N6 = Rf, F6 = rn, L6 = jo, B6 = Bf, j6 = Ho, H6 = Object.prototype, z6 = H6.hasOwnProperty;
function U6(n, e) {
  var t = F6(n), r = !t && N6(n), a = !t && !r && L6(n), i = !t && !r && !a && j6(n), o = t || r || a || i, s = o ? R6(n.length, String) : [], l = s.length;
  for (var u in n)
    (e || z6.call(n, u)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    B6(u, l))) && s.push(u);
  return s;
}
var jf = U6;
function q6(n) {
  var e = [];
  if (n != null)
    for (var t in Object(n))
      e.push(t);
  return e;
}
var W6 = q6, V6 = St, Y6 = Bo, K6 = W6, G6 = Object.prototype, Q6 = G6.hasOwnProperty;
function J6(n) {
  if (!V6(n))
    return K6(n);
  var e = Y6(n), t = [];
  for (var r in n)
    r == "constructor" && (e || !Q6.call(n, r)) || t.push(r);
  return t;
}
var Z6 = J6, X6 = jf, e9 = Z6, t9 = $a;
function n9(n) {
  return t9(n) ? X6(n, !0) : e9(n);
}
var Hf = n9, r9 = k6, a9 = Hf;
function i9(n) {
  return r9(n, a9(n));
}
var o9 = i9, Fl = Df, s9 = B5, l9 = V5, c9 = K5, u9 = s8, Ll = Rf, Bl = rn, f9 = O8, d9 = jo, p9 = Io, h9 = St, m9 = F8, v9 = Ho, jl = Lf, g9 = o9;
function y9(n, e, t, r, a, i, o) {
  var s = jl(n, t), l = jl(e, t), u = o.get(l);
  if (u) {
    Fl(n, t, u);
    return;
  }
  var c = i ? i(s, l, t + "", n, e, o) : void 0, p = c === void 0;
  if (p) {
    var m = Bl(l), y = !m && d9(l), g = !m && !y && v9(l);
    c = l, m || y || g ? Bl(s) ? c = s : f9(s) ? c = c9(s) : y ? (p = !1, c = s9(l, !0)) : g ? (p = !1, c = l9(l, !0)) : c = [] : m9(l) || Ll(l) ? (c = s, Ll(s) ? c = g9(s) : (!h9(s) || p9(s)) && (c = u9(l))) : p = !1;
  }
  p && (o.set(l, c), a(c, l, r, i, o), o.delete(l)), Fl(n, t, c);
}
var b9 = y9, _9 = Ef, w9 = Df, C9 = L5, S9 = b9, x9 = St, O9 = Hf, A9 = Lf;
function zf(n, e, t, r, a) {
  n !== e && C9(e, function(i, o) {
    if (a || (a = new _9()), x9(i))
      S9(n, e, o, t, zf, r, a);
    else {
      var s = r ? r(A9(n, o), i, o + "", n, e, a) : void 0;
      s === void 0 && (s = i), w9(n, o, s);
    }
  }, O9);
}
var $9 = zf;
function E9(n) {
  return n;
}
var Uf = E9;
function k9(n, e, t) {
  switch (t.length) {
    case 0:
      return n.call(e);
    case 1:
      return n.call(e, t[0]);
    case 2:
      return n.call(e, t[0], t[1]);
    case 3:
      return n.call(e, t[0], t[1], t[2]);
  }
  return n.apply(e, t);
}
var D9 = k9, T9 = D9, Hl = Math.max;
function M9(n, e, t) {
  return e = Hl(e === void 0 ? n.length - 1 : e, 0), function() {
    for (var r = arguments, a = -1, i = Hl(r.length - e, 0), o = Array(i); ++a < i; )
      o[a] = r[e + a];
    a = -1;
    for (var s = Array(e + 1); ++a < e; )
      s[a] = r[a];
    return s[e] = t(o), T9(n, this, s);
  };
}
var P9 = M9;
function I9(n) {
  return function() {
    return n;
  };
}
var R9 = I9, N9 = R9, zl = kf, F9 = Uf, L9 = zl ? function(n, e) {
  return zl(n, "toString", {
    configurable: !0,
    enumerable: !1,
    value: N9(e),
    writable: !0
  });
} : F9, B9 = L9, j9 = 800, H9 = 16, z9 = Date.now;
function U9(n) {
  var e = 0, t = 0;
  return function() {
    var r = z9(), a = H9 - (r - t);
    if (t = r, a > 0) {
      if (++e >= j9)
        return arguments[0];
    } else
      e = 0;
    return n.apply(void 0, arguments);
  };
}
var q9 = U9, W9 = B9, V9 = q9, Y9 = V9(W9), K9 = Y9, G9 = Uf, Q9 = P9, J9 = K9;
function Z9(n, e) {
  return J9(Q9(n, e, G9), n + "");
}
var X9 = Z9, e7 = wr, t7 = $a, n7 = Bf, r7 = St;
function a7(n, e, t) {
  if (!r7(t))
    return !1;
  var r = typeof e;
  return (r == "number" ? t7(t) && n7(e, t.length) : r == "string" && e in t) ? e7(t[e], n) : !1;
}
var i7 = a7, o7 = X9, s7 = i7;
function l7(n) {
  return o7(function(e, t) {
    var r = -1, a = t.length, i = a > 1 ? t[a - 1] : void 0, o = a > 2 ? t[2] : void 0;
    for (i = n.length > 3 && typeof i == "function" ? (a--, i) : void 0, o && s7(t[0], t[1], o) && (i = a < 3 ? void 0 : i, a = 1), e = Object(e); ++r < a; ) {
      var s = t[r];
      s && n(e, s, r, i);
    }
    return e;
  });
}
var c7 = l7, u7 = $9, f7 = c7, d7 = f7(function(n, e, t) {
  u7(n, e, t);
}), p7 = d7;
const qf = /* @__PURE__ */ tn(p7);
Pe.add(Zv, Jv);
const h7 = {
  props: {
    sorted: Boolean,
    direction: {
      validator: (n) => ["asc", "desc", "ascending", "descending"].some((e) => e === (n == null ? void 0 : n.toLowerCase()))
    }
  },
  methods: {
    arrowStyle(n) {
      var e;
      return this.sorted ? {
        color: n != null && n.toLowerCase().startsWith((e = this.direction) == null ? void 0 : e.toLowerCase()) ? "var(--color-icon-sorted, #5D5E5E)" : "var(--color-icon-not-sorted, #D5D5D5)"
      } : {
        color: "var(--color-icon-not-sorted, #D5D5D5)"
      };
    }
  },
  components: {
    FontAwesomeLayers: Kc,
    FontAwesomeIcon: Ie
  }
};
var m7 = function() {
  var e = this, t = e._self._c;
  return t("font-awesome-layers", { staticClass: "fa-lg fa-fw margin-left" }, [t("font-awesome-icon", { style: e.arrowStyle("ascending"), attrs: { icon: "sort-up", transform: "down-1" } }), t("font-awesome-icon", { style: e.arrowStyle("descending"), attrs: { icon: "sort-down", transform: "down-1" } })], 1);
}, v7 = [], g7 = /* @__PURE__ */ ee(
  h7,
  m7,
  v7,
  !1,
  null,
  "70e35ebd"
);
const y7 = g7.exports;
var b7 = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 280 280" } }, n.$listeners), [t("circle", { attrs: { cx: "109", cy: "188.25", r: "84.5", fill: "#e0e0e0" } }), t("path", { attrs: { fill: "#fff", d: "m54.79 184.75.21 59.5h146l30-15 1.17-56.15 23.46-13.6-22.78-19.25.15-7 9-16H104l-15 22-24-16-33.66 13.16L56 152.25l-5 7-13 24 16.79 1.5z" } }), t("path", { attrs: { fill: "#e0e0e0", d: "m63 152.25 26-12h137l-25 13-138-1z" } }), t("path", { attrs: { fill: "none", stroke: "#5d5e5e", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "3.46", d: "M55.79 192.75v52h146.63v-91H55.79l33.28-15h143.04L208 150.25" } }), t("path", { attrs: { fill: "none", stroke: "#5d5e5e", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "3.46", d: "m232.11 138.75 23.39 21-27.89 17-25.19-23M232.11 182.25v46.5L210 241.25M199.72 154.75c0 1-17.09 30-17.09 30H37.79l13.5-26M53.09 149.75 30.5 137.19l35.08-15 24.39 15.56M89.97 137.75l14.39-22h140.26l-9.62 17.5M89.97 144.75v9" } }), t("path", { attrs: { fill: "none", stroke: "#f90", "stroke-linejoin": "round", "stroke-width": "3", d: "M144.5 147.75s-.54-1.39-1.35-3.76" } }), t("path", { attrs: { fill: "none", stroke: "#f90", "stroke-dasharray": "8.18 8.18", "stroke-linejoin": "round", "stroke-width": "3", d: "M140.71 136.18c-5.42-19-12-54.58 15.15-54.62 22.56 0 17.13 17.36 13.82 20.55-7.93 7.64-24.28 15.61-41.18-14.36-9.16-16.24-3.66-30.6 1.17-38.52" } }), t("path", { attrs: { fill: "none", stroke: "#f90", "stroke-linejoin": "round", "stroke-width": "3", d: "M132 45.83a31.61 31.61 0 0 1 2.54-3.08" } }), t("path", { attrs: { fill: "#e0e0e0", stroke: "#5d5d5d", "stroke-miterlimit": "10", "stroke-width": "3", d: "M144 28.25s-11-3-5 5l4 2s6.4-4.08 8-6c1.43-1.72 4-8 4-8l-3-3s-14-5-8 10Z" } }), t("path", { attrs: { fill: "none", stroke: "#5d5d5d", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "3", d: "m155 21.25-1-14M155 20.25l4-7" } })]);
};
const _7 = {
  render: b7
};
var w7 = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 280 280" } }, n.$listeners), [t("circle", { attrs: { cx: "140", cy: "147.5", r: "84.5", fill: "#e0e0e0" } }), t("rect", { attrs: { width: "110.46", height: "154.2", x: "100.14", y: "54.82", fill: "#fff", stroke: "#5d5e5e", "stroke-miterlimit": "10", "stroke-width": "3.5", rx: "3", transform: "rotate(-8.36 155.292 131.92)" } }), t("path", { attrs: { fill: "none", stroke: "#f90", "stroke-linecap": "round", "stroke-miterlimit": "10", "stroke-width": "3.5", d: "m110.65 90.88 12.44 9.26 15.24-20.49M117.68 138.71l12.44 9.25 15.24-20.49M124.7 186.53l12.45 9.26 15.24-20.49" } }), t("rect", { attrs: { width: "46.51", height: "7.3", x: "149.86", y: "80", fill: "#e0e0e0", rx: "3", transform: "rotate(-8.1 168.332 80.022)" } }), t("rect", { attrs: { width: "46.51", height: "7.3", x: "156.75", y: "126.93", fill: "#e0e0e0", rx: "3", transform: "rotate(-8.36 179.946 130.558)" } })]);
};
const C7 = {
  render: w7
};
var S7 = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", "data-name": "Empty states", viewBox: "0 0 280 280" } }, n.$listeners), [t("circle", { staticStyle: { fill: "#e0e0e0", "stroke-width": "0" }, attrs: { cx: "140", cy: "147.5", r: "84.5" } }), t("path", { staticStyle: { fill: "#fff", stroke: "#5d5d5d", "stroke-linejoin": "round", "stroke-width": "3.5px" }, attrs: { d: "M163.24 217.98c-23.65-3.75-40.95-19.25-43.39-43.56-2.12-21.21 5.22-40.62 18.76-56.77 6.69-7.99 13.22-15.17 18.43-24.14 4.24-7.34 7.67-14.84 8.81-23.33.16-1.96.65-7.34.81-8.16.81.33 12.4 12.4 16.15 18.93 8.32 14.84 10.11 23.49 9.95 40.29 0 .98-.16 2.12 0 3.1.16 4.73 3.26 10.77 9.46 11.42 4.57.49 8.49-1.47 10.11-5.87 2.12-5.55 3.26-13.37 3.59-14.03 13.54 20.88 21.53 48.12 10.11 73.41-6.69 14.68-19.9 24.14-35.73 28.06-.49.16-25.28.85-25.77.85l-1.31-.2Z" } }), t("path", { staticStyle: { fill: "#f90", "stroke-width": "0" }, attrs: { d: "M175.16 217.45c4.67-.13 11.97-1.89 12.13-2.05 10.11-4.57 14.03-14.52 13.22-24.8-.65-7.99-3.92-14.68-8.81-20.88-3.59-4.4-8.65-8.97-11.58-13.87-2.12-4.08-3.26-8.48-4.73-12.72-5.22 5.38-7.02 12.23-8.49 20.07-.65 3.75-.81 7.83-.98 11.75-.16 3.59-1.96 5.71-5.22 6.2-2.78.33-8.32-3.43-9.3-6.04-.81.16-6.85 10.44-.49 29.2 1.96 5.55 6.14 10.05 11.75 11.42 6.88 1.68 10.74 1.79 11.66 1.71.21-.02.83.01.83.01ZM133.64 38.72s15.34 12.14 3.95 24.28c0 0 11.29-4.94 10.45-12.84s-7.62-11.44-14.4-11.44Zm66.32 42.57s-10.42-4.41 3.11-24.4c0 0-10.68 1.25-12.11 9.07-1.43 7.82 2.51 13.41 9 15.33Zm-40.61-64.38s6.97-1.57 6.18 11c0 0 5.29-3.97 3.54-7.64s-5.64-4.68-9.72-3.36Z" } })]);
};
const x7 = {
  render: S7
};
var O7 = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 280 280" } }, n.$listeners), [t("circle", { attrs: { cx: "140", cy: "147.5", r: "84.5", fill: "#e0e0e0" } }), t("rect", { attrs: { width: "110.46", height: "154.2", x: "100.14", y: "54.82", fill: "#fff", stroke: "#5d5e5e", "stroke-miterlimit": "10", "stroke-width": "3.5", rx: "3", transform: "rotate(-8.36 155.292 131.92)" } }), t("path", { attrs: { fill: "#f90", d: "M132.74 114.47c-1.29-8.79 1.06-13.17 5.61-17.48 3.27-3.06 6.24-6 5.62-10.28-.78-5.3-5.72-8.7-11.42-7.87-6.41.94-10.27 6.67-10.06 13.6l-8.95-.39c-.35-10.71 6.85-19.52 18.09-21.16 10.85-1.58 20.27 4.24 21.7 14 1.06 7.29-2.63 11.38-7.65 15.75-4 3.41-5.53 6.39-4.63 12.57Zm.43 11.25a5.4 5.4 0 0 1 10.68-1.56 5.4 5.4 0 0 1-10.68 1.56Z" } }), t("rect", { attrs: { width: "46.51", height: "7.3", x: "150.39", y: "183.08", fill: "#e0e0e0", rx: "3", transform: "rotate(-8.1 169.469 179.965)" } }), t("rect", { attrs: { width: "46.51", height: "7.3", x: "146.39", y: "156.08", fill: "#e0e0e0", rx: "3", transform: "rotate(-8.1 165.412 153.827)" } })]);
};
const A7 = {
  render: O7
};
var $7 = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 280 280" } }, n.$listeners), [t("circle", { attrs: { cx: "140", cy: "147.5", r: "84.5", fill: "#e0e0e0" } }), t("path", { attrs: { fill: "#fff", stroke: "#5d5d5d", "stroke-linejoin": "round", "stroke-width": "3.5", d: "M229.44 87.24H102.67a3.34 3.34 0 0 0-3.33 3.34v75.61a3.34 3.34 0 0 0 3.33 3.34h20V204l29.06-34.47h77.69a3.35 3.35 0 0 0 3.34-3.34V90.58a3.35 3.35 0 0 0-3.32-3.34Z" } }), t("path", { staticStyle: { "stroke-width": "1.53506" }, attrs: { fill: "#f90", d: "M120.273 135.176v4.264h27.863v-5.645H129.82l17.714-20.597v-4.264h-26.662v5.645h17.295zm33.719 0v4.264h27.863v-5.645H163.54l17.714-20.597v-4.264h-26.661v5.645h17.294zm33.72 0v4.264h27.863v-5.645h-18.316l17.714-20.597v-4.264h-26.661v5.645h17.294z" } })]);
};
const E7 = {
  render: $7
};
var k7 = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 280 280" } }, n.$listeners), [t("circle", { attrs: { cx: "140", cy: "147.5", r: "84.5", fill: "#e0e0e0" } }), t("path", { attrs: { fill: "#fff", stroke: "#5d5d5d", "stroke-linejoin": "round", "stroke-width": "3.5", d: "M229.44 87.24H102.67a3.34 3.34 0 0 0-3.33 3.34v75.61a3.34 3.34 0 0 0 3.33 3.34h20V204l29.06-34.47h77.69a3.35 3.35 0 0 0 3.34-3.34V90.58a3.35 3.35 0 0 0-3.32-3.34Z" } }), t("path", { attrs: { fill: "none", stroke: "#f90", "stroke-linecap": "round", "stroke-miterlimit": "10", "stroke-width": "6.04", d: "m141.46 129.89 20.1 17.67 29.1-33.12" } })]);
};
const D7 = {
  render: k7
};
var T7 = function() {
  var n = this, e = n.$createElement, t = n._self._c || e;
  return t("svg", n._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 280 280" } }, n.$listeners), [t("circle", { attrs: { cx: "140", cy: "147.5", r: "84.5", fill: "#e0e0e0" } }), t("path", { attrs: { fill: "#fff", d: "M122.48 187.5s1 7-7 6-23-1-23-1-5 0-5-6v-51s2-5 9-5H117s5.61 3 5.57 7h8s9.9-3.94 22.45-26c0 0 15.12-11.75 18.55-17 3.78-5.82 8.85-26.31 8.85-26.31s10.38-11.38 16.76 6.47-10.61 37.84-10.61 37.84-5 9 22 9c0 0 18.51-3.79 25 7a29.56 29.56 0 0 0-2 9c0 2.24 4.71 6 5 9 .58 6.06-4.28 6.36-2.69 13.65 2.69 12.35-3.31 19.35-1.32 23.67 1.21 2.6-1.66 4.79-3 5.68 0 0-9 18-105-2Z" } }), t("path", { attrs: { fill: "none", stroke: "#5d5e5e", "stroke-linecap": "round", "stroke-miterlimit": "10", "stroke-width": "3.5", d: "M131.71 136.88s5.65-1.13 11.31-11.31c8.85-15.94 20.58-23.56 27.14-31.66 3.83-4.74 6.78-12.44 9.05-22.62 2.46-11.1 15.83-10.18 18.09 4.52s-3.39 24.88-7.92 31.67-3.38 14.7 13.62 13.57 21.28-.76 26.74 3.17c6.29 4.52 1.79 13.28 1.79 13.28 11 9 0 22 0 22 11 6-1 20-1 20 6 11-12 15-12 15-10.73 3.58-32 3.59-40.4 2.31-12-1.82-55.42-9-55.42-9v-47.97s1.13-9.75-7.91-9.75H93.26s-6.78 1.22-6.78 7.31v49.93s0 6.09 6.78 6.09h19.22" } }), t("circle", { attrs: { cx: "109.48", cy: "179.5", r: "5", fill: "#f90" } })]);
};
const M7 = {
  render: T7
};
var Wf = { exports: {} };
(function(n, e) {
  (function(t, r) {
    n.exports = r();
  })(Dt, function() {
    var t = 1e3, r = 6e4, a = 36e5, i = "millisecond", o = "second", s = "minute", l = "hour", u = "day", c = "week", p = "month", m = "quarter", y = "year", g = "date", b = "Invalid Date", w = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, C = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, S = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(F) {
      var D = ["th", "st", "nd", "rd"], k = F % 100;
      return "[" + F + (D[(k - 20) % 10] || D[k] || D[0]) + "]";
    } }, A = function(F, D, k) {
      var R = String(F);
      return !R || R.length >= D ? F : "" + Array(D + 1 - R.length).join(k) + F;
    }, h = { s: A, z: function(F) {
      var D = -F.utcOffset(), k = Math.abs(D), R = Math.floor(k / 60), T = k % 60;
      return (D <= 0 ? "+" : "-") + A(R, 2, "0") + ":" + A(T, 2, "0");
    }, m: function F(D, k) {
      if (D.date() < k.date()) return -F(k, D);
      var R = 12 * (k.year() - D.year()) + (k.month() - D.month()), T = D.clone().add(R, p), q = k - T < 0, W = D.clone().add(R + (q ? -1 : 1), p);
      return +(-(R + (k - T) / (q ? T - W : W - T)) || 0);
    }, a: function(F) {
      return F < 0 ? Math.ceil(F) || 0 : Math.floor(F);
    }, p: function(F) {
      return { M: p, y, w: c, d: u, D: g, h: l, m: s, s: o, ms: i, Q: m }[F] || String(F || "").toLowerCase().replace(/s$/, "");
    }, u: function(F) {
      return F === void 0;
    } }, E = "en", _ = {};
    _[E] = S;
    var M = "$isDayjsObject", L = function(F) {
      return F instanceof J || !(!F || !F[M]);
    }, z = function F(D, k, R) {
      var T;
      if (!D) return E;
      if (typeof D == "string") {
        var q = D.toLowerCase();
        _[q] && (T = q), k && (_[q] = k, T = q);
        var W = D.split("-");
        if (!T && W.length > 1) return F(W[0]);
      } else {
        var te = D.name;
        _[te] = D, T = te;
      }
      return !R && T && (E = T), T || !R && E;
    }, U = function(F, D) {
      if (L(F)) return F.clone();
      var k = typeof D == "object" ? D : {};
      return k.date = F, k.args = arguments, new J(k);
    }, V = h;
    V.l = z, V.i = L, V.w = function(F, D) {
      return U(F, { locale: D.$L, utc: D.$u, x: D.$x, $offset: D.$offset });
    };
    var J = function() {
      function F(k) {
        this.$L = z(k.locale, null, !0), this.parse(k), this.$x = this.$x || k.x || {}, this[M] = !0;
      }
      var D = F.prototype;
      return D.parse = function(k) {
        this.$d = function(R) {
          var T = R.date, q = R.utc;
          if (T === null) return /* @__PURE__ */ new Date(NaN);
          if (V.u(T)) return /* @__PURE__ */ new Date();
          if (T instanceof Date) return new Date(T);
          if (typeof T == "string" && !/Z$/i.test(T)) {
            var W = T.match(w);
            if (W) {
              var te = W[2] - 1 || 0, ie = (W[7] || "0").substring(0, 3);
              return q ? new Date(Date.UTC(W[1], te, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, ie)) : new Date(W[1], te, W[3] || 1, W[4] || 0, W[5] || 0, W[6] || 0, ie);
            }
          }
          return new Date(T);
        }(k), this.init();
      }, D.init = function() {
        var k = this.$d;
        this.$y = k.getFullYear(), this.$M = k.getMonth(), this.$D = k.getDate(), this.$W = k.getDay(), this.$H = k.getHours(), this.$m = k.getMinutes(), this.$s = k.getSeconds(), this.$ms = k.getMilliseconds();
      }, D.$utils = function() {
        return V;
      }, D.isValid = function() {
        return this.$d.toString() !== b;
      }, D.isSame = function(k, R) {
        var T = U(k);
        return this.startOf(R) <= T && T <= this.endOf(R);
      }, D.isAfter = function(k, R) {
        return U(k) < this.startOf(R);
      }, D.isBefore = function(k, R) {
        return this.endOf(R) < U(k);
      }, D.$g = function(k, R, T) {
        return V.u(k) ? this[R] : this.set(T, k);
      }, D.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, D.valueOf = function() {
        return this.$d.getTime();
      }, D.startOf = function(k, R) {
        var T = this, q = !!V.u(R) || R, W = V.p(k), te = function(Ce, de) {
          var xe = V.w(T.$u ? Date.UTC(T.$y, de, Ce) : new Date(T.$y, de, Ce), T);
          return q ? xe : xe.endOf(u);
        }, ie = function(Ce, de) {
          return V.w(T.toDate()[Ce].apply(T.toDate("s"), (q ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(de)), T);
        }, ce = this.$W, ue = this.$M, le = this.$D, ye = "set" + (this.$u ? "UTC" : "");
        switch (W) {
          case y:
            return q ? te(1, 0) : te(31, 11);
          case p:
            return q ? te(1, ue) : te(0, ue + 1);
          case c:
            var we = this.$locale().weekStart || 0, me = (ce < we ? ce + 7 : ce) - we;
            return te(q ? le - me : le + (6 - me), ue);
          case u:
          case g:
            return ie(ye + "Hours", 0);
          case l:
            return ie(ye + "Minutes", 1);
          case s:
            return ie(ye + "Seconds", 2);
          case o:
            return ie(ye + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, D.endOf = function(k) {
        return this.startOf(k, !1);
      }, D.$set = function(k, R) {
        var T, q = V.p(k), W = "set" + (this.$u ? "UTC" : ""), te = (T = {}, T[u] = W + "Date", T[g] = W + "Date", T[p] = W + "Month", T[y] = W + "FullYear", T[l] = W + "Hours", T[s] = W + "Minutes", T[o] = W + "Seconds", T[i] = W + "Milliseconds", T)[q], ie = q === u ? this.$D + (R - this.$W) : R;
        if (q === p || q === y) {
          var ce = this.clone().set(g, 1);
          ce.$d[te](ie), ce.init(), this.$d = ce.set(g, Math.min(this.$D, ce.daysInMonth())).$d;
        } else te && this.$d[te](ie);
        return this.init(), this;
      }, D.set = function(k, R) {
        return this.clone().$set(k, R);
      }, D.get = function(k) {
        return this[V.p(k)]();
      }, D.add = function(k, R) {
        var T, q = this;
        k = Number(k);
        var W = V.p(R), te = function(ue) {
          var le = U(q);
          return V.w(le.date(le.date() + Math.round(ue * k)), q);
        };
        if (W === p) return this.set(p, this.$M + k);
        if (W === y) return this.set(y, this.$y + k);
        if (W === u) return te(1);
        if (W === c) return te(7);
        var ie = (T = {}, T[s] = r, T[l] = a, T[o] = t, T)[W] || 1, ce = this.$d.getTime() + k * ie;
        return V.w(ce, this);
      }, D.subtract = function(k, R) {
        return this.add(-1 * k, R);
      }, D.format = function(k) {
        var R = this, T = this.$locale();
        if (!this.isValid()) return T.invalidDate || b;
        var q = k || "YYYY-MM-DDTHH:mm:ssZ", W = V.z(this), te = this.$H, ie = this.$m, ce = this.$M, ue = T.weekdays, le = T.months, ye = T.meridiem, we = function(de, xe, De, Ye) {
          return de && (de[xe] || de(R, q)) || De[xe].slice(0, Ye);
        }, me = function(de) {
          return V.s(te % 12 || 12, de, "0");
        }, Ce = ye || function(de, xe, De) {
          var Ye = de < 12 ? "AM" : "PM";
          return De ? Ye.toLowerCase() : Ye;
        };
        return q.replace(C, function(de, xe) {
          return xe || function(De) {
            switch (De) {
              case "YY":
                return String(R.$y).slice(-2);
              case "YYYY":
                return V.s(R.$y, 4, "0");
              case "M":
                return ce + 1;
              case "MM":
                return V.s(ce + 1, 2, "0");
              case "MMM":
                return we(T.monthsShort, ce, le, 3);
              case "MMMM":
                return we(le, ce);
              case "D":
                return R.$D;
              case "DD":
                return V.s(R.$D, 2, "0");
              case "d":
                return String(R.$W);
              case "dd":
                return we(T.weekdaysMin, R.$W, ue, 2);
              case "ddd":
                return we(T.weekdaysShort, R.$W, ue, 3);
              case "dddd":
                return ue[R.$W];
              case "H":
                return String(te);
              case "HH":
                return V.s(te, 2, "0");
              case "h":
                return me(1);
              case "hh":
                return me(2);
              case "a":
                return Ce(te, ie, !0);
              case "A":
                return Ce(te, ie, !1);
              case "m":
                return String(ie);
              case "mm":
                return V.s(ie, 2, "0");
              case "s":
                return String(R.$s);
              case "ss":
                return V.s(R.$s, 2, "0");
              case "SSS":
                return V.s(R.$ms, 3, "0");
              case "Z":
                return W;
            }
            return null;
          }(de) || W.replace(":", "");
        });
      }, D.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, D.diff = function(k, R, T) {
        var q, W = this, te = V.p(R), ie = U(k), ce = (ie.utcOffset() - this.utcOffset()) * r, ue = this - ie, le = function() {
          return V.m(W, ie);
        };
        switch (te) {
          case y:
            q = le() / 12;
            break;
          case p:
            q = le();
            break;
          case m:
            q = le() / 3;
            break;
          case c:
            q = (ue - ce) / 6048e5;
            break;
          case u:
            q = (ue - ce) / 864e5;
            break;
          case l:
            q = ue / a;
            break;
          case s:
            q = ue / r;
            break;
          case o:
            q = ue / t;
            break;
          default:
            q = ue;
        }
        return T ? q : V.a(q);
      }, D.daysInMonth = function() {
        return this.endOf(p).$D;
      }, D.$locale = function() {
        return _[this.$L];
      }, D.locale = function(k, R) {
        if (!k) return this.$L;
        var T = this.clone(), q = z(k, R, !0);
        return q && (T.$L = q), T;
      }, D.clone = function() {
        return V.w(this.$d, this);
      }, D.toDate = function() {
        return new Date(this.valueOf());
      }, D.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, D.toISOString = function() {
        return this.$d.toISOString();
      }, D.toString = function() {
        return this.$d.toUTCString();
      }, F;
    }(), G = J.prototype;
    return U.prototype = G, [["$ms", i], ["$s", o], ["$m", s], ["$H", l], ["$W", u], ["$M", p], ["$y", y], ["$D", g]].forEach(function(F) {
      G[F[1]] = function(D) {
        return this.$g(D, F[0], F[1]);
      };
    }), U.extend = function(F, D) {
      return F.$i || (F(D, J, U), F.$i = !0), U;
    }, U.locale = z, U.isDayjs = L, U.unix = function(F) {
      return U(1e3 * F);
    }, U.en = _[E], U.Ls = _, U.p = {}, U;
  });
})(Wf);
var P7 = Wf.exports;
const Ul = /* @__PURE__ */ tn(P7), ar = {
  enabled: !0,
  texts: {
    count: "Showing {from} to {to} of {count} entries",
    goToPage: "Go to page",
    page: "page"
  },
  page: 1,
  perPage: 10,
  enableGoToPage: !1,
  options: {
    show: !0,
    pageSizeOptions: [10, 25, 50]
  }
};
function I7(n, e, t) {
  return n.filter((r) => t.some((a) => {
    if (!a.filterable) return !1;
    let i;
    return typeof a.filterableValue == "function" ? i = a.filterableValue(r) : i = Dn(r, a.name), `${i}`.toLowerCase().includes(e.toLowerCase());
  }));
}
const aa = {
  enabled: !0,
  searchFunction: I7,
  placeholder: "Search data",
  focusSearchInputOnMount: !1,
  query: ""
}, R7 = {
  unrux: {
    table: {
      column_selection: {
        show_all_columns: "Show all",
        show_columns_dropdown: "Show columns",
        show_default_columns: "Show defaults"
      },
      no_results: {
        title: "No results",
        different_search_term: "Try a different search term or filter.",
        no_matching_records: "No matching records found"
      }
    }
  }
}, zo = (n) => Dn(R7, n), Vf = {
  label: "Column",
  name: "column",
  width: 1,
  tdClass: "",
  sortEnabled: !0,
  sortableValue: null,
  filterable: !0,
  filterableValue: null
}, Yf = (n, e, t, r) => e === "DESC" ? Yf(n, "ASC", t, r).reverse() : n.sort((a, i) => {
  var u;
  let o, s;
  const l = (u = r.find((c) => c.name === t)) == null ? void 0 : u.sortableValue;
  return typeof l == "function" ? (o = l(a), s = l(i)) : (o = Dn(a, t), s = Dn(i, t)), t === "created_at" ? Ul(o).diff(Ul(s)) : typeof o == "number" ? o - s : o == null ? s == null ? 0 : 1 : s == null ? -1 : `${o}`.localeCompare(`${s}`);
}), Kf = {
  mode: null,
  option: "page",
  disabledSelection: [],
  disabledTooltipContent: null
}, N7 = {
  props: {
    titleKey: {
      type: String,
      default: "unrux.table.no_results.title"
    },
    textKey: {
      type: String,
      default: "unrux.table.no_results.different_search_term"
    },
    translationsFunction: {
      type: Function,
      default: zo
    },
    illustration: {
      type: String,
      default: "unrux_no_search_results",
      validator(n) {
        return [
          "unrux_no_search_results",
          "unrux_checklist",
          "unrux_on_fire",
          "unrux_question",
          "unrux_sleep",
          "unrux_success_check",
          "unrux_success_thumb"
        ].includes(n);
      }
    }
  },
  components: {
    unrux_no_search_results: _7,
    unrux_checklist: C7,
    unrux_on_fire: x7,
    unrux_question: A7,
    unrux_sleep: E7,
    unrux_success_check: D7,
    unrux_success_thumb: M7
  }
};
var F7 = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "no-results" }, [t("div", { staticClass: "no-results__icon no-results__icon--large" }, [t(e.illustration, { tag: "component" })], 1), t("div", { staticClass: "no-results__text" }, [t("p", [e._v(e._s(e.translationsFunction(e.titleKey)))]), t("span", [e._v(e._s(e.translationsFunction(e.textKey)))])])]);
}, L7 = [], B7 = /* @__PURE__ */ ee(
  N7,
  F7,
  L7,
  !1,
  null,
  "1b2d03db"
);
const Gf = B7.exports;
Pe.add(eg, Au);
const j7 = {
  name: "SearchField",
  props: {
    searchOptions: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      searchQuery: ""
    };
  },
  mounted() {
    this.searchOptions.focusSearchInputOnMount && this.focusOnSearchInput();
  },
  computed: {
    searchActive() {
      return this.searchQuery.length > 0;
    }
  },
  methods: {
    focusOnSearchInput() {
      this.$refs.searchInputField.focus();
    },
    clearSearch() {
      this.searchQuery = "", Me("table clearing search");
    },
    sendQuery: vr(function() {
      this.$emit("query-change", this.searchQuery), Me("table searching", { query: this.searchQuery });
    }, 400)
  },
  components: {
    FontAwesomeIcon: Ie
  },
  watch: {
    searchQuery() {
      this.sendQuery();
    },
    searchOptions: {
      deep: !0,
      immediate: !0,
      handler() {
        this.searchOptions.query !== this.searchQuery && (this.searchQuery = this.searchOptions.query);
      }
    }
  }
};
var H7 = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "table__search-group" }, [t("div", { staticClass: "table__search" }, [t("font-awesome-icon", { staticClass: "table__search-icon", attrs: { icon: "search" } }), t("input", { directives: [{ name: "model", rawName: "v-model.trim", value: e.searchQuery, expression: "searchQuery", modifiers: { trim: !0 } }], ref: "searchInputField", staticClass: "table__search--input", attrs: { type: "text", placeholder: e.searchOptions.placeholder }, domProps: { value: e.searchQuery }, on: { input: function(r) {
    r.target.composing || (e.searchQuery = r.target.value.trim());
  }, blur: function(r) {
    return e.$forceUpdate();
  } } }), t("a", { class: [
    "table__search-icon",
    "table__search-icon--button",
    { "table__search-icon--hidden": !e.searchActive }
  ], on: { click: e.clearSearch } }, [t("FontAwesomeIcon", { attrs: { icon: "times" } })], 1)], 1)]);
}, z7 = [], U7 = /* @__PURE__ */ ee(
  j7,
  H7,
  z7,
  !1,
  null,
  "1f80a071"
);
const Qf = U7.exports;
var Jf = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "list-ul", r = 512, a = 512, i = [], o = "f0ca", s = "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faListUl = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(Jf);
Pe.add(Jf.faListUl);
const q7 = {
  name: "ColumnSelectionDropdown",
  props: {
    columns: {
      type: Array,
      required: !0
    },
    defaultVisibleColumns: {
      type: Array,
      default: () => []
    },
    translationsFunction: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      displayColumnsDropdown: !1,
      popperInstance: null
    };
  },
  mounted() {
    this.initiatePopper();
  },
  methods: {
    initiatePopper() {
      const n = this.$refs.toggleDropdownButton, e = this.$refs.customDropdown;
      this.popperInstance = ha(n, e, {
        placement: "bottom-start",
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, 10] }
          }
        ]
      });
    },
    toggleDropdown() {
      this.displayColumnsDropdown = !this.displayColumnsDropdown, this.popperInstance.update();
    },
    toggleColumn(n) {
      this.updateColumnSelection(n, !n.hidden);
    },
    checkAllColumns() {
      this.columns.forEach((n) => this.updateColumnSelection(n, !1));
    },
    resetToDefaultColumns() {
      this.columns.forEach((n) => this.updateColumnSelection(n, !this.defaultVisibleColumns.includes(n.name)));
    },
    updateColumnSelection(n, e) {
      n.hidden = e, this.$emit("update-column-selection", n);
    }
  },
  watch: {
    // Maybe a bit strange to watch on columns instead of defaultVisibleColumns
    // The reason for this is that columns are available later in the process. Probably due to merging all kind of defaults etc.
    columns: {
      handler(n) {
        n && this.defaultVisibleColumns && this.resetToDefaultColumns();
      },
      immediate: !0
    }
  },
  components: {
    FontAwesomeIcon: Ie
  }
};
var W7 = function() {
  var e = this, t = e._self._c;
  return t("div", [t("div", { directives: [{ name: "show", rawName: "v-show", value: e.displayColumnsDropdown, expression: "displayColumnsDropdown" }], staticClass: "dropdown-background", on: { click: e.toggleDropdown } }), t("button", { ref: "toggleDropdownButton", staticClass: "btn trigger-button", attrs: { type: "button" }, on: { click: e.toggleDropdown } }, [t("font-awesome-icon", { staticClass: "btn__icon", attrs: { icon: "list-ul" } }), e._v(" " + e._s(e.translationsFunction("unrux.table.column_selection.show_columns_dropdown")) + " ")], 1), t("div", { ref: "customDropdown", class: [
    "custom-dropdown",
    { "custom-dropdown--visible": e.displayColumnsDropdown }
  ], on: { keyup: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "esc", 27, r.key, ["Esc", "Escape"]) ? null : e.toggleDropdown.apply(null, arguments);
  } } }, [t("h4", { staticClass: "custom-dropdown__title" }, [e._v(" " + e._s(e.translationsFunction("unrux.table.column_selection.show_columns_dropdown")) + " ")]), t("ul", { staticClass: "custom-dropdown__list" }, e._l(e.columns, function(r, a) {
    return t("li", { key: `col-li-${a}`, staticClass: "custom-dropdown__list-item" }, [t("input", { ref: "columnInputs", refInFor: !0, staticClass: "custom-dropdown__checkbox", attrs: { type: "checkbox", id: `column-input-${r.name}` }, domProps: { value: r.hidden, checked: !r.hidden }, on: { change: function(i) {
      return e.toggleColumn(r);
    } } }), t("label", { attrs: { for: `column-input-${r.name}` } }, [e._v(e._s(r.label))])]);
  }), 0), t("button", { staticClass: "btn custom-dropdown__button", on: { click: e.checkAllColumns } }, [e._v(" " + e._s(e.translationsFunction("unrux.table.column_selection.show_all_columns")) + " ")]), e.defaultVisibleColumns ? t("button", { staticClass: "btn custom-dropdown__button", on: { click: e.resetToDefaultColumns } }, [e._v(" " + e._s(e.translationsFunction("unrux.table.column_selection.show_default_columns")) + " ")]) : e._e()])]);
}, V7 = [], Y7 = /* @__PURE__ */ ee(
  q7,
  W7,
  V7,
  !1,
  null,
  "810e1e32"
);
const K7 = Y7.exports;
Pe.add(Qv);
const ql = {
  title: null,
  width: 1,
  tdClass: "",
  sortEnabled: !0,
  sortableValue: null,
  filterable: !0,
  filterableValue: null,
  hidden: !1,
  alignCenter: !1,
  alignRight: !1,
  showColumnTitle: !0,
  fitContent: !1,
  emitRowClick: !0
}, G7 = {
  name: "TableBody",
  props: {
    title: {
      type: String
    },
    searchOptions: {
      type: Object,
      default: () => ({})
    },
    slimStandalone: {
      type: Boolean,
      default: !1
    },
    showHeader: {
      type: Boolean,
      default: !0
    },
    showStandaloneSpan: {
      type: Boolean,
      default: !0
    },
    headerBold: {
      type: Boolean,
      default: !1
    },
    columnSelection: {
      type: Boolean,
      default: !1
    },
    defaultVisibleColumns: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    dataForMultiSelect: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: !1
    },
    initialSortSettings: {
      type: Object,
      default: () => ({})
    },
    expandableRowFunction: {
      type: Function,
      default: () => !0
    },
    initialExpandedRowKeys: {
      type: Array,
      default: () => []
    },
    findRowKeyFunction: {
      type: Function,
      default: (n, e) => n.id || n.key || e
    },
    placeholder: {
      type: String,
      default: "-"
    },
    translationsFunction: {
      type: Function,
      required: !0
    },
    searching: {
      type: Boolean,
      default: !1
    },
    groupByField: {
      type: String,
      default: null
    },
    selectionOptions: {
      type: Object,
      required: !0
    },
    allColumnsExpandRowOnClick: {
      type: Boolean,
      default: !1
    },
    highlightedRowKeys: {
      type: Array,
      default: () => []
    },
    paginationOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      initialColumns: [],
      expandedRows: [],
      sortSettings: {
        ...this.initialSortSettings
      },
      userInteractedAtLeastOnce: !1,
      maxValueSize: 40,
      selected: [],
      allSelected: !1,
      selectedIndex: 0,
      emitSelectedChange: !0
    };
  },
  watch: {
    loading: {
      handler(n) {
        !n && !this.userInteractedAtLeastOnce && (this.expandedRows = [...this.initialExpandedRowKeys]);
      },
      immediate: !0
    },
    sortSettings: {
      handler() {
        this.$emit("sort-change", this.sortSettings);
      },
      deep: !0
    },
    mergedColumns: {
      handler() {
        this.initialColumns = this.mergedColumns;
      },
      immediate: !0
    },
    selected: {
      handler() {
        this.emitSelectedChange ? this.$emit("selected-change", this.selected) : this.emitSelectedChange = !0;
      }
    }
  },
  computed: {
    mergedColumns() {
      return this.columns.map((n) => n.columns ? n.columns.map((e, t) => ({
        ...e,
        className: [n.className || "", e.className || ""].join(" "),
        // add group class to all sub columns
        groupStart: t === 0,
        groupName: n.name,
        groupEnd: t === n.columns.length - 1
      })) : n).flat().map((n) => ({ ...ql, ...n }));
    },
    anyGroupColumns() {
      return this.columns.some((n) => n.columns);
    },
    groupHeaders() {
      return this.columns.map((n) => ({
        ...n,
        showColumnTitle: n.showColumnTitle !== !1,
        name: n.columns ? n.name : null,
        span: n.columns ? n.columns.length : 1
      }));
    },
    hasExpandableRows() {
      return this.$scopedSlots.hasOwnProperty("row-details") || this.$scopedSlots.hasOwnProperty("row-details-wrapper") || this.$scopedSlots.hasOwnProperty("expanded-row-wrapper");
    },
    columnSpanForWholeRow() {
      let n = this.mergedColumns.length;
      return n += this.hasExpandableRows ? 1 : 0, n += this.selectionEnabled ? 1 : 0, n;
    },
    groupByOptions() {
      return this.groupByField ? [...new Set(this.data.map((n) => n[this.groupByField]))].sort() : ["all"];
    },
    isIndeterminate() {
      return this.selected.length > 0 && !this.allSelected;
    },
    selectionData() {
      return (this.selectionModeIsMultiWithOptionIsAll ? this.dataForMultiSelect : this.data).filter((e) => !this.selectionOptions.disabledSelection.includes(e));
    },
    selectionEnabled() {
      return this.selectionOptions.mode != null;
    },
    selectionModeIsMulti() {
      return this.selectionOptions.mode === "multi";
    },
    selectionModeIsMultiWithOptionIsAll() {
      return this.selectionModeIsMulti && this.selectionOptions.option === "all";
    },
    selectionModeIsSingle() {
      return this.selectionOptions.mode === "single";
    }
  },
  methods: {
    cellContentBackgroundClass(n, e) {
      return this.isHighLightedRow(n, e) ? "table__row--highlighted" : "table__row--default";
    },
    isHighLightedRow(n, e) {
      const t = this.findRowKeyFunction(n, e);
      return this.highlightedRowKeys.includes(t);
    },
    tdStyle(n) {
      const e = this.mergedColumns.find((t) => t.name === n);
      return e.hidden === !0 ? "display: none;" : e && e.style ? e.style : {};
    },
    lastColumn(n) {
      return this.mergedColumns.map((e) => e.name).indexOf(n) === this.mergedColumns.length - 1;
    },
    columnSortable(n) {
      const { data: e, mergedColumns: t } = this;
      return e.length === 0 ? !1 : (t.find((r) => r.name === n) || ql).sortEnabled;
    },
    sortTable(n) {
      const { columnSortable: e, sortSettings: t } = this;
      e(n) && (t.column === n ? this.sortSettings = {
        ...this.sortSettings,
        direction: t.direction === "DESC" ? "ASC" : "DESC"
      } : this.sortSettings = {
        column: n,
        direction: "DESC"
      });
    },
    // `toggleRowExpanded` method is also called via `$refs`.
    toggleRowExpanded(n, e) {
      if (!this.hasExpandableRows || !this.canExpandRow(n, e))
        return;
      const t = this.findRowKeyFunction(n, e);
      this.expandedRows.includes(t) ? this.expandedRows.splice(this.expandedRows.indexOf(t), 1) : this.expandedRows.push(t), this.userInteractedAtLeastOnce = !0;
    },
    canExpandRow(n, e) {
      return this.hasExpandableRows && this.expandableRowFunction(n, e);
    },
    rowIsExpanded(n, e) {
      return this.expandedRows.includes(this.findRowKeyFunction(n, e));
    },
    getColumnValue(n, e) {
      return Dn(n, e.name);
    },
    groupedByData(n) {
      return n === "all" ? this.data : this.data.filter((e) => e[this.groupByField] === n);
    },
    selectAll() {
      this.selectedIndex = 0, this.allSelected = !this.allSelected, this.selected = this.allSelected ? this.selectionData : [];
    },
    updateMultiple(n) {
      let e = this.clickedCheckboxStatus(n);
      const t = this.selectedIndex;
      if (this.selectedIndex = e.index, this.selectedIndex !== t) {
        const r = this.selectionData.slice(
          Math.min(t, this.selectedIndex),
          Math.max(t, this.selectedIndex)
        ), a = e.selected ? this.removeCheckedSubset : this.addCheckedSubset;
        this.selected = a(this.selected, r), this.selected = [...new Set(this.selected.map((i) => i))], this.updateCheckAll();
      }
    },
    updateCheckAll() {
      this.allSelected = this.selectionData.length === this.selected.length;
    },
    // `resetSelection` method is called via `$refs`.
    resetSelection(n = !0) {
      this.emitSelectedChange = n, this.selected = [], this.updateCheckAll();
    },
    clickedCheckboxStatus(n) {
      const e = n.target.getAttribute("data-index"), t = this.selectionData[e], r = this.selected.indexOf(t) !== -1;
      return { index: e, selected: r };
    },
    addCheckedSubset(n, e) {
      return n.length ? n.concat(e) : e;
    },
    removeCheckedSubset(n, e) {
      return n.filter((t) => e.indexOf(t) === -1);
    },
    updateSelectIndex(n) {
      this.selectedIndex = n.target.getAttribute("data-index");
    },
    disabledMultiSelectCheckboxTooltipContentFor(n) {
      return this.selectionEnabled && this.selectionOptions.disabledTooltipContent && this.selectionOptions.disabledSelection.includes(n) ? this.selectionOptions.disabledTooltipContent : "";
    },
    paginatedIndex(n) {
      return parseInt(n) + (this.paginationOptions.page - 1) * this.paginationOptions.perPage;
    },
    emitRowClick(n, e) {
      e.emitRowClick && this.$emit("row-click", n);
    }
  },
  components: {
    ColumnSelectionDropdown: K7,
    NoResults: Gf,
    ProgressBar: Eu,
    SortingIcon: y7,
    FontAwesomeIcon: Ie,
    SearchField: Qf,
    Tooltip: Mn
  }
};
var Q7 = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "table-wrapper", class: { "table-wrapper--slim-standalone": e.slimStandalone } }, [e._t("header", function() {
    return [e.showHeader ? t("div", { staticClass: "table__header" }, [e.title ? t("h1", { staticClass: "table__header__title" }, [e._v(e._s(e.title))]) : e.$scopedSlots["header-title"] ? t("div", { staticClass: "table__header__title" }, [e._t("header-title")], 2) : e._e(), e.$scopedSlots["header-additional-content"] ? t("div", { staticClass: "table__header__additional-content" }, [e._t("header-additional-content")], 2) : e._e(), e.columnSelection ? t("ColumnSelectionDropdown", { staticClass: "table__header__column-selection", attrs: { "default-visible-columns": e.defaultVisibleColumns, columns: e.initialColumns, "translations-function": e.translationsFunction }, on: { "update-column-selection": (r) => e.$emit("update-column-selection", r) } }) : e._e(), e.searchOptions.enabled ? t("SearchField", { staticClass: "table__header__search", attrs: { "search-options": e.searchOptions }, on: { "query-change": (r) => e.$emit("query-change", r) } }) : e._e()], 1) : e._e()];
  }, { mergedSearchOptions: e.searchOptions, handleQueryChange: (r) => e.$emit("query-change", r) }), t("div", { staticClass: "table table--hover", class: { "table--slim-standalone": e.slimStandalone } }, [t("table", [e.anyGroupColumns ? t("thead", { staticClass: "table__thead table__thead-group" }, [e._l(e.groupHeaders, function(r, a) {
    return t("th", { key: a, staticClass: "table__thead-item", class: [r.className, {
      "table__thead-group-item": !!r.name,
      "table__thead-item--bold": !!r.bold,
      "table__thead-item--hidden": !!r.hidden,
      "table__thead-item--align-center": !!r.alignCenter,
      "table__thead-item--align-right": !!r.alignRight,
      "table__thead-item--fit-content": !!r.fitContent
    }], attrs: { colspan: r.span } }, [r.showColumnTitle ? t("div", { staticClass: "cell-content" }, [e._t(`th-group-${r.name}`, function() {
      return [e._v(" " + e._s(r.name) + " ")];
    }, { header: r })], 2) : e._e()]);
  }), e.hasExpandableRows ? t("th", { staticClass: "table__thead-item", attrs: { colspan: 1 } }) : e._e()], 2) : e._e(), t("thead", { staticClass: "table__thead", class: { "table__thead--slim-standalone": e.slimStandalone } }, [e.selectionModeIsMulti ? t("th", { staticClass: "table__thead-item" }, [t("div", { staticClass: "cell-content" }, [t("input", { directives: [{ name: "model", rawName: "v-model", value: e.allSelected, expression: "allSelected" }], staticClass: "form-check__input", attrs: { type: "checkbox" }, domProps: { indeterminate: e.isIndeterminate, checked: Array.isArray(e.allSelected) ? e._i(e.allSelected, null) > -1 : e.allSelected }, on: { click: e.selectAll, change: function(r) {
    var a = e.allSelected, i = r.target, o = !!i.checked;
    if (Array.isArray(a)) {
      var s = null, l = e._i(a, s);
      i.checked ? l < 0 && (e.allSelected = a.concat([s])) : l > -1 && (e.allSelected = a.slice(0, l).concat(a.slice(l + 1)));
    } else
      e.allSelected = o;
  } } })])]) : e._e(), e.selectionModeIsSingle ? t("th") : e._e(), e._l(e.mergedColumns, function(r) {
    return t("th", { key: `th-col-${r.name}`, staticClass: "table__thead-item", class: [{
      "table__thead-group-subitem": !!r.groupName,
      "table__thead-group-start": r.groupStart,
      "table__thead-group-end": r.groupEnd,
      "table__thead-item--bold": e.headerBold,
      "table__thead-item--hidden": r.hidden,
      "table__thead-item--align-center": r.alignCenter,
      "table__thead-item--align-right": r.alignRight,
      "table__thead-item--fit-content": r.fitContent
    }, r.className], attrs: { tabindex: "0", title: `${r.title || r.label}` }, on: { click: function(a) {
      return e.sortTable(r.name);
    }, keyup: function(a) {
      return !a.type.indexOf("key") && e._k(a.keyCode, "enter", 13, a.key, "Enter") ? null : (a.preventDefault(), e.sortTable(r.name));
    } } }, [r.showColumnTitle ? t("div", { staticClass: "cell-content" }, [e._t(`th-${r.name}`, function() {
      return [e._v(" " + e._s(r.label) + " ")];
    }, { column: r, sortSettings: e.sortSettings }), e._t(`th-${r.name}-sorting-icon`, function() {
      return [e.columnSortable(r.name) ? t("sorting-icon", { attrs: { sorted: r.name === e.sortSettings.column, direction: e.sortSettings.direction } }) : e._e()];
    }, { column: r, sortSettings: e.sortSettings })], 2) : e._e()]);
  }), e.hasExpandableRows ? t("th", { staticClass: "table__thead-item table__thead-item--fit-content" }) : e._e()], 2), e.loading ? t("tr", [t("td", { staticClass: "progress-bar-container", attrs: { colspan: e.columnSpanForWholeRow } }, [t("progress-bar", { attrs: { indeterminate: "", visible: e.loading } })], 1)]) : e._e(), !e.slimStandalone && e.showStandaloneSpan ? t("tr", [t("td", { class: ["header-separator", { "header-separator--loading": e.loading }], attrs: { colspan: e.columnSpanForWholeRow } })]) : e._e(), t("tbody", { staticClass: "table__body", class: { "table__body--slim-standalone": e.slimStandalone, "table__body--loading": e.loading } }, [e.$scopedSlots["before-rows-slot"] ? t("div", { staticClass: "before-rows-slot" }, [e._t("before-rows-slot", null, { sortedFilteredData: e.data })], 2) : e._e(), e._l(e.groupByOptions, function(r, a) {
    return [r !== "all" ? t("tr", { key: `category-${a}`, staticClass: "table__row" }, [t("td", { staticClass: "table__row-item", attrs: { colspan: e.columnSpanForWholeRow } }, [t("div", { staticClass: "category-content" }, [e._v(e._s(r))])])]) : e._e(), e._l(e.groupedByData(r), function(i, o) {
      return [e._t("row", function() {
        return [t("tr", { key: `tr-${r}-${e.findRowKeyFunction(i, o)}`, class: [
          "table__row",
          { "table__row--expanded": e.hasExpandableRows && e.rowIsExpanded(i, o) },
          { "table__row--expansion-disabled": e.hasExpandableRows && !e.canExpandRow(i, o) }
        ] }, [e.selectionModeIsMulti ? t("td", { staticClass: "table__row-item" }, [t("div", { class: ["cell-content", e.cellContentBackgroundClass(i, o)] }, [t("Tooltip", { attrs: { content: e.disabledMultiSelectCheckboxTooltipContentFor(i) } }, [t("input", { directives: [{ name: "model", rawName: "v-model", value: e.selected, expression: "selected" }], staticClass: "form-check__input", attrs: { type: "checkbox", disabled: e.selectionOptions.disabledSelection.includes(i), "data-index": e.paginatedIndex(o) }, domProps: { value: i, checked: Array.isArray(e.selected) ? e._i(e.selected, i) > -1 : e.selected }, on: { change: [function(s) {
          var l = e.selected, u = s.target, c = !!u.checked;
          if (Array.isArray(l)) {
            var p = i, m = e._i(l, p);
            u.checked ? m < 0 && (e.selected = l.concat([p])) : m > -1 && (e.selected = l.slice(0, m).concat(l.slice(m + 1)));
          } else
            e.selected = c;
        }, e.updateCheckAll], click: [function(s) {
          return s.ctrlKey || s.shiftKey || s.altKey || s.metaKey ? null : e.updateSelectIndex(s);
        }, function(s) {
          return s.shiftKey ? e.updateMultiple(s) : null;
        }] } })])], 1)]) : e._e(), e.selectionModeIsSingle ? t("td", { staticClass: "table__row-item" }, [t("div", { class: ["cell-content", e.cellContentBackgroundClass(i, o)], on: { click: function(s) {
          e.selected = i;
        } } }, [t("Tooltip", { attrs: { content: e.disabledMultiSelectCheckboxTooltipContentFor(i) } }, [t("input", { directives: [{ name: "model", rawName: "v-model", value: e.selected, expression: "selected" }], staticClass: "form-check__input", attrs: { type: "radio", disabled: e.selectionOptions.disabledSelection.includes(i), "data-index": e.paginatedIndex(o) }, domProps: { value: i, checked: e._q(e.selected, i) }, on: { click: function(s) {
          return s.ctrlKey || s.shiftKey || s.altKey || s.metaKey ? null : e.updateSelectIndex(s);
        }, change: function(s) {
          e.selected = i;
        } } })])], 1)]) : e._e(), e._l(e.mergedColumns, function(s) {
          return t("td", { key: `row-${o}-cell-${s.name}`, class: ["table__row-item", s.className, { "table__row-item--align-right": s.alignRight }, { "table__row-item--align-center": s.alignCenter }, { "table__row-item--fit-content": s.fitContent }], style: e.tdStyle(s.name), attrs: { tabindex: e.lastColumn(s.name) ? 0 : -1 }, on: { click: function(l) {
            e.emitRowClick(i, s) && (e.lastColumn(s.name) || e.allColumnsExpandRowOnClick) && e.toggleRowExpanded(i, o);
          }, keyup: function(l) {
            if (!l.type.indexOf("key") && e._k(l.keyCode, "enter", 13, l.key, "Enter")) return null;
            l.preventDefault(), (e.lastColumn(s.name) || e.allColumnsExpandRowOnClick) && e.toggleRowExpanded(i, o);
          } } }, [e._t(`${s.name}-wrapper`, function() {
            return [t("div", { class: ["cell-content", e.cellContentBackgroundClass(i, o)] }, [e._t(s.name, function() {
              return [t("span", [e._v(e._s(e.getColumnValue(i, s) || e.placeholder))])];
            }, { row: i, column: s, index: o })], 2)];
          }, { row: i, index: o })], 2);
        }), e.hasExpandableRows ? t("td", { staticClass: "table__row-item", on: { click: function(s) {
          return e.toggleRowExpanded(i, o);
        }, keyup: function(s) {
          return !s.type.indexOf("key") && e._k(s.keyCode, "enter", 13, s.key, "Enter") ? null : (s.preventDefault(), e.toggleRowExpanded(i, o));
        } } }, [t("div", { class: ["cell-content", "table__expanded-indicator", e.cellContentBackgroundClass(i, o)] }, [e.canExpandRow(i, o) ? t("FontAwesomeIcon", { staticClass: "icon", class: { "icon--expanded": e.rowIsExpanded(i, o) }, style: { color: "#9f9f9f" }, attrs: { icon: "chevron-down" } }) : e._e()], 1)]) : e._e()], 2), e.hasExpandableRows && e.rowIsExpanded(i, o) ? e._t("expanded-row-wrapper", function() {
          return [e.hasExpandableRows && e.rowIsExpanded(i, o) ? t("tr", { key: "row-details-" + o }, [t("td", { staticClass: "table__expanded-wrapper", attrs: { colspan: e.columnSpanForWholeRow } }, [e._t("row-details-wrapper", function() {
            return [t("div", { staticClass: "cell-content" }, [e._t("row-details", null, { row: i, index: o })], 2)];
          }, { row: i, index: o })], 2)]) : e._e()];
        }, { row: i, index: o }) : e._e()];
      }, { row: i, index: o })];
    })];
  }), e.data.length === 0 && !e.loading ? t("tr", [t("td", { staticClass: "table__row-item", attrs: { colspan: "100%" } }, [e.searching ? e._t("no-search-items", function() {
    return [t("no-results")];
  }) : e._t("no-items", function() {
    return [t("no-results", { attrs: { "text-key": "unrux.table.no_results.no_matching_records" } })];
  })], 2)]) : e._e()], 2)]), e._t("default")], 2), e.$slots.pagination && e.data.length > 0 ? t("div", { staticClass: "pagination-container", class: { "pagination-container--slim-standalone": e.slimStandalone } }, [e._t("pagination")], 2) : e._e()], 2);
}, J7 = [], Z7 = /* @__PURE__ */ ee(
  G7,
  Q7,
  J7,
  !1,
  null,
  "fd67c2e8"
);
const Zf = Z7.exports, X7 = {
  props: {
    value: {
      type: Object,
      required: !0
    }
  },
  computed: {
    pagination() {
      return this.value;
    },
    amountOfPages() {
      const { value: { records: n, perPage: e } } = this;
      return Math.ceil(n / e);
    },
    counts() {
      const { value: { page: n, perPage: e, records: t, texts: r }, amountOfPages: a } = this;
      if (/{page}/.test(r.count))
        return a <= 1 ? "" : r.count.replace("{page}", n).replace("{pages}", a.toString());
      const i = r.count.split("|"), o = (n - 1) * e + 1, s = n === this.amountOfPages ? t : o + e - 1, l = Math.min(t === 1 ? 2 : a === 1 ? 1 : 0, i.length - 1);
      return i[l].replace("{count}", this.pagination.records).replace("{from}", o).replace("{to}", s);
    },
    items() {
      const { amountOfPages: n, pagination: { page: e }, range: t } = this, r = 5;
      return n <= r ? t(1, n).map((a) => ({ type: "page", pageNumber: a })) : [.../* @__PURE__ */ new Set([1, ...t(e - Math.floor(r / 2), r), n])].filter((a) => a > 0 && a <= n).map((a, i, o) => {
        const s = i < o.length - 1 ? o[i + 1] : null;
        return s && s !== a + 1 ? [{ type: "page", pageNumber: a }, { type: "dots" }] : { type: "page", pageNumber: a };
      }).flat();
    }
  },
  methods: {
    parseInt,
    range(n, e) {
      return Array.from({ length: e }, (t, r) => r + n);
    },
    setPageSize(n) {
      const { page: e, records: t } = this.value, r = Math.ceil(t / n);
      this.$emit("input", {
        ...this.pagination,
        perPage: n,
        page: Math.min(r, e)
      });
    },
    setPage(n, e = !0) {
      e && this.$refs.goToPage && (this.$refs.goToPage.value = "");
      const t = Math.max(1, Math.min(this.amountOfPages, n));
      this.pagination.page !== t && this.$emit("input", { ...this.pagination, page: t });
    },
    setGoToPage: vr(function(n) {
      const e = Number(n.target.value);
      isNaN(e) || this.setPage(e, !1);
    }, 400)
  }
};
var eC = function() {
  var e = this, t = e._self._c;
  return t("div", { directives: [{ name: "show", rawName: "v-show", value: e.pagination.records > 0, expression: "pagination.records > 0" }], staticClass: "table-pagination pagination-wrapper" }, [t("div", { staticClass: "table-pagination__count pagination-page-count" }, [e._v(" " + e._s(e.counts) + " ")]), t("nav", { staticClass: "pagination-nav" }, [t("ul", { directives: [{ name: "show", rawName: "v-show", value: e.pagination.options.show, expression: "pagination.options.show" }], staticClass: "table-pagination__pagination pagination-list" }, [e.amountOfPages > 5 ? t("li", { staticClass: "table-pagination__pagination-item", class: ["pagination-item", { disabled: e.pagination.page === 1 }] }, [t("a", { staticClass: "pagination-link", attrs: { disabled: e.pagination.page === 1 }, on: { click: function(r) {
    return e.setPage(1);
  } } }, [e._v("«")])]) : e._e(), t("li", { staticClass: "table-pagination__pagination-item", class: ["pagination-item", { disabled: e.pagination.page === 1 }] }, [t("a", { staticClass: "pagination-link", attrs: { disabled: e.pagination.page === 1 }, on: { click: function(r) {
    return e.setPage(e.pagination.page - 1);
  } } }, [e._v("‹")])]), e._l(e.items, function(r, a) {
    return [r.type === "page" ? t("li", { key: a, staticClass: "table-pagination__pagination-item", class: ["pagination-item", { active: r.pageNumber === e.pagination.page }] }, [t("a", { class: ["pagination-link", { active: r.pageNumber === e.pagination.page }], on: { click: function(i) {
      return e.setPage(r.pageNumber);
    } } }, [e._v(e._s(r.pageNumber))])]) : e._e(), r.type === "dots" ? t("li", { key: a, staticClass: "table-pagination__pagination-item pagination-item" }, [t("a", { staticClass: "pagination-link", attrs: { disabled: "" } }, [e._v("...")])]) : e._e()];
  }), t("li", { staticClass: "table-pagination__pagination-item", class: ["pagination-item", { disabled: e.pagination.page === e.amountOfPages }] }, [t("a", { staticClass: "pagination-link", attrs: { disabled: e.pagination.page === e.amountOfPages }, on: { click: function(r) {
    return e.setPage(e.pagination.page + 1);
  } } }, [e._v("›")])]), e.amountOfPages > 5 ? t("li", { staticClass: "table-pagination__pagination-item", class: ["pagination-item", { disabled: e.pagination.page === e.amountOfPages }] }, [t("a", { staticClass: "pagination-link", attrs: { disabled: e.pagination.page === e.amountOfPages }, on: { click: function(r) {
    return e.setPage(e.amountOfPages);
  } } }, [e._v("»")])]) : e._e()], 2), e.value.enableGoToPage ? t("div", { staticClass: "pagination-nav__go-to-page" }, [t("span", [e._v(e._s(e.value.texts.goToPage))]), t("input", { ref: "goToPage", attrs: { type: "text" }, on: { input: e.setGoToPage } })]) : e._e(), e.value.options.pageSizeOptions && e.value.options.pageSizeOptions.length > 1 ? t("div", { staticClass: "pagination-nav__page-size" }, [t("select", { domProps: { value: e.value.perPage }, on: { change: ({ target: { value: r } }) => e.setPageSize(parseInt(r, 10)) } }, e._l(e.value.options.pageSizeOptions, function(r) {
    return t("option", { key: r, domProps: { value: r } }, [e._v(" " + e._s(r) + " / " + e._s(e.value.texts.page) + " ")]);
  }), 0)]) : e._e()])]);
}, tC = [], nC = /* @__PURE__ */ ee(
  X7,
  eC,
  tC,
  !1,
  null,
  "e50af647"
);
const Xf = nC.exports, rC = {
  name: "ClientTable",
  props: {
    title: {
      type: String
    },
    data: {
      type: Array,
      default: () => []
    },
    dataLoading: {
      type: Boolean,
      default: !1
    },
    slimStandalone: {
      type: Boolean,
      default: !1
    },
    showHeader: {
      type: Boolean,
      default: !0
    },
    showStandaloneSpan: {
      type: Boolean,
      default: !0
    },
    headerBold: {
      type: Boolean,
      default: !1
    },
    columnSelection: {
      type: Boolean,
      default: !1
    },
    defaultVisibleColumns: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    searchOptions: {
      type: Object,
      default: () => aa
    },
    initialSortSettings: {
      type: Object,
      default: () => ({})
    },
    expandableRowFunction: {
      type: Function,
      default: () => !0
    },
    initialExpandedRowKeys: {
      type: Array,
      default: () => []
    },
    findRowKeyFunction: {
      type: Function,
      default: (n, e) => e
    },
    paginationOptions: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: "-"
    },
    translationsFunction: {
      type: Function,
      default: zo
    },
    groupByField: {
      type: String,
      default: null
    },
    selectionOptions: {
      type: Object,
      default: () => ({})
    },
    allColumnsExpandRowOnClick: {
      type: Boolean,
      default: !1
    },
    highlightedRowKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchQuery: "",
      pagination: qf(
        {},
        ar,
        this.paginationOptions,
        { records: this.data.length }
      ),
      sortSettings: {
        column: "key",
        direction: "DESC",
        ...this.initialSortSettings
      },
      loadingError: !1
    };
  },
  computed: {
    mergedSearchOptions() {
      return {
        ...aa,
        ...this.searchOptions
      };
    },
    mergedSelectionOptions() {
      return {
        ...Kf,
        ...this.selectionOptions
      };
    },
    mergedColumns() {
      return this.columns.map((n) => n.columns || n).flat().map((n) => ({
        ...Vf,
        ...n
      }));
    },
    filteredData() {
      return this.searching ? this.mergedSearchOptions.searchFunction(this.data, this.searchQuery, this.mergedColumns) : this.data;
    },
    sortedFilteredData() {
      const { filteredData: n, sortSettings: e, mergedColumns: t } = this, { column: r, direction: a } = e;
      return t.some((o) => o.name === r) ? (t.find((o) => r === o.name).sortFunction || Yf)(n, a, r, this.mergedColumns) : n;
    },
    paginatedData() {
      const { sortedFilteredData: n, pagination: { enabled: e, page: t, perPage: r } } = this;
      return e ? n.slice((t - 1) * r, t * r) : n;
    },
    searching() {
      return this.$emit("searching", this.searchQuery !== ""), this.searchQuery !== "";
    }
  },
  methods: {
    handleQueryChange(n) {
      this.pagination.page = 1, this.searchQuery = n, this.$emit("query-change", this.searchQuery);
    },
    handleSortSettingChanged(n) {
      this.sortSettings = n, this.$emit("sort-change", this.sortSettings);
    }
  },
  watch: {
    filteredData(n, e) {
      e.length !== n.length && (this.pagination = {
        ...this.pagination,
        page: 1,
        records: n.length
      });
    },
    paginatedData() {
      this.dataLoading || this.$emit("paginated-data-change", this.paginatedData);
    }
  },
  components: {
    TableBody: Zf,
    Pagination: Xf
  }
};
var aC = function() {
  var e = this, t = e._self._c;
  return t("TableBody", { ref: "tableBody", attrs: { title: e.title, placeholder: e.placeholder, "show-header": e.showHeader, "slim-standalone": e.slimStandalone, "show-standalone-span": e.showStandaloneSpan, "header-bold": e.headerBold, "column-selection": e.columnSelection, "default-visible-columns": e.defaultVisibleColumns, columns: e.columns, data: e.paginatedData, "data-for-multi-select": e.sortedFilteredData, "initial-sort-settings": e.initialSortSettings, loading: e.dataLoading, "initial-expanded-row-keys": e.initialExpandedRowKeys, "search-options": e.mergedSearchOptions, searching: e.searching, "translations-function": e.translationsFunction, "group-by-field": e.groupByField, "selection-options": e.mergedSelectionOptions, "all-columns-expand-row-on-click": e.allColumnsExpandRowOnClick, "highlighted-row-keys": e.highlightedRowKeys, "pagination-options": e.pagination, "find-row-key-function": e.findRowKeyFunction }, on: { "sort-change": e.handleSortSettingChanged, "selected-change": (r) => e.$emit("selected-change", r), "query-change": e.handleQueryChange, "update-column-selection": (r) => e.$emit("update-column-selection", r), "row-click": (r) => e.$emit("row-click", r) }, scopedSlots: e._u([e._l(e.$scopedSlots, function(r, a) {
    return { key: a, fn: function(i) {
      return [e._t(a, null, null, i)];
    } };
  }), e.pagination.enabled ? { key: "pagination", fn: function() {
    return [t("Pagination", { model: { value: e.pagination, callback: function(r) {
      e.pagination = r;
    }, expression: "pagination" } })];
  }, proxy: !0 } : null], null, !0) });
}, iC = [], oC = /* @__PURE__ */ ee(
  rC,
  aC,
  iC,
  !1,
  null,
  null
);
const sC = oC.exports;
var lC = "__lodash_hash_undefined__";
function cC(n) {
  return this.__data__.set(n, lC), this;
}
var uC = cC;
function fC(n) {
  return this.__data__.has(n);
}
var dC = fC, pC = No, hC = uC, mC = dC;
function ia(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.__data__ = new pC(); ++e < t; )
    this.add(n[e]);
}
ia.prototype.add = ia.prototype.push = hC;
ia.prototype.has = mC;
var vC = ia;
function gC(n, e) {
  for (var t = -1, r = n == null ? 0 : n.length; ++t < r; )
    if (e(n[t], t, n))
      return !0;
  return !1;
}
var yC = gC;
function bC(n, e) {
  return n.has(e);
}
var _C = bC, wC = vC, CC = yC, SC = _C, xC = 1, OC = 2;
function AC(n, e, t, r, a, i) {
  var o = t & xC, s = n.length, l = e.length;
  if (s != l && !(o && l > s))
    return !1;
  var u = i.get(n), c = i.get(e);
  if (u && c)
    return u == e && c == n;
  var p = -1, m = !0, y = t & OC ? new wC() : void 0;
  for (i.set(n, e), i.set(e, n); ++p < s; ) {
    var g = n[p], b = e[p];
    if (r)
      var w = o ? r(b, g, p, e, n, i) : r(g, b, p, n, e, i);
    if (w !== void 0) {
      if (w)
        continue;
      m = !1;
      break;
    }
    if (y) {
      if (!CC(e, function(C, S) {
        if (!SC(y, S) && (g === C || a(g, C, t, r, i)))
          return y.push(S);
      })) {
        m = !1;
        break;
      }
    } else if (!(g === b || a(g, b, t, r, i))) {
      m = !1;
      break;
    }
  }
  return i.delete(n), i.delete(e), m;
}
var ed = AC;
function $C(n) {
  var e = -1, t = Array(n.size);
  return n.forEach(function(r, a) {
    t[++e] = [a, r];
  }), t;
}
var EC = $C;
function kC(n) {
  var e = -1, t = Array(n.size);
  return n.forEach(function(r) {
    t[++e] = r;
  }), t;
}
var DC = kC, Wl = ma, Vl = Tf, TC = wr, MC = ed, PC = EC, IC = DC, RC = 1, NC = 2, FC = "[object Boolean]", LC = "[object Date]", BC = "[object Error]", jC = "[object Map]", HC = "[object Number]", zC = "[object RegExp]", UC = "[object Set]", qC = "[object String]", WC = "[object Symbol]", VC = "[object ArrayBuffer]", YC = "[object DataView]", Yl = Wl ? Wl.prototype : void 0, oi = Yl ? Yl.valueOf : void 0;
function KC(n, e, t, r, a, i, o) {
  switch (t) {
    case YC:
      if (n.byteLength != e.byteLength || n.byteOffset != e.byteOffset)
        return !1;
      n = n.buffer, e = e.buffer;
    case VC:
      return !(n.byteLength != e.byteLength || !i(new Vl(n), new Vl(e)));
    case FC:
    case LC:
    case HC:
      return TC(+n, +e);
    case BC:
      return n.name == e.name && n.message == e.message;
    case zC:
    case qC:
      return n == e + "";
    case jC:
      var s = PC;
    case UC:
      var l = r & RC;
      if (s || (s = IC), n.size != e.size && !l)
        return !1;
      var u = o.get(n);
      if (u)
        return u == e;
      r |= NC, o.set(n, e);
      var c = MC(s(n), s(e), r, a, i, o);
      return o.delete(n), c;
    case WC:
      if (oi)
        return oi.call(n) == oi.call(e);
  }
  return !1;
}
var GC = KC;
function QC(n, e) {
  for (var t = -1, r = e.length, a = n.length; ++t < r; )
    n[a + t] = e[t];
  return n;
}
var JC = QC, ZC = JC, XC = rn;
function eS(n, e, t) {
  var r = e(n);
  return XC(n) ? r : ZC(r, t(n));
}
var tS = eS;
function nS(n, e) {
  for (var t = -1, r = n == null ? 0 : n.length, a = 0, i = []; ++t < r; ) {
    var o = n[t];
    e(o, t, n) && (i[a++] = o);
  }
  return i;
}
var rS = nS;
function aS() {
  return [];
}
var iS = aS, oS = rS, sS = iS, lS = Object.prototype, cS = lS.propertyIsEnumerable, Kl = Object.getOwnPropertySymbols, uS = Kl ? function(n) {
  return n == null ? [] : (n = Object(n), oS(Kl(n), function(e) {
    return cS.call(n, e);
  }));
} : sS, fS = uS, dS = Mf, pS = dS(Object.keys, Object), hS = pS, mS = Bo, vS = hS, gS = Object.prototype, yS = gS.hasOwnProperty;
function bS(n) {
  if (!mS(n))
    return vS(n);
  var e = [];
  for (var t in Object(n))
    yS.call(n, t) && t != "constructor" && e.push(t);
  return e;
}
var _S = bS, wS = jf, CS = _S, SS = $a;
function xS(n) {
  return SS(n) ? wS(n) : CS(n);
}
var OS = xS, AS = tS, $S = fS, ES = OS;
function kS(n) {
  return AS(n, ES, $S);
}
var DS = kS, Gl = DS, TS = 1, MS = Object.prototype, PS = MS.hasOwnProperty;
function IS(n, e, t, r, a, i) {
  var o = t & TS, s = Gl(n), l = s.length, u = Gl(e), c = u.length;
  if (l != c && !o)
    return !1;
  for (var p = l; p--; ) {
    var m = s[p];
    if (!(o ? m in e : PS.call(e, m)))
      return !1;
  }
  var y = i.get(n), g = i.get(e);
  if (y && g)
    return y == e && g == n;
  var b = !0;
  i.set(n, e), i.set(e, n);
  for (var w = o; ++p < l; ) {
    m = s[p];
    var C = n[m], S = e[m];
    if (r)
      var A = o ? r(S, C, m, e, n, i) : r(C, S, m, n, e, i);
    if (!(A === void 0 ? C === S || a(C, S, t, r, i) : A)) {
      b = !1;
      break;
    }
    w || (w = m == "constructor");
  }
  if (b && !w) {
    var h = n.constructor, E = e.constructor;
    h != E && "constructor" in n && "constructor" in e && !(typeof h == "function" && h instanceof h && typeof E == "function" && E instanceof E) && (b = !1);
  }
  return i.delete(n), i.delete(e), b;
}
var RS = IS, NS = an, FS = nt, LS = NS(FS, "DataView"), BS = LS, jS = an, HS = nt, zS = jS(HS, "Promise"), US = zS, qS = an, WS = nt, VS = qS(WS, "Set"), YS = VS, KS = an, GS = nt, QS = KS(GS, "WeakMap"), JS = QS, Vi = BS, Yi = Ro, Ki = US, Gi = YS, Qi = JS, td = Pn, zn = Cf, Ql = "[object Map]", ZS = "[object Object]", Jl = "[object Promise]", Zl = "[object Set]", Xl = "[object WeakMap]", ec = "[object DataView]", XS = zn(Vi), ex = zn(Yi), tx = zn(Ki), nx = zn(Gi), rx = zn(Qi), Ht = td;
(Vi && Ht(new Vi(new ArrayBuffer(1))) != ec || Yi && Ht(new Yi()) != Ql || Ki && Ht(Ki.resolve()) != Jl || Gi && Ht(new Gi()) != Zl || Qi && Ht(new Qi()) != Xl) && (Ht = function(n) {
  var e = td(n), t = e == ZS ? n.constructor : void 0, r = t ? zn(t) : "";
  if (r)
    switch (r) {
      case XS:
        return ec;
      case ex:
        return Ql;
      case tx:
        return Jl;
      case nx:
        return Zl;
      case rx:
        return Xl;
    }
  return e;
});
var ax = Ht, si = Ef, ix = ed, ox = GC, sx = RS, tc = ax, nc = rn, rc = jo, lx = Ho, cx = 1, ac = "[object Arguments]", ic = "[object Array]", Tr = "[object Object]", ux = Object.prototype, oc = ux.hasOwnProperty;
function fx(n, e, t, r, a, i) {
  var o = nc(n), s = nc(e), l = o ? ic : tc(n), u = s ? ic : tc(e);
  l = l == ac ? Tr : l, u = u == ac ? Tr : u;
  var c = l == Tr, p = u == Tr, m = l == u;
  if (m && rc(n)) {
    if (!rc(e))
      return !1;
    o = !0, c = !1;
  }
  if (m && !c)
    return i || (i = new si()), o || lx(n) ? ix(n, e, t, r, a, i) : ox(n, e, l, t, r, a, i);
  if (!(t & cx)) {
    var y = c && oc.call(n, "__wrapped__"), g = p && oc.call(e, "__wrapped__");
    if (y || g) {
      var b = y ? n.value() : n, w = g ? e.value() : e;
      return i || (i = new si()), a(b, w, t, r, i);
    }
  }
  return m ? (i || (i = new si()), sx(n, e, t, r, a, i)) : !1;
}
var dx = fx, px = dx, sc = nn;
function nd(n, e, t, r, a) {
  return n === e ? !0 : n == null || e == null || !sc(n) && !sc(e) ? n !== n && e !== e : px(n, e, t, r, nd, a);
}
var hx = nd, mx = hx;
function vx(n, e) {
  return mx(n, e);
}
var gx = vx;
const li = /* @__PURE__ */ tn(gx), lc = (n, { sort: e, columns: t, search: r, params: a, pagination: i }) => `${n}?${wf.stringify({
  search: r,
  page: i.page,
  page_size: i.perPage,
  sort: e.column,
  direction: e.direction,
  columns: t,
  ...a
}, { arrayFormat: "brackets" })}`, yx = async (n) => ve.get(n);
function cc({ data: { data: n, page: e, total_elements: t, page_size: r } }) {
  return {
    data: n,
    pagination: {
      records: parseInt(t || ar.records, 10),
      perPage: parseInt(r || ar.page, 10),
      page: parseInt(e || ar.page, 10)
    }
  };
}
const bx = {
  name: "ServerTable",
  props: {
    title: {
      type: String
    },
    url: {
      type: String,
      required: !0
    },
    slimStandalone: {
      type: Boolean,
      default: !1
    },
    showHeader: {
      type: Boolean,
      default: !0
    },
    showStandaloneSpan: {
      type: Boolean,
      default: !0
    },
    headerBold: {
      type: Boolean,
      default: !1
    },
    columnSelection: {
      type: Boolean,
      default: !1
    },
    defaultVisibleColumns: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    searchOptions: {
      type: Object,
      default: () => aa
    },
    initialSortSettings: {
      type: Object,
      default: () => ({})
    },
    expandableRowFunction: {
      type: Function,
      default: () => !0
    },
    initialExpandedRowKeys: {
      type: Array,
      default: () => []
    },
    findRowKeyFunction: {
      type: Function,
      default: (n, e) => e
    },
    requestParams: {
      type: Object,
      default: () => ({})
    },
    urlBuilder: {
      type: Function,
      default: lc
    },
    paginationOptions: {
      type: Object,
      default: () => ({})
    },
    requestFunction: {
      type: Function,
      default: yx
    },
    responseAdapter: {
      type: Function,
      default: (n, e) => cc(n)
    },
    placeholder: {
      type: String,
      default: "-"
    },
    translationsFunction: {
      type: Function,
      default: zo
    },
    allColumnsExpandRowOnClick: {
      type: Boolean,
      default: !1
    },
    highlightedRowKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: [],
      dataLoading: !1,
      searchQuery: "",
      pagination: qf({}, ar, this.paginationOptions),
      sortSettings: {
        column: "key",
        direction: "DESC",
        ...this.initialSortSettings
      },
      loadingError: !1
    };
  },
  computed: {
    mergedSearchOptions() {
      return {
        ...aa,
        ...this.searchOptions
      };
    },
    mergedSelectionOptions() {
      return {
        ...Kf
      };
    },
    mergedColumns() {
      return this.columns.map((n) => ({
        ...Vf,
        ...n
      }));
    },
    columnNames() {
      return this.columns.map((n) => n.name);
    },
    filteredData() {
      return this.data;
    },
    // combine every variable changing the table filter so that we can trigger pagination resets on changes
    filterTriggers() {
      const { searchQuery: n, requestParams: e } = this;
      return { searchQuery: n, requestParams: e };
    },
    // combine every variable that we want to trigger requests on into an object we can watch
    requestTriggers() {
      const { searchQuery: n, pagination: { perPage: e, page: t }, sortSettings: r, mergedColumns: a, requestParams: i, fullUrl: o } = this;
      return { searchQuery: n, perPage: e, page: t, sortSettings: r, mergedColumns: a, requestParams: i, fullUrl: o };
    },
    searching() {
      return this.searchQuery !== "";
    },
    fullUrl() {
      const {
        url: n,
        sortSettings: e,
        columnNames: t,
        pagination: r,
        searchQuery: a,
        requestParams: i,
        urlBuilder: o
      } = this;
      return (o || lc)(n, {
        sort: e,
        columns: t,
        search: a,
        params: i,
        pagination: r
      });
    }
  },
  watch: {
    filterTriggers: {
      handler(n, e) {
        li(e, n) || (this.pagination = {
          ...this.pagination,
          page: 1
        });
      }
    },
    requestTriggers: {
      handler(n, e) {
        li(e, n) || this.sendRequestToFetchDataDebounced();
      },
      deep: !0,
      immediate: !0
    },
    pagination: {
      handler(n, e) {
        !e || li(e, n) || this.$emit("pagination-change", n);
      },
      deep: !0
    },
    dataLoading: {
      handler(n) {
        this.$emit("data-loading", n);
      }
    }
  },
  created() {
    this.sendRequestToFetchData(), this.sendRequestToFetchDataDebounced = vr(function() {
      this.sendRequestToFetchData();
    }, 250);
  },
  methods: {
    handleQueryChange(n) {
      this.searchQuery = n, this.pagination.page = 1;
    },
    handleSortSettingChanged(n) {
      this.sortSettings = n;
    },
    sendRequestToFetchDataDebounced() {
    },
    async sendRequestToFetchData() {
      this.dataLoading = !0, this.$nextTick(async () => {
        const { responseAdapter: n, requestFunction: e, fullUrl: t } = this;
        try {
          const r = await e(t), a = n || cc, { data: i, pagination: o } = a(r);
          this.pagination.page && this.pagination.page === o.page && (this.data = i, this.pagination = {
            ...this.pagination,
            records: o.records
          }, this.dataLoading = !1);
        } catch (r) {
          this.$emit("loading-error", r), this.data = [], this.dataLoading = !1;
        }
      });
    }
  },
  components: {
    TableBody: Zf,
    Pagination: Xf
  }
};
var _x = function() {
  var e = this, t = e._self._c;
  return t("TableBody", { ref: "tableBody", attrs: { title: e.title, placeholder: e.placeholder, "slim-standalone": e.slimStandalone, "show-standalone-span": e.showStandaloneSpan, "header-bold": e.headerBold, "column-selection": e.columnSelection, "default-visible-columns": e.defaultVisibleColumns, columns: e.columns, data: e.filteredData, "initial-sort-settings": e.initialSortSettings, loading: e.dataLoading, "initial-expanded-row-keys": e.initialExpandedRowKeys, "search-options": e.mergedSearchOptions, searching: e.searching, "translations-function": e.translationsFunction, "expandable-row-function": e.expandableRowFunction, "all-columns-expand-row-on-click": e.allColumnsExpandRowOnClick, "highlighted-row-keys": e.highlightedRowKeys, "selection-options": e.mergedSelectionOptions, "find-row-key-function": e.findRowKeyFunction }, on: { "sort-change": e.handleSortSettingChanged, "query-change": e.handleQueryChange, "row-click": (r) => e.$emit("row-click", r), "update-column-selection": (r) => e.$emit("update-column-selection", r) }, scopedSlots: e._u([e._l(e.$scopedSlots, function(r, a) {
    return { key: a, fn: function(i) {
      return [e._t(a, null, null, i)];
    } };
  }), { key: "pagination", fn: function() {
    return [t("Pagination", { model: { value: e.pagination, callback: function(r) {
      e.pagination = r;
    }, expression: "pagination" } })];
  }, proxy: !0 }], null, !0) });
}, wx = [], Cx = /* @__PURE__ */ ee(
  bx,
  _x,
  wx,
  !1,
  null,
  null
);
const Sx = Cx.exports, xx = {
  name: "DMTableHeader",
  props: {
    mergedSearchOptions: {
      type: Object,
      default: () => {
      }
    }
  }
};
var Ox = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "table__header" }, [t("h1", { staticClass: "table__header-title" }, [e._t("title", function() {
    return [e._v(" Table ")];
  })], 2), t("div", { staticClass: "table__header-extras grid-row" }, [t("div", { staticClass: "grid-column-1" }, [e._t("after-title")], 2), e.$slots.search || e.$slots["after-search"] ? t("div", { staticClass: "grid-column-0 table_search_group" }, [e._t("search"), e._t("after-search")], 2) : e._e()])]);
}, Ax = [], $x = /* @__PURE__ */ ee(
  xx,
  Ox,
  Ax,
  !1,
  null,
  "20b1e79b"
);
const Ex = $x.exports;
var rd = { exports: {} }, ci = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], _n = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(n) {
    return typeof console < "u" && console.warn(n);
  },
  getWeek: function(n) {
    var e = new Date(n.getTime());
    e.setHours(0, 0, 0, 0), e.setDate(e.getDate() + 3 - (e.getDay() + 6) % 7);
    var t = new Date(e.getFullYear(), 0, 4);
    return 1 + Math.round(((e.getTime() - t.getTime()) / 864e5 - 3 + (t.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, fr = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(n) {
    var e = n % 100;
    if (e > 3 && e < 21)
      return "th";
    switch (e % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, Re = function(n, e) {
  return e === void 0 && (e = 2), ("000" + n).slice(e * -1);
}, Ke = function(n) {
  return n === !0 ? 1 : 0;
};
function uc(n, e) {
  var t;
  return function() {
    var r = this, a = arguments;
    clearTimeout(t), t = setTimeout(function() {
      return n.apply(r, a);
    }, e);
  };
}
var ui = function(n) {
  return n instanceof Array ? n : [n];
};
function Te(n, e, t) {
  if (t === !0)
    return n.classList.add(e);
  n.classList.remove(e);
}
function se(n, e, t) {
  var r = window.document.createElement(n);
  return e = e || "", t = t || "", r.className = e, t !== void 0 && (r.textContent = t), r;
}
function Mr(n) {
  for (; n.firstChild; )
    n.removeChild(n.firstChild);
}
function ad(n, e) {
  if (e(n))
    return n;
  if (n.parentNode)
    return ad(n.parentNode, e);
}
function Pr(n, e) {
  var t = se("div", "numInputWrapper"), r = se("input", "numInput " + n), a = se("span", "arrowUp"), i = se("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? r.type = "number" : (r.type = "text", r.pattern = "\\d*"), e !== void 0)
    for (var o in e)
      r.setAttribute(o, e[o]);
  return t.appendChild(r), t.appendChild(a), t.appendChild(i), t;
}
function He(n) {
  try {
    if (typeof n.composedPath == "function") {
      var e = n.composedPath();
      return e[0];
    }
    return n.target;
  } catch {
    return n.target;
  }
}
var fi = function() {
}, oa = function(n, e, t) {
  return t.months[e ? "shorthand" : "longhand"][n];
}, kx = {
  D: fi,
  F: function(n, e, t) {
    n.setMonth(t.months.longhand.indexOf(e));
  },
  G: function(n, e) {
    n.setHours((n.getHours() >= 12 ? 12 : 0) + parseFloat(e));
  },
  H: function(n, e) {
    n.setHours(parseFloat(e));
  },
  J: function(n, e) {
    n.setDate(parseFloat(e));
  },
  K: function(n, e, t) {
    n.setHours(n.getHours() % 12 + 12 * Ke(new RegExp(t.amPM[1], "i").test(e)));
  },
  M: function(n, e, t) {
    n.setMonth(t.months.shorthand.indexOf(e));
  },
  S: function(n, e) {
    n.setSeconds(parseFloat(e));
  },
  U: function(n, e) {
    return new Date(parseFloat(e) * 1e3);
  },
  W: function(n, e, t) {
    var r = parseInt(e), a = new Date(n.getFullYear(), 0, 2 + (r - 1) * 7, 0, 0, 0, 0);
    return a.setDate(a.getDate() - a.getDay() + t.firstDayOfWeek), a;
  },
  Y: function(n, e) {
    n.setFullYear(parseFloat(e));
  },
  Z: function(n, e) {
    return new Date(e);
  },
  d: function(n, e) {
    n.setDate(parseFloat(e));
  },
  h: function(n, e) {
    n.setHours((n.getHours() >= 12 ? 12 : 0) + parseFloat(e));
  },
  i: function(n, e) {
    n.setMinutes(parseFloat(e));
  },
  j: function(n, e) {
    n.setDate(parseFloat(e));
  },
  l: fi,
  m: function(n, e) {
    n.setMonth(parseFloat(e) - 1);
  },
  n: function(n, e) {
    n.setMonth(parseFloat(e) - 1);
  },
  s: function(n, e) {
    n.setSeconds(parseFloat(e));
  },
  u: function(n, e) {
    return new Date(parseFloat(e));
  },
  w: fi,
  y: function(n, e) {
    n.setFullYear(2e3 + parseFloat(e));
  }
}, qt = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, ir = {
  Z: function(n) {
    return n.toISOString();
  },
  D: function(n, e, t) {
    return e.weekdays.shorthand[ir.w(n, e, t)];
  },
  F: function(n, e, t) {
    return oa(ir.n(n, e, t) - 1, !1, e);
  },
  G: function(n, e, t) {
    return Re(ir.h(n, e, t));
  },
  H: function(n) {
    return Re(n.getHours());
  },
  J: function(n, e) {
    return e.ordinal !== void 0 ? n.getDate() + e.ordinal(n.getDate()) : n.getDate();
  },
  K: function(n, e) {
    return e.amPM[Ke(n.getHours() > 11)];
  },
  M: function(n, e) {
    return oa(n.getMonth(), !0, e);
  },
  S: function(n) {
    return Re(n.getSeconds());
  },
  U: function(n) {
    return n.getTime() / 1e3;
  },
  W: function(n, e, t) {
    return t.getWeek(n);
  },
  Y: function(n) {
    return Re(n.getFullYear(), 4);
  },
  d: function(n) {
    return Re(n.getDate());
  },
  h: function(n) {
    return n.getHours() % 12 ? n.getHours() % 12 : 12;
  },
  i: function(n) {
    return Re(n.getMinutes());
  },
  j: function(n) {
    return n.getDate();
  },
  l: function(n, e) {
    return e.weekdays.longhand[n.getDay()];
  },
  m: function(n) {
    return Re(n.getMonth() + 1);
  },
  n: function(n) {
    return n.getMonth() + 1;
  },
  s: function(n) {
    return n.getSeconds();
  },
  u: function(n) {
    return n.getTime();
  },
  w: function(n) {
    return n.getDay();
  },
  y: function(n) {
    return String(n.getFullYear()).substring(2);
  }
}, id = function(n) {
  var e = n.config, t = e === void 0 ? _n : e, r = n.l10n, a = r === void 0 ? fr : r, i = n.isMobile, o = i === void 0 ? !1 : i;
  return function(s, l, u) {
    var c = u || a;
    return t.formatDate !== void 0 && !o ? t.formatDate(s, l, c) : l.split("").map(function(p, m, y) {
      return ir[p] && y[m - 1] !== "\\" ? ir[p](s, c, t) : p !== "\\" ? p : "";
    }).join("");
  };
}, Ji = function(n) {
  var e = n.config, t = e === void 0 ? _n : e, r = n.l10n, a = r === void 0 ? fr : r;
  return function(i, o, s, l) {
    if (!(i !== 0 && !i)) {
      var u = l || a, c, p = i;
      if (i instanceof Date)
        c = new Date(i.getTime());
      else if (typeof i != "string" && i.toFixed !== void 0)
        c = new Date(i);
      else if (typeof i == "string") {
        var m = o || (t || _n).dateFormat, y = String(i).trim();
        if (y === "today")
          c = /* @__PURE__ */ new Date(), s = !0;
        else if (t && t.parseDate)
          c = t.parseDate(i, m);
        else if (/Z$/.test(y) || /GMT$/.test(y))
          c = new Date(i);
        else {
          for (var g = void 0, b = [], w = 0, C = 0, S = ""; w < m.length; w++) {
            var A = m[w], h = A === "\\", E = m[w - 1] === "\\" || h;
            if (qt[A] && !E) {
              S += qt[A];
              var _ = new RegExp(S).exec(i);
              _ && (g = !0) && b[A !== "Y" ? "push" : "unshift"]({
                fn: kx[A],
                val: _[++C]
              });
            } else h || (S += ".");
          }
          c = !t || !t.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), b.forEach(function(M) {
            var L = M.fn, z = M.val;
            return c = L(c, z, u) || c;
          }), c = g ? c : void 0;
        }
      }
      if (!(c instanceof Date && !isNaN(c.getTime()))) {
        t.errorHandler(new Error("Invalid date provided: " + p));
        return;
      }
      return s === !0 && c.setHours(0, 0, 0, 0), c;
    }
  };
};
function ze(n, e, t) {
  return t === void 0 && (t = !0), t !== !1 ? new Date(n.getTime()).setHours(0, 0, 0, 0) - new Date(e.getTime()).setHours(0, 0, 0, 0) : n.getTime() - e.getTime();
}
var Dx = function(n, e, t) {
  return n > Math.min(e, t) && n < Math.max(e, t);
}, di = function(n, e, t) {
  return n * 3600 + e * 60 + t;
}, Tx = function(n) {
  var e = Math.floor(n / 3600), t = (n - e * 3600) / 60;
  return [e, t, n - e * 3600 - t * 60];
}, Mx = {
  DAY: 864e5
};
function pi(n) {
  var e = n.defaultHour, t = n.defaultMinute, r = n.defaultSeconds;
  if (n.minDate !== void 0) {
    var a = n.minDate.getHours(), i = n.minDate.getMinutes(), o = n.minDate.getSeconds();
    e < a && (e = a), e === a && t < i && (t = i), e === a && t === i && r < o && (r = n.minDate.getSeconds());
  }
  if (n.maxDate !== void 0) {
    var s = n.maxDate.getHours(), l = n.maxDate.getMinutes();
    e = Math.min(e, s), e === s && (t = Math.min(l, t)), e === s && t === l && (r = n.maxDate.getSeconds());
  }
  return { hours: e, minutes: t, seconds: r };
}
typeof Object.assign != "function" && (Object.assign = function(n) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  if (!n)
    throw TypeError("Cannot convert undefined or null to object");
  for (var r = function(s) {
    s && Object.keys(s).forEach(function(l) {
      return n[l] = s[l];
    });
  }, a = 0, i = e; a < i.length; a++) {
    var o = i[a];
    r(o);
  }
  return n;
});
var Ee = function() {
  return Ee = Object.assign || function(n) {
    for (var e, t = 1, r = arguments.length; t < r; t++) {
      e = arguments[t];
      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (n[a] = e[a]);
    }
    return n;
  }, Ee.apply(this, arguments);
}, fc = function() {
  for (var n = 0, e = 0, t = arguments.length; e < t; e++) n += arguments[e].length;
  for (var r = Array(n), a = 0, e = 0; e < t; e++)
    for (var i = arguments[e], o = 0, s = i.length; o < s; o++, a++)
      r[a] = i[o];
  return r;
}, Px = 300;
function Ix(n, e) {
  var t = {
    config: Ee(Ee({}, _n), _e.defaultConfig),
    l10n: fr
  };
  t.parseDate = Ji({ config: t.config, l10n: t.l10n }), t._handlers = [], t.pluginElements = [], t.loadedPlugins = [], t._bind = b, t._setHoursFromDate = m, t._positionCalendar = pt, t.changeMonth = te, t.changeYear = we, t.clear = ie, t.close = ce, t.onMouseOver = De, t._createElement = se, t.createDay = _, t.destroy = ue, t.isEnabled = me, t.jumpToDate = S, t.updateValue = $e, t.open = on, t.redraw = Ot, t.set = sn, t.setDate = ln, t.toggle = $;
  function r() {
    t.utils = {
      getDaysInMonth: function(f, d) {
        return f === void 0 && (f = t.currentMonth), d === void 0 && (d = t.currentYear), f === 1 && (d % 4 === 0 && d % 100 !== 0 || d % 400 === 0) ? 29 : t.l10n.daysInMonth[f];
      }
    };
  }
  function a() {
    t.element = t.input = n, t.isOpen = !1, Ft(), Lt(), ka(), Ea(), r(), t.isMobile || E(), C(), (t.selectedDates.length || t.config.noCalendar) && (t.config.enableTime && m(t.config.noCalendar ? t.latestSelectedDateObj : void 0), $e(!1)), s();
    var f = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !t.isMobile && f && pt(), I("onReady");
  }
  function i() {
    var f;
    return ((f = t.calendarContainer) === null || f === void 0 ? void 0 : f.getRootNode()).activeElement || document.activeElement;
  }
  function o(f) {
    return f.bind(t);
  }
  function s() {
    var f = t.config;
    f.weekNumbers === !1 && f.showMonths === 1 || f.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (t.calendarContainer !== void 0 && (t.calendarContainer.style.visibility = "hidden", t.calendarContainer.style.display = "block"), t.daysContainer !== void 0) {
        var d = (t.days.offsetWidth + 1) * f.showMonths;
        t.daysContainer.style.width = d + "px", t.calendarContainer.style.width = d + (t.weekWrapper !== void 0 ? t.weekWrapper.offsetWidth : 0) + "px", t.calendarContainer.style.removeProperty("visibility"), t.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function l(f) {
    if (t.selectedDates.length === 0) {
      var d = t.config.minDate === void 0 || ze(/* @__PURE__ */ new Date(), t.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(t.config.minDate.getTime()), v = pi(t.config);
      d.setHours(v.hours, v.minutes, v.seconds, d.getMilliseconds()), t.selectedDates = [d], t.latestSelectedDateObj = d;
    }
    f !== void 0 && f.type !== "blur" && mt(f);
    var O = t._input.value;
    p(), $e(), t._input.value !== O && t._debouncedChange();
  }
  function u(f, d) {
    return f % 12 + 12 * Ke(d === t.l10n.amPM[1]);
  }
  function c(f) {
    switch (f % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return f % 12;
    }
  }
  function p() {
    if (!(t.hourElement === void 0 || t.minuteElement === void 0)) {
      var f = (parseInt(t.hourElement.value.slice(-2), 10) || 0) % 24, d = (parseInt(t.minuteElement.value, 10) || 0) % 60, v = t.secondElement !== void 0 ? (parseInt(t.secondElement.value, 10) || 0) % 60 : 0;
      t.amPM !== void 0 && (f = u(f, t.amPM.textContent));
      var O = t.config.minTime !== void 0 || t.config.minDate && t.minDateHasTime && t.latestSelectedDateObj && ze(t.latestSelectedDateObj, t.config.minDate, !0) === 0, P = t.config.maxTime !== void 0 || t.config.maxDate && t.maxDateHasTime && t.latestSelectedDateObj && ze(t.latestSelectedDateObj, t.config.maxDate, !0) === 0;
      if (t.config.maxTime !== void 0 && t.config.minTime !== void 0 && t.config.minTime > t.config.maxTime) {
        var N = di(t.config.minTime.getHours(), t.config.minTime.getMinutes(), t.config.minTime.getSeconds()), X = di(t.config.maxTime.getHours(), t.config.maxTime.getMinutes(), t.config.maxTime.getSeconds()), H = di(f, d, v);
        if (H > X && H < N) {
          var ne = Tx(N);
          f = ne[0], d = ne[1], v = ne[2];
        }
      } else {
        if (P) {
          var j = t.config.maxTime !== void 0 ? t.config.maxTime : t.config.maxDate;
          f = Math.min(f, j.getHours()), f === j.getHours() && (d = Math.min(d, j.getMinutes())), d === j.getMinutes() && (v = Math.min(v, j.getSeconds()));
        }
        if (O) {
          var Q = t.config.minTime !== void 0 ? t.config.minTime : t.config.minDate;
          f = Math.max(f, Q.getHours()), f === Q.getHours() && d < Q.getMinutes() && (d = Q.getMinutes()), d === Q.getMinutes() && (v = Math.max(v, Q.getSeconds()));
        }
      }
      y(f, d, v);
    }
  }
  function m(f) {
    var d = f || t.latestSelectedDateObj;
    d && d instanceof Date && y(d.getHours(), d.getMinutes(), d.getSeconds());
  }
  function y(f, d, v) {
    t.latestSelectedDateObj !== void 0 && t.latestSelectedDateObj.setHours(f % 24, d, v || 0, 0), !(!t.hourElement || !t.minuteElement || t.isMobile) && (t.hourElement.value = Re(t.config.time_24hr ? f : (12 + f) % 12 + 12 * Ke(f % 12 === 0)), t.minuteElement.value = Re(d), t.amPM !== void 0 && (t.amPM.textContent = t.l10n.amPM[Ke(f >= 12)]), t.secondElement !== void 0 && (t.secondElement.value = Re(v)));
  }
  function g(f) {
    var d = He(f), v = parseInt(d.value) + (f.delta || 0);
    (v / 1e3 > 1 || f.key === "Enter" && !/[^\d]/.test(v.toString())) && we(v);
  }
  function b(f, d, v, O) {
    if (d instanceof Array)
      return d.forEach(function(P) {
        return b(f, P, v, O);
      });
    if (f instanceof Array)
      return f.forEach(function(P) {
        return b(P, d, v, O);
      });
    f.addEventListener(d, v, O), t._handlers.push({
      remove: function() {
        return f.removeEventListener(d, v, O);
      }
    });
  }
  function w() {
    I("onChange");
  }
  function C() {
    if (t.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(v) {
      Array.prototype.forEach.call(t.element.querySelectorAll("[data-" + v + "]"), function(O) {
        return b(O, "click", t[v]);
      });
    }), t.isMobile) {
      Da();
      return;
    }
    var f = uc(Ye, 50);
    if (t._debouncedChange = uc(w, Px), t.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && b(t.daysContainer, "mouseover", function(v) {
      t.config.mode === "range" && De(He(v));
    }), b(t._input, "keydown", xe), t.calendarContainer !== void 0 && b(t.calendarContainer, "keydown", xe), !t.config.inline && !t.config.static && b(window, "resize", f), window.ontouchstart !== void 0 ? b(window.document, "touchstart", ye) : b(window.document, "mousedown", ye), b(window.document, "focus", ye, { capture: !0 }), t.config.clickOpens === !0 && (b(t._input, "focus", t.open), b(t._input, "click", t.open)), t.daysContainer !== void 0 && (b(t.monthNav, "click", xr), b(t.monthNav, ["keyup", "increment"], g), b(t.daysContainer, "click", At)), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0) {
      var d = function(v) {
        return He(v).select();
      };
      b(t.timeContainer, ["increment"], l), b(t.timeContainer, "blur", l, { capture: !0 }), b(t.timeContainer, "click", A), b([t.hourElement, t.minuteElement], ["focus", "click"], d), t.secondElement !== void 0 && b(t.secondElement, "focus", function() {
        return t.secondElement && t.secondElement.select();
      }), t.amPM !== void 0 && b(t.amPM, "click", function(v) {
        l(v);
      });
    }
    t.config.allowInput && b(t._input, "blur", de);
  }
  function S(f, d) {
    var v = f !== void 0 ? t.parseDate(f) : t.latestSelectedDateObj || (t.config.minDate && t.config.minDate > t.now ? t.config.minDate : t.config.maxDate && t.config.maxDate < t.now ? t.config.maxDate : t.now), O = t.currentYear, P = t.currentMonth;
    try {
      v !== void 0 && (t.currentYear = v.getFullYear(), t.currentMonth = v.getMonth());
    } catch (N) {
      N.message = "Invalid date supplied: " + v, t.config.errorHandler(N);
    }
    d && t.currentYear !== O && (I("onYearChange"), G()), d && (t.currentYear !== O || t.currentMonth !== P) && I("onMonthChange"), t.redraw();
  }
  function A(f) {
    var d = He(f);
    ~d.className.indexOf("arrow") && h(f, d.classList.contains("arrowUp") ? 1 : -1);
  }
  function h(f, d, v) {
    var O = f && He(f), P = v || O && O.parentNode && O.parentNode.firstChild, N = K("increment");
    N.delta = d, P && P.dispatchEvent(N);
  }
  function E() {
    var f = window.document.createDocumentFragment();
    if (t.calendarContainer = se("div", "flatpickr-calendar"), t.calendarContainer.tabIndex = -1, !t.config.noCalendar) {
      if (f.appendChild(k()), t.innerContainer = se("div", "flatpickr-innerContainer"), t.config.weekNumbers) {
        var d = W(), v = d.weekWrapper, O = d.weekNumbers;
        t.innerContainer.appendChild(v), t.weekNumbers = O, t.weekWrapper = v;
      }
      t.rContainer = se("div", "flatpickr-rContainer"), t.rContainer.appendChild(T()), t.daysContainer || (t.daysContainer = se("div", "flatpickr-days"), t.daysContainer.tabIndex = -1), J(), t.rContainer.appendChild(t.daysContainer), t.innerContainer.appendChild(t.rContainer), f.appendChild(t.innerContainer);
    }
    t.config.enableTime && f.appendChild(R()), Te(t.calendarContainer, "rangeMode", t.config.mode === "range"), Te(t.calendarContainer, "animate", t.config.animate === !0), Te(t.calendarContainer, "multiMonth", t.config.showMonths > 1), t.calendarContainer.appendChild(f);
    var P = t.config.appendTo !== void 0 && t.config.appendTo.nodeType !== void 0;
    if ((t.config.inline || t.config.static) && (t.calendarContainer.classList.add(t.config.inline ? "inline" : "static"), t.config.inline && (!P && t.element.parentNode ? t.element.parentNode.insertBefore(t.calendarContainer, t._input.nextSibling) : t.config.appendTo !== void 0 && t.config.appendTo.appendChild(t.calendarContainer)), t.config.static)) {
      var N = se("div", "flatpickr-wrapper");
      t.element.parentNode && t.element.parentNode.insertBefore(N, t.element), N.appendChild(t.element), t.altInput && N.appendChild(t.altInput), N.appendChild(t.calendarContainer);
    }
    !t.config.static && !t.config.inline && (t.config.appendTo !== void 0 ? t.config.appendTo : window.document.body).appendChild(t.calendarContainer);
  }
  function _(f, d, v, O) {
    var P = me(d, !0), N = se("span", f, d.getDate().toString());
    return N.dateObj = d, N.$i = O, N.setAttribute("aria-label", t.formatDate(d, t.config.ariaDateFormat)), f.indexOf("hidden") === -1 && ze(d, t.now) === 0 && (t.todayDateElem = N, N.classList.add("today"), N.setAttribute("aria-current", "date")), P ? (N.tabIndex = -1, oe(d) && (N.classList.add("selected"), t.selectedDateElem = N, t.config.mode === "range" && (Te(N, "startRange", t.selectedDates[0] && ze(d, t.selectedDates[0], !0) === 0), Te(N, "endRange", t.selectedDates[1] && ze(d, t.selectedDates[1], !0) === 0), f === "nextMonthDay" && N.classList.add("inRange")))) : N.classList.add("flatpickr-disabled"), t.config.mode === "range" && ae(d) && !oe(d) && N.classList.add("inRange"), t.weekNumbers && t.config.showMonths === 1 && f !== "prevMonthDay" && O % 7 === 6 && t.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + t.config.getWeek(d) + "</span>"), I("onDayCreate", N), N;
  }
  function M(f) {
    f.focus(), t.config.mode === "range" && De(f);
  }
  function L(f) {
    for (var d = f > 0 ? 0 : t.config.showMonths - 1, v = f > 0 ? t.config.showMonths : -1, O = d; O != v; O += f)
      for (var P = t.daysContainer.children[O], N = f > 0 ? 0 : P.children.length - 1, X = f > 0 ? P.children.length : -1, H = N; H != X; H += f) {
        var ne = P.children[H];
        if (ne.className.indexOf("hidden") === -1 && me(ne.dateObj))
          return ne;
      }
  }
  function z(f, d) {
    for (var v = f.className.indexOf("Month") === -1 ? f.dateObj.getMonth() : t.currentMonth, O = d > 0 ? t.config.showMonths : -1, P = d > 0 ? 1 : -1, N = v - t.currentMonth; N != O; N += P)
      for (var X = t.daysContainer.children[N], H = v - t.currentMonth === N ? f.$i + d : d < 0 ? X.children.length - 1 : 0, ne = X.children.length, j = H; j >= 0 && j < ne && j != (d > 0 ? ne : -1); j += P) {
        var Q = X.children[j];
        if (Q.className.indexOf("hidden") === -1 && me(Q.dateObj) && Math.abs(f.$i - j) >= Math.abs(d))
          return M(Q);
      }
    t.changeMonth(P), U(L(P), 0);
  }
  function U(f, d) {
    var v = i(), O = Ce(v || document.body), P = f !== void 0 ? f : O ? v : t.selectedDateElem !== void 0 && Ce(t.selectedDateElem) ? t.selectedDateElem : t.todayDateElem !== void 0 && Ce(t.todayDateElem) ? t.todayDateElem : L(d > 0 ? 1 : -1);
    P === void 0 ? t._input.focus() : O ? z(P, d) : M(P);
  }
  function V(f, d) {
    for (var v = (new Date(f, d, 1).getDay() - t.l10n.firstDayOfWeek + 7) % 7, O = t.utils.getDaysInMonth((d - 1 + 12) % 12, f), P = t.utils.getDaysInMonth(d, f), N = window.document.createDocumentFragment(), X = t.config.showMonths > 1, H = X ? "prevMonthDay hidden" : "prevMonthDay", ne = X ? "nextMonthDay hidden" : "nextMonthDay", j = O + 1 - v, Q = 0; j <= O; j++, Q++)
      N.appendChild(_("flatpickr-day " + H, new Date(f, d - 1, j), j, Q));
    for (j = 1; j <= P; j++, Q++)
      N.appendChild(_("flatpickr-day", new Date(f, d, j), j, Q));
    for (var fe = P + 1; fe <= 42 - v && (t.config.showMonths === 1 || Q % 7 !== 0); fe++, Q++)
      N.appendChild(_("flatpickr-day " + ne, new Date(f, d + 1, fe % P), fe, Q));
    var it = se("div", "dayContainer");
    return it.appendChild(N), it;
  }
  function J() {
    if (t.daysContainer !== void 0) {
      Mr(t.daysContainer), t.weekNumbers && Mr(t.weekNumbers);
      for (var f = document.createDocumentFragment(), d = 0; d < t.config.showMonths; d++) {
        var v = new Date(t.currentYear, t.currentMonth, 1);
        v.setMonth(t.currentMonth + d), f.appendChild(V(v.getFullYear(), v.getMonth()));
      }
      t.daysContainer.appendChild(f), t.days = t.daysContainer.firstChild, t.config.mode === "range" && t.selectedDates.length === 1 && De();
    }
  }
  function G() {
    if (!(t.config.showMonths > 1 || t.config.monthSelectorType !== "dropdown")) {
      var f = function(O) {
        return t.config.minDate !== void 0 && t.currentYear === t.config.minDate.getFullYear() && O < t.config.minDate.getMonth() ? !1 : !(t.config.maxDate !== void 0 && t.currentYear === t.config.maxDate.getFullYear() && O > t.config.maxDate.getMonth());
      };
      t.monthsDropdownContainer.tabIndex = -1, t.monthsDropdownContainer.innerHTML = "";
      for (var d = 0; d < 12; d++)
        if (f(d)) {
          var v = se("option", "flatpickr-monthDropdown-month");
          v.value = new Date(t.currentYear, d).getMonth().toString(), v.textContent = oa(d, t.config.shorthandCurrentMonth, t.l10n), v.tabIndex = -1, t.currentMonth === d && (v.selected = !0), t.monthsDropdownContainer.appendChild(v);
        }
    }
  }
  function F() {
    var f = se("div", "flatpickr-month"), d = window.document.createDocumentFragment(), v;
    t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? v = se("span", "cur-month") : (t.monthsDropdownContainer = se("select", "flatpickr-monthDropdown-months"), t.monthsDropdownContainer.setAttribute("aria-label", t.l10n.monthAriaLabel), b(t.monthsDropdownContainer, "change", function(X) {
      var H = He(X), ne = parseInt(H.value, 10);
      t.changeMonth(ne - t.currentMonth), I("onMonthChange");
    }), G(), v = t.monthsDropdownContainer);
    var O = Pr("cur-year", { tabindex: "-1" }), P = O.getElementsByTagName("input")[0];
    P.setAttribute("aria-label", t.l10n.yearAriaLabel), t.config.minDate && P.setAttribute("min", t.config.minDate.getFullYear().toString()), t.config.maxDate && (P.setAttribute("max", t.config.maxDate.getFullYear().toString()), P.disabled = !!t.config.minDate && t.config.minDate.getFullYear() === t.config.maxDate.getFullYear());
    var N = se("div", "flatpickr-current-month");
    return N.appendChild(v), N.appendChild(O), d.appendChild(N), f.appendChild(d), {
      container: f,
      yearElement: P,
      monthElement: v
    };
  }
  function D() {
    Mr(t.monthNav), t.monthNav.appendChild(t.prevMonthNav), t.config.showMonths && (t.yearElements = [], t.monthElements = []);
    for (var f = t.config.showMonths; f--; ) {
      var d = F();
      t.yearElements.push(d.yearElement), t.monthElements.push(d.monthElement), t.monthNav.appendChild(d.container);
    }
    t.monthNav.appendChild(t.nextMonthNav);
  }
  function k() {
    return t.monthNav = se("div", "flatpickr-months"), t.yearElements = [], t.monthElements = [], t.prevMonthNav = se("span", "flatpickr-prev-month"), t.prevMonthNav.innerHTML = t.config.prevArrow, t.nextMonthNav = se("span", "flatpickr-next-month"), t.nextMonthNav.innerHTML = t.config.nextArrow, D(), Object.defineProperty(t, "_hidePrevMonthArrow", {
      get: function() {
        return t.__hidePrevMonthArrow;
      },
      set: function(f) {
        t.__hidePrevMonthArrow !== f && (Te(t.prevMonthNav, "flatpickr-disabled", f), t.__hidePrevMonthArrow = f);
      }
    }), Object.defineProperty(t, "_hideNextMonthArrow", {
      get: function() {
        return t.__hideNextMonthArrow;
      },
      set: function(f) {
        t.__hideNextMonthArrow !== f && (Te(t.nextMonthNav, "flatpickr-disabled", f), t.__hideNextMonthArrow = f);
      }
    }), t.currentYearElement = t.yearElements[0], be(), t.monthNav;
  }
  function R() {
    t.calendarContainer.classList.add("hasTime"), t.config.noCalendar && t.calendarContainer.classList.add("noCalendar");
    var f = pi(t.config);
    t.timeContainer = se("div", "flatpickr-time"), t.timeContainer.tabIndex = -1;
    var d = se("span", "flatpickr-time-separator", ":"), v = Pr("flatpickr-hour", {
      "aria-label": t.l10n.hourAriaLabel
    });
    t.hourElement = v.getElementsByTagName("input")[0];
    var O = Pr("flatpickr-minute", {
      "aria-label": t.l10n.minuteAriaLabel
    });
    if (t.minuteElement = O.getElementsByTagName("input")[0], t.hourElement.tabIndex = t.minuteElement.tabIndex = -1, t.hourElement.value = Re(t.latestSelectedDateObj ? t.latestSelectedDateObj.getHours() : t.config.time_24hr ? f.hours : c(f.hours)), t.minuteElement.value = Re(t.latestSelectedDateObj ? t.latestSelectedDateObj.getMinutes() : f.minutes), t.hourElement.setAttribute("step", t.config.hourIncrement.toString()), t.minuteElement.setAttribute("step", t.config.minuteIncrement.toString()), t.hourElement.setAttribute("min", t.config.time_24hr ? "0" : "1"), t.hourElement.setAttribute("max", t.config.time_24hr ? "23" : "12"), t.hourElement.setAttribute("maxlength", "2"), t.minuteElement.setAttribute("min", "0"), t.minuteElement.setAttribute("max", "59"), t.minuteElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(v), t.timeContainer.appendChild(d), t.timeContainer.appendChild(O), t.config.time_24hr && t.timeContainer.classList.add("time24hr"), t.config.enableSeconds) {
      t.timeContainer.classList.add("hasSeconds");
      var P = Pr("flatpickr-second");
      t.secondElement = P.getElementsByTagName("input")[0], t.secondElement.value = Re(t.latestSelectedDateObj ? t.latestSelectedDateObj.getSeconds() : f.seconds), t.secondElement.setAttribute("step", t.minuteElement.getAttribute("step")), t.secondElement.setAttribute("min", "0"), t.secondElement.setAttribute("max", "59"), t.secondElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(se("span", "flatpickr-time-separator", ":")), t.timeContainer.appendChild(P);
    }
    return t.config.time_24hr || (t.amPM = se("span", "flatpickr-am-pm", t.l10n.amPM[Ke((t.latestSelectedDateObj ? t.hourElement.value : t.config.defaultHour) > 11)]), t.amPM.title = t.l10n.toggleTitle, t.amPM.tabIndex = -1, t.timeContainer.appendChild(t.amPM)), t.timeContainer;
  }
  function T() {
    t.weekdayContainer ? Mr(t.weekdayContainer) : t.weekdayContainer = se("div", "flatpickr-weekdays");
    for (var f = t.config.showMonths; f--; ) {
      var d = se("div", "flatpickr-weekdaycontainer");
      t.weekdayContainer.appendChild(d);
    }
    return q(), t.weekdayContainer;
  }
  function q() {
    if (t.weekdayContainer) {
      var f = t.l10n.firstDayOfWeek, d = fc(t.l10n.weekdays.shorthand);
      f > 0 && f < d.length && (d = fc(d.splice(f, d.length), d.splice(0, f)));
      for (var v = t.config.showMonths; v--; )
        t.weekdayContainer.children[v].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + d.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function W() {
    t.calendarContainer.classList.add("hasWeeks");
    var f = se("div", "flatpickr-weekwrapper");
    f.appendChild(se("span", "flatpickr-weekday", t.l10n.weekAbbreviation));
    var d = se("div", "flatpickr-weeks");
    return f.appendChild(d), {
      weekWrapper: f,
      weekNumbers: d
    };
  }
  function te(f, d) {
    d === void 0 && (d = !0);
    var v = d ? f : f - t.currentMonth;
    v < 0 && t._hidePrevMonthArrow === !0 || v > 0 && t._hideNextMonthArrow === !0 || (t.currentMonth += v, (t.currentMonth < 0 || t.currentMonth > 11) && (t.currentYear += t.currentMonth > 11 ? 1 : -1, t.currentMonth = (t.currentMonth + 12) % 12, I("onYearChange"), G()), J(), I("onMonthChange"), be());
  }
  function ie(f, d) {
    if (f === void 0 && (f = !0), d === void 0 && (d = !0), t.input.value = "", t.altInput !== void 0 && (t.altInput.value = ""), t.mobileInput !== void 0 && (t.mobileInput.value = ""), t.selectedDates = [], t.latestSelectedDateObj = void 0, d === !0 && (t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth()), t.config.enableTime === !0) {
      var v = pi(t.config), O = v.hours, P = v.minutes, N = v.seconds;
      y(O, P, N);
    }
    t.redraw(), f && I("onChange");
  }
  function ce() {
    t.isOpen = !1, t.isMobile || (t.calendarContainer !== void 0 && t.calendarContainer.classList.remove("open"), t._input !== void 0 && t._input.classList.remove("active")), I("onClose");
  }
  function ue() {
    t.config !== void 0 && I("onDestroy");
    for (var f = t._handlers.length; f--; )
      t._handlers[f].remove();
    if (t._handlers = [], t.mobileInput)
      t.mobileInput.parentNode && t.mobileInput.parentNode.removeChild(t.mobileInput), t.mobileInput = void 0;
    else if (t.calendarContainer && t.calendarContainer.parentNode)
      if (t.config.static && t.calendarContainer.parentNode) {
        var d = t.calendarContainer.parentNode;
        if (d.lastChild && d.removeChild(d.lastChild), d.parentNode) {
          for (; d.firstChild; )
            d.parentNode.insertBefore(d.firstChild, d);
          d.parentNode.removeChild(d);
        }
      } else
        t.calendarContainer.parentNode.removeChild(t.calendarContainer);
    t.altInput && (t.input.type = "text", t.altInput.parentNode && t.altInput.parentNode.removeChild(t.altInput), delete t.altInput), t.input && (t.input.type = t.input._type, t.input.classList.remove("flatpickr-input"), t.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(v) {
      try {
        delete t[v];
      } catch {
      }
    });
  }
  function le(f) {
    return t.calendarContainer.contains(f);
  }
  function ye(f) {
    if (t.isOpen && !t.config.inline) {
      var d = He(f), v = le(d), O = d === t.input || d === t.altInput || t.element.contains(d) || f.path && f.path.indexOf && (~f.path.indexOf(t.input) || ~f.path.indexOf(t.altInput)), P = !O && !v && !le(f.relatedTarget), N = !t.config.ignoredFocusElements.some(function(X) {
        return X.contains(d);
      });
      P && N && (t.config.allowInput && t.setDate(t._input.value, !1, t.config.altInput ? t.config.altFormat : t.config.dateFormat), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0 && t.input.value !== "" && t.input.value !== void 0 && l(), t.close(), t.config && t.config.mode === "range" && t.selectedDates.length === 1 && t.clear(!1));
    }
  }
  function we(f) {
    if (!(!f || t.config.minDate && f < t.config.minDate.getFullYear() || t.config.maxDate && f > t.config.maxDate.getFullYear())) {
      var d = f, v = t.currentYear !== d;
      t.currentYear = d || t.currentYear, t.config.maxDate && t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth = Math.min(t.config.maxDate.getMonth(), t.currentMonth) : t.config.minDate && t.currentYear === t.config.minDate.getFullYear() && (t.currentMonth = Math.max(t.config.minDate.getMonth(), t.currentMonth)), v && (t.redraw(), I("onYearChange"), G());
    }
  }
  function me(f, d) {
    var v;
    d === void 0 && (d = !0);
    var O = t.parseDate(f, void 0, d);
    if (t.config.minDate && O && ze(O, t.config.minDate, d !== void 0 ? d : !t.minDateHasTime) < 0 || t.config.maxDate && O && ze(O, t.config.maxDate, d !== void 0 ? d : !t.maxDateHasTime) > 0)
      return !1;
    if (!t.config.enable && t.config.disable.length === 0)
      return !0;
    if (O === void 0)
      return !1;
    for (var P = !!t.config.enable, N = (v = t.config.enable) !== null && v !== void 0 ? v : t.config.disable, X = 0, H = void 0; X < N.length; X++) {
      if (H = N[X], typeof H == "function" && H(O))
        return P;
      if (H instanceof Date && O !== void 0 && H.getTime() === O.getTime())
        return P;
      if (typeof H == "string") {
        var ne = t.parseDate(H, void 0, !0);
        return ne && ne.getTime() === O.getTime() ? P : !P;
      } else if (typeof H == "object" && O !== void 0 && H.from && H.to && O.getTime() >= H.from.getTime() && O.getTime() <= H.to.getTime())
        return P;
    }
    return !P;
  }
  function Ce(f) {
    return t.daysContainer !== void 0 ? f.className.indexOf("hidden") === -1 && f.className.indexOf("flatpickr-disabled") === -1 && t.daysContainer.contains(f) : !1;
  }
  function de(f) {
    var d = f.target === t._input, v = t._input.value.trimEnd() !== Ae();
    d && v && !(f.relatedTarget && le(f.relatedTarget)) && t.setDate(t._input.value, !0, f.target === t.altInput ? t.config.altFormat : t.config.dateFormat);
  }
  function xe(f) {
    var d = He(f), v = t.config.wrap ? n.contains(d) : d === t._input, O = t.config.allowInput, P = t.isOpen && (!O || !v), N = t.config.inline && v && !O;
    if (f.keyCode === 13 && v) {
      if (O)
        return t.setDate(t._input.value, !0, d === t.altInput ? t.config.altFormat : t.config.dateFormat), t.close(), d.blur();
      t.open();
    } else if (le(d) || P || N) {
      var X = !!t.timeContainer && t.timeContainer.contains(d);
      switch (f.keyCode) {
        case 13:
          X ? (f.preventDefault(), l(), et()) : At(f);
          break;
        case 27:
          f.preventDefault(), et();
          break;
        case 8:
        case 46:
          v && !t.config.allowInput && (f.preventDefault(), t.clear());
          break;
        case 37:
        case 39:
          if (!X && !v) {
            f.preventDefault();
            var H = i();
            if (t.daysContainer !== void 0 && (O === !1 || H && Ce(H))) {
              var ne = f.keyCode === 39 ? 1 : -1;
              f.ctrlKey ? (f.stopPropagation(), te(ne), U(L(1), 0)) : U(void 0, ne);
            }
          } else t.hourElement && t.hourElement.focus();
          break;
        case 38:
        case 40:
          f.preventDefault();
          var j = f.keyCode === 40 ? 1 : -1;
          t.daysContainer && d.$i !== void 0 || d === t.input || d === t.altInput ? f.ctrlKey ? (f.stopPropagation(), we(t.currentYear - j), U(L(1), 0)) : X || U(void 0, j * 7) : d === t.currentYearElement ? we(t.currentYear - j) : t.config.enableTime && (!X && t.hourElement && t.hourElement.focus(), l(f), t._debouncedChange());
          break;
        case 9:
          if (X) {
            var Q = [
              t.hourElement,
              t.minuteElement,
              t.secondElement,
              t.amPM
            ].concat(t.pluginElements).filter(function(je) {
              return je;
            }), fe = Q.indexOf(d);
            if (fe !== -1) {
              var it = Q[fe + (f.shiftKey ? -1 : 1)];
              f.preventDefault(), (it || t._input).focus();
            }
          } else !t.config.noCalendar && t.daysContainer && t.daysContainer.contains(d) && f.shiftKey && (f.preventDefault(), t._input.focus());
          break;
      }
    }
    if (t.amPM !== void 0 && d === t.amPM)
      switch (f.key) {
        case t.l10n.amPM[0].charAt(0):
        case t.l10n.amPM[0].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[0], p(), $e();
          break;
        case t.l10n.amPM[1].charAt(0):
        case t.l10n.amPM[1].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[1], p(), $e();
          break;
      }
    (v || le(d)) && I("onKeyDown", f);
  }
  function De(f, d) {
    if (d === void 0 && (d = "flatpickr-day"), !(t.selectedDates.length !== 1 || f && (!f.classList.contains(d) || f.classList.contains("flatpickr-disabled")))) {
      for (var v = f ? f.dateObj.getTime() : t.days.firstElementChild.dateObj.getTime(), O = t.parseDate(t.selectedDates[0], void 0, !0).getTime(), P = Math.min(v, t.selectedDates[0].getTime()), N = Math.max(v, t.selectedDates[0].getTime()), X = !1, H = 0, ne = 0, j = P; j < N; j += Mx.DAY)
        me(new Date(j), !0) || (X = X || j > P && j < N, j < O && (!H || j > H) ? H = j : j > O && (!ne || j < ne) && (ne = j));
      var Q = Array.from(t.rContainer.querySelectorAll("*:nth-child(-n+" + t.config.showMonths + ") > ." + d));
      Q.forEach(function(fe) {
        var it = fe.dateObj, je = it.getTime(), Un = H > 0 && je < H || ne > 0 && je > ne;
        if (Un) {
          fe.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(cn) {
            fe.classList.remove(cn);
          });
          return;
        } else if (X && !Un)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(cn) {
          fe.classList.remove(cn);
        }), f !== void 0 && (f.classList.add(v <= t.selectedDates[0].getTime() ? "startRange" : "endRange"), O < v && je === O ? fe.classList.add("startRange") : O > v && je === O && fe.classList.add("endRange"), je >= H && (ne === 0 || je <= ne) && Dx(je, O, v) && fe.classList.add("inRange"));
      });
    }
  }
  function Ye() {
    t.isOpen && !t.config.static && !t.config.inline && pt();
  }
  function on(f, d) {
    if (d === void 0 && (d = t._positionElement), t.isMobile === !0) {
      if (f) {
        f.preventDefault();
        var v = He(f);
        v && v.blur();
      }
      t.mobileInput !== void 0 && (t.mobileInput.focus(), t.mobileInput.click()), I("onOpen");
      return;
    } else if (t._input.disabled || t.config.inline)
      return;
    var O = t.isOpen;
    t.isOpen = !0, O || (t.calendarContainer.classList.add("open"), t._input.classList.add("active"), I("onOpen"), pt(d)), t.config.enableTime === !0 && t.config.noCalendar === !0 && t.config.allowInput === !1 && (f === void 0 || !t.timeContainer.contains(f.relatedTarget)) && setTimeout(function() {
      return t.hourElement.select();
    }, 50);
  }
  function Nt(f) {
    return function(d) {
      var v = t.config["_" + f + "Date"] = t.parseDate(d, t.config.dateFormat), O = t.config["_" + (f === "min" ? "max" : "min") + "Date"];
      v !== void 0 && (t[f === "min" ? "minDateHasTime" : "maxDateHasTime"] = v.getHours() > 0 || v.getMinutes() > 0 || v.getSeconds() > 0), t.selectedDates && (t.selectedDates = t.selectedDates.filter(function(P) {
        return me(P);
      }), !t.selectedDates.length && f === "min" && m(v), $e()), t.daysContainer && (Ot(), v !== void 0 ? t.currentYearElement[f] = v.getFullYear().toString() : t.currentYearElement.removeAttribute(f), t.currentYearElement.disabled = !!O && v !== void 0 && O.getFullYear() === v.getFullYear());
    };
  }
  function Ft() {
    var f = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], d = Ee(Ee({}, JSON.parse(JSON.stringify(n.dataset || {}))), e), v = {};
    t.config.parseDate = d.parseDate, t.config.formatDate = d.formatDate, Object.defineProperty(t.config, "enable", {
      get: function() {
        return t.config._enable;
      },
      set: function(Q) {
        t.config._enable = Cr(Q);
      }
    }), Object.defineProperty(t.config, "disable", {
      get: function() {
        return t.config._disable;
      },
      set: function(Q) {
        t.config._disable = Cr(Q);
      }
    });
    var O = d.mode === "time";
    if (!d.dateFormat && (d.enableTime || O)) {
      var P = _e.defaultConfig.dateFormat || _n.dateFormat;
      v.dateFormat = d.noCalendar || O ? "H:i" + (d.enableSeconds ? ":S" : "") : P + " H:i" + (d.enableSeconds ? ":S" : "");
    }
    if (d.altInput && (d.enableTime || O) && !d.altFormat) {
      var N = _e.defaultConfig.altFormat || _n.altFormat;
      v.altFormat = d.noCalendar || O ? "h:i" + (d.enableSeconds ? ":S K" : " K") : N + (" h:i" + (d.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(t.config, "minDate", {
      get: function() {
        return t.config._minDate;
      },
      set: Nt("min")
    }), Object.defineProperty(t.config, "maxDate", {
      get: function() {
        return t.config._maxDate;
      },
      set: Nt("max")
    });
    var X = function(Q) {
      return function(fe) {
        t.config[Q === "min" ? "_minTime" : "_maxTime"] = t.parseDate(fe, "H:i:S");
      };
    };
    Object.defineProperty(t.config, "minTime", {
      get: function() {
        return t.config._minTime;
      },
      set: X("min")
    }), Object.defineProperty(t.config, "maxTime", {
      get: function() {
        return t.config._maxTime;
      },
      set: X("max")
    }), d.mode === "time" && (t.config.noCalendar = !0, t.config.enableTime = !0), Object.assign(t.config, v, d);
    for (var H = 0; H < f.length; H++)
      t.config[f[H]] = t.config[f[H]] === !0 || t.config[f[H]] === "true";
    ci.filter(function(Q) {
      return t.config[Q] !== void 0;
    }).forEach(function(Q) {
      t.config[Q] = ui(t.config[Q] || []).map(o);
    }), t.isMobile = !t.config.disableMobile && !t.config.inline && t.config.mode === "single" && !t.config.disable.length && !t.config.enable && !t.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var H = 0; H < t.config.plugins.length; H++) {
      var ne = t.config.plugins[H](t) || {};
      for (var j in ne)
        ci.indexOf(j) > -1 ? t.config[j] = ui(ne[j]).map(o).concat(t.config[j]) : typeof d[j] > "u" && (t.config[j] = ne[j]);
    }
    d.altInputClass || (t.config.altInputClass = xt().className + " " + t.config.altInputClass), I("onParseConfig");
  }
  function xt() {
    return t.config.wrap ? n.querySelector("[data-input]") : n;
  }
  function Lt() {
    typeof t.config.locale != "object" && typeof _e.l10ns[t.config.locale] > "u" && t.config.errorHandler(new Error("flatpickr: invalid locale " + t.config.locale)), t.l10n = Ee(Ee({}, _e.l10ns.default), typeof t.config.locale == "object" ? t.config.locale : t.config.locale !== "default" ? _e.l10ns[t.config.locale] : void 0), qt.D = "(" + t.l10n.weekdays.shorthand.join("|") + ")", qt.l = "(" + t.l10n.weekdays.longhand.join("|") + ")", qt.M = "(" + t.l10n.months.shorthand.join("|") + ")", qt.F = "(" + t.l10n.months.longhand.join("|") + ")", qt.K = "(" + t.l10n.amPM[0] + "|" + t.l10n.amPM[1] + "|" + t.l10n.amPM[0].toLowerCase() + "|" + t.l10n.amPM[1].toLowerCase() + ")";
    var f = Ee(Ee({}, e), JSON.parse(JSON.stringify(n.dataset || {})));
    f.time_24hr === void 0 && _e.defaultConfig.time_24hr === void 0 && (t.config.time_24hr = t.l10n.time_24hr), t.formatDate = id(t), t.parseDate = Ji({ config: t.config, l10n: t.l10n });
  }
  function pt(f) {
    if (typeof t.config.position == "function")
      return void t.config.position(t, f);
    if (t.calendarContainer !== void 0) {
      I("onPreCalendarPosition");
      var d = f || t._positionElement, v = Array.prototype.reduce.call(t.calendarContainer.children, function(hd, md) {
        return hd + md.offsetHeight;
      }, 0), O = t.calendarContainer.offsetWidth, P = t.config.position.split(" "), N = P[0], X = P.length > 1 ? P[1] : null, H = d.getBoundingClientRect(), ne = window.innerHeight - H.bottom, j = N === "above" || N !== "below" && ne < v && H.top > v, Q = window.pageYOffset + H.top + (j ? -v - 2 : d.offsetHeight + 2);
      if (Te(t.calendarContainer, "arrowTop", !j), Te(t.calendarContainer, "arrowBottom", j), !t.config.inline) {
        var fe = window.pageXOffset + H.left, it = !1, je = !1;
        X === "center" ? (fe -= (O - H.width) / 2, it = !0) : X === "right" && (fe -= O - H.width, je = !0), Te(t.calendarContainer, "arrowLeft", !it && !je), Te(t.calendarContainer, "arrowCenter", it), Te(t.calendarContainer, "arrowRight", je);
        var Un = window.document.body.offsetWidth - (window.pageXOffset + H.right), cn = fe + O > window.document.body.offsetWidth, sd = Un + O > window.document.body.offsetWidth;
        if (Te(t.calendarContainer, "rightMost", cn), !t.config.static)
          if (t.calendarContainer.style.top = Q + "px", !cn)
            t.calendarContainer.style.left = fe + "px", t.calendarContainer.style.right = "auto";
          else if (!sd)
            t.calendarContainer.style.left = "auto", t.calendarContainer.style.right = Un + "px";
          else {
            var Ta = Xe();
            if (Ta === void 0)
              return;
            var ld = window.document.body.offsetWidth, cd = Math.max(0, ld / 2 - O / 2), ud = ".flatpickr-calendar.centerMost:before", fd = ".flatpickr-calendar.centerMost:after", dd = Ta.cssRules.length, pd = "{left:" + H.left + "px;right:auto;}";
            Te(t.calendarContainer, "rightMost", !1), Te(t.calendarContainer, "centerMost", !0), Ta.insertRule(ud + "," + fd + pd, dd), t.calendarContainer.style.left = cd + "px", t.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function Xe() {
    for (var f = null, d = 0; d < document.styleSheets.length; d++) {
      var v = document.styleSheets[d];
      if (v.cssRules) {
        try {
          v.cssRules;
        } catch {
          continue;
        }
        f = v;
        break;
      }
    }
    return f ?? at();
  }
  function at() {
    var f = document.createElement("style");
    return document.head.appendChild(f), f.sheet;
  }
  function Ot() {
    t.config.noCalendar || t.isMobile || (G(), be(), J());
  }
  function et() {
    t._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(t.close, 0) : t.close();
  }
  function At(f) {
    f.preventDefault(), f.stopPropagation();
    var d = function(Q) {
      return Q.classList && Q.classList.contains("flatpickr-day") && !Q.classList.contains("flatpickr-disabled") && !Q.classList.contains("notAllowed");
    }, v = ad(He(f), d);
    if (v !== void 0) {
      var O = v, P = t.latestSelectedDateObj = new Date(O.dateObj.getTime()), N = (P.getMonth() < t.currentMonth || P.getMonth() > t.currentMonth + t.config.showMonths - 1) && t.config.mode !== "range";
      if (t.selectedDateElem = O, t.config.mode === "single")
        t.selectedDates = [P];
      else if (t.config.mode === "multiple") {
        var X = oe(P);
        X ? t.selectedDates.splice(parseInt(X), 1) : t.selectedDates.push(P);
      } else t.config.mode === "range" && (t.selectedDates.length === 2 && t.clear(!1, !1), t.latestSelectedDateObj = P, t.selectedDates.push(P), ze(P, t.selectedDates[0], !0) !== 0 && t.selectedDates.sort(function(Q, fe) {
        return Q.getTime() - fe.getTime();
      }));
      if (p(), N) {
        var H = t.currentYear !== P.getFullYear();
        t.currentYear = P.getFullYear(), t.currentMonth = P.getMonth(), H && (I("onYearChange"), G()), I("onMonthChange");
      }
      if (be(), J(), $e(), !N && t.config.mode !== "range" && t.config.showMonths === 1 ? M(O) : t.selectedDateElem !== void 0 && t.hourElement === void 0 && t.selectedDateElem && t.selectedDateElem.focus(), t.hourElement !== void 0 && t.hourElement !== void 0 && t.hourElement.focus(), t.config.closeOnSelect) {
        var ne = t.config.mode === "single" && !t.config.enableTime, j = t.config.mode === "range" && t.selectedDates.length === 2 && !t.config.enableTime;
        (ne || j) && et();
      }
      w();
    }
  }
  var ht = {
    locale: [Lt, q],
    showMonths: [D, s, T],
    minDate: [S],
    maxDate: [S],
    positionElement: [Sr],
    clickOpens: [
      function() {
        t.config.clickOpens === !0 ? (b(t._input, "focus", t.open), b(t._input, "click", t.open)) : (t._input.removeEventListener("focus", t.open), t._input.removeEventListener("click", t.open));
      }
    ]
  };
  function sn(f, d) {
    if (f !== null && typeof f == "object") {
      Object.assign(t.config, f);
      for (var v in f)
        ht[v] !== void 0 && ht[v].forEach(function(O) {
          return O();
        });
    } else
      t.config[f] = d, ht[f] !== void 0 ? ht[f].forEach(function(O) {
        return O();
      }) : ci.indexOf(f) > -1 && (t.config[f] = ui(d));
    t.redraw(), $e(!0);
  }
  function Bt(f, d) {
    var v = [];
    if (f instanceof Array)
      v = f.map(function(O) {
        return t.parseDate(O, d);
      });
    else if (f instanceof Date || typeof f == "number")
      v = [t.parseDate(f, d)];
    else if (typeof f == "string")
      switch (t.config.mode) {
        case "single":
        case "time":
          v = [t.parseDate(f, d)];
          break;
        case "multiple":
          v = f.split(t.config.conjunction).map(function(O) {
            return t.parseDate(O, d);
          });
          break;
        case "range":
          v = f.split(t.l10n.rangeSeparator).map(function(O) {
            return t.parseDate(O, d);
          });
          break;
      }
    else
      t.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(f)));
    t.selectedDates = t.config.allowInvalidPreload ? v : v.filter(function(O) {
      return O instanceof Date && me(O, !1);
    }), t.config.mode === "range" && t.selectedDates.sort(function(O, P) {
      return O.getTime() - P.getTime();
    });
  }
  function ln(f, d, v) {
    if (d === void 0 && (d = !1), v === void 0 && (v = t.config.dateFormat), f !== 0 && !f || f instanceof Array && f.length === 0)
      return t.clear(d);
    Bt(f, v), t.latestSelectedDateObj = t.selectedDates[t.selectedDates.length - 1], t.redraw(), S(void 0, d), m(), t.selectedDates.length === 0 && t.clear(!1), $e(d), d && I("onChange");
  }
  function Cr(f) {
    return f.slice().map(function(d) {
      return typeof d == "string" || typeof d == "number" || d instanceof Date ? t.parseDate(d, void 0, !0) : d && typeof d == "object" && d.from && d.to ? {
        from: t.parseDate(d.from, void 0),
        to: t.parseDate(d.to, void 0)
      } : d;
    }).filter(function(d) {
      return d;
    });
  }
  function Ea() {
    t.selectedDates = [], t.now = t.parseDate(t.config.now) || /* @__PURE__ */ new Date();
    var f = t.config.defaultDate || ((t.input.nodeName === "INPUT" || t.input.nodeName === "TEXTAREA") && t.input.placeholder && t.input.value === t.input.placeholder ? null : t.input.value);
    f && Bt(f, t.config.dateFormat), t._initialDate = t.selectedDates.length > 0 ? t.selectedDates[0] : t.config.minDate && t.config.minDate.getTime() > t.now.getTime() ? t.config.minDate : t.config.maxDate && t.config.maxDate.getTime() < t.now.getTime() ? t.config.maxDate : t.now, t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth(), t.selectedDates.length > 0 && (t.latestSelectedDateObj = t.selectedDates[0]), t.config.minTime !== void 0 && (t.config.minTime = t.parseDate(t.config.minTime, "H:i")), t.config.maxTime !== void 0 && (t.config.maxTime = t.parseDate(t.config.maxTime, "H:i")), t.minDateHasTime = !!t.config.minDate && (t.config.minDate.getHours() > 0 || t.config.minDate.getMinutes() > 0 || t.config.minDate.getSeconds() > 0), t.maxDateHasTime = !!t.config.maxDate && (t.config.maxDate.getHours() > 0 || t.config.maxDate.getMinutes() > 0 || t.config.maxDate.getSeconds() > 0);
  }
  function ka() {
    if (t.input = xt(), !t.input) {
      t.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    t.input._type = t.input.type, t.input.type = "text", t.input.classList.add("flatpickr-input"), t._input = t.input, t.config.altInput && (t.altInput = se(t.input.nodeName, t.config.altInputClass), t._input = t.altInput, t.altInput.placeholder = t.input.placeholder, t.altInput.disabled = t.input.disabled, t.altInput.required = t.input.required, t.altInput.tabIndex = t.input.tabIndex, t.altInput.type = "text", t.input.setAttribute("type", "hidden"), !t.config.static && t.input.parentNode && t.input.parentNode.insertBefore(t.altInput, t.input.nextSibling)), t.config.allowInput || t._input.setAttribute("readonly", "readonly"), Sr();
  }
  function Sr() {
    t._positionElement = t.config.positionElement || t._input;
  }
  function Da() {
    var f = t.config.enableTime ? t.config.noCalendar ? "time" : "datetime-local" : "date";
    t.mobileInput = se("input", t.input.className + " flatpickr-mobile"), t.mobileInput.tabIndex = 1, t.mobileInput.type = f, t.mobileInput.disabled = t.input.disabled, t.mobileInput.required = t.input.required, t.mobileInput.placeholder = t.input.placeholder, t.mobileFormatStr = f === "datetime-local" ? "Y-m-d\\TH:i:S" : f === "date" ? "Y-m-d" : "H:i:S", t.selectedDates.length > 0 && (t.mobileInput.defaultValue = t.mobileInput.value = t.formatDate(t.selectedDates[0], t.mobileFormatStr)), t.config.minDate && (t.mobileInput.min = t.formatDate(t.config.minDate, "Y-m-d")), t.config.maxDate && (t.mobileInput.max = t.formatDate(t.config.maxDate, "Y-m-d")), t.input.getAttribute("step") && (t.mobileInput.step = String(t.input.getAttribute("step"))), t.input.type = "hidden", t.altInput !== void 0 && (t.altInput.type = "hidden");
    try {
      t.input.parentNode && t.input.parentNode.insertBefore(t.mobileInput, t.input.nextSibling);
    } catch {
    }
    b(t.mobileInput, "change", function(d) {
      t.setDate(He(d).value, !1, t.mobileFormatStr), I("onChange"), I("onClose");
    });
  }
  function $(f) {
    if (t.isOpen === !0)
      return t.close();
    t.open(f);
  }
  function I(f, d) {
    if (t.config !== void 0) {
      var v = t.config[f];
      if (v !== void 0 && v.length > 0)
        for (var O = 0; v[O] && O < v.length; O++)
          v[O](t.selectedDates, t.input.value, t, d);
      f === "onChange" && (t.input.dispatchEvent(K("change")), t.input.dispatchEvent(K("input")));
    }
  }
  function K(f) {
    var d = document.createEvent("Event");
    return d.initEvent(f, !0, !0), d;
  }
  function oe(f) {
    for (var d = 0; d < t.selectedDates.length; d++) {
      var v = t.selectedDates[d];
      if (v instanceof Date && ze(v, f) === 0)
        return "" + d;
    }
    return !1;
  }
  function ae(f) {
    return t.config.mode !== "range" || t.selectedDates.length < 2 ? !1 : ze(f, t.selectedDates[0]) >= 0 && ze(f, t.selectedDates[1]) <= 0;
  }
  function be() {
    t.config.noCalendar || t.isMobile || !t.monthNav || (t.yearElements.forEach(function(f, d) {
      var v = new Date(t.currentYear, t.currentMonth, 1);
      v.setMonth(t.currentMonth + d), t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? t.monthElements[d].textContent = oa(v.getMonth(), t.config.shorthandCurrentMonth, t.l10n) + " " : t.monthsDropdownContainer.value = v.getMonth().toString(), f.value = v.getFullYear().toString();
    }), t._hidePrevMonthArrow = t.config.minDate !== void 0 && (t.currentYear === t.config.minDate.getFullYear() ? t.currentMonth <= t.config.minDate.getMonth() : t.currentYear < t.config.minDate.getFullYear()), t._hideNextMonthArrow = t.config.maxDate !== void 0 && (t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth + 1 > t.config.maxDate.getMonth() : t.currentYear > t.config.maxDate.getFullYear()));
  }
  function Ae(f) {
    var d = f || (t.config.altInput ? t.config.altFormat : t.config.dateFormat);
    return t.selectedDates.map(function(v) {
      return t.formatDate(v, d);
    }).filter(function(v, O, P) {
      return t.config.mode !== "range" || t.config.enableTime || P.indexOf(v) === O;
    }).join(t.config.mode !== "range" ? t.config.conjunction : t.l10n.rangeSeparator);
  }
  function $e(f) {
    f === void 0 && (f = !0), t.mobileInput !== void 0 && t.mobileFormatStr && (t.mobileInput.value = t.latestSelectedDateObj !== void 0 ? t.formatDate(t.latestSelectedDateObj, t.mobileFormatStr) : ""), t.input.value = Ae(t.config.dateFormat), t.altInput !== void 0 && (t.altInput.value = Ae(t.config.altFormat)), f !== !1 && I("onValueUpdate");
  }
  function xr(f) {
    var d = He(f), v = t.prevMonthNav.contains(d), O = t.nextMonthNav.contains(d);
    v || O ? te(v ? -1 : 1) : t.yearElements.indexOf(d) >= 0 ? d.select() : d.classList.contains("arrowUp") ? t.changeYear(t.currentYear + 1) : d.classList.contains("arrowDown") && t.changeYear(t.currentYear - 1);
  }
  function mt(f) {
    f.preventDefault();
    var d = f.type === "keydown", v = He(f), O = v;
    t.amPM !== void 0 && v === t.amPM && (t.amPM.textContent = t.l10n.amPM[Ke(t.amPM.textContent === t.l10n.amPM[0])]);
    var P = parseFloat(O.getAttribute("min")), N = parseFloat(O.getAttribute("max")), X = parseFloat(O.getAttribute("step")), H = parseInt(O.value, 10), ne = f.delta || (d ? f.which === 38 ? 1 : -1 : 0), j = H + X * ne;
    if (typeof O.value < "u" && O.value.length === 2) {
      var Q = O === t.hourElement, fe = O === t.minuteElement;
      j < P ? (j = N + j + Ke(!Q) + (Ke(Q) && Ke(!t.amPM)), fe && h(void 0, -1, t.hourElement)) : j > N && (j = O === t.hourElement ? j - N - Ke(!t.amPM) : P, fe && h(void 0, 1, t.hourElement)), t.amPM && Q && (X === 1 ? j + H === 23 : Math.abs(j - H) > X) && (t.amPM.textContent = t.l10n.amPM[Ke(t.amPM.textContent === t.l10n.amPM[0])]), O.value = Re(j);
    }
  }
  return a(), t;
}
function wn(n, e) {
  for (var t = Array.prototype.slice.call(n).filter(function(o) {
    return o instanceof HTMLElement;
  }), r = [], a = 0; a < t.length; a++) {
    var i = t[a];
    try {
      if (i.getAttribute("data-fp-omit") !== null)
        continue;
      i._flatpickr !== void 0 && (i._flatpickr.destroy(), i._flatpickr = void 0), i._flatpickr = Ix(i, e || {}), r.push(i._flatpickr);
    } catch (o) {
      console.error(o);
    }
  }
  return r.length === 1 ? r[0] : r;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(n) {
  return wn(this, n);
}, HTMLElement.prototype.flatpickr = function(n) {
  return wn([this], n);
});
var _e = function(n, e) {
  return typeof n == "string" ? wn(window.document.querySelectorAll(n), e) : n instanceof Node ? wn([n], e) : wn(n, e);
};
_e.defaultConfig = {};
_e.l10ns = {
  en: Ee({}, fr),
  default: Ee({}, fr)
};
_e.localize = function(n) {
  _e.l10ns.default = Ee(Ee({}, _e.l10ns.default), n);
};
_e.setDefaults = function(n) {
  _e.defaultConfig = Ee(Ee({}, _e.defaultConfig), n);
};
_e.parseDate = Ji({});
_e.formatDate = id({});
_e.compareDates = ze;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(n) {
  return wn(this, n);
});
Date.prototype.fp_incr = function(n) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof n == "string" ? parseInt(n, 10) : n));
};
typeof window < "u" && (window.flatpickr = _e);
const Rx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _e
}, Symbol.toStringTag, { value: "Module" })), Nx = /* @__PURE__ */ jc(Rx);
(function(n, e) {
  (function(r, a) {
    n.exports = a(Nx);
  })(Dt, (t) => (
    /******/
    (() => {
      var r = {
        /***/
        311: (
          /***/
          (s) => {
            s.exports = t;
          }
        )
        /******/
      }, a = {};
      function i(s) {
        var l = a[s];
        if (l !== void 0)
          return l.exports;
        var u = a[s] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return r[s](u, u.exports, i), u.exports;
      }
      i.n = (s) => {
        var l = s && s.__esModule ? (
          /******/
          () => s.default
        ) : (
          /******/
          () => s
        );
        return i.d(l, { a: l }), l;
      }, i.d = (s, l) => {
        for (var u in l)
          i.o(l, u) && !i.o(s, u) && Object.defineProperty(s, u, { enumerable: !0, get: l[u] });
      }, i.o = (s, l) => Object.prototype.hasOwnProperty.call(s, l);
      var o = {};
      return (() => {
        i.d(o, {
          default: () => (
            /* binding */
            h
          )
        });
        var s = i(311), l = /* @__PURE__ */ i.n(s), u = ["onChange", "onClose", "onDestroy", "onMonthChange", "onOpen", "onYearChange"], c = ["onValueUpdate", "onDayCreate", "onParseConfig", "onReady", "onPreCalendarPosition", "onKeyDown"];
        function p() {
          return p = Object.assign ? Object.assign.bind() : function(E) {
            for (var _ = 1; _ < arguments.length; _++) {
              var M = arguments[_];
              for (var L in M)
                Object.prototype.hasOwnProperty.call(M, L) && (E[L] = M[L]);
            }
            return E;
          }, p.apply(this, arguments);
        }
        var m = function(_) {
          return _.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }, y = function(_) {
          return _ instanceof Array ? _ : [_];
        }, g = function(_) {
          return _ && _.length ? _ : null;
        }, b = function(_) {
          return p({}, _);
        }, w = u.concat(c), C = ["locale", "showMonths"];
        const S = {
          name: "flat-pickr",
          render: function(_) {
            return _("input", {
              attrs: {
                type: "text",
                "data-input": !0
              },
              props: {
                disabled: this.disabled
              },
              on: {
                input: this.onInput
              }
            });
          },
          props: {
            value: {
              default: null,
              required: !0,
              validator: function(_) {
                return _ === null || _ instanceof Date || typeof _ == "string" || _ instanceof String || _ instanceof Array || typeof _ == "number";
              }
            },
            // https://flatpickr.js.org/options/
            config: {
              type: Object,
              default: function() {
                return {
                  wrap: !1,
                  defaultDate: null
                };
              }
            },
            events: {
              type: Array,
              default: function() {
                return u;
              }
            },
            disabled: {
              type: Boolean,
              default: !1
            }
          },
          data: function() {
            return {
              /**
               * The flatpickr instance
               */
              fp: null
            };
          },
          mounted: function() {
            var _ = this;
            if (!this.fp) {
              var M = b(this.config);
              this.events.forEach(function(L) {
                var z = l().defaultConfig[L] || [], U = function() {
                  for (var J = arguments.length, G = new Array(J), F = 0; F < J; F++)
                    G[F] = arguments[F];
                  _.$emit.apply(_, [m(L)].concat(G));
                };
                M[L] = y(M[L] || []).concat(z, U);
              }), M.defaultDate = this.value || M.defaultDate, this.fp = new (l())(this.getElem(), M), this.fpInput().addEventListener("blur", this.onBlur), this.$on("on-close", this.onClose), this.$watch("disabled", this.watchDisabled, {
                immediate: !0
              });
            }
          },
          methods: {
            /**
             * Get the HTML node where flatpickr to be attached
             * Bind on parent element if wrap is true
             */
            getElem: function() {
              return this.config.wrap ? this.$el.parentNode : this.$el;
            },
            /**
             * Watch for value changed by date-picker itself and notify parent component
             *
             * @param event
             */
            onInput: function(_) {
              var M = this, L = _.target;
              this.$nextTick(function() {
                M.$emit("input", g(L.value));
              });
            },
            /**
             * @return HTMLElement
             */
            fpInput: function() {
              return this.fp.altInput || this.fp.input;
            },
            /**
             * Blur event is required by many validation libraries
             *
             * @param event
             */
            onBlur: function(_) {
              this.$emit("blur", g(_.target.value));
            },
            /**
             * Flatpickr does not emit input event in some cases
             */
            onClose: function(_, M) {
              this.$emit("input", g(M));
            },
            /**
             * Watch for the disabled property and sets the value to the real input.
             *
             * @param newState
             */
            watchDisabled: function(_) {
              _ ? this.fpInput().setAttribute("disabled", _) : this.fpInput().removeAttribute("disabled");
            }
          },
          watch: {
            /**
             * Watch for any config changes and redraw date-picker
             *
             * @param newConfig Object
             */
            config: {
              deep: !0,
              handler: function(_) {
                var M = this, L = b(_);
                w.forEach(function(z) {
                  delete L[z];
                }), this.fp.set(L), C.forEach(function(z) {
                  typeof L[z] < "u" && M.fp.set(z, L[z]);
                });
              }
            },
            /**
             * Watch for changes from parent component and update DOM
             *
             * @param newValue
             */
            value: function(_) {
              _ !== g(this.$el.value) && this.fp && // Notify flatpickr instance that there is a change in value
              this.fp.setDate(_, !0);
            }
          },
          /**
           * Free up memory
           */
          beforeDestroy: function() {
            this.fp && (this.fpInput().removeEventListener("blur", this.onBlur), this.fp.destroy(), this.fp = null);
          }
        };
        var A = function(_, M) {
          var L = "flat-pickr";
          typeof M == "string" && (L = M), _.component(L, S);
        };
        S.install = A;
        const h = S;
      })(), o = o.default, o;
    })()
  ));
})(rd);
var Fx = rd.exports;
const Lx = /* @__PURE__ */ tn(Fx);
var od = {};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 });
  var e = "fas", t = "calendar", r = 448, a = 512, i = [], o = "f133", s = "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z";
  n.definition = {
    prefix: e,
    iconName: t,
    icon: [
      r,
      a,
      i,
      o,
      s
    ]
  }, n.faCalendar = n.definition, n.prefix = e, n.iconName = t, n.width = r, n.height = a, n.ligatures = i, n.unicode = o, n.svgPathData = s;
})(od);
Pe.add(od.faCalendar);
const Bx = {
  props: {
    config: {
      type: Object
    },
    value: [String, Number, Date, Array, null],
    showCalendar: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String
    }
  },
  data() {
    return {
      defaultFlatPickrConfig: {
        enableTime: !0,
        dateFormat: "Y-m-d H:i",
        time_24hr: !0,
        monthSelectorType: "static"
      }
    };
  },
  computed: {
    mergedConfiguration() {
      return { ...this.defaultFlatPickrConfig, ...this.config };
    }
  },
  methods: {
    handleInput(n) {
      this.$emit("input", n);
    }
  },
  watch: {
    showCalendar: {
      handler(n) {
        n && this.$refs.pickr.$el._flatpickr.open();
      }
    }
  },
  components: {
    FontAwesomeIcon: Ie,
    flatPickr: Lx
  }
};
var jx = function() {
  var e = this, t = e._self._c;
  return t("span", [t("font-awesome-icon", { staticClass: "icon", attrs: { icon: "calendar" } }), t("flat-pickr", { ref: "pickr", staticClass: "flatpickr", attrs: { config: e.mergedConfiguration, placeholder: e.placeholder, value: e.value }, on: { input: e.handleInput } })], 1);
}, Hx = [], zx = /* @__PURE__ */ ee(
  Bx,
  jx,
  Hx,
  !1,
  null,
  "9d9ef1c4"
);
const Ux = zx.exports, qx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Alert: yh,
  Autocomplete: og,
  Carousel: Sh,
  CarouselBackTrigger: Ah,
  CarouselNextTrigger: $h,
  ClientTable: sC,
  CollapsableList: Nh,
  CollapsableListItem: Jc,
  CopyToClipboard: O1,
  CopyToClipboardTrigger: $1,
  DatePicker: Ux,
  DmTableHeader: Ex,
  EnvironmentIndicator: jg,
  Footer: Yg,
  HeaderBar: Og,
  InfiniteNavigation: o5,
  Modal: Su,
  ModalTrigger: k1,
  NedapOnly: e0,
  NoResults: Gf,
  ProgressBar: Eu,
  Releases: c0,
  Search: pw,
  ServerTable: Sx,
  SimpleDropdown: $u,
  SingleMarkerMap: wo,
  SlidingPanel: kw,
  StatusFlag: Sw,
  StoreMap: ev,
  Switch: yw,
  TableSearchField: Qf,
  Tooltip: Mn
}, Symbol.toStringTag, { value: "Module" })), Zi = function(e) {
  Zi.installed || (Zi.installed = !0, Object.entries(qx).forEach(([t, r]) => {
    e.component(t, r);
  }));
}, Wx = {
  install: Zi
};
export {
  yh as Alert,
  og as Autocomplete,
  Sh as Carousel,
  Ah as CarouselBackTrigger,
  $h as CarouselNextTrigger,
  sC as ClientTable,
  Nh as CollapsableList,
  Jc as CollapsableListItem,
  O1 as CopyToClipboard,
  $1 as CopyToClipboardTrigger,
  Ux as DatePicker,
  Ex as DmTableHeader,
  jg as EnvironmentIndicator,
  Yg as Footer,
  Og as HeaderBar,
  o5 as InfiniteNavigation,
  Su as Modal,
  k1 as ModalTrigger,
  e0 as NedapOnly,
  Gf as NoResults,
  Eu as ProgressBar,
  c0 as Releases,
  pw as Search,
  Sx as ServerTable,
  $u as SimpleDropdown,
  wo as SingleMarkerMap,
  kw as SlidingPanel,
  Sw as StatusFlag,
  ev as StoreMap,
  yw as Switch,
  Qf as TableSearchField,
  Mn as Tooltip,
  Wx as default
};
